// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.cU.dD === region.cw.dD)
	{
		return 'on line ' + region.cU.dD;
	}
	return 'on lines ' + region.cU.dD + ' through ' + region.cw.dD;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.j1,
		impl.lw,
		impl.ld,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bF: func(record.bF),
		gz: record.gz,
		gg: record.gg
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bF;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.gz;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.gg) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.j1,
		impl.lw,
		impl.ld,
		function(sendToApp, initialModel) {
			var view = impl.lD;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.j1,
		impl.lw,
		impl.ld,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.gr && impl.gr(sendToApp)
			var view = impl.lD;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.jl);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.d) && (_VirtualDom_doc.title = title = doc.d);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.kH;
	var onUrlRequest = impl.kI;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		gr: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.il === next.il
							&& curr.hw === next.hw
							&& curr.ic.a === next.ic.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		j1: function(flags)
		{
			return A3(impl.j1, flags, _Browser_getUrl(), key);
		},
		lD: impl.lD,
		lw: impl.lw,
		ld: impl.ld
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { jY: 'hidden', js: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { jY: 'mozHidden', js: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { jY: 'msHidden', js: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { jY: 'webkitHidden', js: 'webkitvisibilitychange' }
		: { jY: 'hidden', js: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		iz: _Browser_getScene(),
		i1: {
			M: _Browser_window.pageXOffset,
			N: _Browser_window.pageYOffset,
			h: _Browser_doc.documentElement.clientWidth,
			p: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		h: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		p: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			iz: {
				h: node.scrollWidth,
				p: node.scrollHeight
			},
			i1: {
				M: node.scrollLeft,
				N: node.scrollTop,
				h: node.clientWidth,
				p: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			iz: _Browser_getScene(),
			i1: {
				M: x,
				N: y,
				h: _Browser_doc.documentElement.clientWidth,
				p: _Browser_doc.documentElement.clientHeight
			},
			hk: {
				M: x + rect.left,
				N: y + rect.top,
				h: rect.width,
				p: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.ks) { flags += 'm'; }
	if (options.jq) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.G) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.J);
		} else {
			var treeLen = builder.G * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.T) : builder.T;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.G);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.J);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{T: nodeList, G: (len / $elm$core$Array$branchFactor) | 0, J: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {hs: fragment, hw: host, kQ: path, ic: port_, il: protocol, ce: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Chart$Empty = {$: 7};
var $author$project$Chart$GeneralMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Chart$ConsumptionProfile = function (a) {
	return {$: 4, a: a};
};
var $author$project$Chart$General = function (a) {
	return {$: 3, a: a};
};
var $author$project$Chart$AggregateEntities = function (a) {
	return {$: 2, a: a};
};
var $author$project$Chart$AggregateEntities$Model = F3(
	function (points, unit, timeZone) {
		return {ib: points, iU: timeZone, i$: unit};
	});
var $author$project$Chart$AggregateEntities$ConsumptionData = F3(
	function (month, actual, excess) {
		return {e3: actual, fo: excess, hW: month};
	});
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.cU, posixMinutes) < 0) {
					return posixMinutes + era.kG;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		hb: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		hW: month,
		i9: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hb;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hW;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).i9;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {g0: col, jy: contextStack, $8: problem, iv: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.iv, s.g0, x, s.j));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.kG, s.c);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{g0: 1, j: s.j, q: s.q, kG: s.kG + 1, iv: s.iv + 1, c: s.c}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{g0: s.g0 + 1, j: s.j, q: s.q, kG: newOffset, iv: s.iv, c: s.c}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.$8;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.c),
			s.kG) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.kG, s1.kG, s0.c),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.kG, s.iv, s.g0, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{g0: newCol, j: s.j, q: s.q, kG: newOffset, iv: newRow, c: s.c});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {g0: col, $8: problem, iv: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.iv, p.g0, p.$8);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{g0: 1, j: _List_Nil, q: 1, kG: 0, iv: 1, c: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {r: index, ki: match, eJ: number, iM: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{jq: false, ks: false},
		string);
};
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Enectiva$Conversion$parseStdDateWithFallback = F2(
	function (fallback, str) {
		return A2(
			$elm$core$Result$withDefault,
			fallback,
			$justinmimbs$date$Date$fromIsoString(
				function () {
					var _v0 = $elm$regex$Regex$fromString('T.+$');
					if (_v0.$ === 1) {
						return str;
					} else {
						var regex = _v0.a;
						return A3(
							$elm$regex$Regex$replace,
							regex,
							$elm$core$Basics$always(''),
							str);
					}
				}()));
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Enectiva$Conversion$parseStdDate = $author$project$Enectiva$Conversion$parseStdDateWithFallback(
	A2(
		$justinmimbs$date$Date$fromPosix,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(0)));
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Enectiva$Conversion$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$Conversion$parseStdDate(s));
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Chart$AggregateEntities$consumptionDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'excess',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actual',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'month',
			$author$project$Enectiva$Conversion$dateDecoder,
			$elm$json$Json$Decode$succeed($author$project$Chart$AggregateEntities$ConsumptionData))));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 1:
			return 'expecting int';
		case 2:
			return 'expecting hex';
		case 3:
			return 'expecting octal';
		case 4:
			return 'expecting binary';
		case 5:
			return 'expecting float';
		case 6:
			return 'expecting number';
		case 7:
			return 'expecting variable';
		case 8:
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 9:
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 10:
			return 'expecting end';
		case 11:
			return 'unexpected char';
		case 12:
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.$8) + (' at row ' + ($elm$core$String$fromInt(deadend.iv) + (', col ' + $elm$core$String$fromInt(deadend.g0))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.c);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.kG, offset) < 0,
					0,
					{g0: col, j: s0.j, q: s0.q, kG: offset, iv: row, c: s0.c});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.kG, s.iv, s.g0, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$millisToMinutes = function (millis) {
	return (((millis / 1000) | 0) / 60) | 0;
};
var $author$project$Types$utcOffsetInMinutesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$posixToMillis,
		A2($elm$core$Basics$composeR, $author$project$Types$millisToMinutes, $elm$json$Json$Decode$succeed)),
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder);
var $author$project$Types$offsetChangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'offset',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start',
		$author$project$Types$utcOffsetInMinutesDecoder,
		$elm$json$Json$Decode$succeed(
			F2(
				function (s, o) {
					return {kG: o, cU: s};
				}))));
var $author$project$Types$timeZoneDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'changes',
	$elm$json$Json$Decode$list($author$project$Types$offsetChangeDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'offset',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($elm$time$Time$customZone)));
var $author$project$Chart$aggregateEntitiesDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$AggregateEntities,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timeZone',
		$author$project$Types$timeZoneDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'unit',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'aggregateEntities',
				$elm$json$Json$Decode$list($author$project$Chart$AggregateEntities$consumptionDataDecoder),
				$elm$json$Json$Decode$succeed($author$project$Chart$AggregateEntities$Model)))));
var $author$project$Chart$BinaryAnalysis = function (a) {
	return {$: 6, a: a};
};
var $author$project$Chart$Shared$None = 2;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Exhaustive = function (a) {
	return {$: 0, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NoHighlight = {$: 0};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Shortened = {$: 1};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration = 10;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Asc = 0;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$SeriesAndTime = 0;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$defaultSorting = {dr: 0, dV: 0};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$maxBuckets = 13;
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minBuckets = 6;
var $author$project$Chart$Shared$tableModeToBool = function (mode) {
	switch (mode) {
		case 0:
			return true;
		case 1:
			return true;
		default:
			return false;
	}
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$initChart = F6(
	function (idPrefix, title, series, timeZone, range, tableMode) {
		var maxDuration = function (v) {
			return (((v / $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration) | 0) + 1) * $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					A2(
						$elm$core$List$concatMap,
						$elm$core$List$map(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.cO;
								},
								function ($) {
									return $.B;
								})),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.jA;
							},
							series)))));
		var totalBuckets = ((maxDuration + ($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration - 1)) / $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration) | 0;
		var histogramPolicy = function () {
			var _v0 = _Utils_Tuple2(
				_Utils_cmp(totalBuckets, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$maxBuckets) > 0,
				_Utils_cmp(totalBuckets, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minBuckets) < 0);
			if (_v0.a) {
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Shortened;
			} else {
				if (_v0.b) {
					return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Exhaustive($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minBuckets);
				} else {
					return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Exhaustive(totalBuckets);
				}
			}
		}();
		var extendedMaxDuration = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(
				_List_fromArray(
					[maxDuration, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minBuckets * $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration])));
		var domain = {S: extendedMaxDuration, Z: 0};
		return {
			dq: $author$project$Chart$Shared$tableModeToBool(tableMode),
			ep: domain,
			bB: domain,
			aO: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NoHighlight,
			ew: histogramPolicy,
			ex: idPrefix + '_bdsa_',
			cO: range,
			iD: series,
			eV: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$defaultSorting,
			iU: timeZone,
			d: title
		};
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Series = F4(
	function (name, monitoredValueLabel, data, dataRange) {
		return {jA: data, g9: dataRange, hV: monitoredValueLabel, kt: name};
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Interval = F2(
	function (range, reliability) {
		return {cO: range, cg: reliability};
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$newTimeRange = F2(
	function (from, to) {
		return {
			B: ((((to - from) / 1000) | 0) / 60) | 0,
			jT: $elm$time$Time$millisToPosix(from),
			lj: $elm$time$Time$millisToPosix(to)
		};
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$timeRangeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (list) {
		if (list.b && list.b.b) {
			var from = list.a;
			var _v1 = list.b;
			var to = _v1.a;
			return $elm$json$Json$Decode$succeed(
				A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$newTimeRange, from, to));
		} else {
			return $elm$json$Json$Decode$fail('unparseable time range');
		}
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int));
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$intervalDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reliability',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'range',
		$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$timeRangeDecoder,
		$elm$json$Json$Decode$succeed($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Interval)));
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$seriesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dataRange',
	$elm$json$Json$Decode$nullable($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$timeRangeDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'data',
		$elm$json$Json$Decode$list($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$intervalDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'monitoredValueLabel',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Series)))));
var $author$project$Chart$Shared$Horizontal = 0;
var $author$project$Chart$Shared$Vertical = 1;
var $author$project$Chart$Shared$tableModeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'horizontal':
				return $elm$json$Json$Decode$succeed(0);
			case 'vertical':
				return $elm$json$Json$Decode$succeed(1);
			case 'none':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('unknown table mode ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$decoder = function (idPrefix) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'table_mode',
		$author$project$Chart$Shared$tableModeDecoder,
		2,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'range',
			$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$timeRangeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'timeZone',
				$author$project$Types$timeZoneDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'series',
					$elm$json$Json$Decode$list($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$seriesDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed(
							$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$initChart(idPrefix)))))));
};
var $author$project$Chart$binaryAnalysisDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (p) {
		if (p === 'binary_analysis') {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Chart$BinaryAnalysis,
				$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$decoder(''));
		} else {
			return $elm$json$Json$Decode$fail('not a binary_analysis presenter');
		}
	},
	A2($elm$json$Json$Decode$field, 'presenter', $elm$json$Json$Decode$string));
var $author$project$Chart$ConsumptionProfile$Model = F7(
	function (current, previous, unit, showPrevious, rangeDiffMinutes, timeZone, extensions) {
		return {bA: current, fp: extensions, bM: previous, $9: rangeDiffMinutes, cR: showPrevious, iU: timeZone, i$: unit};
	});
var $author$project$Chart$ConsumptionProfile$DataPoint = F2(
	function (time, value) {
		return {bT: time, aW: value};
	});
var $author$project$Chart$ConsumptionProfile$ImpossibleDivision = function (a) {
	return {$: 2, a: a};
};
var $author$project$Chart$ConsumptionProfile$MissingValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$ConsumptionProfile$OkValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$ConsumptionProfile$valueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (tp) {
		switch (tp) {
			case 'ok':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Chart$ConsumptionProfile$OkValue,
					A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$float));
			case 'missing':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Chart$ConsumptionProfile$MissingValue,
					A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
			case 'impossible_division':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Chart$ConsumptionProfile$ImpossibleDivision,
					A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('unsupported value type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Chart$ConsumptionProfile$dataPointDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$author$project$Chart$ConsumptionProfile$valueDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'time',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		$elm$json$Json$Decode$succeed($author$project$Chart$ConsumptionProfile$DataPoint)));
var $author$project$Chart$ConsumptionProfile$ContinuousDataSeries = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$ConsumptionProfile$ContinuousDataSeriesExtension = F3(
	function (dataSeries, current, previous) {
		return {bA: current, dl: dataSeries, bM: previous};
	});
var $author$project$Chart$ConsumptionProfile$Aggregates = function (avg) {
	return {aM: avg};
};
var $author$project$Chart$ConsumptionProfile$aggregatesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'avg',
	$elm$json$Json$Decode$list($author$project$Chart$ConsumptionProfile$dataPointDecoder),
	$elm$json$Json$Decode$succeed($author$project$Chart$ConsumptionProfile$Aggregates));
var $author$project$Chart$ConsumptionProfile$DataSeriesDesc = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$ConsumptionProfile$NotAvailable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$ConsumptionProfile$DataSeries = F2(
	function (name, unit) {
		return {kt: name, i$: unit};
	});
var $author$project$Chart$ConsumptionProfile$dataSeriesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unit',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Chart$ConsumptionProfile$DataSeries)));
var $author$project$Chart$ConsumptionProfile$dataSeriesOrNotAvailableDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Chart$ConsumptionProfile$DataSeriesDesc, $author$project$Chart$ConsumptionProfile$dataSeriesDecoder),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Chart$ConsumptionProfile$NotAvailable,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))
		]));
var $author$project$Chart$ConsumptionProfile$continuousDataSeriesDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$ConsumptionProfile$ContinuousDataSeries,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'previous',
		$author$project$Chart$ConsumptionProfile$aggregatesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current',
			$author$project$Chart$ConsumptionProfile$aggregatesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'data_series',
				$author$project$Chart$ConsumptionProfile$dataSeriesOrNotAvailableDecoder,
				$elm$json$Json$Decode$succeed($author$project$Chart$ConsumptionProfile$ContinuousDataSeriesExtension)))));
var $author$project$Chart$ConsumptionProfile$DailySpecificConsumption = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$ConsumptionProfile$DailySpecificConsumptionExtension = F3(
	function (divisor, currentSpecificConsumptions, previousSpecificConsumptions) {
		return {g6: currentSpecificConsumptions, hh: divisor, ie: previousSpecificConsumptions};
	});
var $author$project$Divisor$AggregateAreaTypeDivisor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Divisor$StructuredDivisor = F3(
	function (id, name, unit) {
		return {hA: id, kt: name, i$: unit};
	});
var $author$project$Divisor$structuredDivisorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unit',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Divisor$StructuredDivisor))));
var $author$project$Divisor$aggregateAreaTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$AggregateAreaTypeDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $author$project$Divisor$DataSourceDivisor = function (a) {
	return {$: 0, a: a};
};
var $author$project$Divisor$dataSourceDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$DataSourceDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $author$project$Divisor$IndividualAreaTypeDivisor = function (a) {
	return {$: 3, a: a};
};
var $author$project$Divisor$individualAreaTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$IndividualAreaTypeDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $author$project$Divisor$PropertyDivisor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Divisor$propertyDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$PropertyDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $author$project$Divisor$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (tp) {
				switch (tp) {
					case 'data_source':
						return $author$project$Divisor$dataSourceDecoder;
					case 'property':
						return $author$project$Divisor$propertyDecoder;
					case 'aggregate_area_type':
						return $author$project$Divisor$aggregateAreaTypeDecoder;
					case 'individual_area_type':
						return $author$project$Divisor$individualAreaTypeDecoder;
					default:
						return $elm$json$Json$Decode$fail('unknown divisor type ' + tp);
				}
			},
			A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string))
		]));
var $author$project$Chart$ConsumptionProfile$dailySpecificConsumptionDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$ConsumptionProfile$DailySpecificConsumption,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'previous_specific_consumptions',
		$elm$json$Json$Decode$list($author$project$Chart$ConsumptionProfile$dataPointDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current_specific_consumptions',
			$elm$json$Json$Decode$list($author$project$Chart$ConsumptionProfile$dataPointDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'divisor',
				$author$project$Divisor$decoder,
				$elm$json$Json$Decode$succeed($author$project$Chart$ConsumptionProfile$DailySpecificConsumptionExtension)))));
var $author$project$Chart$ConsumptionProfile$extensionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'continuous_data_series':
				return $author$project$Chart$ConsumptionProfile$continuousDataSeriesDecoder;
			case 'daily_specific_consumption':
				return $author$project$Chart$ConsumptionProfile$dailySpecificConsumptionDecoder;
			default:
				return $elm$json$Json$Decode$fail('unsupported extension');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Chart$ConsumptionProfile$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'extensions',
	$elm$json$Json$Decode$list($author$project$Chart$ConsumptionProfile$extensionDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timeZone',
		$author$project$Types$timeZoneDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rangeDiffMinutes',
			$elm$json$Json$Decode$int,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'previous',
						$elm$json$Json$Decode$list($author$project$Chart$ConsumptionProfile$dataPointDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'current',
							$elm$json$Json$Decode$list($author$project$Chart$ConsumptionProfile$dataPointDecoder),
							$elm$json$Json$Decode$succeed($author$project$Chart$ConsumptionProfile$Model))))))));
var $author$project$Chart$Shared$KnownDimensions = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Chart$Shared$UnknownDimensions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$Shared$DimensionConfig = F2(
	function (width, height) {
		return {p: height, h: width};
	});
var $author$project$Chart$Shared$dimensionsDecoder = function (maybePrevious) {
	if ((!maybePrevious.$) && (maybePrevious.a.$ === 1)) {
		var _v1 = maybePrevious.a;
		var dimensionConfig = _v1.a;
		return $elm$json$Json$Decode$succeed(dimensionConfig);
	} else {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'height',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'width',
				$elm$json$Json$Decode$float,
				$elm$json$Json$Decode$succeed($author$project$Chart$Shared$DimensionConfig)));
	}
};
var $author$project$Chart$Shared$State = function (title) {
	return function (subtitle) {
		return function (data) {
			return function (tooltip) {
				return function (containerId) {
					return function (topLeftHtmlCoords) {
						return function (serverErrors) {
							return function (additionalInfo) {
								return function (drill) {
									return function (range) {
										return function (hourFilter) {
											return function (tableMode) {
												return function (timeZone) {
													return function (statHighlight) {
														return function (displaySecondaryStats) {
															return {gR: additionalInfo, dh: containerId, jA: data, fj: displaySecondaryStats, fl: drill, jZ: hourFilter, cO: range, iE: serverErrors, bR: statHighlight, iO: subtitle, iP: tableMode, iU: timeZone, d: title, K: tooltip, e$: topLeftHtmlCoords};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Chart$Shared$NoAdditionalInfo = {$: 0};
var $author$project$Chart$Shared$FinancialPerformance = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Chart$Shared$nonEmptyStringDecoder = A2(
	$elm$json$Json$Decode$map,
	function (s) {
		if (s === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(s);
		}
	},
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, path, valDecoder, fallback),
			decoder);
	});
var $author$project$Chart$Shared$financialPerformanceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'celkem',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$float),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['yAxis', '0', 'title']),
		$author$project$Chart$Shared$nonEmptyStringDecoder,
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Chart$Shared$FinancialPerformance)));
var $author$project$Chart$Shared$ReservedCapacity = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Chart$Shared$reservedCapacityDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['reserved_capacity', 'value']),
	$elm$json$Json$Decode$float,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['reserved_capacity', 'since']),
		$elm$json$Json$Decode$nullable($author$project$Enectiva$Conversion$dateDecoder),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Chart$Shared$ReservedCapacity)));
var $author$project$Chart$Shared$SubordinateConsumption = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Chart$Shared$SubordinateConsumptionDetail = F5(
	function (unit, consumption, consumptionPercent, production, productionPercent) {
		return {g2: consumption, g4: consumptionPercent, ii: production, ik: productionPercent, i$: unit};
	});
var $author$project$Chart$Shared$subordinateConsumptionDetailDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'production_percent',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'production',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'consumption_percent',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'consumption',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Chart$Shared$SubordinateConsumptionDetail))))));
var $author$project$Chart$Shared$subordinateConsumptionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['celkem', '1']),
	$elm$json$Json$Decode$maybe($author$project$Chart$Shared$subordinateConsumptionDetailDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['celkem', '0']),
		$author$project$Chart$Shared$subordinateConsumptionDetailDecoder,
		$elm$json$Json$Decode$succeed($author$project$Chart$Shared$SubordinateConsumption)));
var $author$project$Chart$Shared$additionalInfoDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Chart$Shared$financialPerformanceDecoder,
			$author$project$Chart$Shared$subordinateConsumptionDecoder,
			$author$project$Chart$Shared$reservedCapacityDecoder,
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$NoAdditionalInfo)
		]));
var $gampleman$elm_visualization$Transition$FromBeginning = 1;
var $gampleman$elm_visualization$Transition$Transition = $elm$core$Basics$identity;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $gampleman$elm_visualization$Transition$easeFor = F3(
	function (t, _v0, interpolator) {
		var easing = _v0;
		return {
			ct: 0,
			es: easing,
			b8: interpolator,
			dP: 1,
			aU: 1,
			al: 0,
			bq: $elm$core$Basics$abs(t)
		};
	});
var $gampleman$elm_visualization$Transition$Easing = $elm$core$Basics$identity;
var $gampleman$elm_visualization$Transition$easeLinear = $elm$core$Basics$identity;
var $gampleman$elm_visualization$Transition$constant = function (val) {
	return A3(
		$gampleman$elm_visualization$Transition$easeFor,
		0,
		$gampleman$elm_visualization$Transition$easeLinear,
		$elm$core$Basics$always(val));
};
var $author$project$Chart$Shared$containerIdDecoder = function (maybeId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$string,
				function () {
				if (!maybeId.$) {
					var hardcodedId = maybeId.a;
					return $elm$json$Json$Decode$succeed(hardcodedId);
				} else {
					return $elm$json$Json$Decode$fail('no hardcoded ID provided');
				}
			}()
			]));
};
var $author$project$Chart$Shared$Continuous = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Visibility$Visible = function (a) {
	return {$: 0, a: a};
};
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$Chart$Shared$fallbackColor = A3($avh4$elm_color$Color$rgb255, 70, 70, 70);
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Chart$Shared$colorByIndex = F2(
	function (idx, palette) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Chart$Shared$fallbackColor,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$getAt,
					A2(
						$elm$core$Basics$modBy,
						$elm$core$List$length(palette),
						idx),
					palette)));
	});
var $author$project$Chart$Shared$Blue = 0;
var $author$project$Chart$Shared$Green = 1;
var $author$project$Chart$Shared$Orange = 2;
var $author$project$Chart$Shared$Yellow = 3;
var $author$project$Chart$Shared$completePalette = _List_fromArray(
	[
		_Utils_Tuple2(
		0,
		A3($avh4$elm_color$Color$rgb255, 5, 141, 199)),
		_Utils_Tuple2(
		1,
		A3($avh4$elm_color$Color$rgb255, 80, 180, 50)),
		_Utils_Tuple2(
		2,
		A3($avh4$elm_color$Color$rgb255, 237, 86, 27)),
		_Utils_Tuple2(
		3,
		A3($avh4$elm_color$Color$rgb255, 221, 223, 0)),
		_Utils_Tuple2(
		0,
		A3($avh4$elm_color$Color$rgb255, 36, 203, 229)),
		_Utils_Tuple2(
		1,
		A3($avh4$elm_color$Color$rgb255, 100, 229, 114)),
		_Utils_Tuple2(
		2,
		A3($avh4$elm_color$Color$rgb255, 255, 150, 85)),
		_Utils_Tuple2(
		3,
		A3($avh4$elm_color$Color$rgb255, 255, 242, 99)),
		_Utils_Tuple2(
		1,
		A3($avh4$elm_color$Color$rgb255, 106, 249, 196))
	]);
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Chart$Shared$color = F2(
	function (preference, idx) {
		switch (preference.$) {
			case 1:
				var clr = preference.a;
				return clr;
			case 0:
				return A2($author$project$Chart$Shared$colorByIndex, idx, $author$project$Chart$Shared$completePalette);
			case 2:
				var shade = preference.a;
				return A2(
					$author$project$Chart$Shared$colorByIndex,
					idx,
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var s = _v1.a;
							return _Utils_eq(s, shade);
						},
						$author$project$Chart$Shared$completePalette));
			default:
				var shade = preference.a;
				return A2(
					$author$project$Chart$Shared$colorByIndex,
					idx,
					A2(
						$elm$core$List$filter,
						function (_v2) {
							var s = _v2.a;
							return !_Utils_eq(s, shade);
						},
						$author$project$Chart$Shared$completePalette));
		}
	});
var $author$project$Chart$Shared$PartiallyDecodedContinuousTimeSeries = F4(
	function (series, yAxisIndex, temporalShift, colorPreference) {
		return {aC: colorPreference, iD: series, iR: temporalShift, i8: yAxisIndex};
	});
var $author$project$Chart$Shared$ExactColor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$NoColorPreference = {$: 0};
var $author$project$Chart$Shared$NotShade = function (a) {
	return {$: 3, a: a};
};
var $author$project$Chart$Shared$OnlyShade = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Char$toLower = _Char_toLower;
var $author$project$ColorHack$hexToInt = function (_char) {
	var _v0 = $elm$core$Char$toLower(_char);
	switch (_v0) {
		case '0':
			return $elm$core$Maybe$Just(0);
		case '1':
			return $elm$core$Maybe$Just(1);
		case '2':
			return $elm$core$Maybe$Just(2);
		case '3':
			return $elm$core$Maybe$Just(3);
		case '4':
			return $elm$core$Maybe$Just(4);
		case '5':
			return $elm$core$Maybe$Just(5);
		case '6':
			return $elm$core$Maybe$Just(6);
		case '7':
			return $elm$core$Maybe$Just(7);
		case '8':
			return $elm$core$Maybe$Just(8);
		case '9':
			return $elm$core$Maybe$Just(9);
		case 'a':
			return $elm$core$Maybe$Just(10);
		case 'b':
			return $elm$core$Maybe$Just(11);
		case 'c':
			return $elm$core$Maybe$Just(12);
		case 'd':
			return $elm$core$Maybe$Just(13);
		case 'e':
			return $elm$core$Maybe$Just(14);
		case 'f':
			return $elm$core$Maybe$Just(15);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $author$project$ColorHack$hex2ToInt = F2(
	function (c1, c2) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (v1, v2) {
					return (v1 << 4) + v2;
				}),
			$author$project$ColorHack$hexToInt(c1),
			$author$project$ColorHack$hexToInt(c2));
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $author$project$ColorHack$fromHex8 = F4(
	function (_v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		return A5(
			$elm$core$Maybe$map4,
			F4(
				function (r, g, b, a) {
					return A4($avh4$elm_color$Color$rgba, r / 255, g / 255, b / 255, a / 255);
				}),
			A2($author$project$ColorHack$hex2ToInt, r1, r2),
			A2($author$project$ColorHack$hex2ToInt, g1, g2),
			A2($author$project$ColorHack$hex2ToInt, b1, b2),
			A2($author$project$ColorHack$hex2ToInt, a1, a2));
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$ColorHack$fromHex = function (hexString) {
	var _v0 = $elm$core$String$toList(hexString);
	_v0$8:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v4 = _v0.b;
				var g = _v4.a;
				var _v5 = _v4.b;
				var b = _v5.a;
				return A4(
					$author$project$ColorHack$fromHex8,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					if ('#' === _v0.a) {
						var _v1 = _v0.b;
						var r = _v1.a;
						var _v2 = _v1.b;
						var g = _v2.a;
						var _v3 = _v2.b;
						var b = _v3.a;
						return A4(
							$author$project$ColorHack$fromHex8,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2('f', 'f'));
					} else {
						var r = _v0.a;
						var _v10 = _v0.b;
						var g = _v10.a;
						var _v11 = _v10.b;
						var b = _v11.a;
						var _v12 = _v11.b;
						var a = _v12.a;
						return A4(
							$author$project$ColorHack$fromHex8,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					}
				} else {
					if (!_v0.b.b.b.b.b.b) {
						if ('#' === _v0.a) {
							var _v6 = _v0.b;
							var r = _v6.a;
							var _v7 = _v6.b;
							var g = _v7.a;
							var _v8 = _v7.b;
							var b = _v8.a;
							var _v9 = _v8.b;
							var a = _v9.a;
							return A4(
								$author$project$ColorHack$fromHex8,
								_Utils_Tuple2(r, r),
								_Utils_Tuple2(g, g),
								_Utils_Tuple2(b, b),
								_Utils_Tuple2(a, a));
						} else {
							break _v0$8;
						}
					} else {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v19 = _v0.b;
							var r2 = _v19.a;
							var _v20 = _v19.b;
							var g1 = _v20.a;
							var _v21 = _v20.b;
							var g2 = _v21.a;
							var _v22 = _v21.b;
							var b1 = _v22.a;
							var _v23 = _v22.b;
							var b2 = _v23.a;
							return A4(
								$author$project$ColorHack$fromHex8,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (!_v0.b.b.b.b.b.b.b.b) {
								if ('#' === _v0.a) {
									var _v13 = _v0.b;
									var r1 = _v13.a;
									var _v14 = _v13.b;
									var r2 = _v14.a;
									var _v15 = _v14.b;
									var g1 = _v15.a;
									var _v16 = _v15.b;
									var g2 = _v16.a;
									var _v17 = _v16.b;
									var b1 = _v17.a;
									var _v18 = _v17.b;
									var b2 = _v18.a;
									return A4(
										$author$project$ColorHack$fromHex8,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2('f', 'f'));
								} else {
									break _v0$8;
								}
							} else {
								if (_v0.b.b.b.b.b.b.b.b.b) {
									if (('#' === _v0.a) && (!_v0.b.b.b.b.b.b.b.b.b.b)) {
										var _v24 = _v0.b;
										var r1 = _v24.a;
										var _v25 = _v24.b;
										var r2 = _v25.a;
										var _v26 = _v25.b;
										var g1 = _v26.a;
										var _v27 = _v26.b;
										var g2 = _v27.a;
										var _v28 = _v27.b;
										var b1 = _v28.a;
										var _v29 = _v28.b;
										var b2 = _v29.a;
										var _v30 = _v29.b;
										var a1 = _v30.a;
										var _v31 = _v30.b;
										var a2 = _v31.a;
										return A4(
											$author$project$ColorHack$fromHex8,
											_Utils_Tuple2(r1, r2),
											_Utils_Tuple2(g1, g2),
											_Utils_Tuple2(b1, b2),
											_Utils_Tuple2(a1, a2));
									} else {
										break _v0$8;
									}
								} else {
									var r1 = _v0.a;
									var _v32 = _v0.b;
									var r2 = _v32.a;
									var _v33 = _v32.b;
									var g1 = _v33.a;
									var _v34 = _v33.b;
									var g2 = _v34.a;
									var _v35 = _v34.b;
									var b1 = _v35.a;
									var _v36 = _v35.b;
									var b2 = _v36.a;
									var _v37 = _v36.b;
									var a1 = _v37.a;
									var _v38 = _v37.b;
									var a2 = _v38.a;
									return A4(
										$author$project$ColorHack$fromHex8,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								}
							}
						}
					}
				}
			}
		} else {
			break _v0$8;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Chart$Shared$shadeFromStr = function (str) {
	switch (str) {
		case 'blue':
			return $elm$core$Result$Ok(0);
		case 'green':
			return $elm$core$Result$Ok(1);
		case 'orange':
			return $elm$core$Result$Ok(2);
		case 'yellow':
			return $elm$core$Result$Ok(3);
		default:
			return $elm$core$Result$Err('unknown shade ' + str);
	}
};
var $author$project$Chart$Shared$colorPreferenceFieldDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (str) {
				var _v0 = $author$project$ColorHack$fromHex(str);
				if (!_v0.$) {
					var c = _v0.a;
					return $elm$json$Json$Decode$succeed(
						$author$project$Chart$Shared$ExactColor(c));
				} else {
					if (A2($elm$core$String$startsWith, '!', str)) {
						var _v1 = $author$project$Chart$Shared$shadeFromStr(
							A3(
								$elm$core$String$slice,
								1,
								$elm$core$String$length(str),
								str));
						if (!_v1.$) {
							var shade = _v1.a;
							return $elm$json$Json$Decode$succeed(
								$author$project$Chart$Shared$NotShade(shade));
						} else {
							var err = _v1.a;
							return $elm$json$Json$Decode$fail(err);
						}
					} else {
						var _v2 = $author$project$Chart$Shared$shadeFromStr(str);
						if (!_v2.$) {
							var shade = _v2.a;
							return $elm$json$Json$Decode$succeed(
								$author$project$Chart$Shared$OnlyShade(shade));
						} else {
							var err = _v2.a;
							return $elm$json$Json$Decode$fail(err);
						}
					}
				}
			},
			A2($elm$json$Json$Decode$field, 'color', $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$NoColorPreference)
		]));
var $author$project$Chart$Shared$ContinuousTimeDataPoint = F3(
	function (time, value, label) {
		return {fF: label, bT: time, aW: value};
	});
var $author$project$Chart$Shared$labelledContinuousTimeDataPointDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'label',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'time',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$ContinuousTimeDataPoint))));
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Chart$Shared$simpleContinuousTimeDataPointDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$index,
			1,
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$index,
				0,
				A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$ContinuousTimeDataPoint))));
var $author$project$Chart$Shared$continuousTimeDataPointDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Chart$Shared$simpleContinuousTimeDataPointDecoder, $author$project$Chart$Shared$labelledContinuousTimeDataPointDecoder]));
var $author$project$Chart$Shared$NoShift = 1;
var $author$project$Chart$Shared$PreviousYear = 0;
var $author$project$Chart$Shared$temporalShiftDecoder = A2(
	$elm$json$Json$Decode$map,
	function (yAxisIndex) {
		return (yAxisIndex === 1) ? 0 : 1;
	},
	A2($elm$json$Json$Decode$field, 'xAxis', $elm$json$Json$Decode$int));
var $author$project$Chart$Shared$TimeSeriesTmp = F7(
	function (name, data, markPoints, curve, colorPreference, samplingRatio, stats) {
		return {aC: colorPreference, bi: curve, jA: data, a1: markPoints, kt: name, a6: samplingRatio, V: stats};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Chart$Shared$StepCurve = 0;
var $author$project$Chart$Shared$stepDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (step) {
		return step ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('this is definitely not a step line');
	},
	$elm$json$Json$Decode$bool);
var $author$project$Chart$Shared$MonotoneInX = 1;
var $author$project$Chart$Shared$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (tp) {
		switch (tp) {
			case 'spline':
				return $elm$json$Json$Decode$succeed(1);
			case 'area':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('unknown curve type ' + tp);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Chart$Shared$curveDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'step', $author$project$Chart$Shared$stepDecoder),
			A2($elm$json$Json$Decode$field, 'type', $author$project$Chart$Shared$typeDecoder)
		]));
var $author$project$Chart$Shared$Stat = F3(
	function (tp, name, value) {
		return {kt: name, c4: tp, aW: value};
	});
var $author$project$Chart$Shared$DayHourAverage = {$: 8};
var $author$project$Chart$Shared$Diff = {$: 2};
var $author$project$Chart$Shared$Max = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$Shared$Min = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$NightHourAverage = {$: 7};
var $author$project$Chart$Shared$NonWorkDayAverage = {$: 6};
var $author$project$Chart$Shared$OverallAverage = {$: 3};
var $author$project$Chart$Shared$Sum = {$: 4};
var $author$project$Chart$Shared$WorkDayAverage = {$: 5};
var $author$project$Chart$Shared$statTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'min':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Chart$Shared$Min,
					A2(
						$elm$json$Json$Decode$field,
						'xs',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
			case 'max':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Chart$Shared$Max,
					A2(
						$elm$json$Json$Decode$field,
						'xs',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
			case 'overall_average':
				return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$OverallAverage);
			case 'non_work_day_avg':
				return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$NonWorkDayAverage);
			case 'work_day_avg':
				return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$WorkDayAverage);
			case 'night_avg':
				return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$NightHourAverage);
			case 'day_avg':
				return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$DayHourAverage);
			case 'sum':
				return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$Sum);
			case 'diff':
				return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$Diff);
			default:
				return $elm$json$Json$Decode$fail('unknown stat type ' + str);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Chart$Shared$statDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Chart$Shared$statTypeDecoder,
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$Stat))));
var $author$project$Chart$Shared$timeSeriesDecoder = function (dataPointDecoder) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'stats',
		$elm$json$Json$Decode$list($author$project$Chart$Shared$statDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sampling',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
			$elm$core$Maybe$Nothing,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Chart$Shared$colorPreferenceFieldDecoder,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Chart$Shared$curveDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'marker',
						$elm$json$Json$Decode$bool,
						true,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'data',
							$elm$json$Json$Decode$list(dataPointDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Chart$Shared$TimeSeriesTmp))))))));
};
var $author$project$Chart$Shared$continuousTimeSeriesWithAxesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Chart$Shared$colorPreferenceFieldDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Chart$Shared$temporalShiftDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'yAxis',
			$elm$json$Json$Decode$int,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Chart$Shared$timeSeriesDecoder($author$project$Chart$Shared$continuousTimeDataPointDecoder),
				$elm$json$Json$Decode$succeed($author$project$Chart$Shared$PartiallyDecodedContinuousTimeSeries)))));
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Chart$Shared$DataMinOrZero = {$: 0};
var $author$project$Chart$Shared$Floats = 0;
var $author$project$Chart$Shared$packYAxes = F2(
	function (tagger, byYAxisData) {
		if (!byYAxisData.b) {
			return A2(
				tagger,
				{
					jA: _List_Nil,
					o: {f_: 0, cO: $author$project$Chart$Shared$DataMinOrZero, d: $elm$core$Maybe$Nothing}
				},
				$elm$core$Maybe$Nothing);
		} else {
			if (!byYAxisData.b.b) {
				var primary = byYAxisData.a;
				return A2(tagger, primary, $elm$core$Maybe$Nothing);
			} else {
				var primary = byYAxisData.a;
				var _v1 = byYAxisData.b;
				var secondary = _v1.a;
				return A2(
					tagger,
					primary,
					$elm$core$Maybe$Just(secondary));
			}
		}
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Chart$Shared$YAxis = F3(
	function (title, range, numberGroup) {
		return {f_: numberGroup, cO: range, d: title};
	});
var $author$project$Chart$Shared$Integers = 1;
var $author$project$Chart$Shared$numberGroupDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (allowDecimals) {
		return allowDecimals ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$succeed(1);
	},
	$elm$json$Json$Decode$bool);
var $author$project$Chart$Shared$Dynamic = {$: 2};
var $author$project$Chart$Shared$FixedMinimum = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$yAxisRangeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Chart$Shared$FixedMinimum, $elm$json$Json$Decode$float),
			A2(
			$elm$json$Json$Decode$andThen,
			function (s) {
				if (s === 'dynamic') {
					return $elm$json$Json$Decode$succeed($author$project$Chart$Shared$Dynamic);
				} else {
					return $elm$json$Json$Decode$fail(s);
				}
			},
			$elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$DataMinOrZero)
		]));
var $author$project$Chart$Shared$yAxisDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'allowDecimals',
	$author$project$Chart$Shared$numberGroupDecoder,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'min',
		$author$project$Chart$Shared$yAxisRangeDecoder,
		$author$project$Chart$Shared$DataMinOrZero,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'title',
			$author$project$Chart$Shared$nonEmptyStringDecoder,
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$YAxis))));
var $author$project$Chart$Shared$continuousDataDecoder = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (seriesWithAxes, now, yAxes) {
			var indexedYAxes = $elm$core$Dict$fromList(
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, yAxes));
			return A2(
				$author$project$Chart$Shared$packYAxes,
				$author$project$Chart$Shared$Continuous(now),
				A2(
					$elm$core$List$filterMap,
					function (_v4) {
						var yAxisIndex = _v4.a;
						var series = _v4.b;
						var _v5 = A2($elm$core$Dict$get, yAxisIndex, indexedYAxes);
						if (_v5.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var yAxis = _v5.a;
							return $elm$core$Maybe$Just(
								{jA: series, o: yAxis});
						}
					},
					A2(
						$elm$core$List$map,
						function (_v3) {
							var head = _v3.a;
							var tail = _v3.b;
							return _Utils_Tuple2(
								head.b,
								A2(
									$elm$core$List$cons,
									head.a,
									A2($elm$core$List$map, $elm$core$Tuple$first, tail)));
						},
						A2(
							$elm_community$list_extra$List$Extra$groupWhile,
							F2(
								function (_v1, _v2) {
									var yAxisIndexA = _v1.b;
									var yAxisIndexB = _v2.b;
									return _Utils_eq(yAxisIndexA, yAxisIndexB);
								}),
							A2(
								$elm$core$List$sortBy,
								$elm$core$Tuple$second,
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, _v0) {
											var series = _v0.iD;
											var yAxisIndex = _v0.i8;
											var temporalShift = _v0.iR;
											var colorPreference = _v0.aC;
											var s = {
												f: A2($author$project$Chart$Shared$color, colorPreference, index),
												bi: series.bi,
												jA: series.jA,
												r: index,
												a1: series.a1,
												kt: series.kt,
												a6: series.a6,
												V: _List_Nil
											};
											return _Utils_Tuple2(
												$author$project$Visibility$Visible(
													_Utils_Tuple2(s, temporalShift)),
												yAxisIndex);
										}),
									seriesWithAxes))))));
		}),
	A2(
		$elm$json$Json$Decode$field,
		'series',
		$elm$json$Json$Decode$list($author$project$Chart$Shared$continuousTimeSeriesWithAxesDecoder)),
	A2($elm$json$Json$Decode$field, 'now', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['yAxis']),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Chart$Shared$yAxisDecoder),
					A2($elm$json$Json$Decode$map, $elm$core$List$singleton, $author$project$Chart$Shared$yAxisDecoder)
				]))));
var $author$project$Chart$Shared$BarGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$FakeLine = function (a) {
	return {$: 2, a: a};
};
var $author$project$Chart$Shared$SingleBar = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$Shared$VerticalBars = 0;
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Chart$Shared$addCategoriesToATemporalSeries = F2(
	function (categories, ts) {
		var name = ts.kt;
		var data = ts.jA;
		var markPoints = ts.a1;
		var curve = ts.bi;
		var index = ts.r;
		var samplingRatio = ts.a6;
		return {
			f: ts.f,
			bi: curve,
			jA: A2(
				$elm$core$List$map,
				function (_v0) {
					var category = _v0.a;
					var _v1 = _v0.b;
					var value = _v1.a;
					var preformattedLabel = _v1.b;
					return {aN: category, bL: preformattedLabel, aW: value};
				},
				A2($elm_community$list_extra$List$Extra$zip, categories, data)),
			r: index,
			a1: markPoints,
			kt: name,
			a6: samplingRatio,
			V: ts.V
		};
	});
var $author$project$Visibility$Hidden = function (a) {
	return {$: 1, a: a};
};
var $author$project$Visibility$map = F2(
	function (fn, optional) {
		if (!optional.$) {
			var a = optional.a;
			return $author$project$Visibility$Visible(
				fn(a));
		} else {
			var a = optional.a;
			return $author$project$Visibility$Hidden(
				fn(a));
		}
	});
var $author$project$Chart$Shared$addCategoriesToTemporalSeries = F2(
	function (categories, series) {
		return A2(
			$elm$core$List$map,
			$author$project$Visibility$map(
				$author$project$Chart$Shared$addCategoriesToATemporalSeries(categories)),
			series);
	});
var $author$project$Chart$Shared$Bar = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Chart$Shared$Temporal = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		_List_Nil,
		alist);
};
var $pzp1997$assoc_list$AssocList$map = F2(
	function (alter, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var key = _v1.a;
				var value = _v1.b;
				return _Utils_Tuple2(
					key,
					A2(alter, key, value));
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$update = F3(
	function (targetKey, alter, dict) {
		var alist = dict;
		var maybeValue = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!maybeValue.$) {
			var _v1 = alter(maybeValue);
			if (!_v1.$) {
				var alteredValue = _v1.a;
				return A2(
					$elm$core$List$map,
					function (entry) {
						var key = entry.a;
						return _Utils_eq(key, targetKey) ? _Utils_Tuple2(targetKey, alteredValue) : entry;
					},
					alist);
			} else {
				return A2($pzp1997$assoc_list$AssocList$remove, targetKey, dict);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var alteredValue = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(targetKey, alteredValue),
					alist);
			} else {
				return dict;
			}
		}
	});
var $pzp1997$assoc_list$AssocList$values = function (_v0) {
	var alist = _v0;
	return A2($elm$core$List$map, $elm$core$Tuple$second, alist);
};
var $author$project$Chart$Shared$addIndexAndColorToPartialSeries = function (series) {
	var seriesWithColorPreference = A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, ps) {
				var preference = function () {
					if (!ps.$) {
						var colorPreference = ps.d.aC;
						return colorPreference;
					} else {
						var colorPreference = ps.d.aC;
						return colorPreference;
					}
				}();
				return _Utils_Tuple2(
					preference,
					_Utils_Tuple2(ps, index));
			}),
		series);
	var emptyListByPreference = $pzp1997$assoc_list$AssocList$fromList(
		A2(
			$elm$core$List$map,
			function (p) {
				return _Utils_Tuple2(p, _List_Nil);
			},
			A2($elm$core$List$map, $elm$core$Tuple$first, seriesWithColorPreference)));
	var accumulateSeriesByPreference = F2(
		function (_v4, dict) {
			var p = _v4.a;
			var indexedSeries = _v4.b;
			return A3(
				$pzp1997$assoc_list$AssocList$update,
				p,
				$elm$core$Maybe$map(
					function (list) {
						return A2($elm$core$List$cons, indexedSeries, list);
					}),
				dict);
		});
	return A2(
		$elm$core$List$sortBy,
		function (ps) {
			if (!ps.$) {
				var index = ps.d.r;
				return index;
			} else {
				var index = ps.d.r;
				return index;
			}
		},
		$elm$core$List$concat(
			$pzp1997$assoc_list$AssocList$values(
				A2(
					$pzp1997$assoc_list$AssocList$map,
					F2(
						function (_v0, list) {
							return A2(
								$elm$core$List$indexedMap,
								F2(
									function (indexWithinPreference, _v1) {
										var ps = _v1.a;
										var overallIndex = _v1.b;
										if (!ps.$) {
											var yAxisIndex = ps.a;
											var visible = ps.b;
											var stack = ps.c;
											var name = ps.d.kt;
											var data = ps.d.jA;
											var xAxis = ps.d.bZ;
											var colorPreference = ps.d.aC;
											var stats = ps.d.V;
											return A4(
												$author$project$Chart$Shared$Bar,
												yAxisIndex,
												visible,
												stack,
												{
													f: A2($author$project$Chart$Shared$color, colorPreference, indexWithinPreference),
													jA: data,
													r: overallIndex,
													kt: name,
													V: stats,
													bZ: xAxis
												});
										} else {
											var yAxisIndex = ps.a;
											var visible = ps.b;
											var stack = ps.c;
											var name = ps.d.kt;
											var data = ps.d.jA;
											var markPoints = ps.d.a1;
											var curve = ps.d.bi;
											var colorPreference = ps.d.aC;
											var samplingRatio = ps.d.a6;
											var stats = ps.d.V;
											return A4(
												$author$project$Chart$Shared$Temporal,
												yAxisIndex,
												visible,
												stack,
												{
													f: A2($author$project$Chart$Shared$color, colorPreference, indexWithinPreference),
													bi: curve,
													jA: data,
													r: overallIndex,
													a1: markPoints,
													kt: name,
													a6: samplingRatio,
													V: stats
												});
										}
									}),
								$elm$core$List$reverse(list));
						}),
					A3($elm$core$List$foldl, accumulateSeriesByPreference, emptyListByPreference, seriesWithColorPreference)))));
};
var $author$project$Chart$Shared$HorizontalBars = 1;
var $author$project$Chart$Shared$barsOrientationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'vertical_bars':
				return $elm$json$Json$Decode$succeed(0);
			case 'horizontal_bars':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('unknown bars orientation ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Chart$Shared$categoricalXAxisDecoder = $elm$json$Json$Decode$list($elm$json$Json$Decode$string);
var $author$project$Chart$Shared$isStackedDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (str) {
				if (str === 'normal') {
					return $elm$json$Json$Decode$succeed(true);
				} else {
					return $elm$json$Json$Decode$fail('unknown stacking mode ' + str);
				}
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['plotOptions', 'column', 'stacking']),
				$elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed(false)
		]));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Chart$Shared$nonEmptyListDecoder = function (d) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (list) {
			if (!list.b) {
				return $elm$json$Json$Decode$fail('empty list');
			} else {
				var head = list.a;
				var tail = list.b;
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(head, tail));
			}
		},
		$elm$json$Json$Decode$list(d));
};
var $author$project$Chart$Shared$CategoricalSeriesTmp = F5(
	function (name, data, colorPreference, xAxis, stats) {
		return {aC: colorPreference, jA: data, kt: name, V: stats, bZ: xAxis};
	});
var $author$project$Chart$Shared$onlyValueDataPointDecoder = A2(
	$elm$json$Json$Decode$map,
	function (value) {
		return {aC: $author$project$Chart$Shared$NoColorPreference, aQ: $elm$core$Maybe$Nothing, bL: $elm$core$Maybe$Nothing, e_: $elm$core$Maybe$Nothing, aW: value};
	},
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float));
var $author$project$Chart$Shared$CategoricalDataPoint = F5(
	function (value, colorPreference, tooltipSuffix, preformattedLabel, link) {
		return {aC: colorPreference, aQ: link, bL: preformattedLabel, e_: tooltipSuffix, aW: value};
	});
var $author$project$Chart$Shared$structuredDataPointDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'link',
	$author$project$Chart$Shared$nonEmptyStringDecoder,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'label',
		$author$project$Chart$Shared$nonEmptyStringDecoder,
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			$author$project$Chart$Shared$nonEmptyStringDecoder,
			$elm$core$Maybe$Nothing,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Chart$Shared$colorPreferenceFieldDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'y',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
					$elm$json$Json$Decode$succeed($author$project$Chart$Shared$CategoricalDataPoint))))));
var $author$project$Chart$Shared$dataPointsDecoder = $elm$json$Json$Decode$list(
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[$author$project$Chart$Shared$structuredDataPointDecoder, $author$project$Chart$Shared$onlyValueDataPointDecoder])));
var $author$project$Chart$Shared$categoricalSeriesDecoder = function (xAxisDict) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'stats',
		$elm$json$Json$Decode$list($author$project$Chart$Shared$statDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'xAxis',
			A2(
				$elm$json$Json$Decode$andThen,
				function (idx) {
					var _v0 = A2($elm$core$Dict$get, idx, xAxisDict);
					if (_v0.$ === 1) {
						return $elm$json$Json$Decode$fail(
							'xAxis ' + ($elm$core$String$fromInt(idx) + ' not found'));
					} else {
						var xAxis = _v0.a;
						return $elm$json$Json$Decode$succeed(xAxis);
					}
				},
				$elm$json$Json$Decode$int),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Chart$Shared$colorPreferenceFieldDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'data',
					$author$project$Chart$Shared$dataPointsDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Chart$Shared$CategoricalSeriesTmp))))));
};
var $author$project$Chart$Shared$discreteTimeSeriesDecoder = $author$project$Chart$Shared$timeSeriesDecoder(
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'y',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)
				])),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'label',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
				]))));
var $author$project$Chart$Shared$inverseBoolDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$not, $elm$json$Json$Decode$bool);
var $author$project$Chart$Shared$partiallyDecodeSeriesDecoder = function (xAxisDict) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Chart$Shared$discreteTimeSeriesDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'stack',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'hidden',
						$author$project$Chart$Shared$inverseBoolDecoder,
						true,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'yAxis',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Chart$Shared$Temporal))))),
				A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Chart$Shared$categoricalSeriesDecoder(xAxisDict),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'stack',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'hidden',
						$author$project$Chart$Shared$inverseBoolDecoder,
						true,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'yAxis',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Chart$Shared$Bar)))))
			]));
};
var $author$project$Chart$Shared$Discrete = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Visibility$raiseFromBool = F2(
	function (bool, val) {
		return bool ? $author$project$Visibility$Visible(val) : $author$project$Visibility$Hidden(val);
	});
var $author$project$Chart$Shared$finalizeSeries = F3(
	function (barFn, timeFn, partialSeries) {
		var lineBasedData = timeFn(
			A2(
				$elm$core$List$filterMap,
				function (ps) {
					if (ps.$ === 1) {
						var visible = ps.b;
						var ts = ps.d;
						return $elm$core$Maybe$Just(
							A2($author$project$Visibility$raiseFromBool, visible, ts));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				partialSeries));
		var barBasedData = A2(
			$elm$core$List$concatMap,
			barFn,
			A2(
				$elm$core$List$map,
				function (_v3) {
					var head = _v3.a;
					var tail = _v3.b;
					return A2(
						$elm$core$List$cons,
						head.b,
						A2($elm$core$List$map, $elm$core$Tuple$second, tail));
				},
				A2(
					$elm_community$list_extra$List$Extra$groupWhile,
					F2(
						function (_v1, _v2) {
							var stackA = _v1.a;
							var stackB = _v2.a;
							return _Utils_eq(stackA, stackB);
						}),
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Maybe$withDefault('never-used-stack-name-just-for-sorting')),
						A2(
							$elm$core$List$filterMap,
							function (ps) {
								if (!ps.$) {
									var visible = ps.b;
									var stack = ps.c;
									var bs = ps.d;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											stack,
											A2($author$project$Visibility$raiseFromBool, visible, bs)));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							partialSeries)))));
		return _Utils_ap(barBasedData, lineBasedData);
	});
var $author$project$Chart$Shared$partialSeriesYAxisIndex = function (ps) {
	if (!ps.$) {
		var yAxisIndex = ps.a;
		return yAxisIndex;
	} else {
		var yAxisIndex = ps.a;
		return yAxisIndex;
	}
};
var $author$project$Chart$Shared$splitPartialSeries = F6(
	function (yAxes, barsOrientation, categories, barFn, timeFn, partialSeries) {
		var indexedYAxes = $elm$core$Dict$fromList(
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, yAxes));
		return A2(
			$author$project$Chart$Shared$packYAxes,
			A2($author$project$Chart$Shared$Discrete, barsOrientation, categories),
			A2(
				$elm$core$List$filterMap,
				function (_v1) {
					var yAxisIndex = _v1.a;
					var series = _v1.b;
					var _v2 = A2($elm$core$Dict$get, yAxisIndex, indexedYAxes);
					if (_v2.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var yAxis = _v2.a;
						return $elm$core$Maybe$Just(
							{
								jA: A3($author$project$Chart$Shared$finalizeSeries, barFn, timeFn, series),
								o: yAxis
							});
					}
				},
				A2(
					$elm$core$List$map,
					function (_v0) {
						var head = _v0.a;
						var tail = _v0.b;
						return _Utils_Tuple2(
							$author$project$Chart$Shared$partialSeriesYAxisIndex(head),
							A2($elm$core$List$cons, head, tail));
					},
					A2(
						$elm_community$list_extra$List$Extra$groupWhile,
						F2(
							function (ps1, ps2) {
								return _Utils_eq(
									$author$project$Chart$Shared$partialSeriesYAxisIndex(ps1),
									$author$project$Chart$Shared$partialSeriesYAxisIndex(ps2));
							}),
						A2($elm$core$List$sortBy, $author$project$Chart$Shared$partialSeriesYAxisIndex, partialSeries)))));
	});
var $author$project$Chart$Shared$discreteDataDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var xAxes = _v0.i6;
		var isStacked = _v0.hJ;
		var barsOrientation = _v0.gW;
		var yAxes = _v0.i7;
		var _v1 = xAxes;
		var primaryXAxis = _v1.a;
		var otherXAxes = _v1.b;
		var xAxisDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(0, primaryXAxis),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, a) {
							return _Utils_Tuple2(i + 1, a);
						}),
					otherXAxes)));
		return A2(
			$elm$json$Json$Decode$map,
			A5(
				$author$project$Chart$Shared$splitPartialSeries,
				yAxes,
				barsOrientation,
				primaryXAxis,
				function (barSeries) {
					return isStacked ? $elm$core$List$singleton(
						$author$project$Chart$Shared$BarGroup(barSeries)) : A2($elm$core$List$map, $author$project$Chart$Shared$SingleBar, barSeries);
				},
				function (timeSeries) {
					return A2(
						$elm$core$List$map,
						$author$project$Chart$Shared$FakeLine,
						A2($author$project$Chart$Shared$addCategoriesToTemporalSeries, primaryXAxis, timeSeries));
				}),
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Chart$Shared$addIndexAndColorToPartialSeries,
				A2(
					$elm$json$Json$Decode$field,
					'series',
					$elm$json$Json$Decode$list(
						$author$project$Chart$Shared$partiallyDecodeSeriesDecoder(xAxisDict)))));
	},
	A5(
		$elm$json$Json$Decode$map4,
		F4(
			function (xAxes, isStacked, barsOrientation, yAxes) {
				return {gW: barsOrientation, hJ: isStacked, i6: xAxes, i7: yAxes};
			}),
		A2(
			$elm$json$Json$Decode$field,
			'xAxis',
			$author$project$Chart$Shared$nonEmptyListDecoder($author$project$Chart$Shared$categoricalXAxisDecoder)),
		$author$project$Chart$Shared$isStackedDecoder,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'barsOrientation', $author$project$Chart$Shared$barsOrientationDecoder),
					$elm$json$Json$Decode$succeed(0)
				])),
		A2(
			$elm$json$Json$Decode$field,
			'yAxis',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$list($author$project$Chart$Shared$yAxisDecoder),
						A2($elm$json$Json$Decode$map, $elm$core$List$singleton, $author$project$Chart$Shared$yAxisDecoder)
					])))));
var $author$project$Chart$Shared$Pie = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Chart$Shared$Slice = F3(
	function (name, value, color) {
		return {f: color, kt: name, aW: value};
	});
var $author$project$Chart$Shared$sliceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'y',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Chart$Shared$Slice)));
var $author$project$Chart$Shared$slicesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (sliceFns) {
		return $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (idx, fn) {
						return fn(
							A2($author$project$Chart$Shared$color, $author$project$Chart$Shared$NoColorPreference, idx));
					}),
				sliceFns));
	},
	$elm$json$Json$Decode$list($author$project$Chart$Shared$sliceDecoder));
var $author$project$Chart$Shared$pieDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['series', '1', 'data']),
	$elm$json$Json$Decode$maybe($author$project$Chart$Shared$slicesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['series', '0', 'data']),
		$author$project$Chart$Shared$slicesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'yAxis',
			$author$project$Chart$Shared$yAxisDecoder,
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$Pie))));
var $author$project$Chart$Shared$dataDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Chart$Shared$discreteDataDecoder, $author$project$Chart$Shared$continuousDataDecoder, $author$project$Chart$Shared$pieDataDecoder]));
var $author$project$Chart$Shared$NoDrill = {$: 0};
var $author$project$Chart$Shared$EntityDrillState = F3(
	function (level, drillUp, drillDown) {
		return {eq: drillDown, er: drillUp, fQ: level};
	});
var $author$project$Chart$Shared$EntityGroupingDrill = function (a) {
	return {$: 2, a: a};
};
var $author$project$ChartAndControlSet$ChartPort$EntityTypes = 0;
var $author$project$ChartAndControlSet$ChartPort$IndividualEntities = 1;
var $author$project$ChartAndControlSet$ChartPort$entityDrillLevelFromString = function (str) {
	switch (str) {
		case 'et':
			return $elm$core$Maybe$Just(0);
		case 'e':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ChartAndControlSet$ChartPort$entityDrillLevelDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$ChartAndControlSet$ChartPort$entityDrillLevelFromString(s);
		if (!_v0.$) {
			var t = _v0.a;
			return $elm$json$Json$Decode$succeed(t);
		} else {
			return $elm$json$Json$Decode$fail('unknown entity drill level');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Chart$Shared$entityLevelDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$Shared$EntityGroupingDrill,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'drilldown',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'drillup',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'drill_level',
				$author$project$ChartAndControlSet$ChartPort$entityDrillLevelDecoder,
				$elm$json$Json$Decode$succeed($author$project$Chart$Shared$EntityDrillState)))));
var $author$project$Chart$Shared$TimeDrill = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$TimeDrillState = F5(
	function (startDate, today, period, drillUp, drillDown) {
		return {eq: drillDown, er: drillUp, gf: period, gy: startDate, iX: today};
	});
var $author$project$ChartAndControlSet$Period$Day = {$: 2};
var $author$project$ChartAndControlSet$Period$Hour = {$: 3};
var $author$project$ChartAndControlSet$Period$Month = {$: 1};
var $author$project$ChartAndControlSet$Period$Quarter = function (a) {
	return {$: 4, a: a};
};
var $author$project$ChartAndControlSet$Period$Year = {$: 0};
var $author$project$ChartAndControlSet$Period$fromString = function (str) {
	switch (str) {
		case 'year':
			return $author$project$ChartAndControlSet$Period$Year;
		case 'month':
			return $author$project$ChartAndControlSet$Period$Month;
		case 'day':
			return $author$project$ChartAndControlSet$Period$Day;
		case 'hour':
			return $author$project$ChartAndControlSet$Period$Hour;
		case 'quarter':
			return $author$project$ChartAndControlSet$Period$Quarter(8);
		default:
			return $author$project$ChartAndControlSet$Period$Month;
	}
};
var $author$project$ChartAndControlSet$Period$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$ChartAndControlSet$Period$fromString, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$string);
var $author$project$Chart$Shared$timeDrillDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$Shared$TimeDrill,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'drilldown',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'drillup',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'period',
				$author$project$ChartAndControlSet$Period$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'now',
					$author$project$Enectiva$Conversion$dateDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'start_date',
						$author$project$Enectiva$Conversion$dateDecoder,
						$elm$json$Json$Decode$succeed($author$project$Chart$Shared$TimeDrillState)))))));
var $author$project$Chart$Shared$drillDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Chart$Shared$timeDrillDecoder,
			$author$project$Chart$Shared$entityLevelDecoder,
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$NoDrill)
		]));
var $author$project$Chart$Shared$NoServerErrors = {$: 0};
var $author$project$Chart$Shared$ServerErrors = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$GeneralServerErrors = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$Shared$SeriesServerErrors = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Chart$Shared$ServerError = F2(
	function (description, link) {
		return {fi: description, aQ: link};
	});
var $author$project$Chart$Shared$serverErrorDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'link',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'desc',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Chart$Shared$ServerError)));
var $author$project$Chart$Shared$serverErrorGroupDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'entries',
			$elm$json$Json$Decode$list($author$project$Chart$Shared$serverErrorDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'series',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Chart$Shared$SeriesServerErrors))),
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'entries',
			$elm$json$Json$Decode$list($author$project$Chart$Shared$serverErrorDecoder),
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$GeneralServerErrors))
		]));
var $author$project$Chart$Shared$serverErrorsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$Shared$ServerErrors,
	$elm$json$Json$Decode$list($author$project$Chart$Shared$serverErrorGroupDecoder));
var $author$project$Chart$Shared$errorsFieldDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'errors', $author$project$Chart$Shared$serverErrorsDecoder),
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$NoServerErrors)
		]));
var $author$project$Chart$Shared$HourFilter = F3(
	function (inverted, from, to) {
		return {jT: from, j6: inverted, lj: to};
	});
var $author$project$Chart$Shared$hourFilterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'inverted',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Chart$Shared$HourFilter))));
var $author$project$Chart$Shared$stateDecoder = F3(
	function (maybePrevious, maybeId, rangeStr) {
		var coordinates = function () {
			if ((!maybePrevious.$) && (maybePrevious.a.$ === 1)) {
				var _v1 = maybePrevious.a;
				var topLeftHtmlCoords = _v1.b.e$;
				return topLeftHtmlCoords;
			} else {
				return {M: 0, N: 0};
			}
		}();
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			false,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'timeZone',
					$author$project$Types$timeZoneDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'table_mode',
						$author$project$Chart$Shared$tableModeDecoder,
						2,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'hour_filter',
							$elm$json$Json$Decode$nullable($author$project$Chart$Shared$hourFilterDecoder),
							$elm$core$Maybe$Nothing,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								rangeStr,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									$author$project$Chart$Shared$drillDecoder,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										$author$project$Chart$Shared$additionalInfoDecoder,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$author$project$Chart$Shared$errorsFieldDecoder,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
												coordinates,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'containerId',
													$author$project$Chart$Shared$containerIdDecoder(maybeId),
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														$gampleman$elm_visualization$Transition$constant($elm$core$Maybe$Nothing),
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
															$author$project$Chart$Shared$dataDecoder,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'subtitle',
																$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																$elm$core$Maybe$Nothing,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'title',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Chart$Shared$State))))))))))))))));
	});
var $author$project$Chart$Shared$decoder = F3(
	function (maybePrevious, maybeId, rangeStr) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (state) {
				return $elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$map,
							function (dc) {
								return A2($author$project$Chart$Shared$KnownDimensions, dc, state);
							},
							$author$project$Chart$Shared$dimensionsDecoder(maybePrevious)),
							$elm$json$Json$Decode$succeed(
							$author$project$Chart$Shared$UnknownDimensions(state))
						]));
			},
			A3($author$project$Chart$Shared$stateDecoder, maybePrevious, maybeId, rangeStr));
	});
var $author$project$Chart$HeatMap = function (a) {
	return {$: 5, a: a};
};
var $author$project$ChartAndControlSet$HeatMap$HeatMap = F6(
	function (title, xAxis, yAxis, series, appearance, highlight) {
		return {ee: appearance, aO: highlight, iD: series, d: title, bZ: xAxis, o: yAxis};
	});
var $author$project$ChartAndControlSet$HeatMap$Large = 0;
var $author$project$ChartAndControlSet$HeatMap$NoHighlight = {$: 0};
var $author$project$ChartAndControlSet$HeatMap$Compact = 1;
var $author$project$ChartAndControlSet$HeatMap$appearanceDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'large':
				return $elm$json$Json$Decode$succeed(0);
			case 'compact':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('unsupported appearance ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$ChartAndControlSet$HeatMap$ComplexCategory = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ChartAndControlSet$HeatMap$SimpleCategory = function (a) {
	return {$: 0, a: a};
};
var $author$project$ChartAndControlSet$HeatMap$axisCategoryDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$ChartAndControlSet$HeatMap$SimpleCategory, $elm$json$Json$Decode$string),
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tooltip',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$ChartAndControlSet$HeatMap$ComplexCategory)))
		]));
var $author$project$ChartAndControlSet$HeatMap$HighlightAvailable = function (a) {
	return {$: 1, a: a};
};
var $author$project$ChartAndControlSet$HeatMap$CoordinateRange = F2(
	function (start, end) {
		return {cw: end, cU: start};
	});
var $author$project$ChartAndControlSet$HeatMap$coordinateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (list) {
		if ((list.b && list.b.b) && (!list.b.b.b)) {
			var row = list.a;
			var _v1 = list.b;
			var col = _v1.a;
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(row, col));
		} else {
			return $elm$json$Json$Decode$fail('invalid coordinates');
		}
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int));
var $author$project$ChartAndControlSet$HeatMap$coordinateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end',
	$author$project$ChartAndControlSet$HeatMap$coordinateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start',
		$author$project$ChartAndControlSet$HeatMap$coordinateDecoder,
		$elm$json$Json$Decode$succeed($author$project$ChartAndControlSet$HeatMap$CoordinateRange)));
var $author$project$ChartAndControlSet$HeatMap$highlightDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$ChartAndControlSet$HeatMap$HighlightAvailable,
	$elm$json$Json$Decode$list($author$project$ChartAndControlSet$HeatMap$coordinateRangeDecoder));
var $author$project$ChartAndControlSet$HeatMap$Series = F4(
	function (name, unit, data, range) {
		return {jA: data, kt: name, cO: range, i$: unit};
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{T: nodeList, G: nodeListSize, J: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $avh4$elm_color$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, alpha);
	});
var $avh4$elm_color$Color$hsl = F3(
	function (h, s, l) {
		return A4($avh4$elm_color$Color$hsla, h, s, l, 1.0);
	});
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $author$project$Palette$gradual = A2(
	$elm$core$Array$map,
	$avh4$elm_color$Color$toCssString,
	$elm$core$Array$fromList(
		_List_fromArray(
			[
				A3($avh4$elm_color$Color$hsl, 206.0 / 360, 1, 0.97),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.97, 0.93),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.93, 0.9),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.89, 0.88),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.86, 0.86),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.84, 0.82),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.82, 0.77),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.8, 0.73),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.78, 0.7),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.76, 0.67),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.74, 0.62),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.72, 0.58),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.71, 0.53),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.69, 0.5),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.67, 0.47),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.66, 0.45),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.64, 0.45),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.62, 0.4),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.6, 0.35),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.58, 0.31),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.56, 0.27),
				A3($avh4$elm_color$Color$hsl, 208.0 / 360, 0.53, 0.23),
				A3($avh4$elm_color$Color$hsl, 208.0 / 360, 0.53, 0.2),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.53, 0.15)
			])));
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Palette$length = $elm$core$Array$length($author$project$Palette$gradual);
var $author$project$ChartAndControlSet$HeatMap$calculateRange = F2(
	function (min, max) {
		return {Z: min, cX: (max - min) / $author$project$Palette$length};
	});
var $author$project$ChartAndControlSet$HeatMap$seriesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'max',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'data',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$list(
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'unit',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed(
						F5(
							function (n, u, d, min, max) {
								return A4(
									$author$project$ChartAndControlSet$HeatMap$Series,
									n,
									u,
									d,
									A2($author$project$ChartAndControlSet$HeatMap$calculateRange, min, max));
							})))))));
var $author$project$ChartAndControlSet$HeatMap$XAxis = F2(
	function (beginnings, backstop) {
		return {e8: backstop, de: beginnings};
	});
var $author$project$ChartAndControlSet$HeatMap$xAxisDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'xAxisBackstop',
	$author$project$ChartAndControlSet$HeatMap$axisCategoryDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'xAxis',
		$elm$json$Json$Decode$list($author$project$ChartAndControlSet$HeatMap$axisCategoryDecoder),
		$elm$json$Json$Decode$succeed($author$project$ChartAndControlSet$HeatMap$XAxis)));
var $author$project$ChartAndControlSet$HeatMap$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'highlight',
	$author$project$ChartAndControlSet$HeatMap$highlightDecoder,
	$author$project$ChartAndControlSet$HeatMap$NoHighlight,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'appearance',
		$author$project$ChartAndControlSet$HeatMap$appearanceDecoder,
		0,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'series',
			$author$project$ChartAndControlSet$HeatMap$seriesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'yAxis',
				$elm$json$Json$Decode$list($author$project$ChartAndControlSet$HeatMap$axisCategoryDecoder),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$ChartAndControlSet$HeatMap$xAxisDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['title', 'text']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						$elm$json$Json$Decode$succeed($author$project$ChartAndControlSet$HeatMap$HeatMap)))))));
var $author$project$Chart$heatMapDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (p) {
		if (p === 'heat_map') {
			return A2($elm$json$Json$Decode$map, $author$project$Chart$HeatMap, $author$project$ChartAndControlSet$HeatMap$decoder);
		} else {
			return $elm$json$Json$Decode$fail('not a heat map presenter');
		}
	},
	A2($elm$json$Json$Decode$field, 'presenter', $elm$json$Json$Decode$string));
var $author$project$Chart$Percentage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$Percentage$Model = F3(
	function (data, energy, excess) {
		return {jA: data, hm: energy, fo: excess};
	});
var $author$project$Enectiva$Conversion$decodeResult = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$json$Json$Decode$succeed(a);
	} else {
		var err = result.a;
		return $elm$json$Json$Decode$fail(err);
	}
};
var $author$project$Types$Co = 5;
var $author$project$Types$El = 1;
var $author$project$Types$Ga = 2;
var $author$project$Types$Hca = 6;
var $author$project$Types$He = 4;
var $author$project$Types$Lf = 7;
var $author$project$Types$Wa = 3;
var $author$project$Types$energyFromString = function (str) {
	switch (str) {
		case 'el':
			return $elm$core$Result$Ok(1);
		case 'ga':
			return $elm$core$Result$Ok(2);
		case 'wa':
			return $elm$core$Result$Ok(3);
		case 'he':
			return $elm$core$Result$Ok(4);
		case 'co':
			return $elm$core$Result$Ok(5);
		case 'hca':
			return $elm$core$Result$Ok(6);
		case 'lf':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('unknown energy ' + str);
	}
};
var $author$project$Types$energyDecoder = A3(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$map($author$project$Types$energyFromString),
	$elm$json$Json$Decode$andThen($author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $author$project$Chart$Percentage$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'excess',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'energy',
		$author$project$Types$energyDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'data',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$float),
			$elm$json$Json$Decode$succeed($author$project$Chart$Percentage$Model))));
var $author$project$Chart$percentageDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$Percentage,
	A2($elm$json$Json$Decode$field, 'percentage', $author$project$Chart$Percentage$decoder));
var $author$project$Chart$SingleEntity$Model = F4(
	function (points, unit, timeZone, includeTheoreticalConsumption) {
		return {fD: includeTheoreticalConsumption, ib: points, iU: timeZone, i$: unit};
	});
var $author$project$Chart$SingleEntity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$SingleEntity$ConsumptionData = F3(
	function (month, actual, theoretical) {
		return {e3: actual, hW: month, dZ: theoretical};
	});
var $author$project$Chart$SingleEntity$consumptionDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'theoretical',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actual',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'month',
			$author$project$Enectiva$Conversion$dateDecoder,
			$elm$json$Json$Decode$succeed($author$project$Chart$SingleEntity$ConsumptionData))));
var $author$project$Chart$singleEntityDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Chart$SingleEntity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'includeTheoreticalConsumption',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'timeZone',
			$author$project$Types$timeZoneDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'unit',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'singleEntity',
					$elm$json$Json$Decode$list($author$project$Chart$SingleEntity$consumptionDataDecoder),
					$elm$json$Json$Decode$succeed($author$project$Chart$SingleEntity$Model))))));
var $author$project$Chart$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Chart$percentageDecoder,
			$author$project$Chart$singleEntityDecoder,
			$author$project$Chart$aggregateEntitiesDecoder,
			A2(
			$elm$json$Json$Decode$field,
			'consumptionProfile',
			A2($elm$json$Json$Decode$map, $author$project$Chart$ConsumptionProfile, $author$project$Chart$ConsumptionProfile$decoder)),
			$author$project$Chart$heatMapDecoder,
			$author$project$Chart$binaryAnalysisDecoder,
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Chart$General,
			A3($author$project$Chart$Shared$decoder, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, ''))
		]));
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$monitorResize = _Platform_outgoingPort('monitorResize', $elm$json$Json$Encode$string);
var $author$project$Chart$Shared$unpackState = function (model) {
	if (!model.$) {
		var s = model.a;
		return s;
	} else {
		var s = model.b;
		return s;
	}
};
var $author$project$Chart$Shared$init = function (model) {
	return $author$project$Ports$monitorResize(
		$author$project$Chart$Shared$unpackState(model).dh);
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Enectiva$I18n$Translations = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$newTranslations = $author$project$Enectiva$I18n$Translations;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Chart$init = function (flags) {
	var translations = A2($author$project$Enectiva$I18n$newTranslations, flags.fR, flags.cl);
	var chart = A2(
		$elm$core$Result$withDefault,
		$author$project$Chart$Empty,
		A2($elm$json$Json$Decode$decodeValue, $author$project$Chart$decoder, flags.aA));
	var cmd = function () {
		if (chart.$ === 3) {
			var model = chart.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Chart$GeneralMsg,
				$author$project$Chart$Shared$init(model));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	}();
	return _Utils_Tuple2(
		{aA: chart, cl: translations},
		cmd);
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Chart$Shared$ContainerResized = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Chart$Shared$IrrelevantMsg = {$: 23};
var $author$project$Ports$resized = _Platform_incomingPort(
	'resized',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					A2(
						$elm$json$Json$Decode$andThen,
						function (window) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (element) {
									return $elm$json$Json$Decode$succeed(
										{hk: element, lG: window});
								},
								A2(
									$elm$json$Json$Decode$field,
									'element',
									A2(
										$elm$json$Json$Decode$andThen,
										function (width) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (height) {
													return $elm$json$Json$Decode$succeed(
														{p: height, h: width});
												},
												A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
										},
										A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int))));
						},
						A2(
							$elm$json$Json$Decode$field,
							'window',
							A2(
								$elm$json$Json$Decode$andThen,
								function (width) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (height) {
											return $elm$json$Json$Decode$succeed(
												{p: height, h: width});
										},
										A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
								},
								A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int))))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Chart$Shared$containerResized = function (model) {
	var htmlId = $author$project$Chart$Shared$unpackState(model).dh;
	return $author$project$Ports$resized(
		function (_v0) {
			var id = _v0.a;
			var element = _v0.b.hk;
			var window = _v0.b.lG;
			return _Utils_eq(id, htmlId) ? A2($author$project$Chart$Shared$ContainerResized, element.h, window.p) : $author$project$Chart$Shared$IrrelevantMsg;
		});
};
var $author$project$Chart$Shared$AnimationTick = function (a) {
	return {$: 5, a: a};
};
var $gampleman$elm_visualization$Transition$isComplete = function (_v0) {
	var t = _v0;
	return (_Utils_cmp(t.ct + 1, t.aU) > -1) && (_Utils_cmp(t.al, t.bq) > -1);
};
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {f$: oldTime, ir: request, iN: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.ir;
		var oldTime = _v0.f$;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.iN;
		var oldTime = _v0.f$;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $author$project$Chart$Shared$tooltipAnimationSubscription = function (model) {
	return $gampleman$elm_visualization$Transition$isComplete(
		$author$project$Chart$Shared$unpackState(model).K) ? $elm$core$Platform$Sub$none : $elm$browser$Browser$Events$onAnimationFrameDelta(
		A2($elm$core$Basics$composeR, $elm$core$Basics$round, $author$project$Chart$Shared$AnimationTick));
};
var $author$project$Chart$Shared$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Chart$Shared$tooltipAnimationSubscription(model),
				$author$project$Chart$Shared$containerResized(model)
			]));
};
var $author$project$Chart$subscriptions = function (_v0) {
	var chart = _v0.aA;
	if (chart.$ === 3) {
		var m = chart.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Chart$GeneralMsg,
			$author$project$Chart$Shared$subscriptions(m));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Chart$ConsumptionProfileMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Enectiva$Util$noCmd = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Chart$ConsumptionProfile$update = F2(
	function (msg, model) {
		var checked = msg;
		return $author$project$Enectiva$Util$noCmd(
			_Utils_update(
				model,
				{cR: checked}));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Ports$toggleNativeDialog = _Platform_outgoingPort('toggleNativeDialog', $elm$core$Basics$identity);
var $author$project$Ports$closeNativeDialog = function (id) {
	return $author$project$Ports$toggleNativeDialog(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'show',
					$elm$json$Json$Encode$bool(false))
				])));
};
var $author$project$Chart$Shared$diffCoords = F2(
	function (a, b) {
		return {M: a.M - b.M, N: a.N - b.N};
	});
var $author$project$Chart$Shared$ChangeDateRange = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Chart$Shared$ChangeEntityDrillLevel = function (a) {
	return {$: 1, a: a};
};
var $author$project$ChartAndControlSet$ChartPort$moreGranularEntityDrillLevel = function (_v0) {
	return 1;
};
var $author$project$Chart$Shared$parentMsg = F2(
	function (msg, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple3(
			a,
			b,
			$elm$core$Maybe$Just(msg));
	});
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$Years = 0;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {hb: d, hW: m, i9: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		f0: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		i9: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.i9, 0, date.f0);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.i9 - 1)) + ($justinmimbs$date$Date$monthToNumber(date.hW) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.hb,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $author$project$Enectiva$DateRange$new = F2(
	function (from, to) {
		return _Utils_Tuple2(from, to);
	});
var $author$project$Chart$Shared$singleDay = function (date) {
	return A2($author$project$Enectiva$DateRange$new, date, date);
};
var $justinmimbs$date$Date$Month = 2;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.hW;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $author$project$Chart$Shared$singleMonth = function (date) {
	var start = A2($justinmimbs$date$Date$floor, 2, date);
	return A2(
		$author$project$Enectiva$DateRange$new,
		start,
		A3(
			$justinmimbs$date$Date$add,
			3,
			-1,
			A3($justinmimbs$date$Date$add, 1, 1, start)));
};
var $justinmimbs$date$Date$Year = 0;
var $author$project$Chart$Shared$singleYear = function (date) {
	return A2(
		$author$project$Enectiva$DateRange$new,
		A2($justinmimbs$date$Date$floor, 0, date),
		A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			11,
			31));
};
var $author$project$Chart$Shared$shrinkRange = F3(
	function (date, currentPeriod, shift) {
		switch (currentPeriod.$) {
			case 0:
				return _Utils_Tuple2(
					$author$project$Chart$Shared$singleYear(
						A3($justinmimbs$date$Date$add, 0, shift, date)),
					$author$project$ChartAndControlSet$Period$Month);
			case 1:
				return _Utils_Tuple2(
					$author$project$Chart$Shared$singleMonth(
						A3($justinmimbs$date$Date$add, 1, shift, date)),
					$author$project$ChartAndControlSet$Period$Day);
			case 2:
				return _Utils_Tuple2(
					$author$project$Chart$Shared$singleDay(
						A3($justinmimbs$date$Date$add, 3, shift, date)),
					$author$project$ChartAndControlSet$Period$Hour);
			case 3:
				return _Utils_Tuple2(
					$author$project$Chart$Shared$singleDay(date),
					$author$project$ChartAndControlSet$Period$Quarter(shift));
			default:
				return _Utils_Tuple2(
					A2($author$project$Enectiva$DateRange$new, date, date),
					currentPeriod);
		}
	});
var $elm_community$basics_extra$Basics$Extra$uncurry = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $author$project$Chart$Shared$noParentMsg = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	return _Utils_Tuple3(a, b, $elm$core$Maybe$Nothing);
};
var $author$project$Chart$Shared$updateNothing = function (model) {
	return $author$project$Chart$Shared$noParentMsg(
		$author$project$Enectiva$Util$noCmd(model));
};
var $author$project$Chart$Shared$drillDown = F2(
	function (state, maybeIndex) {
		var _v0 = _Utils_Tuple2(state.fl, maybeIndex);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (!_v0.b.$) {
						var timeDrill = _v0.a.a;
						var dataPointIndex = _v0.b.a;
						return timeDrill.eq ? A2(
							$author$project$Chart$Shared$parentMsg,
							A2(
								$elm_community$basics_extra$Basics$Extra$uncurry,
								$author$project$Chart$Shared$ChangeDateRange,
								A3($author$project$Chart$Shared$shrinkRange, timeDrill.gy, timeDrill.gf, dataPointIndex)),
							$author$project$Enectiva$Util$noCmd(state)) : $author$project$Chart$Shared$updateNothing(state);
					} else {
						break _v0$2;
					}
				case 2:
					var entityDrill = _v0.a.a;
					return entityDrill.eq ? A2(
						$author$project$Chart$Shared$parentMsg,
						$author$project$Chart$Shared$ChangeEntityDrillLevel(
							$author$project$ChartAndControlSet$ChartPort$moreGranularEntityDrillLevel(entityDrill.fQ)),
						$author$project$Enectiva$Util$noCmd(state)) : $author$project$Chart$Shared$updateNothing(state);
				default:
					break _v0$2;
			}
		}
		return $author$project$Chart$Shared$updateNothing(state);
	});
var $justinmimbs$date$Date$max = F2(
	function (dateA, dateB) {
		var a = dateA;
		var b = dateB;
		return (_Utils_cmp(a, b) < 0) ? dateB : dateA;
	});
var $justinmimbs$date$Date$min = F2(
	function (dateA, dateB) {
		var a = dateA;
		var b = dateB;
		return (_Utils_cmp(a, b) < 0) ? dateA : dateB;
	});
var $author$project$Chart$Shared$yearsUntilToday = F2(
	function (date, today) {
		var min = A2($justinmimbs$date$Date$min, date, today);
		var max = A2($justinmimbs$date$Date$max, date, today);
		return A2(
			$author$project$Enectiva$DateRange$new,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(min) - 1,
				0,
				1),
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(max),
				11,
				31));
	});
var $author$project$Chart$Shared$expandRange = F3(
	function (today, date, currentPeriod) {
		switch (currentPeriod.$) {
			case 0:
				return _Utils_Tuple2(
					A2($author$project$Chart$Shared$yearsUntilToday, date, today),
					$author$project$ChartAndControlSet$Period$Year);
			case 1:
				return _Utils_Tuple2(
					A2($author$project$Chart$Shared$yearsUntilToday, date, today),
					$author$project$ChartAndControlSet$Period$Year);
			case 2:
				return _Utils_Tuple2(
					$author$project$Chart$Shared$singleYear(date),
					$author$project$ChartAndControlSet$Period$Month);
			case 3:
				return _Utils_Tuple2(
					$author$project$Chart$Shared$singleMonth(date),
					$author$project$ChartAndControlSet$Period$Day);
			default:
				return _Utils_Tuple2(
					$author$project$Chart$Shared$singleDay(date),
					$author$project$ChartAndControlSet$Period$Hour);
		}
	});
var $author$project$ChartAndControlSet$ChartPort$lessGranularEntityDrillLevel = function (_v0) {
	return 0;
};
var $author$project$Chart$Shared$drillUp = function (state) {
	var _v0 = state.fl;
	switch (_v0.$) {
		case 1:
			var timeDrill = _v0.a;
			return timeDrill.er ? A2(
				$author$project$Chart$Shared$parentMsg,
				A2(
					$elm_community$basics_extra$Basics$Extra$uncurry,
					$author$project$Chart$Shared$ChangeDateRange,
					A3($author$project$Chart$Shared$expandRange, timeDrill.iX, timeDrill.gy, timeDrill.gf)),
				$author$project$Enectiva$Util$noCmd(state)) : $author$project$Chart$Shared$updateNothing(state);
		case 2:
			var entityDrill = _v0.a;
			return entityDrill.er ? A2(
				$author$project$Chart$Shared$parentMsg,
				$author$project$Chart$Shared$ChangeEntityDrillLevel(
					$author$project$ChartAndControlSet$ChartPort$lessGranularEntityDrillLevel(entityDrill.fQ)),
				$author$project$Enectiva$Util$noCmd(state)) : $author$project$Chart$Shared$updateNothing(state);
		default:
			return $author$project$Chart$Shared$updateNothing(state);
	}
};
var $author$project$Chart$Shared$TooltipExpired = function (a) {
	return {$: 15, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Chart$Shared$tooltipAnimationLength = 200;
var $author$project$Chart$Shared$eventuallyExpireTooltip = function (generation) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(
			$author$project$Chart$Shared$TooltipExpired(generation)),
		$elm$core$Process$sleep($author$project$Chart$Shared$tooltipAnimationLength * 2));
};
var $gampleman$elm_visualization$Transition$value = function (_v0) {
	var soFar = _v0.al;
	var total = _v0.bq;
	var easing = _v0.es;
	var interpolator = _v0.b8;
	return interpolator(
		easing(soFar / total));
};
var $author$project$Chart$Shared$expireTooltip = function (state) {
	var _v0 = $gampleman$elm_visualization$Transition$value(state.K);
	if (!_v0.$) {
		var generation = _v0.a.b5;
		return $author$project$Chart$Shared$noParentMsg(
			_Utils_Tuple2(
				state,
				$author$project$Chart$Shared$eventuallyExpireTooltip(generation)));
	} else {
		return $author$project$Chart$Shared$noParentMsg(
			$author$project$Enectiva$Util$noCmd(state));
	}
};
var $gampleman$elm_visualization$Interpolation$float = F2(
	function (a, to) {
		var b = to - a;
		return function (t) {
			return a + (b * t);
		};
	});
var $elm$core$Basics$pow = _Basics_pow;
var $gampleman$elm_visualization$Transition$easePolynomial = function (exponent) {
	return function (time) {
		var t = time * 2;
		return (t <= 1) ? (A2($elm$core$Basics$pow, t, exponent) / 2) : ((A2($elm$core$Basics$pow, t - 2, exponent) + 2) / 2);
	};
};
var $gampleman$elm_visualization$Transition$easeCubic = $gampleman$elm_visualization$Transition$easePolynomial(3);
var $gampleman$elm_visualization$Transition$for = function (t) {
	return A2($gampleman$elm_visualization$Transition$easeFor, t, $gampleman$elm_visualization$Transition$easeCubic);
};
var $gampleman$elm_visualization$Interpolation$map = $elm$core$Basics$composeL;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $TSFoster$elm_tuple_extra$Tuple3$mapFirst = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			fn(a),
			b,
			c);
	});
var $author$project$Chart$Shared$moreStatsDialogId = 'more-stats';
var $justinmimbs$time_extra$Time$Extra$Year = 0;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$Chart$Shared$applyTemporalShift = F3(
	function (shift, timeZone, time) {
		if (shift === 1) {
			return time;
		} else {
			return A4($justinmimbs$time_extra$Time$Extra$add, 0, 1, timeZone, time);
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Chart$Shared$anyStats = F3(
	function (seriesHasStats, primaryAxisData, maybeSecondaryAxisData) {
		return A2($elm$core$List$any, seriesHasStats, primaryAxisData.jA) || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jA;
					},
					$elm$core$List$any(seriesHasStats)),
				maybeSecondaryAxisData));
	});
var $author$project$Chart$Shared$bottomPaddingWithSpaceForLegend = 25;
var $author$project$Chart$Shared$generalPadding = 5;
var $author$project$Chart$Shared$horizontalPaddingForTicks = 52;
var $author$project$Chart$Shared$horizontalPaddingForUnit = 18;
var $author$project$Chart$Shared$horizontalPaddingForYAxis = function (maybeYAxis) {
	if (maybeYAxis.$ === 1) {
		return $author$project$Chart$Shared$generalPadding;
	} else {
		var title = maybeYAxis.a.d;
		if (title.$ === 1) {
			return $author$project$Chart$Shared$horizontalPaddingForTicks;
		} else {
			return $author$project$Chart$Shared$horizontalPaddingForTicks + $author$project$Chart$Shared$horizontalPaddingForUnit;
		}
	}
};
var $author$project$Chart$Shared$statsSidebarWidth = 270;
var $author$project$Chart$Shared$calculateSizes = F4(
	function (seriesHasStats, primaryAxisData, maybeSecondaryAxisData, dimensionConfig) {
		var width = A3($author$project$Chart$Shared$anyStats, seriesHasStats, primaryAxisData, maybeSecondaryAxisData) ? (dimensionConfig.h - $author$project$Chart$Shared$statsSidebarWidth) : dimensionConfig.h;
		return {
			fa: $author$project$Chart$Shared$bottomPaddingWithSpaceForLegend,
			p: dimensionConfig.p,
			ca: $author$project$Chart$Shared$horizontalPaddingForYAxis(
				$elm$core$Maybe$Just(primaryAxisData.o)),
			gl: $author$project$Chart$Shared$horizontalPaddingForYAxis(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.o;
					},
					maybeSecondaryAxisData)),
			ci: 45,
			h: width
		};
	});
var $gampleman$elm_visualization$Scale$Scale = $elm$core$Basics$identity;
var $gampleman$elm_visualization$Scale$Band$normalizeConfig = function (_v0) {
	var paddingInner = _v0.kO;
	var paddingOuter = _v0.kP;
	var align = _v0.gS;
	return {
		gS: A3($elm$core$Basics$clamp, 0, 1, align),
		kO: A3($elm$core$Basics$clamp, 0, 1, paddingInner),
		kP: A3($elm$core$Basics$clamp, 0, 1, paddingOuter)
	};
};
var $gampleman$elm_visualization$Scale$Band$bandwidth = F3(
	function (cfg, domain, _v0) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		var n = $elm$core$List$length(domain);
		var _v1 = (_Utils_cmp(d0, d1) < 0) ? _Utils_Tuple2(d0, d1) : _Utils_Tuple2(d1, d0);
		var start = _v1.a;
		var stop = _v1.b;
		var _v2 = $gampleman$elm_visualization$Scale$Band$normalizeConfig(cfg);
		var paddingInner = _v2.kO;
		var paddingOuter = _v2.kP;
		var step = (stop - start) / A2($elm$core$Basics$max, 1, (n - paddingInner) + (paddingOuter * 2));
		return step * (1 - paddingInner);
	});
var $gampleman$elm_visualization$Scale$Band$computePositions = F3(
	function (cfg, n, _v0) {
		var start = _v0.a;
		var stop = _v0.b;
		var _v1 = $gampleman$elm_visualization$Scale$Band$normalizeConfig(cfg);
		var paddingInner = _v1.kO;
		var paddingOuter = _v1.kP;
		var align = _v1.gS;
		var step = (stop - start) / A2($elm$core$Basics$max, 1, (n - paddingInner) + (paddingOuter * 2));
		var start2 = start + (((stop - start) - (step * (n - paddingInner))) * align);
		return _Utils_Tuple2(start2, step);
	});
var $gampleman$elm_visualization$Scale$Band$indexOfHelp = F3(
	function (index, value, list) {
		indexOfHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (_Utils_eq(value, x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$value = value,
						$temp$list = xs;
					index = $temp$index;
					value = $temp$value;
					list = $temp$list;
					continue indexOfHelp;
				}
			}
		}
	});
var $gampleman$elm_visualization$Scale$Band$indexOf = $gampleman$elm_visualization$Scale$Band$indexOfHelp(0);
var $gampleman$elm_visualization$Scale$Band$convert = F4(
	function (cfg, domain, _v0, value) {
		var start = _v0.a;
		var stop = _v0.b;
		var _v1 = A2($gampleman$elm_visualization$Scale$Band$indexOf, value, domain);
		if (!_v1.$) {
			var index = _v1.a;
			var n = $elm$core$List$length(domain);
			if (_Utils_cmp(start, stop) < 0) {
				var _v2 = A3(
					$gampleman$elm_visualization$Scale$Band$computePositions,
					cfg,
					n,
					_Utils_Tuple2(start, stop));
				var start2 = _v2.a;
				var step = _v2.b;
				return start2 + (step * index);
			} else {
				var _v3 = A3(
					$gampleman$elm_visualization$Scale$Band$computePositions,
					cfg,
					n,
					_Utils_Tuple2(stop, start));
				var stop2 = _v3.a;
				var step = _v3.b;
				return stop2 + (step * ((n - index) - 1));
			}
		} else {
			return 0 / 0;
		}
	});
var $gampleman$elm_visualization$Scale$band = F3(
	function (config, range_, domain_) {
		return {
			eg: A3($gampleman$elm_visualization$Scale$Band$bandwidth, config, domain_, range_),
			bh: $gampleman$elm_visualization$Scale$Band$convert(config),
			ep: domain_,
			cO: range_
		};
	});
var $gampleman$elm_visualization$Scale$defaultBandConfig = {gS: 0.5, kO: 0.0, kP: 0.0};
var $author$project$Chart$Shared$categoricalXScale = F2(
	function (sizes, categories) {
		return A3(
			$gampleman$elm_visualization$Scale$band,
			_Utils_update(
				$gampleman$elm_visualization$Scale$defaultBandConfig,
				{kO: 0.2, kP: 0.2}),
			_Utils_Tuple2(0, (sizes.h - sizes.ca) - sizes.gl),
			categories);
	});
var $author$project$Visibility$toMaybe = function (a) {
	if (!a.$) {
		var v = a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $gampleman$elm_visualization$Scale$Continuous$normalize = F2(
	function (a, b) {
		var c = b - a;
		return (!c) ? $elm$core$Basics$always(0.5) : ($elm$core$Basics$isNaN(c) ? $elm$core$Basics$always(0 / 0) : function (x) {
			return (x - a) / c;
		});
	});
var $gampleman$elm_visualization$Scale$Continuous$bimap = F3(
	function (_v0, _v1, interpolate) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		var r0 = _v1.a;
		var r1 = _v1.b;
		var _v2 = (_Utils_cmp(d1, d0) < 0) ? _Utils_Tuple2(
			A2($gampleman$elm_visualization$Scale$Continuous$normalize, d1, d0),
			A2(interpolate, r1, r0)) : _Utils_Tuple2(
			A2($gampleman$elm_visualization$Scale$Continuous$normalize, d0, d1),
			A2(interpolate, r0, r1));
		var de = _v2.a;
		var re = _v2.b;
		return A2($elm$core$Basics$composeL, re, de);
	});
var $gampleman$elm_visualization$Scale$Continuous$convertTransform = F4(
	function (transform, interpolate, _v0, range) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		return A2(
			$elm$core$Basics$composeR,
			transform,
			A3(
				$gampleman$elm_visualization$Scale$Continuous$bimap,
				_Utils_Tuple2(
					transform(d0),
					transform(d1)),
				range,
				interpolate));
	});
var $gampleman$elm_visualization$Scale$Continuous$invertTransform = F4(
	function (transform, untransform, _v0, range) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		return A2(
			$elm$core$Basics$composeR,
			A3(
				$gampleman$elm_visualization$Scale$Continuous$bimap,
				range,
				_Utils_Tuple2(
					transform(d0),
					transform(d1)),
				$gampleman$elm_visualization$Interpolation$float),
			untransform);
	});
var $gampleman$elm_visualization$Scale$Continuous$fixPoint = F3(
	function (maxIterations, initialInput, fn) {
		var helper = F2(
			function (iters, _v0) {
				helper:
				while (true) {
					var a = _v0.a;
					var b = _v0.b;
					if (_Utils_cmp(iters + 1, maxIterations) > -1) {
						return b;
					} else {
						var _v1 = fn(b);
						var outA = _v1.a;
						var outB = _v1.b;
						if (_Utils_eq(outA, a)) {
							return b;
						} else {
							if (!outA) {
								return b;
							} else {
								var $temp$iters = iters + 1,
									$temp$_v0 = _Utils_Tuple2(outA, outB);
								iters = $temp$iters;
								_v0 = $temp$_v0;
								continue helper;
							}
						}
					}
				}
			});
		return A2(
			helper,
			1,
			fn(initialInput));
	});
var $elm$core$Basics$e = _Basics_e;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $gampleman$elm_visualization$Scale$Continuous$e10 = $elm$core$Basics$sqrt(50);
var $gampleman$elm_visualization$Scale$Continuous$e2 = $elm$core$Basics$sqrt(2);
var $gampleman$elm_visualization$Scale$Continuous$e5 = $elm$core$Basics$sqrt(10);
var $gampleman$elm_visualization$Scale$Continuous$ln10 = A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10);
var $gampleman$elm_visualization$Scale$Continuous$tickIncrement = F3(
	function (start, stop, count) {
		var step = (stop - start) / A2($elm$core$Basics$max, 0, count);
		var powr = $elm$core$Basics$floor(
			A2($elm$core$Basics$logBase, $elm$core$Basics$e, step) / $gampleman$elm_visualization$Scale$Continuous$ln10);
		var error = step / A2($elm$core$Basics$pow, 10, powr);
		var order = (_Utils_cmp(error, $gampleman$elm_visualization$Scale$Continuous$e10) > -1) ? 10 : ((_Utils_cmp(error, $gampleman$elm_visualization$Scale$Continuous$e5) > -1) ? 5 : ((_Utils_cmp(error, $gampleman$elm_visualization$Scale$Continuous$e2) > -1) ? 2 : 1));
		return (powr >= 0) ? (order * A2($elm$core$Basics$pow, 10, powr)) : ((-A2($elm$core$Basics$pow, 10, -powr)) / order);
	});
var $gampleman$elm_visualization$Scale$Continuous$withNormalizedDomain = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		if (_Utils_cmp(a, b) < 0) {
			return fn(
				_Utils_Tuple2(a, b));
		} else {
			var _v1 = fn(
				_Utils_Tuple2(b, a));
			var d = _v1.a;
			var c = _v1.b;
			return _Utils_Tuple2(c, d);
		}
	});
var $gampleman$elm_visualization$Scale$Continuous$nice = F2(
	function (domain, count) {
		var computation = function (_v0) {
			var start = _v0.a;
			var stop = _v0.b;
			var step = A3($gampleman$elm_visualization$Scale$Continuous$tickIncrement, start, stop, count);
			return _Utils_Tuple2(
				step,
				(step > 0) ? _Utils_Tuple2(
					$elm$core$Basics$floor(start / step) * step,
					$elm$core$Basics$ceiling(stop / step) * step) : ((step < 0) ? _Utils_Tuple2(
					$elm$core$Basics$ceiling(start * step) / step,
					$elm$core$Basics$floor(stop * step) / step) : _Utils_Tuple2(start, stop)));
		};
		return A2(
			$gampleman$elm_visualization$Scale$Continuous$withNormalizedDomain,
			function (dmn) {
				return A3($gampleman$elm_visualization$Scale$Continuous$fixPoint, 10, dmn, computation);
			},
			domain);
	});
var $gampleman$elm_visualization$Scale$Continuous$exponent = function (num) {
	var helper = F2(
		function (soFar, x) {
			helper:
			while (true) {
				if (!x) {
					return soFar;
				} else {
					if (x < 1) {
						var $temp$soFar = 1 + soFar,
							$temp$x = x * 10;
						soFar = $temp$soFar;
						x = $temp$x;
						continue helper;
					} else {
						return soFar;
					}
				}
			}
		});
	return A2(helper, 0, num);
};
var $gampleman$elm_visualization$Scale$Continuous$precisionFixed = function (step) {
	return A2(
		$elm$core$Basics$max,
		0,
		$gampleman$elm_visualization$Scale$Continuous$exponent(
			$elm$core$Basics$abs(step)));
};
var $gampleman$elm_visualization$Statistics$tickStep = F3(
	function (start, stop, count) {
		var step0 = $elm$core$Basics$abs(stop - start) / A2($elm$core$Basics$max, 0, count);
		var step1 = A2(
			$elm$core$Basics$pow,
			10,
			$elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Basics$e, step0) / A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10)));
		var error = step0 / step1;
		var step2 = (_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(50)) > -1) ? (step1 * 10) : ((_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(10)) > -1) ? (step1 * 5) : ((_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(2)) > -1) ? (step1 * 2) : step1));
		return (_Utils_cmp(stop, start) < 0) ? (-step2) : step2;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $gampleman$elm_visualization$Scale$Continuous$toFixed = F2(
	function (precision, value) {
		var power_ = A2($elm$core$Basics$pow, 10, precision);
		var pad = function (num) {
			_v0$2:
			while (true) {
				if (num.b) {
					if (num.b.b) {
						if (!num.b.b.b) {
							var x = num.a;
							var _v1 = num.b;
							var y = _v1.a;
							return _List_fromArray(
								[
									x,
									A3($elm$core$String$padRight, precision, '0', y)
								]);
						} else {
							break _v0$2;
						}
					} else {
						var val = num.a;
						return (precision > 0) ? _List_fromArray(
							[
								val,
								A3($elm$core$String$padRight, precision, '0', '')
							]) : _List_fromArray(
							[val]);
					}
				} else {
					break _v0$2;
				}
			}
			var val = num;
			return val;
		};
		return A2(
			$elm$core$String$join,
			'.',
			pad(
				A2(
					$elm$core$String$split,
					'.',
					$elm$core$String$fromFloat(
						$elm$core$Basics$round(value * power_) / power_))));
	});
var $gampleman$elm_visualization$Scale$Continuous$tickFormat = F2(
	function (_v0, count) {
		var start = _v0.a;
		var stop = _v0.b;
		return $gampleman$elm_visualization$Scale$Continuous$toFixed(
			$gampleman$elm_visualization$Scale$Continuous$precisionFixed(
				A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count)));
	});
var $elmcraft$core_extra$Float$Extra$range = F3(
	function (start, stop, step) {
		if (!step) {
			return _List_Nil;
		} else {
			var n = A2(
				$elm$core$Basics$max,
				0,
				$elm$core$Basics$ceiling((stop - start) / step));
			var helper = F2(
				function (i, list) {
					helper:
					while (true) {
						if (i >= 0) {
							var $temp$i = i - 1,
								$temp$list = A2($elm$core$List$cons, start + (step * i), list);
							i = $temp$i;
							list = $temp$list;
							continue helper;
						} else {
							return list;
						}
					}
				});
			return A2(helper, n - 1, _List_Nil);
		}
	});
var $gampleman$elm_visualization$Statistics$range = $elmcraft$core_extra$Float$Extra$range;
var $gampleman$elm_visualization$Statistics$ticks = F3(
	function (start, stop, count) {
		var step = A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count);
		var end = ($elm$core$Basics$floor(stop / step) * step) + (step / 2);
		var beg = $elm$core$Basics$ceiling(start / step) * step;
		return A3($gampleman$elm_visualization$Statistics$range, beg, end, step);
	});
var $gampleman$elm_visualization$Scale$Continuous$ticks = F2(
	function (_v0, count) {
		var start = _v0.a;
		var end = _v0.b;
		return A3($gampleman$elm_visualization$Statistics$ticks, start, end, count);
	});
var $gampleman$elm_visualization$Scale$Continuous$scaleWithTransform = F4(
	function (transform, untransform, range_, domain_) {
		return {
			bh: A2($gampleman$elm_visualization$Scale$Continuous$convertTransform, transform, $gampleman$elm_visualization$Interpolation$float),
			ep: domain_,
			j5: A2($gampleman$elm_visualization$Scale$Continuous$invertTransform, transform, untransform),
			h0: $gampleman$elm_visualization$Scale$Continuous$nice,
			cO: range_,
			gj: F2(
				function (_v0, r) {
					return r;
				}),
			gC: $gampleman$elm_visualization$Scale$Continuous$tickFormat,
			gD: $gampleman$elm_visualization$Scale$Continuous$ticks
		};
	});
var $gampleman$elm_visualization$Scale$Continuous$linear = A2($gampleman$elm_visualization$Scale$Continuous$scaleWithTransform, $elm$core$Basics$identity, $elm$core$Basics$identity);
var $gampleman$elm_visualization$Scale$linear = F2(
	function (range_, domain_) {
		return A2($gampleman$elm_visualization$Scale$Continuous$linear, range_, domain_);
	});
var $gampleman$elm_visualization$Scale$nice = F2(
	function (count, _v0) {
		var scale = _v0;
		return _Utils_update(
			scale,
			{
				ep: A2(scale.h0, scale.ep, count)
			});
	});
var $author$project$Chart$Shared$discontinuityHeight = 20;
var $author$project$Chart$Shared$yAxisHeight = F2(
	function (sizes, discontinuity) {
		var maxHeight = (sizes.p - sizes.ci) - sizes.fa;
		return discontinuity ? (maxHeight - $author$project$Chart$Shared$discontinuityHeight) : maxHeight;
	});
var $author$project$Chart$Shared$yAxisTickCount = function (height) {
	return $elm$core$Basics$floor(height / 90);
};
var $author$project$Chart$Shared$dynamicRangeRatio = 0.5;
var $author$project$Chart$Shared$dynamicRangeMin = F2(
	function (max, maybeMin) {
		if (maybeMin.$ === 1) {
			return _Utils_Tuple2(0, false);
		} else {
			var min = maybeMin.a;
			return (min <= 0) ? _Utils_Tuple2(min, false) : ((_Utils_cmp(max - min, max * $author$project$Chart$Shared$dynamicRangeRatio) < 1) ? _Utils_Tuple2(min, true) : _Utils_Tuple2(0, false));
		}
	});
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Chart$Shared$negativeOrZero = function (maybeMin) {
	if (!maybeMin.$) {
		var m = maybeMin.a;
		return (m < 0) ? m : 0;
	} else {
		return 0;
	}
};
var $author$project$Chart$Shared$yDomainExtentContinuous = function (primaryYAxisData) {
	var visibleSeries = A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2($elm$core$List$filterMap, $author$project$Visibility$toMaybe, primaryYAxisData.jA));
	var max = A2(
		$elm$core$Maybe$withDefault,
		1,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.aW;
				},
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.jA;
					},
					visibleSeries))));
	var _v0 = function () {
		var _v1 = primaryYAxisData.o.cO;
		switch (_v1.$) {
			case 1:
				var m = _v1.a;
				return _Utils_Tuple2(m, false);
			case 0:
				return function (m) {
					return _Utils_Tuple2(m, false);
				}(
					$author$project$Chart$Shared$negativeOrZero(
						$elm$core$List$minimum(
							A2(
								$elm$core$List$filterMap,
								function ($) {
									return $.aW;
								},
								A2(
									$elm$core$List$concatMap,
									function ($) {
										return $.jA;
									},
									visibleSeries)))));
			default:
				return A2(
					$author$project$Chart$Shared$dynamicRangeMin,
					max,
					$elm$core$List$minimum(
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.aW;
							},
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.jA;
								},
								visibleSeries))));
		}
	}();
	var min = _v0.a;
	var discontinuity = _v0.b;
	return _Utils_Tuple3(min, max, discontinuity);
};
var $author$project$Chart$Shared$yScaleFromContinuous = F2(
	function (sizes, axisData) {
		var _v0 = $author$project$Chart$Shared$yDomainExtentContinuous(axisData);
		var min = _v0.a;
		var max = _v0.b;
		var discontinuity = _v0.c;
		return _Utils_Tuple2(
			A2(
				$gampleman$elm_visualization$Scale$nice,
				$author$project$Chart$Shared$yAxisTickCount(sizes.p),
				A2(
					$gampleman$elm_visualization$Scale$linear,
					_Utils_Tuple2(
						A2($author$project$Chart$Shared$yAxisHeight, sizes, discontinuity),
						0),
					_Utils_Tuple2(min, max))),
			discontinuity);
	});
var $author$project$Chart$Shared$continuousLineSeriesByAxis = F2(
	function (sizes, dataByAxis) {
		return _Utils_Tuple3(
			dataByAxis.o.d,
			A2($author$project$Chart$Shared$yScaleFromContinuous, sizes, dataByAxis).a,
			A2($elm$core$List$filterMap, $author$project$Visibility$toMaybe, dataByAxis.jA));
	});
var $author$project$Chart$Shared$continuousSeriesHasStats = function (_v0) {
	return false;
};
var $gampleman$elm_visualization$Scale$convert = F2(
	function (_v0, value) {
		var scale = _v0;
		return A3(scale.bh, scale.ep, scale.cO, value);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Visibility$value = function (optional) {
	if (!optional.$) {
		var a = optional.a;
		return a;
	} else {
		var a = optional.a;
		return a;
	}
};
var $author$project$Chart$Shared$singleBarHasStats = function (visibilityData) {
	return !$elm$core$List$isEmpty(
		$author$project$Visibility$value(visibilityData).V);
};
var $author$project$Chart$Shared$discreteSeriesHasStats = function (data) {
	switch (data.$) {
		case 0:
			var visibilityData = data.a;
			return $author$project$Chart$Shared$singleBarHasStats(visibilityData);
		case 1:
			var groupedSeries = data.a;
			return A2($elm$core$List$any, $author$project$Chart$Shared$singleBarHasStats, groupedSeries);
		default:
			var fakeLine = data.a;
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$List$isEmpty,
				$elm$core$Basics$not,
				$author$project$Visibility$value(fakeLine).V);
	}
};
var $author$project$Enectiva$I18n$AsFloat = function (a) {
	return {$: 1, a: a};
};
var $author$project$Enectiva$I18n$escapeDelimiter = function (delimiter) {
	if (delimiter === '.') {
		return '\\.';
	} else {
		return delimiter;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$String$reverse = _String_reverse;
var $elm$core$Basics$truncate = _Basics_truncate;
var $author$project$Enectiva$I18n$formatIntegerPartOfNumber = F2(
	function (delimiter, number) {
		var escapedDelimiter = $author$project$Enectiva$I18n$escapeDelimiter(delimiter);
		return A3(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^' + (escapedDelimiter + ('?(.+?)' + (escapedDelimiter + '?$'))))),
			function (_v0) {
				var submatches = _v0.iM;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						$elm$core$List$head(submatches)));
			},
			A3(
				$elm$core$List$foldl,
				F2(
					function (group, acc) {
						var segment = $elm$core$String$fromList(
							$elm$core$List$reverse(group));
						return _Utils_ap(
							segment,
							_Utils_ap(delimiter, acc));
					}),
				'',
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					3,
					$elm$core$String$toList(
						$elm$core$String$reverse(
							$elm$core$String$fromInt(
								$elm$core$Basics$abs(number) | 0))))));
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Enectiva$I18n$keyToKeyPath = $elm$core$String$split('.');
var $author$project$Enectiva$I18n$tHelp = F2(
	function (_v0, keyPath) {
		var translations = _v0.b;
		return A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$at, keyPath, $elm$json$Json$Decode$string),
			translations);
	});
var $author$project$Enectiva$I18n$t = F2(
	function (translations, key) {
		return A2(
			$elm$core$Result$withDefault,
			key,
			A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				$author$project$Enectiva$I18n$keyToKeyPath(key)));
	});
var $author$project$Enectiva$I18n$formatNumberWithPrecision = F3(
	function (translations, precision, number) {
		var sign = (number < 0) ? '-' : '';
		var delimiter = A2($author$project$Enectiva$I18n$t, translations, 'number.format.delimiter');
		if (!precision.$) {
			return _Utils_ap(
				sign,
				A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, number));
		} else {
			var decimalPlaces = precision.a;
			var shift = A2($elm$core$Basics$pow, 10, decimalPlaces);
			var shiftedNumber = $elm$core$Basics$round(
				$elm$core$Basics$abs(number * shift));
			var decimalPart = A3(
				$elm$core$String$padRight,
				decimalPlaces,
				'0',
				A3(
					$elm$core$String$padLeft,
					decimalPlaces,
					'0',
					$elm$core$String$fromInt(
						function (n) {
							return A2($elm$core$Basics$modBy, shift, n);
						}(shiftedNumber))));
			return _Utils_ap(
				sign,
				_Utils_ap(
					A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, (shiftedNumber / shift) | 0),
					_Utils_ap(
						A2($author$project$Enectiva$I18n$t, translations, 'number.format.separator'),
						decimalPart)));
		}
	});
var $author$project$Enectiva$I18n$formatNumber = function (translations) {
	return A2(
		$author$project$Enectiva$I18n$formatNumberWithPrecision,
		translations,
		$author$project$Enectiva$I18n$AsFloat(2));
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$View$nbsp = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(160));
var $author$project$View$spaceRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString(' '));
var $author$project$View$replaceSpacesByNbsp = function (str) {
	return A3(
		$elm$regex$Regex$replace,
		$author$project$View$spaceRegex,
		function (_v0) {
			return $author$project$View$nbsp;
		},
		str);
};
var $author$project$View$formatNumberWithNbsp = function (translations) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$formatNumber(translations),
		$author$project$View$replaceSpacesByNbsp);
};
var $author$project$Enectiva$I18n$fourDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$year, $elm$core$String$fromInt));
};
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $author$project$Enectiva$I18n$oneDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthNumber, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$monthAbbr = F2(
	function (translations, zone) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Enectiva$I18n$oneDigitMonth(zone),
			function (number) {
				return A2($author$project$Enectiva$I18n$t, translations, 'date.abbr_month_names.' + number);
			});
	});
var $author$project$Enectiva$I18n$oneDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		$elm$core$String$fromInt);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.hb;
	});
var $author$project$Enectiva$I18n$oneDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$day, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$twoDigits = A2($elm$core$String$padLeft, 2, '0');
var $author$project$Enectiva$I18n$twoDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitDay(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitMinute = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toMinute(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitMonth(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitSecond = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toSecond(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$Enectiva$I18n$twoDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$fourDigitYear(zone),
		$elm$core$String$right(2));
};
var $author$project$Enectiva$I18n$dateReplacers = F2(
	function (translations, zone) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'yyyy',
				$author$project$Enectiva$I18n$fourDigitYear(zone)),
				_Utils_Tuple2(
				'yy',
				$author$project$Enectiva$I18n$twoDigitYear(zone)),
				_Utils_Tuple2(
				'MMM',
				A2($author$project$Enectiva$I18n$monthAbbr, translations, zone)),
				_Utils_Tuple2(
				'MM',
				$author$project$Enectiva$I18n$twoDigitMonth(zone)),
				_Utils_Tuple2(
				'M',
				$author$project$Enectiva$I18n$oneDigitMonth(zone)),
				_Utils_Tuple2(
				'dd',
				$author$project$Enectiva$I18n$twoDigitDay(zone)),
				_Utils_Tuple2(
				'd',
				$author$project$Enectiva$I18n$oneDigitDay(zone)),
				_Utils_Tuple2(
				'HH',
				$author$project$Enectiva$I18n$twoDigit24Hour(zone)),
				_Utils_Tuple2(
				'H',
				$author$project$Enectiva$I18n$oneDigit24Hour(zone)),
				_Utils_Tuple2(
				'mm',
				$author$project$Enectiva$I18n$twoDigitMinute(zone)),
				_Utils_Tuple2(
				'ss',
				$author$project$Enectiva$I18n$twoDigitSecond(zone))
			]);
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $author$project$Enectiva$I18n$replacePlaceholders = F3(
	function (replacers, time, placeholder) {
		return function (replacer) {
			if (!replacer.$) {
				var r = replacer.a;
				return r(time);
			} else {
				return '';
			}
		}(
			A2(
				$elm_community$list_extra$List$Extra$findMap,
				function (_v0) {
					var p = _v0.a;
					var dr = _v0.b;
					return _Utils_eq(p, placeholder) ? $elm$core$Maybe$Just(dr) : $elm$core$Maybe$Nothing;
				},
				replacers));
	});
var $author$project$Enectiva$I18n$formatDateTimeCustomPattern = F4(
	function (pattern, translations, zone, time) {
		var replacers = A2($author$project$Enectiva$I18n$dateReplacers, translations, zone);
		var placeholdersRegex = function (s) {
			return '(' + (s + ')');
		}(
			A2(
				$elm$core$String$join,
				'|',
				A2($elm$core$List$map, $elm$core$Tuple$first, replacers)));
		var primaryRegex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('(.*?)' + placeholdersRegex));
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, matches) {
						var _v0 = matches.iM;
						_v0$2:
						while (true) {
							if (_v0.b) {
								if (_v0.a.$ === 1) {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var _v1 = _v0.a;
										var _v2 = _v0.b;
										var placeholder = _v2.a.a;
										return A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder);
									} else {
										break _v0$2;
									}
								} else {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var literal = _v0.a.a;
										var _v3 = _v0.b;
										var placeholder = _v3.a.a;
										return _Utils_ap(
											literal,
											A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder));
									} else {
										break _v0$2;
									}
								}
							} else {
								break _v0$2;
							}
						}
						return matches.ki;
					}),
				A2($elm$regex$Regex$find, primaryRegex, pattern)));
	});
var $author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate = F2(
	function (formatKey, translations) {
		return A2(
			$author$project$Enectiva$I18n$formatDateTimeCustomPattern,
			A2($author$project$Enectiva$I18n$t, translations, formatKey),
			translations);
	});
var $author$project$Enectiva$I18n$formatTimeCustom = function (formatSuffix) {
	return $author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate('time.formats.js.' + formatSuffix);
};
var $author$project$Chart$Shared$onlyFakeLineSeries = function (categoricalData) {
	return A2(
		$elm$core$List$concatMap,
		function (cd) {
			if ((cd.$ === 2) && (!cd.a.$)) {
				var series = cd.a.a;
				return _List_fromArray(
					[series]);
			} else {
				return _List_Nil;
			}
		},
		categoricalData);
};
var $gampleman$elm_visualization$Shape$Stack$calculateExtremes = function (coords) {
	var folder = F2(
		function (_v2, _v3) {
			var y1 = _v2.a;
			var y2 = _v2.b;
			var accmin = _v3.a;
			var accmax = _v3.b;
			return _Utils_Tuple2(
				A2(
					$elm$core$Basics$min,
					accmin,
					A2($elm$core$Basics$min, y1, y2)),
				A2(
					$elm$core$Basics$max,
					accmax,
					A2($elm$core$Basics$max, y1, y2)));
		});
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, _v1) {
				var mi = _v0.a;
				var ma = _v0.b;
				var accmin = _v1.a;
				var accmax = _v1.b;
				return _Utils_Tuple2(
					A2($elm$core$Basics$min, mi, accmin),
					A2($elm$core$Basics$max, ma, accmax));
			}),
		_Utils_Tuple2(0, 0),
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$List$foldl,
				folder,
				_Utils_Tuple2(0, 0)),
			coords));
};
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $gampleman$elm_visualization$Shape$Stack$computeStack = function (_v0) {
	var offset = _v0.kG;
	var order = _v0.kL;
	var data = _v0.jA;
	var _v1 = $elm$core$List$unzip(
		order(data));
	var labels = _v1.a;
	var values = _v1.b;
	var stacked = offset(
		A2(
			$elm$core$List$map,
			$elm$core$List$map(
				function (e) {
					return _Utils_Tuple2(0, e);
				}),
			values));
	return {
		jQ: $gampleman$elm_visualization$Shape$Stack$calculateExtremes(stacked),
		kb: labels,
		lB: stacked
	};
};
var $gampleman$elm_visualization$Shape$stack = $gampleman$elm_visualization$Shape$Stack$computeStack;
var $gampleman$elm_visualization$Shape$Stack$offsetNone = function (series) {
	if (!series.b) {
		return _List_Nil;
	} else {
		var x = series.a;
		var xs = series.b;
		var weirdAdd = F2(
			function (_v3, _v4) {
				var s11 = _v3.b;
				var s00 = _v4.a;
				var s01 = _v4.b;
				return $elm$core$Basics$isNaN(s01) ? _Utils_Tuple2(s00, s11 + s00) : _Utils_Tuple2(s01, s11 + s01);
			});
		var helper = F2(
			function (s1, _v2) {
				var s0 = _v2.a;
				var accum = _v2.b;
				return _Utils_Tuple2(
					A3($elm$core$List$map2, weirdAdd, s1, s0),
					A2($elm$core$List$cons, s0, accum));
			});
		return $elm$core$List$reverse(
			function (_v1) {
				var a = _v1.a;
				var b = _v1.b;
				return A2($elm$core$List$cons, a, b);
			}(
				A3(
					$elm$core$List$foldl,
					helper,
					_Utils_Tuple2(x, _List_Nil),
					xs)));
	}
};
var $gampleman$elm_visualization$Shape$stackOffsetNone = $gampleman$elm_visualization$Shape$Stack$offsetNone;
var $author$project$Chart$Shared$calculateStack = function (series) {
	return $gampleman$elm_visualization$Shape$stack(
		{
			jA: A2(
				$elm$core$List$map,
				function (s) {
					return _Utils_Tuple2(
						s.kt,
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.aW;
								},
								$elm$core$Maybe$withDefault(0)),
							s.jA));
				},
				series),
			kG: $gampleman$elm_visualization$Shape$stackOffsetNone,
			kL: $elm$core$List$reverse
		});
};
var $author$project$Chart$Shared$positiveOrOne = function (maybeMin) {
	if (!maybeMin.$) {
		var m = maybeMin.a;
		return (m > 0) ? m : 1;
	} else {
		return 1;
	}
};
var $author$project$Chart$Shared$unzip3 = function (triples) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var z = _v0.c;
			var xs = _v1.a;
			var ys = _v1.b;
			var zs = _v1.c;
			return _Utils_Tuple3(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys),
				A2($elm$core$List$cons, z, zs));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
		triples);
};
var $author$project$Chart$Shared$yDomainExtentDiscrete = F2(
	function (range, categoricalData) {
		return function (_v5) {
			var mins = _v5.a;
			var maxs = _v5.b;
			var disc = _v5.c;
			return _Utils_Tuple3(
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$List$minimum(mins)),
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$List$maximum(maxs)),
				A3($elm$core$List$foldl, $elm$core$Basics$and, true, disc));
		}(
			$author$project$Chart$Shared$unzip3(
				A2(
					$elm$core$List$filterMap,
					function (cd) {
						_v0$3:
						while (true) {
							switch (cd.$) {
								case 1:
									var series = cd.a;
									return $elm$core$Maybe$Just(
										function (_v1) {
											var min = _v1.a;
											var max = _v1.b;
											return _Utils_Tuple3(min, max, false);
										}(
											$author$project$Chart$Shared$calculateStack(
												A2($elm$core$List$filterMap, $author$project$Visibility$toMaybe, series)).jQ));
								case 0:
									if (!cd.a.$) {
										var series = cd.a.a;
										var values = A2(
											$elm$core$List$filterMap,
											function ($) {
												return $.aW;
											},
											series.jA);
										var dataMin = function () {
											switch (range.$) {
												case 1:
													var m = range.a;
													return m;
												case 0:
													return $author$project$Chart$Shared$negativeOrZero(
														$elm$core$List$minimum(values));
												default:
													return $author$project$Chart$Shared$negativeOrZero(
														$elm$core$List$minimum(values));
											}
										}();
										var dataMax = $author$project$Chart$Shared$positiveOrOne(
											$elm$core$List$maximum(values));
										return _Utils_eq(dataMin, dataMax) ? ((dataMin < 0) ? $elm$core$Maybe$Just(
											_Utils_Tuple3(dataMin, 0, false)) : $elm$core$Maybe$Just(
											_Utils_Tuple3(0, dataMax, false))) : $elm$core$Maybe$Just(
											_Utils_Tuple3(dataMin, dataMax, false));
									} else {
										break _v0$3;
									}
								default:
									if (!cd.a.$) {
										var series = cd.a.a;
										var max = A2(
											$elm$core$Maybe$withDefault,
											1,
											$elm$core$List$maximum(
												A2(
													$elm$core$List$filterMap,
													function ($) {
														return $.aW;
													},
													series.jA)));
										var _v3 = function () {
											switch (range.$) {
												case 1:
													var m = range.a;
													return _Utils_Tuple2(m, false);
												case 0:
													return function (m) {
														return _Utils_Tuple2(m, false);
													}(
														$author$project$Chart$Shared$negativeOrZero(
															$elm$core$List$minimum(
																A2(
																	$elm$core$List$filterMap,
																	function ($) {
																		return $.aW;
																	},
																	series.jA))));
												default:
													return A2(
														$author$project$Chart$Shared$dynamicRangeMin,
														max,
														$elm$core$List$minimum(
															A2(
																$elm$core$List$filterMap,
																function ($) {
																	return $.aW;
																},
																series.jA)));
											}
										}();
										var min = _v3.a;
										var discontinuity = _v3.b;
										return $elm$core$Maybe$Just(
											_Utils_Tuple3(min, max, discontinuity));
									} else {
										break _v0$3;
									}
							}
						}
						return $elm$core$Maybe$Nothing;
					},
					categoricalData)));
	});
var $author$project$Chart$Shared$yScaleFromAxisData = F2(
	function (sizes, yAxisData) {
		var _v0 = A2($author$project$Chart$Shared$yDomainExtentDiscrete, yAxisData.o.cO, yAxisData.jA);
		var min = _v0.a;
		var max = _v0.b;
		var discontinuity = _v0.c;
		return _Utils_Tuple2(
			A2(
				$gampleman$elm_visualization$Scale$nice,
				$author$project$Chart$Shared$yAxisTickCount(sizes.p),
				A2(
					$gampleman$elm_visualization$Scale$linear,
					_Utils_Tuple2(
						A2($author$project$Chart$Shared$yAxisHeight, sizes, discontinuity),
						0),
					_Utils_Tuple2(min, max))),
			discontinuity);
	});
var $author$project$Chart$Shared$lineSeriesByAxis = F2(
	function (sizes, dataByAxis) {
		return _Utils_Tuple3(
			dataByAxis.o.d,
			A2($author$project$Chart$Shared$yScaleFromAxisData, sizes, dataByAxis).a,
			A2(
				$elm$core$List$map,
				function (s) {
					return _Utils_Tuple2(s, 0);
				},
				$author$project$Chart$Shared$onlyFakeLineSeries(dataByAxis.jA)));
	});
var $gampleman$elm_visualization$Scale$bandwidth = function (_v0) {
	var scale = _v0;
	return scale.eg;
};
var $author$project$Chart$Shared$lineSizesInCategoricalChart = F2(
	function (scaleX, sizes) {
		return _Utils_update(
			sizes,
			{
				ca: sizes.ca + ($gampleman$elm_visualization$Scale$bandwidth(scaleX) / 2)
			});
	});
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $gampleman$elm_visualization$Scale$Time$timeLength = function (interval) {
	switch (interval) {
		case 15:
			return 1;
		case 14:
			return 1000;
		case 13:
			return 60 * 1000;
		case 12:
			return (60 * 60) * 1000;
		case 11:
			return ((24 * 60) * 60) * 1000;
		case 2:
			return (((30 * 24) * 60) * 60) * 1000;
		case 0:
			return ((((365 * 30) * 24) * 60) * 60) * 1000;
		case 1:
			return ((((4 * 30) * 24) * 60) * 60) * 1000;
		case 3:
			return (((7 * 24) * 60) * 60) * 1000;
		default:
			return 0;
	}
};
var $gampleman$elm_visualization$Scale$Time$findInterval = F2(
	function (target, intervals) {
		findInterval:
		while (true) {
			if (!intervals.b) {
				return _Utils_Tuple2(0, 1);
			} else {
				if (intervals.b.b) {
					var _v1 = intervals.a;
					var interval = _v1.a;
					var step = _v1.b;
					var _v2 = intervals.b;
					var _v3 = _v2.a;
					var interval_ = _v3.a;
					var step_ = _v3.b;
					var xs = _v2.b;
					var ratio_ = (step_ * $gampleman$elm_visualization$Scale$Time$timeLength(interval_)) / target;
					var ratio = target / (step * $gampleman$elm_visualization$Scale$Time$timeLength(interval));
					if (_Utils_cmp(ratio, ratio_) < 0) {
						return _Utils_Tuple2(interval, step);
					} else {
						var $temp$target = target,
							$temp$intervals = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(interval_, step_),
							xs);
						target = $temp$target;
						intervals = $temp$intervals;
						continue findInterval;
					}
				} else {
					var x = intervals.a;
					return x;
				}
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$Hour = 12;
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $justinmimbs$time_extra$Time$Extra$Second = 14;
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $gampleman$elm_visualization$Scale$Time$tickIntervals = _List_fromArray(
	[
		_Utils_Tuple2(14, 1),
		_Utils_Tuple2(14, 5),
		_Utils_Tuple2(14, 15),
		_Utils_Tuple2(14, 30),
		_Utils_Tuple2(13, 1),
		_Utils_Tuple2(13, 5),
		_Utils_Tuple2(13, 15),
		_Utils_Tuple2(13, 30),
		_Utils_Tuple2(12, 1),
		_Utils_Tuple2(12, 3),
		_Utils_Tuple2(12, 6),
		_Utils_Tuple2(12, 12),
		_Utils_Tuple2(11, 1),
		_Utils_Tuple2(11, 2),
		_Utils_Tuple2(3, 1),
		_Utils_Tuple2(2, 1),
		_Utils_Tuple2(2, 3),
		_Utils_Tuple2(0, 1)
	]);
var $gampleman$elm_visualization$Scale$Time$toTime = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	return _Utils_Tuple2(
		$elm$time$Time$posixToMillis(a),
		$elm$time$Time$posixToMillis(b));
};
var $gampleman$elm_visualization$Scale$Time$nice = F3(
	function (zone, domain, count) {
		var _v0 = $gampleman$elm_visualization$Scale$Time$toTime(domain);
		var start = _v0.a;
		var end = _v0.b;
		var target = $elm$core$Basics$abs(start - end) / count;
		var _v1 = A2($gampleman$elm_visualization$Scale$Time$findInterval, target, $gampleman$elm_visualization$Scale$Time$tickIntervals);
		var interval = _v1.a;
		return _Utils_Tuple2(
			A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, domain.a),
			A3($justinmimbs$time_extra$Time$Extra$ceiling, interval, zone, domain.b));
	});
var $ryan_haskell$date_format$DateFormat$AmPmLowercase = {$: 23};
var $ryan_haskell$date_format$DateFormat$amPmLowercase = $ryan_haskell$date_format$DateFormat$AmPmLowercase;
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {lk: toAmPm, lm: toMonthAbbreviation, ln: toMonthName, c0: toOrdinalSuffix, lr: toWeekdayAbbreviation, ls: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.lk(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$core$String$toLower = _String_toLower;
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$core$String$toUpper = _String_toUpper;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.c0(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.lm(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.ln(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.c0(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.c0(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.c0(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.c0(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.lr(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.ls(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.c0(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$HourFixed = {$: 27};
var $ryan_haskell$date_format$DateFormat$hourFixed = $ryan_haskell$date_format$DateFormat$HourFixed;
var $ryan_haskell$date_format$DateFormat$MillisecondFixed = {$: 35};
var $ryan_haskell$date_format$DateFormat$millisecondFixed = $ryan_haskell$date_format$DateFormat$MillisecondFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $ryan_haskell$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryan_haskell$date_format$DateFormat$monthNameFull = $ryan_haskell$date_format$DateFormat$MonthNameFull;
var $ryan_haskell$date_format$DateFormat$SecondFixed = {$: 33};
var $ryan_haskell$date_format$DateFormat$secondFixed = $ryan_haskell$date_format$DateFormat$SecondFixed;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $gampleman$elm_visualization$Scale$Time$tickFormat = F4(
	function (zone, _v0, _v1, date) {
		var time = $elm$time$Time$posixToMillis(date);
		var significant = function (interval) {
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(
					A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, date)),
				time) < 0;
		};
		var format = significant(14) ? _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$text('.'),
				$ryan_haskell$date_format$DateFormat$millisecondFixed
			]) : (significant(13) ? _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$secondFixed
			]) : (significant(12) ? _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$hourFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]) : (significant(11) ? _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$hourFixed,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$amPmLowercase
			]) : (significant(2) ? _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$monthNameAbbreviated
			]) : (significant(0) ? _List_fromArray(
			[$ryan_haskell$date_format$DateFormat$monthNameFull]) : _List_fromArray(
			[$ryan_haskell$date_format$DateFormat$yearNumber]))))));
		return A3($ryan_haskell$date_format$DateFormat$format, format, zone, date);
	});
var $justinmimbs$time_extra$Time$Extra$rangeHelp = F6(
	function (interval, step, zone, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$time$Time$posixToMillis(current),
				$elm$time$Time$posixToMillis(until)) < 0) {
				var $temp$interval = interval,
					$temp$step = step,
					$temp$zone = zone,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = A4($justinmimbs$time_extra$Time$Extra$add, interval, step, zone, current);
				interval = $temp$interval;
				step = $temp$step;
				zone = $temp$zone;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$range = F5(
	function (interval, step, zone, start, until) {
		return A6(
			$justinmimbs$time_extra$Time$Extra$rangeHelp,
			interval,
			A2($elm$core$Basics$max, 1, step),
			zone,
			until,
			_List_Nil,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, interval, zone, start));
	});
var $gampleman$elm_visualization$Scale$Time$ticks = F3(
	function (zone, domain, count) {
		var _v0 = $gampleman$elm_visualization$Scale$Time$toTime(domain);
		var start = _v0.a;
		var end = _v0.b;
		var target = $elm$core$Basics$abs(start - end) / count;
		var _v1 = A2($gampleman$elm_visualization$Scale$Time$findInterval, target, $gampleman$elm_visualization$Scale$Time$tickIntervals);
		var interval = _v1.a;
		var step = _v1.b;
		return A5(
			$justinmimbs$time_extra$Time$Extra$range,
			interval,
			$elm$core$Basics$round(step),
			zone,
			domain.a,
			domain.b);
	});
var $gampleman$elm_visualization$Scale$Time$scale = F3(
	function (zone, range_, domain_) {
		return {
			bh: A2(
				$gampleman$elm_visualization$Scale$Continuous$convertTransform,
				A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$Basics$toFloat),
				$gampleman$elm_visualization$Interpolation$float),
			ep: domain_,
			j5: A2(
				$gampleman$elm_visualization$Scale$Continuous$invertTransform,
				A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$Basics$toFloat),
				A2($elm$core$Basics$composeR, $elm$core$Basics$round, $elm$time$Time$millisToPosix)),
			h0: $gampleman$elm_visualization$Scale$Time$nice(zone),
			cO: range_,
			gj: F2(
				function (_v0, r) {
					return r;
				}),
			gC: $gampleman$elm_visualization$Scale$Time$tickFormat(zone),
			gD: $gampleman$elm_visualization$Scale$Time$ticks(zone)
		};
	});
var $gampleman$elm_visualization$Scale$time = F3(
	function (zone, range_, domain_) {
		return A3($gampleman$elm_visualization$Scale$Time$scale, zone, range_, domain_);
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Chart$Shared$timeXRange = F3(
	function (timeZone, now, seriesWithShifts) {
		var _v0 = A3(
			$elm$core$Tuple$mapBoth,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$elm$core$List$unzip(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var data = _v1.a.jA;
						var shift = _v1.b;
						return _Utils_Tuple2(
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bT;
									},
									A2($author$project$Chart$Shared$applyTemporalShift, shift, timeZone)),
								$elm$core$List$head(data)),
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bT;
									},
									A2($author$project$Chart$Shared$applyTemporalShift, shift, timeZone)),
								$elm_community$list_extra$List$Extra$last(data)));
					},
					seriesWithShifts)));
		var starts = _v0.a;
		var ends = _v0.b;
		var max = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$posixToMillis(now),
			$elm$core$List$maximum(
				A2($elm$core$List$map, $elm$time$Time$posixToMillis, ends)));
		var min = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$posixToMillis(now),
			$elm$core$List$minimum(
				A2($elm$core$List$map, $elm$time$Time$posixToMillis, starts)));
		return _Utils_eq(min, max) ? _Utils_Tuple2(
			$elm$time$Time$millisToPosix(min - ((60 * 60) * 1000)),
			$elm$time$Time$millisToPosix(max + ((60 * 60) * 1000))) : _Utils_Tuple2(
			$elm$time$Time$millisToPosix(min),
			$elm$time$Time$millisToPosix(max));
	});
var $author$project$Chart$Shared$timeXScale = F4(
	function (sizes, timeZone, now, seriesWithShifts) {
		return A3(
			$gampleman$elm_visualization$Scale$time,
			timeZone,
			_Utils_Tuple2(0, (sizes.h - sizes.ca) - sizes.gl),
			A3($author$project$Chart$Shared$timeXRange, timeZone, now, seriesWithShifts));
	});
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$minimumBy = F2(
	function (f, ls) {
		var minBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) < 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						minBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Chart$Shared$tooltipDistance = 10;
var $author$project$Chart$Shared$tooltipForClosestLineDataPoint = F7(
	function (sizes, _v0, transitioningTooltip, seriesByAxis, dpX, labelFormatter, valueFormatter) {
		var x = _v0.M;
		var y = _v0.N;
		var thresholdDistance = function () {
			var _v5 = $gampleman$elm_visualization$Transition$value(transitioningTooltip);
			if (!_v5.$) {
				var opacity = _v5.a.bJ;
				return (!opacity) ? $author$project$Chart$Shared$tooltipDistance : ($author$project$Chart$Shared$tooltipDistance * 5);
			} else {
				return $author$project$Chart$Shared$tooltipDistance;
			}
		}();
		var closeDataPoints = A2(
			$elm$core$List$concatMap,
			function (_v2) {
				var unit = _v2.a;
				var scaleY = _v2.b;
				var series = _v2.c;
				return A2(
					$elm$core$List$concatMap,
					function (_v3) {
						var s = _v3.a;
						var customArgument = _v3.b;
						return A2(
							$elm$core$List$filterMap,
							function (dp) {
								var _v4 = dp.aW;
								if (_v4.$ === 1) {
									return $elm$core$Maybe$Nothing;
								} else {
									var v = _v4.a;
									var dpy = A2($gampleman$elm_visualization$Scale$convert, scaleY, v) + sizes.ci;
									var dpx = A2(dpX, customArgument, dp) + sizes.ca;
									var distance = $elm$core$Basics$sqrt(
										A2($elm$core$Basics$pow, dpx - x, 2) + A2($elm$core$Basics$pow, dpy - y, 2));
									return (_Utils_cmp(distance, thresholdDistance) < 0) ? $elm$core$Maybe$Just(
										_Utils_Tuple2(
											distance,
											{
												g7: dp,
												g8: {a9: 0, M: dpx, N: dpy},
												aJ: s.kt,
												i$: unit
											})) : $elm$core$Maybe$Nothing;
								}
							},
							s.jA);
					},
					series);
			},
			seriesByAxis);
		var closestDataPoint = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2($elm_community$list_extra$List$Extra$minimumBy, $elm$core$Tuple$first, closeDataPoints));
		return $elm_community$maybe_extra$Maybe$Extra$join(
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var dataPoint = _v1.g7;
					var dataPointCoords = _v1.g8;
					var seriesName = _v1.aJ;
					var unit = _v1.i$;
					return A2(
						$elm$core$Maybe$map,
						function (v) {
							return {
								O: dataPointCoords,
								fF: labelFormatter(dataPoint),
								d: $elm$core$Maybe$Just(seriesName),
								i$: unit,
								aW: A2(valueFormatter, v, dataPoint),
								bY: true
							};
						},
						dataPoint.aW);
				},
				closestDataPoint));
	});
var $author$project$Chart$Shared$visibleContinuousSeries = F2(
	function (primaryYAxisData, secondaryYAxisData) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2($elm$core$List$filterMap, $author$project$Visibility$toMaybe, primaryYAxisData.jA)),
						A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jA;
							},
							$elm$core$List$filterMap($author$project$Visibility$toMaybe)),
						secondaryYAxisData)
					])));
	});
var $author$project$Chart$Shared$newTooltipFromCoordinates = F4(
	function (translations, dimensionConfig, state, coords) {
		var timeZone = state.iU;
		var _v0 = state.jA;
		switch (_v0.$) {
			case 0:
				var now = _v0.a;
				var primaryYAxisData = _v0.b;
				var secondaryYAxisData = _v0.c;
				var visibleSeries = A2($author$project$Chart$Shared$visibleContinuousSeries, primaryYAxisData, secondaryYAxisData);
				var sizes = A4($author$project$Chart$Shared$calculateSizes, $author$project$Chart$Shared$continuousSeriesHasStats, primaryYAxisData, secondaryYAxisData, dimensionConfig);
				var seriesByAxis = A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2($author$project$Chart$Shared$continuousLineSeriesByAxis, sizes, primaryYAxisData)),
							A2(
							$elm$core$Maybe$map,
							$author$project$Chart$Shared$continuousLineSeriesByAxis(sizes),
							secondaryYAxisData)
						]));
				var scaleX = A4($author$project$Chart$Shared$timeXScale, sizes, timeZone, now, visibleSeries);
				return A7(
					$author$project$Chart$Shared$tooltipForClosestLineDataPoint,
					sizes,
					coords,
					state.K,
					seriesByAxis,
					F2(
						function (shift, dp) {
							return A2(
								$gampleman$elm_visualization$Scale$convert,
								scaleX,
								A3($author$project$Chart$Shared$applyTemporalShift, shift, timeZone, dp.bT));
						}),
					function (dp) {
						return A4($author$project$Enectiva$I18n$formatTimeCustom, 'date_and_time', translations, timeZone, dp.bT);
					},
					F2(
						function (v, dp) {
							var _v1 = dp.fF;
							if (!_v1.$) {
								var valueLabel = _v1.a;
								return valueLabel;
							} else {
								return A2($author$project$View$formatNumberWithNbsp, translations, v);
							}
						}));
			case 1:
				var categories = _v0.b;
				var primaryYAxisData = _v0.c;
				var secondaryYAxisData = _v0.d;
				var sizes = A4($author$project$Chart$Shared$calculateSizes, $author$project$Chart$Shared$discreteSeriesHasStats, primaryYAxisData, secondaryYAxisData, dimensionConfig);
				var seriesByAxis = A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2($author$project$Chart$Shared$lineSeriesByAxis, sizes, primaryYAxisData)),
							A2(
							$elm$core$Maybe$map,
							$author$project$Chart$Shared$lineSeriesByAxis(sizes),
							secondaryYAxisData)
						]));
				var scaleX = A2($author$project$Chart$Shared$categoricalXScale, sizes, categories);
				return A7(
					$author$project$Chart$Shared$tooltipForClosestLineDataPoint,
					A2($author$project$Chart$Shared$lineSizesInCategoricalChart, scaleX, sizes),
					coords,
					state.K,
					seriesByAxis,
					F2(
						function (_v2, _v3) {
							var category = _v3.aN;
							return A2($gampleman$elm_visualization$Scale$convert, scaleX, category);
						}),
					function (_v4) {
						var category = _v4.aN;
						var preformattedLabel = _v4.bL;
						return A2($elm$core$Maybe$withDefault, category, preformattedLabel);
					},
					F2(
						function (v, dp) {
							return A2($author$project$View$formatNumberWithNbsp, translations, v);
						}));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Ports$openNativeDialog = function (id) {
	return $author$project$Ports$toggleNativeDialog(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'show',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $gampleman$elm_visualization$Transition$step = F2(
	function (ms, _v0) {
		var transition = _v0;
		if (_Utils_cmp(ms + transition.al, transition.bq) > 0) {
			if (_Utils_cmp(transition.aU + 1, transition.ct) > -1) {
				return _Utils_update(
					transition,
					{al: transition.bq});
			} else {
				var _v1 = transition.dP;
				if (!_v1) {
					return _Utils_update(
						transition,
						{
							b8: function (t) {
								return transition.b8(1 - t);
							},
							aU: transition.aU + 1,
							al: (transition.al - ms) - transition.bq
						});
				} else {
					return _Utils_update(
						transition,
						{aU: transition.aU + 1, al: (transition.al - ms) - transition.bq});
				}
			}
		} else {
			return _Utils_update(
				transition,
				{al: transition.al + ms});
		}
	});
var $author$project$Visibility$toggle = function (optional) {
	if (!optional.$) {
		var a = optional.a;
		return $author$project$Visibility$Hidden(a);
	} else {
		var a = optional.a;
		return $author$project$Visibility$Visible(a);
	}
};
var $author$project$Chart$Shared$toggleSeriesVisibilityByIndex = F3(
	function (index, getter, series) {
		return _Utils_eq(
			index,
			getter(
				$author$project$Visibility$value(series)).r) ? $author$project$Visibility$toggle(series) : series;
	});
var $author$project$Chart$Shared$toggleContinuousSeriesVisibilityByIndex = F2(
	function (index, byAxis) {
		var data = A2(
			$elm$core$List$map,
			A2($author$project$Chart$Shared$toggleSeriesVisibilityByIndex, index, $elm$core$Tuple$first),
			byAxis.jA);
		return _Utils_update(
			byAxis,
			{jA: data});
	});
var $author$project$Chart$Shared$toggleDiscreteSeriesVisibilityByIndex = F2(
	function (index, byAxis) {
		var data = A2(
			$elm$core$List$map,
			function (cd) {
				switch (cd.$) {
					case 0:
						var s = cd.a;
						return $author$project$Chart$Shared$SingleBar(
							A3($author$project$Chart$Shared$toggleSeriesVisibilityByIndex, index, $elm$core$Basics$identity, s));
					case 1:
						var ss = cd.a;
						return $author$project$Chart$Shared$BarGroup(
							A2(
								$elm$core$List$map,
								A2($author$project$Chart$Shared$toggleSeriesVisibilityByIndex, index, $elm$core$Basics$identity),
								ss));
					default:
						var s = cd.a;
						return $author$project$Chart$Shared$FakeLine(
							A3($author$project$Chart$Shared$toggleSeriesVisibilityByIndex, index, $elm$core$Basics$identity, s));
				}
			},
			byAxis.jA);
		return _Utils_update(
			byAxis,
			{jA: data});
	});
var $author$project$Chart$Shared$toggleSeriesVisibilityInSetByIndex = F2(
	function (index, data) {
		switch (data.$) {
			case 0:
				var now = data.a;
				var primaryYAxisData = data.b;
				var secondaryYAxisData = data.c;
				return A3(
					$author$project$Chart$Shared$Continuous,
					now,
					A2($author$project$Chart$Shared$toggleContinuousSeriesVisibilityByIndex, index, primaryYAxisData),
					A2(
						$elm$core$Maybe$map,
						$author$project$Chart$Shared$toggleContinuousSeriesVisibilityByIndex(index),
						secondaryYAxisData));
			case 1:
				var barsOrientation = data.a;
				var categories = data.b;
				var primaryYAxisData = data.c;
				var secondaryYAxisData = data.d;
				return A4(
					$author$project$Chart$Shared$Discrete,
					barsOrientation,
					categories,
					A2($author$project$Chart$Shared$toggleDiscreteSeriesVisibilityByIndex, index, primaryYAxisData),
					A2(
						$elm$core$Maybe$map,
						$author$project$Chart$Shared$toggleDiscreteSeriesVisibilityByIndex(index),
						secondaryYAxisData));
			default:
				return data;
		}
	});
var $author$project$Chart$Shared$CoordinatesOfChartReceived = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Chart$Shared$defaultRatio = 2.2;
var $author$project$Chart$Shared$limitHeightToWindow = F2(
	function (windowHeight, dc) {
		return function (height) {
			return _Utils_update(
				dc,
				{p: height});
		}(
			$elm$core$Basics$ceiling(
				A2(
					$elm$core$Maybe$withDefault,
					1,
					$elm$core$List$minimum(
						_List_fromArray(
							[windowHeight * 0.75, dc.h / $author$project$Chart$Shared$defaultRatio])))));
	});
var $author$project$Chart$Shared$updateContainerResized = F5(
	function (containerWidth, windowHeight, maybeDimensionConfig, tagger, state) {
		if (containerWidth < 1) {
			return $author$project$Chart$Shared$noParentMsg(
				$author$project$Enectiva$Util$noCmd(
					tagger(state)));
		} else {
			var config = A2(
				$author$project$Chart$Shared$limitHeightToWindow,
				windowHeight,
				function (dc) {
					return _Utils_update(
						dc,
						{h: containerWidth});
				}(
					A2(
						$elm$core$Maybe$withDefault,
						{p: 1, h: 1},
						maybeDimensionConfig)));
			return $author$project$Chart$Shared$noParentMsg(
				_Utils_Tuple2(
					A2($author$project$Chart$Shared$KnownDimensions, config, state),
					A2(
						$elm$core$Task$attempt,
						$author$project$Chart$Shared$CoordinatesOfChartReceived,
						$elm$browser$Browser$Dom$getElement(state.dh))));
		}
	});
var $gampleman$elm_visualization$Interpolation$map4 = F5(
	function (fn, a, b, c, d) {
		return function (t) {
			return A4(
				fn,
				a(t),
				b(t),
				c(t),
				d(t));
		};
	});
var $author$project$Chart$Shared$newTooltipTransition = F2(
	function (oldTransitioningTooltip, newTooltip) {
		var _v0 = _Utils_Tuple2(
			$gampleman$elm_visualization$Transition$value(oldTransitioningTooltip),
			newTooltip);
		if (_v0.a.$ === 1) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var nt = _v0.b.a;
				return $author$project$Enectiva$Util$noCmd(
					A2(
						$gampleman$elm_visualization$Transition$for,
						$author$project$Chart$Shared$tooltipAnimationLength,
						A2(
							$gampleman$elm_visualization$Interpolation$map,
							function (o) {
								return $elm$core$Maybe$Just(
									{b5: 0, bJ: o, K: nt});
							},
							A2($gampleman$elm_visualization$Interpolation$float, 0, 1))));
			} else {
				return $author$project$Enectiva$Util$noCmd(
					$gampleman$elm_visualization$Transition$constant($elm$core$Maybe$Nothing));
			}
		} else {
			if (!_v0.b.$) {
				var generation = _v0.a.a.b5;
				var tooltip = _v0.a.a.K;
				var opacity = _v0.a.a.bJ;
				var nt = _v0.b.a;
				return $author$project$Enectiva$Util$noCmd(
					A2(
						$gampleman$elm_visualization$Transition$for,
						$author$project$Chart$Shared$tooltipAnimationLength,
						A5(
							$gampleman$elm_visualization$Interpolation$map4,
							F4(
								function (x, y, tw, o) {
									return $elm$core$Maybe$Just(
										{
											b5: generation + 1,
											bJ: o,
											K: _Utils_update(
												nt,
												{
													O: {a9: tw, M: x, N: y}
												})
										});
								}),
							A2($gampleman$elm_visualization$Interpolation$float, tooltip.O.M, nt.O.M),
							A2($gampleman$elm_visualization$Interpolation$float, tooltip.O.N, nt.O.N),
							A2($gampleman$elm_visualization$Interpolation$float, tooltip.O.a9, nt.O.a9),
							A2($gampleman$elm_visualization$Interpolation$float, opacity, 1))));
			} else {
				var tooltip = _v0.a.a.K;
				var generation = _v0.a.a.b5;
				var _v2 = _v0.b;
				var cmd = tooltip.bY ? $author$project$Chart$Shared$eventuallyExpireTooltip(generation) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(oldTransitioningTooltip, cmd);
			}
		}
	});
var $author$project$Chart$Shared$updateTooltip = F2(
	function (state, tooltip) {
		var _v0 = A2($author$project$Chart$Shared$newTooltipTransition, state.K, tooltip);
		var newTooltip = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{K: newTooltip}),
			cmd);
	});
var $author$project$Chart$Shared$updateKnownDimensions = F4(
	function (translations, msg, dimensionConfig, state) {
		switch (msg.$) {
			case 0:
				var coords = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
						A2(
							$author$project$Chart$Shared$updateTooltip,
							state,
							A4($author$project$Chart$Shared$newTooltipFromCoordinates, translations, dimensionConfig, state, coords))));
			case 1:
				var coords = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
						A2(
							$author$project$Chart$Shared$updateTooltip,
							state,
							A4(
								$author$project$Chart$Shared$newTooltipFromCoordinates,
								translations,
								dimensionConfig,
								state,
								A2($author$project$Chart$Shared$diffCoords, coords, state.e$)))));
			case 6:
				var tooltip = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
						A2(
							$author$project$Chart$Shared$updateTooltip,
							state,
							$elm$core$Maybe$Just(tooltip))));
			case 7:
				return A2(
					$TSFoster$elm_tuple_extra$Tuple3$mapFirst,
					$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
					$author$project$Chart$Shared$expireTooltip(state));
			case 8:
				var tooltip = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
						A2(
							$author$project$Chart$Shared$updateTooltip,
							state,
							$elm$core$Maybe$Just(tooltip))));
			case 9:
				return A2(
					$TSFoster$elm_tuple_extra$Tuple3$mapFirst,
					$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
					$author$project$Chart$Shared$expireTooltip(state));
			case 10:
				var dataPointIndex = msg.a;
				return A2(
					$TSFoster$elm_tuple_extra$Tuple3$mapFirst,
					$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
					A2(
						$author$project$Chart$Shared$drillDown,
						state,
						$elm$core$Maybe$Just(dataPointIndex)));
			case 11:
				return A2(
					$TSFoster$elm_tuple_extra$Tuple3$mapFirst,
					$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
					A2($author$project$Chart$Shared$drillDown, state, $elm$core$Maybe$Nothing));
			case 12:
				var tooltip = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
						A2(
							$author$project$Chart$Shared$updateTooltip,
							state,
							$elm$core$Maybe$Just(tooltip))));
			case 13:
				return A2(
					$TSFoster$elm_tuple_extra$Tuple3$mapFirst,
					$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
					$author$project$Chart$Shared$expireTooltip(state));
			case 14:
				return A2(
					$TSFoster$elm_tuple_extra$Tuple3$mapFirst,
					$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
					$author$project$Chart$Shared$drillUp(state));
			case 15:
				var generation = msg.a;
				var _v1 = $gampleman$elm_visualization$Transition$value(state.K);
				if (!_v1.$) {
					var tooltip = _v1.a;
					return _Utils_eq(generation, tooltip.b5) ? $author$project$Chart$Shared$noParentMsg(
						$author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Chart$Shared$KnownDimensions,
								dimensionConfig,
								_Utils_update(
									state,
									{
										K: A2(
											$gampleman$elm_visualization$Transition$for,
											$author$project$Chart$Shared$tooltipAnimationLength,
											A2(
												$gampleman$elm_visualization$Interpolation$map,
												function (o) {
													return $elm$core$Maybe$Just(
														_Utils_update(
															tooltip,
															{bJ: o}));
												},
												A2($gampleman$elm_visualization$Interpolation$float, tooltip.bJ, 0)))
									})))) : $author$project$Chart$Shared$noParentMsg(
						$author$project$Enectiva$Util$noCmd(
							A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state)));
				} else {
					return $author$project$Chart$Shared$noParentMsg(
						$author$project$Enectiva$Util$noCmd(
							A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state)));
				}
			case 2:
				if (!msg.a.$) {
					var element = msg.a.a.hk;
					return $author$project$Chart$Shared$noParentMsg(
						$author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Chart$Shared$KnownDimensions,
								dimensionConfig,
								_Utils_update(
									state,
									{
										e$: {M: element.M, N: element.N}
									}))));
				} else {
					return $author$project$Chart$Shared$noParentMsg(
						$author$project$Enectiva$Util$noCmd(
							A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state)));
				}
			case 3:
				var index = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Chart$Shared$KnownDimensions,
							dimensionConfig,
							_Utils_update(
								state,
								{
									jA: A2($author$project$Chart$Shared$toggleSeriesVisibilityInSetByIndex, index, state.jA)
								}))));
			case 5:
				var t = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Chart$Shared$KnownDimensions,
							dimensionConfig,
							_Utils_update(
								state,
								{
									K: A2($gampleman$elm_visualization$Transition$step, t, state.K)
								}))));
			case 4:
				var containerWidth = msg.a;
				var windowHeight = msg.b;
				return A5(
					$author$project$Chart$Shared$updateContainerResized,
					containerWidth,
					windowHeight,
					$elm$core$Maybe$Just(dimensionConfig),
					$author$project$Chart$Shared$KnownDimensions(dimensionConfig),
					state);
			case 16:
				var statHighlight = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Chart$Shared$KnownDimensions,
							dimensionConfig,
							_Utils_update(
								state,
								{
									bR: $elm$core$Maybe$Just(
										_List_fromArray(
											[statHighlight]))
								}))));
			case 17:
				var statHighlight = msg.a;
				return _Utils_eq(
					state.bR,
					$elm$core$Maybe$Just(
						_List_fromArray(
							[statHighlight]))) ? $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Chart$Shared$KnownDimensions,
							dimensionConfig,
							_Utils_update(
								state,
								{bR: $elm$core$Maybe$Nothing})))) : $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state)));
			case 18:
				var statHighlights = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Chart$Shared$KnownDimensions,
							dimensionConfig,
							_Utils_update(
								state,
								{
									bR: $elm$core$Maybe$Just(statHighlights)
								}))));
			case 19:
				var statHighlights = msg.a;
				return _Utils_eq(
					state.bR,
					$elm$core$Maybe$Just(statHighlights)) ? $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Chart$Shared$KnownDimensions,
							dimensionConfig,
							_Utils_update(
								state,
								{bR: $elm$core$Maybe$Nothing})))) : $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state)));
			case 20:
				return $author$project$Chart$Shared$noParentMsg(
					_Utils_Tuple2(
						A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state),
						$author$project$Ports$openNativeDialog($author$project$Chart$Shared$moreStatsDialogId)));
			case 21:
				return $author$project$Chart$Shared$noParentMsg(
					_Utils_Tuple2(
						A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state),
						$author$project$Ports$closeNativeDialog($author$project$Chart$Shared$moreStatsDialogId)));
			case 22:
				var displayPrimaryStats = msg.a;
				return $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Chart$Shared$KnownDimensions,
							dimensionConfig,
							_Utils_update(
								state,
								{fj: displayPrimaryStats}))));
			default:
				return $author$project$Chart$Shared$noParentMsg(
					$author$project$Enectiva$Util$noCmd(
						A2($author$project$Chart$Shared$KnownDimensions, dimensionConfig, state)));
		}
	});
var $author$project$Chart$Shared$updateUnknownDimensions = F2(
	function (msg, state) {
		if (msg.$ === 4) {
			var containerWidth = msg.a;
			var windowHeight = msg.b;
			return A5($author$project$Chart$Shared$updateContainerResized, containerWidth, windowHeight, $elm$core$Maybe$Nothing, $author$project$Chart$Shared$UnknownDimensions, state);
		} else {
			return $author$project$Chart$Shared$noParentMsg(
				$author$project$Enectiva$Util$noCmd(
					$author$project$Chart$Shared$UnknownDimensions(state)));
		}
	});
var $author$project$Chart$Shared$update = F3(
	function (translations, msg, model) {
		if (model.$ === 1) {
			var dc = model.a;
			var s = model.b;
			return A4($author$project$Chart$Shared$updateKnownDimensions, translations, msg, dc, s);
		} else {
			var s = model.a;
			return A2($author$project$Chart$Shared$updateUnknownDimensions, msg, s);
		}
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$EventHighlight = function (a) {
	return {$: 1, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$RangeHighlight = function (a) {
	return {$: 2, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg = function (chart) {
	return _Utils_Tuple2(chart, $elm$core$Maybe$Nothing);
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$shortenedScaleMax = $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$maxBuckets * $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$update = F2(
	function (msg, chart) {
		var durationFilter = chart.bB;
		var histogramPolicy = chart.ew;
		switch (msg.$) {
			case 0:
				var sortBy = msg.a;
				var direction = msg.b;
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{
							eV: {dr: direction, dV: sortBy}
						}));
			case 1:
				if (!msg.a) {
					var _v1 = msg.a;
					var value = msg.b;
					return (_Utils_cmp(value, durationFilter.S) < 0) ? $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
						_Utils_update(
							chart,
							{
								bB: _Utils_update(
									durationFilter,
									{Z: value})
							})) : $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(chart);
				} else {
					var _v2 = msg.a;
					var value = msg.b;
					var unscaledValue = function () {
						if (histogramPolicy.$ === 1) {
							return _Utils_eq(value, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$shortenedScaleMax) ? chart.ep.S : value;
						} else {
							return value;
						}
					}();
					return (_Utils_cmp(unscaledValue, durationFilter.Z) > 0) ? $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
						_Utils_update(
							chart,
							{
								bB: _Utils_update(
									durationFilter,
									{S: unscaledValue})
							})) : $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(chart);
				}
			case 2:
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{dq: !chart.dq}));
			case 3:
				var event = msg.a;
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{
							aO: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$EventHighlight(event)
						}));
			case 4:
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{aO: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NoHighlight}));
			case 5:
				var event = msg.a;
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{
							aO: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$EventHighlight(event)
						}));
			case 6:
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{aO: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NoHighlight}));
			case 7:
				var range = msg.a;
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{
							aO: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$RangeHighlight(range)
						}));
			case 8:
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$noParentMsg(
					_Utils_update(
						chart,
						{aO: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NoHighlight}));
			default:
				var parentMsg = msg.a;
				return _Utils_Tuple2(
					chart,
					$elm$core$Maybe$Just(parentMsg));
		}
	});
var $author$project$ChartAndControlSet$HeatMap$Highlighted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ChartAndControlSet$HeatMap$filterHighlightedValues = F2(
	function (coordinateRanges, _v0) {
		var data = _v0.jA;
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$concatMap,
				function (_v1) {
					var start = _v1.cU;
					var end = _v1.cw;
					var rowData = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm_community$list_extra$List$Extra$getAt, start.a, data));
					return A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, v) {
									return ((_Utils_cmp(start.b, i) < 1) && (_Utils_cmp(i, end.b) < 1)) ? $elm$core$Maybe$Just(v) : $elm$core$Maybe$Nothing;
								}),
							rowData));
				},
				coordinateRanges));
	});
var $author$project$ChartAndControlSet$HeatMap$update = F2(
	function (msg, heatMap) {
		switch (msg.$) {
			case 2:
				var parentMsg = msg.a;
				return _Utils_Tuple2(
					heatMap,
					$elm$core$Maybe$Just(parentMsg));
			case 0:
				var _v1 = heatMap.aO;
				if (_v1.$ === 1) {
					var coordinateRanges = _v1.a;
					var highlightedValues = A2($author$project$ChartAndControlSet$HeatMap$filterHighlightedValues, coordinateRanges, heatMap.iD);
					var max = A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$List$maximum(highlightedValues));
					var min = A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$List$minimum(highlightedValues));
					var valueRange = A2($author$project$ChartAndControlSet$HeatMap$calculateRange, min, max);
					return _Utils_Tuple2(
						_Utils_update(
							heatMap,
							{
								aO: A2($author$project$ChartAndControlSet$HeatMap$Highlighted, coordinateRanges, valueRange)
							}),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple2(heatMap, $elm$core$Maybe$Nothing);
				}
			default:
				var _v2 = heatMap.aO;
				if (_v2.$ === 2) {
					var coordinateRanges = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							heatMap,
							{
								aO: $author$project$ChartAndControlSet$HeatMap$HighlightAvailable(coordinateRanges)
							}),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple2(heatMap, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Chart$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.aA);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (_v0.b.$ === 3) {
						var m = _v0.a.a;
						var mdl = _v0.b.a;
						var _v1 = A3($author$project$Chart$Shared$update, model.cl, m, mdl);
						var cm = _v1.a;
						var cmd = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aA: $author$project$Chart$General(cm)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Chart$GeneralMsg, cmd));
					} else {
						break _v0$4;
					}
				case 1:
					if (_v0.b.$ === 4) {
						var m = _v0.a.a;
						var mdl = _v0.b.a;
						var _v2 = A2($author$project$Chart$ConsumptionProfile$update, m, mdl);
						var umdl = _v2.a;
						var cmd = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aA: $author$project$Chart$ConsumptionProfile(umdl)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Chart$ConsumptionProfileMsg, cmd));
					} else {
						break _v0$4;
					}
				case 2:
					if (_v0.b.$ === 5) {
						var m = _v0.a.a;
						var mdl = _v0.b.a;
						var _v3 = A2($author$project$ChartAndControlSet$HeatMap$update, m, mdl);
						var umdl = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aA: $author$project$Chart$HeatMap(umdl)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						break _v0$4;
					}
				default:
					if (_v0.b.$ === 6) {
						var m = _v0.a.a;
						var mdl = _v0.b.a;
						var _v4 = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$update, m, mdl);
						var umdl = _v4.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aA: $author$project$Chart$BinaryAnalysis(umdl)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						break _v0$4;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Chart$BinaryAnalysisMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Chart$HeatMapMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NotInteractive = {$: 0};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$View$tt = F2(
	function (translations, path) {
		return $elm$html$Html$text(
			A2($author$project$Enectiva$I18n$t, translations, path));
	});
var $author$project$ChartAndControlSet$ChartControls$error = F2(
	function (translations, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full p-4 rounded bg-red-200 text-red-900 text-center')
				]),
			$elm$core$List$singleton(
				A2($author$project$View$tt, translations, 'stats.error.' + msg)));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Enectiva$View$nothing = $elm$html$Html$text('');
var $elm_community$typed_svg$TypedSvg$Types$Translate = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $gampleman$elm_visualization$Scale$tickFormat = function (_v0) {
	var opts = _v0;
	return opts.gC(opts.ep);
};
var $gampleman$elm_visualization$Scale$ticks = F2(
	function (_v0, count) {
		var scale = _v0;
		return A2(scale.gD, scale.ep, count);
	});
var $gampleman$elm_visualization$Axis$computeOptions = F2(
	function (attrs, scale) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (attr, _v1) {
					var babyOpts = _v1.a;
					var post = _v1.b;
					switch (attr.$) {
						case 2:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{c_: val}),
								post);
						case 3:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{c$: val}),
								post);
						case 4:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{bS: val}),
								post);
						case 5:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{d_: val}),
								post);
						default:
							return _Utils_Tuple2(
								babyOpts,
								A2($elm$core$List$cons, attr, post));
					}
				}),
			_Utils_Tuple2(
				{c_: 10, d_: 3, c$: 6, bS: 6},
				_List_Nil),
			attrs);
		var opts = _v0.a;
		var postList = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (attr, options) {
					switch (attr.$) {
						case 0:
							var val = attr.a;
							return _Utils_update(
								options,
								{gD: val});
						case 1:
							var val = attr.a;
							return _Utils_update(
								options,
								{gC: val});
						default:
							return options;
					}
				}),
			{
				c_: opts.c_,
				gC: A2($gampleman$elm_visualization$Scale$tickFormat, scale, opts.c_),
				d_: opts.d_,
				c$: opts.c$,
				bS: opts.bS,
				gD: A2($gampleman$elm_visualization$Scale$ticks, scale, opts.c_)
			},
			postList);
	});
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$dy = _VirtualDom_attribute('dy');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $gampleman$elm_visualization$Scale$rangeExtent = function (_v0) {
	var options = _v0;
	return A2(options.gj, options.ep, options.cO);
};
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $gampleman$elm_visualization$Axis$element = F4(
	function (_v0, k, displacement, textAnchorPosition) {
		var x = _v0.M;
		var y = _v0.N;
		var x2 = _v0.lJ;
		var y1 = _v0.lM;
		var y2 = _v0.lN;
		var translate = _v0.gH;
		var horizontal = _v0.ft;
		return F2(
			function (attrs, scale) {
				var rangeExtent = $gampleman$elm_visualization$Scale$rangeExtent(scale);
				var range1 = rangeExtent.b + 0.5;
				var range0 = rangeExtent.a + 0.5;
				var position = $gampleman$elm_visualization$Scale$convert(scale);
				var opts = A2($gampleman$elm_visualization$Axis$computeOptions, attrs, scale);
				var spacing = A2($elm$core$Basics$max, opts.c$, 0) + opts.d_;
				var drawTick = function (tick) {
					return A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('tick'),
								$elm$svg$Svg$Attributes$transform(
								translate(
									position(tick)))
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stroke('#000'),
										x2(k * opts.c$),
										y1(0.5),
										y2(0.5)
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$text_,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('#000'),
										x(k * spacing),
										y(0.5),
										$elm$svg$Svg$Attributes$dy(displacement)
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$text(
										opts.gC(tick))
									]))
							]));
				};
				var domainLine = horizontal ? ('M' + ($elm$core$String$fromFloat(k * opts.bS) + (',' + ($elm$core$String$fromFloat(range0) + ('H0.5V' + ($elm$core$String$fromFloat(range1) + ('H' + $elm$core$String$fromFloat(k * opts.bS)))))))) : ('M' + ($elm$core$String$fromFloat(range0) + (',' + ($elm$core$String$fromFloat(k * opts.bS) + ('V0.5H' + ($elm$core$String$fromFloat(range1) + ('V' + $elm$core$String$fromFloat(k * opts.bS))))))));
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$fontSize('10'),
							$elm$svg$Svg$Attributes$fontFamily('sans-serif'),
							$elm$svg$Svg$Attributes$textAnchor(textAnchorPosition)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('domain'),
									$elm$svg$Svg$Attributes$stroke('#000'),
									$elm$svg$Svg$Attributes$d(domainLine)
								]),
							_List_Nil),
						A2($elm$core$List$map, drawTick, opts.gD)));
			});
	});
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $gampleman$elm_visualization$Axis$verticalAttrs = {
	ft: false,
	gH: function (x) {
		return 'translate(' + ($elm$core$String$fromFloat(x) + ', 0)');
	},
	M: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y, $elm$core$String$fromFloat),
	lI: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y1, $elm$core$String$fromFloat),
	lJ: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y2, $elm$core$String$fromFloat),
	N: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x, $elm$core$String$fromFloat),
	lM: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x1, $elm$core$String$fromFloat),
	lN: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x2, $elm$core$String$fromFloat)
};
var $gampleman$elm_visualization$Axis$bottom = A4($gampleman$elm_visualization$Axis$element, $gampleman$elm_visualization$Axis$verticalAttrs, 1, '0.71em', 'middle');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm_community$typed_svg$TypedSvg$Core$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm_community$typed_svg$TypedSvg$Attributes$class = function (names) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'class',
		A2($elm$core$String$join, ' ', names));
};
var $author$project$Chart$AggregateEntities$classes = _List_fromArray(
	['below-theoretical', 'excess']);
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm_community$typed_svg$TypedSvg$Core$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm_community$typed_svg$TypedSvg$g = $elm_community$typed_svg$TypedSvg$Core$node('g');
var $elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString = function (length) {
	switch (length.$) {
		case 0:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'cm';
		case 1:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'em';
		case 2:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'ex';
		case 3:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'in';
		case 4:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'mm';
		case 5:
			var x = length.a;
			return $elm$core$String$fromFloat(x);
		case 6:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pc';
		case 7:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + '%';
		case 8:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pt';
		case 9:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'px';
		default:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'rem';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$height = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'height',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Types$Px = function (a) {
	return {$: 9, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$px = $elm_community$typed_svg$TypedSvg$Types$Px;
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$height = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$height(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$rect = $elm_community$typed_svg$TypedSvg$Core$node('rect');
var $elm_community$typed_svg$TypedSvg$Attributes$width = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'width',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$width = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$width(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$x = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Chart$AggregateEntities$column = F2(
	function (xScale, _v0) {
		var month = _v0.a;
		var values = _v0.b;
		var block = F2(
			function (barClass, _v1) {
				var upperY = _v1.a;
				var lowerY = _v1.b;
				return A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
							A2($gampleman$elm_visualization$Scale$convert, xScale, month)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$List$minimum(
									_List_fromArray(
										[lowerY, upperY])))),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
							$gampleman$elm_visualization$Scale$bandwidth(xScale)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(
							$elm$core$Basics$abs(upperY - lowerY)),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								[barClass]))
						]),
					_List_Nil);
			});
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['column']))
				]),
			A3($elm$core$List$map2, block, $author$project$Chart$AggregateEntities$classes, values));
	});
var $author$project$Chart$AggregateEntities$series = _List_fromArray(
	[
		{
		e2: function (cd) {
			var _v0 = cd.fo;
			if (!_v0.$) {
				var exc = _v0.a;
				return cd.e3 - exc;
			} else {
				return cd.e3;
			}
		},
		fF: 'basic'
	},
		{
		e2: function (cd) {
			return A2($elm$core$Maybe$withDefault, 0, cd.fo);
		},
		fF: 'excess'
	}
	]);
var $author$project$Chart$AggregateEntities$samples = function (points) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var label = _v0.fF;
			var accessor = _v0.e2;
			return _Utils_Tuple2(
				label,
				A2($elm$core$List$map, accessor, points));
		},
		$author$project$Chart$AggregateEntities$series);
};
var $author$project$Chart$AggregateEntities$config = function (points) {
	return {
		jA: $author$project$Chart$AggregateEntities$samples(points),
		kG: $gampleman$elm_visualization$Shape$stackOffsetNone,
		kL: $elm$core$Basics$identity
	};
};
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {hb: day, fu: hour, fT: millisecond, fV: minute, hW: month, gp: second, i9: year};
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.i9;
		var month = _v0.hW;
		var day = _v0.hb;
		var hour = _v0.fu;
		var minute = _v0.fV;
		var second = _v0.gp;
		var millisecond = _v0.fT;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Enectiva$I18n$dateToMidnight = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		A7(
			$justinmimbs$time_extra$Time$Extra$Parts,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			$justinmimbs$date$Date$day(date),
			0,
			0,
			0,
			0));
};
var $author$project$Chart$AggregateEntities$h = 400;
var $gampleman$elm_visualization$Axis$horizontalAttrs = {
	ft: true,
	gH: function (y) {
		return 'translate(0, ' + ($elm$core$String$fromFloat(y) + ')');
	},
	M: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x, $elm$core$String$fromFloat),
	lI: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x1, $elm$core$String$fromFloat),
	lJ: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x2, $elm$core$String$fromFloat),
	N: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y, $elm$core$String$fromFloat),
	lM: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y1, $elm$core$String$fromFloat),
	lN: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y2, $elm$core$String$fromFloat)
};
var $gampleman$elm_visualization$Axis$left = A4($gampleman$elm_visualization$Axis$element, $gampleman$elm_visualization$Axis$horizontalAttrs, -1, '0.32em', 'end');
var $author$project$Chart$AggregateEntities$padding = {fa: 60, ca: 60, gl: 30, ci: 30};
var $elm_community$typed_svg$TypedSvg$svg = $elm_community$typed_svg$TypedSvg$Core$node('svg');
var $gampleman$elm_visualization$Axis$TickCount = function (a) {
	return {$: 2, a: a};
};
var $gampleman$elm_visualization$Axis$tickCount = $gampleman$elm_visualization$Axis$TickCount;
var $gampleman$elm_visualization$Scale$toRenderable = F2(
	function (toString, _v0) {
		var scale = _v0;
		return {
			bh: F3(
				function (dmn, rng, value) {
					return A3(scale.bh, dmn, rng, value) + (A2($elm$core$Basics$max, scale.eg - 1, 0) / 2);
				}),
			ep: scale.ep,
			cO: scale.cO,
			gj: F2(
				function (_v1, rng) {
					return rng;
				}),
			gC: F2(
				function (_v2, _v3) {
					return toString;
				}),
			gD: F2(
				function (dmn, _v4) {
					return dmn;
				})
		};
	});
var $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString = function (xform) {
	var tr = F2(
		function (name, args) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						'(',
						A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, args)),
						')'
					]));
		});
	switch (xform.$) {
		case 0:
			var a = xform.a;
			var b = xform.b;
			var c = xform.c;
			var d = xform.d;
			var e = xform.e;
			var f = xform.f;
			return A2(
				tr,
				'matrix',
				_List_fromArray(
					[a, b, c, d, e, f]));
		case 1:
			var a = xform.a;
			var x = xform.b;
			var y = xform.c;
			return A2(
				tr,
				'rotate',
				_List_fromArray(
					[a, x, y]));
		case 2:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'scale',
				_List_fromArray(
					[x, y]));
		case 3:
			var x = xform.a;
			return A2(
				tr,
				'skewX',
				_List_fromArray(
					[x]));
		case 4:
			var y = xform.a;
			return A2(
				tr,
				'skewY',
				_List_fromArray(
					[y]));
		default:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'translate',
				_List_fromArray(
					[x, y]));
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$transform = function (transforms) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'transform',
		A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString, transforms)));
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm_community$list_extra$List$Extra$rowsLength = function (listOfLists) {
	if (!listOfLists.b) {
		return 0;
	} else {
		var x = listOfLists.a;
		return $elm$core$List$length(x);
	}
};
var $elm_community$list_extra$List$Extra$transpose = function (listOfLists) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$List$map2($elm$core$List$cons),
		A2(
			$elm$core$List$repeat,
			$elm_community$list_extra$List$Extra$rowsLength(listOfLists),
			_List_Nil),
		listOfLists);
};
var $elm_community$typed_svg$TypedSvg$Attributes$viewBox = F4(
	function (minX, minY, vWidth, vHeight) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$attribute,
			'viewBox',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromFloat,
					_List_fromArray(
						[minX, minY, vWidth, vHeight]))));
	});
var $author$project$Chart$AggregateEntities$w = 1000;
var $elm_community$typed_svg$TypedSvg$line = $elm_community$typed_svg$TypedSvg$Core$node('line');
var $elm_community$typed_svg$TypedSvg$Attributes$strokeWidth = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'stroke-width',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$strokeWidth(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$x1 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x1',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x1 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x1(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$x2 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x2',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x2 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x2(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y1 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y1',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y1 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y1(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y2 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y2',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y2 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y2(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Chart$AggregateEntities$yGridLine = F3(
	function (yScale, index, tick) {
		return A2(
			$elm_community$typed_svg$TypedSvg$line,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1($author$project$Chart$AggregateEntities$padding.ca),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2($author$project$Chart$AggregateEntities$w - $author$project$Chart$AggregateEntities$padding.gl),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(
					$author$project$Chart$AggregateEntities$padding.ci + A2($gampleman$elm_visualization$Scale$convert, yScale, tick)),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2(
					$author$project$Chart$AggregateEntities$padding.ci + A2($gampleman$elm_visualization$Scale$convert, yScale, tick)),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['horizontal-grid-line'])),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(0.5)
				]),
			_List_Nil);
	});
var $author$project$Chart$AggregateEntities$view = F2(
	function (translations, model) {
		var points = model.ib;
		var timeZone = model.iU;
		var months = A2(
			$elm$core$List$map,
			function ($) {
				return $.hW;
			},
			points);
		var xScale = A3(
			$gampleman$elm_visualization$Scale$band,
			_Utils_update(
				$gampleman$elm_visualization$Scale$defaultBandConfig,
				{kO: 0.35, kP: 0.35}),
			_Utils_Tuple2(0, $author$project$Chart$AggregateEntities$w - ($author$project$Chart$AggregateEntities$padding.ci + $author$project$Chart$AggregateEntities$padding.fa)),
			months);
		var formatDate = A2(
			$elm$core$Basics$composeR,
			$author$project$Enectiva$I18n$dateToMidnight,
			A3($author$project$Enectiva$I18n$formatTimeCustom, 'month', translations, timeZone));
		var _v0 = $gampleman$elm_visualization$Shape$stack(
			$author$project$Chart$AggregateEntities$config(points));
		var values = _v0.lB;
		var labels = _v0.kb;
		var extent = _v0.jQ;
		var yScale = A2(
			$gampleman$elm_visualization$Scale$nice,
			4,
			A2(
				$gampleman$elm_visualization$Scale$linear,
				_Utils_Tuple2($author$project$Chart$AggregateEntities$h - ($author$project$Chart$AggregateEntities$padding.ca + $author$project$Chart$AggregateEntities$padding.gl), 0),
				extent));
		var monthValues = $elm_community$list_extra$List$Extra$transpose(values);
		var scaledValues = A2(
			$elm$core$List$map,
			$elm$core$List$map(
				function (_v1) {
					var y1 = _v1.a;
					var y2 = _v1.b;
					return _Utils_Tuple2(
						A2($gampleman$elm_visualization$Scale$convert, yScale, y1),
						A2($gampleman$elm_visualization$Scale$convert, yScale, y2));
				}),
			monthValues);
		return A2(
			$elm_community$typed_svg$TypedSvg$svg,
			_List_fromArray(
				[
					A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, $author$project$Chart$AggregateEntities$w, $author$project$Chart$AggregateEntities$h),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['bar-chart']))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Chart$AggregateEntities$yGridLine(yScale),
						A2($gampleman$elm_visualization$Scale$ticks, yScale, 10))),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$AggregateEntities$padding.ca - 1, $author$project$Chart$AggregateEntities$h - $author$project$Chart$AggregateEntities$padding.fa)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['x-axis']))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$bottom,
							_List_fromArray(
								[
									$gampleman$elm_visualization$Axis$tickCount(10)
								]),
							A2($gampleman$elm_visualization$Scale$toRenderable, formatDate, xScale))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$AggregateEntities$padding.ca, $author$project$Chart$AggregateEntities$padding.ci)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['y-axis']))
						]),
					_List_fromArray(
						[
							A2($gampleman$elm_visualization$Axis$left, _List_Nil, yScale)
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$AggregateEntities$padding.ca, $author$project$Chart$AggregateEntities$padding.ci / 2.5)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['y-axis-unit']))
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$text_,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fontSize('10'),
									$elm$svg$Svg$Attributes$fontFamily('sans-serif'),
									$elm$svg$Svg$Attributes$textAnchor('end'),
									$elm$svg$Svg$Attributes$x('-9')
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(model.i$)
								]))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$AggregateEntities$padding.ca, $author$project$Chart$AggregateEntities$padding.ci)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['series']))
						]),
					A2(
						$elm$core$List$map,
						$author$project$Chart$AggregateEntities$column(xScale),
						A3(
							$elm$core$List$map2,
							F2(
								function (a, b) {
									return _Utils_Tuple2(a, b);
								}),
							months,
							scaledValues)))
				]));
	});
var $elm_community$typed_svg$TypedSvg$Types$AnchorEnd = 3;
var $elm_community$typed_svg$TypedSvg$Types$Paint = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$ConsumptionProfile$bands = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6]);
var $elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString = function (paint) {
	switch (paint.$) {
		case 0:
			var color = paint.a;
			return $avh4$elm_color$Color$toCssString(color);
		case 1:
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['var(' + (string + ')')]));
		case 2:
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['url(#', string, ')']));
		case 3:
			return 'context-fill';
		case 4:
			return 'context-stroke';
		default:
			return 'none';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$fill = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('fill'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $avh4$elm_color$Color$lightGray = A4($avh4$elm_color$Color$RgbaSpace, 238 / 255, 238 / 255, 236 / 255, 1.0);
var $gampleman$elm_visualization$Scale$range = function (_v0) {
	var options = _v0;
	return options.cO;
};
var $author$project$Chart$ConsumptionProfile$alternatingDailyBgs = F2(
	function (xScale, yScale) {
		var _v0 = $gampleman$elm_visualization$Scale$range(yScale);
		var yMax = _v0.a;
		var yMin = _v0.b;
		var drawRect = function (dayOfTheWeek) {
			return A2(
				$elm$core$List$any,
				function (d) {
					return _Utils_eq(d, dayOfTheWeek);
				},
				_List_fromArray(
					[1, 3, 5])) ? A2(
				$elm_community$typed_svg$TypedSvg$rect,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
						A2($gampleman$elm_visualization$Scale$convert, xScale, dayOfTheWeek)),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(yMin),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
						$gampleman$elm_visualization$Scale$bandwidth(xScale)),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(yMax),
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['fill-current text-grey-300'])),
						$elm_community$typed_svg$TypedSvg$Attributes$fill(
						$elm_community$typed_svg$TypedSvg$Types$Paint($avh4$elm_color$Color$lightGray))
					]),
				_List_Nil) : $author$project$Enectiva$View$nothing;
		};
		return A2($elm$core$List$map, drawRect, $author$project$Chart$ConsumptionProfile$bands);
	});
var $author$project$Chart$ConsumptionProfile$barHelp = F7(
	function (xScale, rangeDiffMinutes, timeZone, yScale, color, time, value) {
		var scaledValue = A2($gampleman$elm_visualization$Scale$convert, yScale, value);
		var max = $gampleman$elm_visualization$Scale$range(yScale).a;
		return A2(
			$elm_community$typed_svg$TypedSvg$rect,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
					A2(
						$gampleman$elm_visualization$Scale$convert,
						xScale,
						A4($justinmimbs$time_extra$Time$Extra$add, 13, rangeDiffMinutes, timeZone, time))),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(scaledValue),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
					$gampleman$elm_visualization$Scale$bandwidth(xScale)),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(max - scaledValue),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['bar'])),
					$elm_community$typed_svg$TypedSvg$Attributes$fill(
					$elm_community$typed_svg$TypedSvg$Types$Paint(color))
				]),
			_List_Nil);
	});
var $author$project$Chart$ConsumptionProfile$bar = F6(
	function (xScale, rangeDiffMinutes, timeZone, yScale, color, _v0) {
		var value = _v0.aW;
		var time = _v0.bT;
		if (!value.$) {
			var v = value.a;
			return A7($author$project$Chart$ConsumptionProfile$barHelp, xScale, rangeDiffMinutes, timeZone, yScale, color, time, v);
		} else {
			return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$Chart$ConsumptionProfile$dataPointToMaybe = F2(
	function (show, dp) {
		return show ? $elm$core$Maybe$Just(dp) : $elm$core$Maybe$Nothing;
	});
var $elm_community$typed_svg$TypedSvg$title = $elm_community$typed_svg$TypedSvg$Core$node('title');
var $author$project$Enectiva$View$viewIf = F2(
	function (view, condition) {
		return condition ? view(0) : $elm$html$Html$text('');
	});
var $author$project$Chart$ConsumptionProfile$column = function (tooltip) {
	return function (xScale) {
		return function (yScale) {
			return function (rangeDiffMinutes) {
				return function (timeZone) {
					return function (currentColor) {
						return function (previousColor) {
							return function (showPrevious) {
								return function (currentConsumption) {
									return function (previousConsumption) {
										return function (currentSecondary) {
											return function (previousSecondary) {
												return A2(
													$elm_community$typed_svg$TypedSvg$g,
													_List_fromArray(
														[
															$elm_community$typed_svg$TypedSvg$Attributes$class(
															_List_fromArray(
																['columns']))
														]),
													_List_fromArray(
														[
															A6($author$project$Chart$ConsumptionProfile$bar, xScale, 0, timeZone, yScale, currentColor, currentConsumption),
															A2(
															$author$project$Enectiva$View$viewIf,
															function (_v0) {
																return A6($author$project$Chart$ConsumptionProfile$bar, xScale, rangeDiffMinutes, timeZone, yScale, previousColor, previousConsumption);
															},
															showPrevious),
															A2(
															$elm_community$typed_svg$TypedSvg$title,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A4(
																		tooltip,
																		currentConsumption,
																		A2($author$project$Chart$ConsumptionProfile$dataPointToMaybe, showPrevious, previousConsumption),
																		currentSecondary,
																		function () {
																			if (!previousSecondary.$) {
																				var dp = previousSecondary.a;
																				return A2($author$project$Chart$ConsumptionProfile$dataPointToMaybe, showPrevious, dp);
																			} else {
																				return $elm$core$Maybe$Nothing;
																			}
																		}()))
																]))
														]));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Chart$ConsumptionProfile$firstContinuousExtensionUnit = function (continuousExtensions) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$map,
			function (e) {
				var _v0 = e.dl;
				if (!_v0.$) {
					var ds = _v0.a;
					return $elm$core$Maybe$Just(ds.i$);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$elm$core$List$head(continuousExtensions)));
};
var $elm_community$list_extra$List$Extra$initialize = F2(
	function (n, f) {
		var step = F2(
			function (i, acc) {
				step:
				while (true) {
					if (i < 0) {
						return acc;
					} else {
						var $temp$i = i - 1,
							$temp$acc = A2(
							$elm$core$List$cons,
							f(i),
							acc);
						i = $temp$i;
						acc = $temp$acc;
						continue step;
					}
				}
			});
		return A2(step, n - 1, _List_Nil);
	});
var $author$project$Chart$ConsumptionProfile$firstDataSeriesData = F3(
	function (continuousExtensions, length, func) {
		var empty = A2(
			$elm_community$list_extra$List$Extra$initialize,
			length,
			function (_v1) {
				return $elm$core$Maybe$Nothing;
			});
		return A2(
			$elm$core$Maybe$withDefault,
			empty,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function (e) {
						var _v0 = e.dl;
						if (!_v0.$) {
							return $elm$core$Maybe$Just(
								A2(
									$elm$core$List$map,
									$elm$core$Maybe$Just,
									func(e)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					$elm$core$List$head(continuousExtensions))));
	});
var $author$project$Chart$ConsumptionProfile$firstDataSeriesCurrent = F2(
	function (continuousExtensions, length) {
		return A3(
			$author$project$Chart$ConsumptionProfile$firstDataSeriesData,
			continuousExtensions,
			length,
			function (e) {
				return e.bA.aM;
			});
	});
var $author$project$Chart$ConsumptionProfile$firstDataSeriesPrevious = F2(
	function (continuousExtensions, length) {
		return A3(
			$author$project$Chart$ConsumptionProfile$firstDataSeriesData,
			continuousExtensions,
			length,
			function (e) {
				return e.bM.aM;
			});
	});
var $elm$core$List$map4 = _List_map4;
var $author$project$Chart$ConsumptionProfile$padding = {fa: 40, ca: 60, gl: 35, ci: 30};
var $author$project$Chart$ConsumptionProfile$tooltipDiff = F4(
	function (translations, unit, current, previous) {
		var _v0 = _Utils_Tuple2(current.aW, previous.aW);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var c = _v0.a.a;
			var p = _v0.b.a;
			var diff = c - p;
			var arrow = (diff > 0) ? '▲' : '▼';
			return $elm$core$Maybe$Just(
				arrow + ('   ' + (A2($author$project$Enectiva$I18n$formatNumber, translations, diff) + (' ' + unit))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Enectiva$I18n$defaultTimeFormatName = 'time.formats.js_time_now';
var $author$project$Enectiva$I18n$formatTime = $author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate($author$project$Enectiva$I18n$defaultTimeFormatName);
var $author$project$Chart$ConsumptionProfile$tooltipLine = F4(
	function (translations, zone, unit, _v0) {
		var time = _v0.bT;
		var value = _v0.aW;
		var prefix = A3($author$project$Enectiva$I18n$formatTime, translations, zone, time) + ': ';
		switch (value.$) {
			case 0:
				var v = value.a;
				return prefix + (A2($author$project$Enectiva$I18n$formatNumber, translations, v) + (' ' + unit));
			case 1:
				var err = value.a;
				return _Utils_ap(prefix, err);
			default:
				var err = value.a;
				return _Utils_ap(prefix, err);
		}
	});
var $author$project$Chart$ConsumptionProfile$tooltipView = F8(
	function (translations, zone, unitMain, maybeUnitSecondary, currentMain, maybePreviousMain, maybeCurrentSecondary, maybePreviousSecondary) {
		var showDelimiter = function () {
			var _v1 = _Utils_Tuple2(maybeCurrentSecondary, maybePreviousSecondary);
			if ((_v1.a.$ === 1) && (_v1.b.$ === 1)) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				return false;
			} else {
				return true;
			}
		}();
		var secondaryDiff = function () {
			if (!maybeCurrentSecondary.$) {
				var currentSecondary = maybeCurrentSecondary.a;
				return $elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						A3(
							$author$project$Chart$ConsumptionProfile$tooltipDiff,
							translations,
							A2($elm$core$Maybe$withDefault, '', maybeUnitSecondary),
							currentSecondary),
						maybePreviousSecondary));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var delimiter = showDelimiter ? $elm$core$Maybe$Just('') : $elm$core$Maybe$Nothing;
		return A2(
			$elm$core$String$join,
			'\n',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A4($author$project$Chart$ConsumptionProfile$tooltipLine, translations, zone, unitMain, currentMain)),
						A2(
						$elm$core$Maybe$map,
						A3($author$project$Chart$ConsumptionProfile$tooltipLine, translations, zone, unitMain),
						maybePreviousMain),
						$elm_community$maybe_extra$Maybe$Extra$join(
						A2(
							$elm$core$Maybe$map,
							A3($author$project$Chart$ConsumptionProfile$tooltipDiff, translations, unitMain, currentMain),
							maybePreviousMain)),
						delimiter,
						A2(
						$elm$core$Maybe$map,
						A3(
							$author$project$Chart$ConsumptionProfile$tooltipLine,
							translations,
							zone,
							A2($elm$core$Maybe$withDefault, '', maybeUnitSecondary)),
						maybeCurrentSecondary),
						A2(
						$elm$core$Maybe$map,
						A3(
							$author$project$Chart$ConsumptionProfile$tooltipLine,
							translations,
							zone,
							A2($elm$core$Maybe$withDefault, '', maybeUnitSecondary)),
						maybePreviousSecondary),
						secondaryDiff
					])));
	});
var $author$project$Chart$ConsumptionProfile$consumptionSeries = function (translations) {
	return function (timeZone) {
		return function (timeXScale) {
			return function (consumptionYScale) {
				return function (rangeDiffMinutes) {
					return function (currentColor) {
						return function (previousColor) {
							return function (showPrevious) {
								return function (current) {
									return function (previous) {
										return function (unit) {
											return function (continuousExtensions) {
												var length = $elm$core$List$length(current);
												return A2(
													$elm_community$typed_svg$TypedSvg$g,
													_List_fromArray(
														[
															$elm_community$typed_svg$TypedSvg$Attributes$transform(
															_List_fromArray(
																[
																	A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$padding.ca, $author$project$Chart$ConsumptionProfile$padding.ci)
																])),
															$elm_community$typed_svg$TypedSvg$Attributes$class(
															_List_fromArray(
																['consumption-series']))
														]),
													A5(
														$elm$core$List$map4,
														A8(
															$author$project$Chart$ConsumptionProfile$column,
															A4(
																$author$project$Chart$ConsumptionProfile$tooltipView,
																translations,
																timeZone,
																unit,
																$author$project$Chart$ConsumptionProfile$firstContinuousExtensionUnit(continuousExtensions)),
															timeXScale,
															consumptionYScale,
															rangeDiffMinutes,
															timeZone,
															currentColor,
															previousColor,
															showPrevious),
														current,
														previous,
														A2($author$project$Chart$ConsumptionProfile$firstDataSeriesCurrent, continuousExtensions, length),
														A2($author$project$Chart$ConsumptionProfile$firstDataSeriesPrevious, continuousExtensions, length)));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $gampleman$elm_visualization$Scale$domain = function (_v0) {
	var scale = _v0;
	return scale.ep;
};
var $elm_community$typed_svg$TypedSvg$Attributes$fontFamily = function (families) {
	if (!families.b) {
		return A2($elm_community$typed_svg$TypedSvg$Core$attribute, 'font-family', 'inherit');
	} else {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$attribute,
			'font-family',
			A2($elm$core$String$join, ', ', families));
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$fontSize = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'font-size',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$fontSize = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$fontSize(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Enectiva$I18n$asFloat = function (prec) {
	return (prec < 1) ? $author$project$Enectiva$I18n$AsFloat(1) : $author$project$Enectiva$I18n$AsFloat(prec);
};
var $author$project$Enectiva$I18n$AsInteger = {$: 0};
var $author$project$Enectiva$I18n$asInteger = $author$project$Enectiva$I18n$AsInteger;
var $author$project$Chart$ConsumptionProfile$formatFloatToString = F3(
	function (translations, range, ticksCount) {
		var precision = (_Utils_cmp(range, ticksCount) < 0) ? $author$project$Enectiva$I18n$asFloat(2) : $author$project$Enectiva$I18n$asInteger;
		return A2($author$project$Enectiva$I18n$formatNumberWithPrecision, translations, precision);
	});
var $avh4$elm_color$Color$gray = A4($avh4$elm_color$Color$RgbaSpace, 211 / 255, 215 / 255, 207 / 255, 1.0);
var $author$project$Chart$ConsumptionProfile$h = 400;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Chart$ConsumptionProfile$quantile = F3(
	function (ignoreNHighestValues, q, values) {
		var relevantCount = function () {
			var keep = $elm$core$List$length(values) - ignoreNHighestValues;
			return (keep < 1) ? 1 : keep;
		}();
		var sortedAsc = A2(
			$elm$core$List$take,
			relevantCount,
			$elm$core$List$sort(values));
		var idx = (q * $elm$core$List$length(values)) / 100;
		var interval = A2(
			$elm$core$List$take,
			(1 + $elm$core$Basics$ceiling(idx)) - $elm$core$Basics$floor(idx),
			A2(
				$elm$core$List$drop,
				$elm$core$Basics$floor(idx) - 1,
				sortedAsc));
		var _v0 = _Utils_Tuple2(
			$elm$core$List$head(interval),
			$elm$core$List$tail(interval));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var a = _v0.a.a;
				var list = _v0.b.a;
				var _v1 = $elm$core$List$head(list);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just((a + b) / 2);
				} else {
					return $elm$core$Maybe$Just(a);
				}
			} else {
				var a = _v0.a.a;
				var _v2 = _v0.b;
				return $elm$core$Maybe$Just(a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $gampleman$elm_visualization$Axis$right = A4($gampleman$elm_visualization$Axis$element, $gampleman$elm_visualization$Axis$horizontalAttrs, 1, '0.32em', 'start');
var $elm_community$typed_svg$TypedSvg$circle = $elm_community$typed_svg$TypedSvg$Core$node('circle');
var $elm_community$typed_svg$TypedSvg$Attributes$cx = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'cx',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$cy = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'cy',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $author$project$Chart$ConsumptionProfile$dataPointsToMaybe = F2(
	function (show, dps) {
		return A2(
			$elm$core$List$map,
			$author$project$Chart$ConsumptionProfile$dataPointToMaybe(show),
			dps);
	});
var $elm$core$List$map5 = _List_map5;
var $elm_community$typed_svg$TypedSvg$Attributes$r = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'r',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $author$project$Chart$ConsumptionProfile$dots = F8(
	function (tooltip, showPrevious, color, points, currentMain, previousMain, currentSecondary, previousSecondary) {
		var drawCircle = F5(
			function (point, current, maybePrevious, maybeCurrentSecondary, maybePreviousSecondary) {
				if (!point.$) {
					var _v1 = point.a;
					var x = _v1.a;
					var y = _v1.b;
					var c = A2(
						$elm_community$typed_svg$TypedSvg$circle,
						_List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Attributes$cx(
								$elm_community$typed_svg$TypedSvg$Types$px(x)),
								$elm_community$typed_svg$TypedSvg$Attributes$cy(
								$elm_community$typed_svg$TypedSvg$Types$px(y)),
								$elm_community$typed_svg$TypedSvg$Attributes$r(
								$elm_community$typed_svg$TypedSvg$Types$px(2)),
								$elm_community$typed_svg$TypedSvg$Attributes$fill(
								$elm_community$typed_svg$TypedSvg$Types$Paint(color))
							]),
						_List_fromArray(
							[
								A2(
								$elm_community$typed_svg$TypedSvg$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A4(tooltip, current, maybePrevious, maybeCurrentSecondary, maybePreviousSecondary))
									]))
							]));
					return $elm$core$Maybe$Just(c);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A6(
					$elm$core$List$map5,
					drawCircle,
					points,
					currentMain,
					A2($author$project$Chart$ConsumptionProfile$dataPointsToMaybe, showPrevious, previousMain),
					A2($author$project$Chart$ConsumptionProfile$dataPointsToMaybe, true, currentSecondary),
					A2($author$project$Chart$ConsumptionProfile$dataPointsToMaybe, showPrevious, previousSecondary))));
	});
var $folkertdev$one_true_path_experiment$SubPath$Empty = {$: 1};
var $folkertdev$one_true_path_experiment$SubPath$SubPath = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_deque$Deque$Deque = $elm$core$Basics$identity;
var $folkertdev$elm_deque$Internal$empty = {aG: _List_Nil, aI: _List_Nil, av: 0, aw: 0};
var $folkertdev$elm_deque$Deque$empty = $folkertdev$elm_deque$Internal$empty;
var $folkertdev$elm_deque$Internal$rebalance = function (deque) {
	var sizeF = deque.av;
	var sizeR = deque.aw;
	var front = deque.aG;
	var rear = deque.aI;
	var size1 = ((sizeF + sizeR) / 2) | 0;
	var size2 = (sizeF + sizeR) - size1;
	var balanceConstant = 4;
	if ((sizeF + sizeR) < 2) {
		return deque;
	} else {
		if (_Utils_cmp(sizeF, (balanceConstant * sizeR) + 1) > 0) {
			var newRear = _Utils_ap(
				rear,
				$elm$core$List$reverse(
					A2($elm$core$List$drop, size1, front)));
			var newFront = A2($elm$core$List$take, size1, front);
			return {aG: newFront, aI: newRear, av: size1, aw: size2};
		} else {
			if (_Utils_cmp(sizeR, (balanceConstant * sizeF) + 1) > 0) {
				var newRear = A2($elm$core$List$take, size1, rear);
				var newFront = _Utils_ap(
					front,
					$elm$core$List$reverse(
						A2($elm$core$List$drop, size1, rear)));
				return {aG: newFront, aI: newRear, av: size1, aw: size2};
			} else {
				return deque;
			}
		}
	}
};
var $folkertdev$elm_deque$Internal$fromList = function (list) {
	return $folkertdev$elm_deque$Internal$rebalance(
		{
			aG: list,
			aI: _List_Nil,
			av: $elm$core$List$length(list),
			aw: 0
		});
};
var $folkertdev$elm_deque$Deque$fromList = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $folkertdev$elm_deque$Internal$fromList);
var $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath = {$: 4};
var $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc = function (a) {
	return {$: 3, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo = function (a) {
	return {$: 2, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$merge = F2(
	function (instruction1, instruction2) {
		var _v0 = _Utils_Tuple2(instruction1, instruction2);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				default:
					if (_v0.b.$ === 4) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath);
					} else {
						break _v0$5;
					}
			}
		}
		return $elm$core$Result$Err(
			_Utils_Tuple2(instruction1, instruction2));
	});
var $folkertdev$elm_deque$Internal$toList = function (deque) {
	return _Utils_ap(
		deque.aG,
		$elm$core$List$reverse(deque.aI));
};
var $folkertdev$elm_deque$Deque$unwrap = function (_v0) {
	var boundedDeque = _v0;
	return boundedDeque;
};
var $folkertdev$elm_deque$Deque$toList = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$toList, $folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$one_true_path_experiment$SubPath$compressHelper = function (drawtos) {
	var folder = F2(
		function (instruction, _v3) {
			var previous = _v3.a;
			var accum = _v3.b;
			var _v2 = A2($folkertdev$one_true_path_experiment$LowLevel$Command$merge, previous, instruction);
			if (!_v2.$) {
				var merged = _v2.a;
				return _Utils_Tuple2(merged, accum);
			} else {
				return _Utils_Tuple2(
					instruction,
					A2($elm$core$List$cons, previous, accum));
			}
		});
	var _v0 = $folkertdev$elm_deque$Deque$toList(drawtos);
	if (!_v0.b) {
		return $folkertdev$elm_deque$Deque$empty;
	} else {
		var first = _v0.a;
		var rest = _v0.b;
		return $folkertdev$elm_deque$Deque$fromList(
			$elm$core$List$reverse(
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$core$List$cons, a, b);
				}(
					A3(
						$elm$core$List$foldl,
						folder,
						_Utils_Tuple2(first, _List_Nil),
						rest))));
	}
};
var $folkertdev$one_true_path_experiment$SubPath$compress = function (subpath) {
	if (subpath.$ === 1) {
		return $folkertdev$one_true_path_experiment$SubPath$Empty;
	} else {
		var data = subpath.a;
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			_Utils_update(
				data,
				{
					hj: $folkertdev$one_true_path_experiment$SubPath$compressHelper(data.hj)
				}));
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$DecimalPlaces = $elm$core$Basics$identity;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$SubPath$defaultConfig = {eo: $elm$core$Maybe$Nothing, eF: false};
var $folkertdev$one_true_path_experiment$SubPath$optionFolder = F2(
	function (option, config) {
		if (!option.$) {
			var n = option.a;
			return _Utils_update(
				config,
				{
					eo: $elm$core$Maybe$Just(n)
				});
		} else {
			return _Utils_update(
				config,
				{eF: true});
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$Absolute = 1;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath = {$: 8};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo = function (drawto) {
	switch (drawto.$) {
		case 0:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo, 1, coordinates);
		case 1:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo, 1, coordinates);
		case 2:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo, 1, coordinates);
		case 3:
			var _arguments = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc, 1, _arguments);
		default:
			return $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath;
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo = function (_v0) {
	var target = _v0;
	return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo, 1, target);
};
var $folkertdev$one_true_path_experiment$SubPath$toLowLevel = function (subpath) {
	if (subpath.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var moveto = subpath.a.hY;
		var drawtos = subpath.a.hj;
		return $elm$core$Maybe$Just(
			{
				hj: A2(
					$elm$core$List$map,
					$folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo,
					$folkertdev$elm_deque$Deque$toList(drawtos)),
				hY: $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo(moveto)
			});
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig = {dw: $elm$core$String$fromFloat};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo = F2(
	function (n, value) {
		if (!n) {
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(value));
		} else {
			var sign = (value < 0.0) ? '-' : '';
			var exp = A2($elm$core$Basics$pow, 10, n);
			var raised = $elm$core$Basics$abs(
				$elm$core$Basics$round(value * exp));
			var decimals = raised % exp;
			return (!decimals) ? _Utils_ap(
				sign,
				$elm$core$String$fromInt((raised / exp) | 0)) : (sign + ($elm$core$String$fromInt((raised / exp) | 0) + ('.' + $elm$core$String$fromInt(decimals))));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder = F2(
	function (option, config) {
		var n = option;
		return _Utils_update(
			config,
			{
				dw: $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo(n)
			});
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions = A2($elm$core$List$foldl, $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder, $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig);
var $folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty = function (command) {
	switch (command.$) {
		case 0:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 1:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 2:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 3:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 4:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 5:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 6:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 7:
			var mode = command.a;
			var _arguments = command.b;
			return $elm$core$List$isEmpty(_arguments);
		default:
			return false;
	}
};
var $elm$core$Char$toUpper = _Char_toUpper;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter = F2(
	function (mode, character) {
		if (mode === 1) {
			return $elm$core$String$fromChar(
				$elm$core$Char$toUpper(character));
		} else {
			return $elm$core$String$fromChar(
				$elm$core$Char$toLower(character));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate = F2(
	function (config, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return config.dw(x) + (',' + config.dw(y));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		var c3 = _v0.c;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + (A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c3))));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags = function (_v0) {
	var arcFlag = _v0.a;
	var direction = _v0.b;
	var _v1 = _Utils_Tuple2(arcFlag, direction);
	if (_v1.a === 1) {
		if (!_v1.b) {
			var _v2 = _v1.a;
			var _v3 = _v1.b;
			return _Utils_Tuple2(1, 0);
		} else {
			var _v6 = _v1.a;
			var _v7 = _v1.b;
			return _Utils_Tuple2(1, 1);
		}
	} else {
		if (!_v1.b) {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return _Utils_Tuple2(0, 0);
		} else {
			var _v8 = _v1.a;
			var _v9 = _v1.b;
			return _Utils_Tuple2(0, 1);
		}
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument = F2(
	function (config, _v0) {
		var radii = _v0.bN;
		var xAxisRotate = _v0.bv;
		var arcFlag = _v0.e7;
		var direction = _v0.dr;
		var target = _v0.a8;
		var _v1 = $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags(
			_Utils_Tuple2(arcFlag, direction));
		var arc = _v1.a;
		var sweep = _v1.b;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, radii),
					$elm$core$String$fromFloat(xAxisRotate),
					$elm$core$String$fromInt(arc),
					$elm$core$String$fromInt(sweep),
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, target)
				]));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo = F2(
	function (config, command) {
		if ($folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty(command)) {
			return '';
		} else {
			switch (command.$) {
				case 0:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'L'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 1:
					var mode = command.a;
					var coordinates = command.b;
					return $elm$core$List$isEmpty(coordinates) ? '' : _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'H'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 2:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'V'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 3:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'C'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3(config),
								coordinates)));
				case 4:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'S'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 5:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'Q'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 6:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'T'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 7:
					var mode = command.a;
					var _arguments = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'A'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument(config),
								_arguments)));
				default:
					return 'Z';
			}
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo = F2(
	function (config, _v0) {
		var mode = _v0.a;
		var coordinate = _v0.b;
		if (mode === 1) {
			return 'M' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		} else {
			return 'm' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath = F2(
	function (config, _v0) {
		var moveto = _v0.hY;
		var drawtos = _v0.hj;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo, config, moveto) + (' ' + A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo(config),
				drawtos)));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith = F2(
	function (options, subpaths) {
		var config = $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions(options);
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath(config),
				subpaths));
	});
var $folkertdev$one_true_path_experiment$SubPath$toStringWith = F2(
	function (options, subpath) {
		var config = A3($elm$core$List$foldl, $folkertdev$one_true_path_experiment$SubPath$optionFolder, $folkertdev$one_true_path_experiment$SubPath$defaultConfig, options);
		var lowLevelOptions = function () {
			var _v0 = config.eo;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var n = _v0.a;
				return _List_fromArray(
					[
						$folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces(n)
					]);
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith(lowLevelOptions),
					$elm$core$List$singleton),
				$folkertdev$one_true_path_experiment$SubPath$toLowLevel(
					(config.eF ? $folkertdev$one_true_path_experiment$SubPath$compress : $elm$core$Basics$identity)(subpath))));
	});
var $folkertdev$one_true_path_experiment$SubPath$toString = function (subpath) {
	return A2($folkertdev$one_true_path_experiment$SubPath$toStringWith, _List_Nil, subpath);
};
var $folkertdev$one_true_path_experiment$Path$toString = A2(
	$elm$core$Basics$composeL,
	$elm$core$String$join(' '),
	$elm$core$List$map($folkertdev$one_true_path_experiment$SubPath$toString));
var $folkertdev$one_true_path_experiment$Path$element = F2(
	function (path, attributes) {
		return A2(
			$elm$svg$Svg$path,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$d(
					$folkertdev$one_true_path_experiment$Path$toString(path)),
				attributes),
			_List_Nil);
	});
var $gampleman$elm_visualization$Shape$Generators$line = F2(
	function (curve, data) {
		var makeCurves = F2(
			function (datum, _v3) {
				var prev = _v3.a;
				var list = _v3.b;
				var _v0 = _Utils_Tuple3(prev, datum, list);
				if (_v0.b.$ === 1) {
					var _v1 = _v0.b;
					var l = _v0.c;
					return _Utils_Tuple2(false, l);
				} else {
					if (!_v0.a) {
						var point = _v0.b.a;
						var l = _v0.c;
						return _Utils_Tuple2(
							true,
							A2(
								$elm$core$List$cons,
								_List_fromArray(
									[point]),
								l));
					} else {
						if (_v0.c.b) {
							var p1 = _v0.b.a;
							var _v2 = _v0.c;
							var ps = _v2.a;
							var l = _v2.b;
							return _Utils_Tuple2(
								true,
								A2(
									$elm$core$List$cons,
									A2($elm$core$List$cons, p1, ps),
									l));
						} else {
							var p1 = _v0.b.a;
							var l = _v0.c;
							return _Utils_Tuple2(
								true,
								A2(
									$elm$core$List$cons,
									_List_fromArray(
										[p1]),
									l));
						}
					}
				}
			});
		return A2(
			$elm$core$List$map,
			curve,
			A3(
				$elm$core$List$foldr,
				makeCurves,
				_Utils_Tuple2(false, _List_Nil),
				data).b);
	});
var $gampleman$elm_visualization$Shape$line = $gampleman$elm_visualization$Shape$Generators$line;
var $folkertdev$one_true_path_experiment$LowLevel$Command$cubicCurveTo = $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo;
var $folkertdev$one_true_path_experiment$SubPath$empty = $folkertdev$one_true_path_experiment$SubPath$Empty;
var $ianmackenzie$elm_units$Quantity$Quantity = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Quantity$float = function (value) {
	return value;
};
var $ianmackenzie$elm_geometry$Geometry$Types$Vector2d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Vector2d$xy = F2(
	function (_v0, _v1) {
		var x = _v0;
		var y = _v1;
		return {M: x, N: y};
	});
var $ianmackenzie$elm_geometry$Vector2d$fromTuple = F2(
	function (toQuantity, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return A2(
			$ianmackenzie$elm_geometry$Vector2d$xy,
			toQuantity(x),
			toQuantity(y));
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$lineTo = $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo;
var $folkertdev$one_true_path_experiment$Curve$monotonePoint = F4(
	function (_v0, _v1, t0, t1) {
		var x0 = _v0.a;
		var y0 = _v0.b;
		var x1 = _v1.a;
		var y1 = _v1.b;
		var dx = (x1 - x0) / 3;
		return _Utils_Tuple3(
			_Utils_Tuple2(x0 + dx, y0 + (dx * t0)),
			_Utils_Tuple2(x1 - dx, y1 - (dx * t1)),
			_Utils_Tuple2(x1, y1));
	});
var $ianmackenzie$elm_geometry$Vector2d$minus = F2(
	function (_v0, _v1) {
		var v2 = _v0;
		var v1 = _v1;
		return {M: v1.M - v2.M, N: v1.N - v2.N};
	});
var $ianmackenzie$elm_units$Quantity$toFloat = function (_v0) {
	var value = _v0;
	return value;
};
var $ianmackenzie$elm_geometry$Vector2d$xComponent = function (_v0) {
	var v = _v0;
	return v.M;
};
var $ianmackenzie$elm_geometry$Vector2d$yComponent = function (_v0) {
	var v = _v0;
	return v.N;
};
var $ianmackenzie$elm_geometry$Vector2d$toTuple = F2(
	function (fromQuantity, vector) {
		return _Utils_Tuple2(
			fromQuantity(
				$ianmackenzie$elm_geometry$Vector2d$xComponent(vector)),
			fromQuantity(
				$ianmackenzie$elm_geometry$Vector2d$yComponent(vector)));
	});
var $folkertdev$one_true_path_experiment$Curve$slope2 = F3(
	function (p0, p1, t) {
		var _v0 = A2(
			$ianmackenzie$elm_geometry$Vector2d$toTuple,
			$ianmackenzie$elm_units$Quantity$toFloat,
			A2($ianmackenzie$elm_geometry$Vector2d$minus, p1, p0));
		var dx = _v0.a;
		var dy = _v0.b;
		return (!(!dx)) ? ((((3 * dy) / dx) - t) / 2) : t;
	});
var $folkertdev$one_true_path_experiment$Curve$sign = function (x) {
	return (x < 0) ? (-1) : 1;
};
var $folkertdev$one_true_path_experiment$Curve$toH = F2(
	function (h0, h1) {
		return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
	});
var $folkertdev$one_true_path_experiment$Curve$slope3 = F3(
	function (p0, p1, p2) {
		var _v0 = A2(
			$ianmackenzie$elm_geometry$Vector2d$toTuple,
			$ianmackenzie$elm_units$Quantity$toFloat,
			A2($ianmackenzie$elm_geometry$Vector2d$minus, p1, p2));
		var dx2 = _v0.a;
		var dy2 = _v0.b;
		var _v1 = A2(
			$ianmackenzie$elm_geometry$Vector2d$toTuple,
			$ianmackenzie$elm_units$Quantity$toFloat,
			A2($ianmackenzie$elm_geometry$Vector2d$minus, p0, p1));
		var dx1 = _v1.a;
		var dy1 = _v1.b;
		var _v2 = _Utils_Tuple2(
			A2($folkertdev$one_true_path_experiment$Curve$toH, dx1, dx2),
			A2($folkertdev$one_true_path_experiment$Curve$toH, dx2, dx1));
		var s0h = _v2.a;
		var s1h = _v2.b;
		var s1 = dy2 / s1h;
		var s0 = dy1 / s0h;
		var p = ((s0 * dx2) + (s1 * dx1)) / (dx1 + dx2);
		return ($folkertdev$one_true_path_experiment$Curve$sign(s0) + $folkertdev$one_true_path_experiment$Curve$sign(s1)) * A2(
			$elm$core$Basics$min,
			A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(s0),
				$elm$core$Basics$abs(s1)),
			0.5 * $elm$core$Basics$abs(p));
	});
var $folkertdev$one_true_path_experiment$Curve$monotoneXHelper = F3(
	function (acc, t0, remaininPoints) {
		monotoneXHelper:
		while (true) {
			if (remaininPoints.b && remaininPoints.b.b) {
				if (remaininPoints.b.b.b) {
					var p0 = remaininPoints.a;
					var _v1 = remaininPoints.b;
					var p1 = _v1.a;
					var _v2 = _v1.b;
					var p = _v2.a;
					var rest = _v2.b;
					var t1 = A3(
						$folkertdev$one_true_path_experiment$Curve$slope3,
						A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p0),
						A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p1),
						A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p));
					var $temp$acc = A2(
						$elm$core$List$cons,
						A4($folkertdev$one_true_path_experiment$Curve$monotonePoint, p0, p1, t0, t1),
						acc),
						$temp$t0 = t1,
						$temp$remaininPoints = A2(
						$elm$core$List$cons,
						p1,
						A2($elm$core$List$cons, p, rest));
					acc = $temp$acc;
					t0 = $temp$t0;
					remaininPoints = $temp$remaininPoints;
					continue monotoneXHelper;
				} else {
					var p0 = remaininPoints.a;
					var _v3 = remaininPoints.b;
					var p1 = _v3.a;
					var t1 = A3(
						$folkertdev$one_true_path_experiment$Curve$slope2,
						A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p0),
						A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p1),
						t0);
					return $elm$core$List$reverse(
						A2(
							$elm$core$List$cons,
							A4($folkertdev$one_true_path_experiment$Curve$monotonePoint, p0, p1, t0, t1),
							acc));
				}
			} else {
				return _List_Nil;
			}
		}
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$MoveTo = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$SubPath$with = F2(
	function (moveto, drawtos) {
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			{
				hj: $folkertdev$elm_deque$Deque$fromList(drawtos),
				hY: moveto
			});
	});
var $folkertdev$one_true_path_experiment$Curve$monotoneX = function (points) {
	if (points.b && points.b.b) {
		if (points.b.b.b) {
			var p0 = points.a;
			var _v1 = points.b;
			var p1 = _v1.a;
			var _v2 = _v1.b;
			var p = _v2.a;
			var rest = _v2.b;
			var t1 = A3(
				$folkertdev$one_true_path_experiment$Curve$slope3,
				A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p0),
				A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p1),
				A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p));
			var otherInstructions = A3(
				$folkertdev$one_true_path_experiment$Curve$monotoneXHelper,
				_List_Nil,
				t1,
				A2(
					$elm$core$List$cons,
					p1,
					A2($elm$core$List$cons, p, rest)));
			var initialInstruction = A4(
				$folkertdev$one_true_path_experiment$Curve$monotonePoint,
				p0,
				p1,
				A3(
					$folkertdev$one_true_path_experiment$Curve$slope2,
					A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p0),
					A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p1),
					t1),
				t1);
			return A2(
				$folkertdev$one_true_path_experiment$SubPath$with,
				$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p0),
				_List_fromArray(
					[
						$folkertdev$one_true_path_experiment$LowLevel$Command$cubicCurveTo(
						A2($elm$core$List$cons, initialInstruction, otherInstructions))
					]));
		} else {
			var p0 = points.a;
			var _v3 = points.b;
			var p1 = _v3.a;
			return A2(
				$folkertdev$one_true_path_experiment$SubPath$with,
				$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p0),
				_List_fromArray(
					[
						$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(
						_List_fromArray(
							[p1]))
					]));
		}
	} else {
		return $folkertdev$one_true_path_experiment$SubPath$empty;
	}
};
var $gampleman$elm_visualization$Shape$monotoneInXCurve = $folkertdev$one_true_path_experiment$Curve$monotoneX;
var $elm_community$typed_svg$TypedSvg$Types$PaintNone = {$: 5};
var $elm_community$typed_svg$TypedSvg$Attributes$noFill = $elm_community$typed_svg$TypedSvg$Attributes$fill($elm_community$typed_svg$TypedSvg$Types$PaintNone);
var $elm_community$typed_svg$TypedSvg$Attributes$stroke = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('stroke'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $author$project$Chart$ConsumptionProfile$spline = F2(
	function (color, points) {
		return function (path) {
			return A2(
				$folkertdev$one_true_path_experiment$Path$element,
				path,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$noFill,
						$elm_community$typed_svg$TypedSvg$Attributes$stroke(
						$elm_community$typed_svg$TypedSvg$Types$Paint(color)),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(1)
					]));
		}(
			A2($gampleman$elm_visualization$Shape$line, $gampleman$elm_visualization$Shape$monotoneInXCurve, points));
	});
var $author$project$Chart$ConsumptionProfile$splines = function (tooltip) {
	return function (xScale) {
		return function (yScale) {
			return function (timeZone) {
				return function (currentColor) {
					return function (previousColor) {
						return function (showPrevious) {
							return function (consumptionUnit) {
								return function (currentConsumptions) {
									return function (previousConsumptions) {
										return function (extension) {
											var unit = function () {
												var _v2 = extension.dl;
												if (!_v2.$) {
													var ds = _v2.a;
													return ds.i$;
												} else {
													return '';
												}
											}();
											var previousPoints = showPrevious ? A2(
												$elm$core$List$map,
												function (dp) {
													var _v1 = dp.aW;
													if (!_v1.$) {
														var value = _v1.a;
														return $elm$core$Maybe$Just(
															_Utils_Tuple2(
																A2(
																	$gampleman$elm_visualization$Scale$convert,
																	xScale,
																	A4($justinmimbs$time_extra$Time$Extra$add, 3, 1, timeZone, dp.bT)),
																A2($gampleman$elm_visualization$Scale$convert, yScale, value)));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												},
												extension.bM.aM) : _List_Nil;
											var currentPoints = A2(
												$elm$core$List$map,
												function (dp) {
													var _v0 = dp.aW;
													if (!_v0.$) {
														var value = _v0.a;
														return $elm$core$Maybe$Just(
															_Utils_Tuple2(
																A2($gampleman$elm_visualization$Scale$convert, xScale, dp.bT),
																A2($gampleman$elm_visualization$Scale$convert, yScale, value)));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												},
												extension.bA.aM);
											return A2(
												$elm_community$typed_svg$TypedSvg$g,
												_List_fromArray(
													[
														$elm_community$typed_svg$TypedSvg$Attributes$class(
														_List_fromArray(
															['splines']))
													]),
												_List_fromArray(
													[
														A2(
														$elm_community$typed_svg$TypedSvg$g,
														_List_Nil,
														_List_fromArray(
															[
																A2($author$project$Chart$ConsumptionProfile$spline, currentColor, currentPoints),
																A8(
																$author$project$Chart$ConsumptionProfile$dots,
																A2(
																	tooltip,
																	unit,
																	$elm$core$Maybe$Just(consumptionUnit)),
																showPrevious,
																currentColor,
																currentPoints,
																extension.bA.aM,
																extension.bM.aM,
																currentConsumptions,
																previousConsumptions)
															])),
														A2(
														$elm_community$typed_svg$TypedSvg$g,
														_List_Nil,
														_List_fromArray(
															[
																A2($author$project$Chart$ConsumptionProfile$spline, previousColor, previousPoints),
																A8(
																$author$project$Chart$ConsumptionProfile$dots,
																A2(
																	tooltip,
																	unit,
																	$elm$core$Maybe$Just(consumptionUnit)),
																showPrevious,
																previousColor,
																previousPoints,
																extension.bM.aM,
																extension.bA.aM,
																previousConsumptions,
																currentConsumptions)
															]))
													]));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_community$typed_svg$TypedSvg$TypesToStrings$anchorAlignmentToString = function (anchorAlignment) {
	switch (anchorAlignment) {
		case 0:
			return 'inherit';
		case 1:
			return 'start';
		case 2:
			return 'middle';
		default:
			return 'end';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$textAnchor = function (anchorAlignment) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'text-anchor',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$anchorAlignmentToString(anchorAlignment));
};
var $elm_community$typed_svg$TypedSvg$text_ = $elm_community$typed_svg$TypedSvg$Core$node('text');
var $gampleman$elm_visualization$Axis$TickFormat = function (a) {
	return {$: 1, a: a};
};
var $gampleman$elm_visualization$Axis$tickFormat = $gampleman$elm_visualization$Axis$TickFormat;
var $gampleman$elm_visualization$Axis$TickSizeOuter = function (a) {
	return {$: 4, a: a};
};
var $gampleman$elm_visualization$Axis$tickSizeOuter = $gampleman$elm_visualization$Axis$TickSizeOuter;
var $author$project$Chart$ConsumptionProfile$tickValuesRange = F2(
	function (ticksCount, scale) {
		var allFloats = A2($gampleman$elm_visualization$Scale$ticks, scale, ticksCount);
		var max = A2(
			$elm$core$Maybe$withDefault,
			10,
			$elm$core$List$maximum(allFloats));
		var min = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$minimum(allFloats));
		return max - min;
	});
var $author$project$Chart$ConsumptionProfile$w = 1000;
var $author$project$Chart$ConsumptionProfile$yGridLine = F2(
	function (yScale, tick) {
		return A2(
			$elm_community$typed_svg$TypedSvg$line,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1($author$project$Chart$ConsumptionProfile$padding.ca),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2($author$project$Chart$ConsumptionProfile$w - $author$project$Chart$ConsumptionProfile$padding.gl),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(
					$author$project$Chart$ConsumptionProfile$padding.ci + A2($gampleman$elm_visualization$Scale$convert, yScale, tick)),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2(
					$author$project$Chart$ConsumptionProfile$padding.ci + A2($gampleman$elm_visualization$Scale$convert, yScale, tick)),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['horizontal-grid-line'])),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(0.5)
				]),
			_List_Nil);
	});
var $author$project$Chart$ConsumptionProfile$chart = F3(
	function (translations, _v0, dailySpecificConsumptionPresent) {
		var current = _v0.bA;
		var previous = _v0.bM;
		var unit = _v0.i$;
		var showPrevious = _v0.cR;
		var rangeDiffMinutes = _v0.$9;
		var timeZone = _v0.iU;
		var extensions = _v0.fp;
		var timeXScale = A3(
			$gampleman$elm_visualization$Scale$band,
			_Utils_update(
				$gampleman$elm_visualization$Scale$defaultBandConfig,
				{kO: 0.15, kP: 0.35}),
			_Utils_Tuple2(0, $author$project$Chart$ConsumptionProfile$w - ($author$project$Chart$ConsumptionProfile$padding.ca + $author$project$Chart$ConsumptionProfile$padding.gl)),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.bT;
				},
				current));
		var svgClasses = dailySpecificConsumptionPresent ? (showPrevious ? _List_fromArray(
			['bar-chart mt-7']) : _List_fromArray(
			['bar-chart mt-3'])) : _List_fromArray(
			['bar-chart']);
		var seriesQuantileOverlap = 0;
		var previousColor = A2(
			$elm$core$Maybe$withDefault,
			$avh4$elm_color$Color$gray,
			$author$project$ColorHack$fromHex('#f6993f88'));
		var numberOfYTicks = 10;
		var ticksRange = $author$project$Chart$ConsumptionProfile$tickValuesRange(numberOfYTicks);
		var noons = A2(
			$elm$core$List$filterMap,
			function (c) {
				return (A2($elm$time$Time$toHour, timeZone, c.bT) === 12) ? $elm$core$Maybe$Just(c.bT) : $elm$core$Maybe$Nothing;
			},
			current);
		var timeSecondaryXScale = A3(
			$gampleman$elm_visualization$Scale$band,
			_Utils_update(
				$gampleman$elm_visualization$Scale$defaultBandConfig,
				{kO: 0.7, kP: 0.35}),
			_Utils_Tuple2(0, $author$project$Chart$ConsumptionProfile$w - ($author$project$Chart$ConsumptionProfile$padding.ca + $author$project$Chart$ConsumptionProfile$padding.gl)),
			noons);
		var formatHour = function (t) {
			var _v7 = A2($elm$time$Time$toHour, timeZone, t);
			switch (_v7) {
				case 0:
					return '0';
				case 6:
					return '6';
				case 12:
					return '12';
				case 18:
					return '18';
				default:
					return '';
			}
		};
		var formatDay = function (t) {
			var idx = function () {
				var _v6 = A2($elm$time$Time$toWeekday, timeZone, t);
				switch (_v6) {
					case 0:
						return '1';
					case 1:
						return '2';
					case 2:
						return '3';
					case 3:
						return '4';
					case 4:
						return '5';
					case 5:
						return '6';
					default:
						return '0';
				}
			}();
			return A2($author$project$Enectiva$I18n$t, translations, 'date.day_names.' + idx);
		};
		var currentColor = A2(
			$elm$core$Maybe$withDefault,
			$avh4$elm_color$Color$gray,
			$author$project$ColorHack$fromHex('#2758acff'));
		var continuousExtensions = A2(
			$elm$core$List$filterMap,
			function (e) {
				if (e.$ === 1) {
					var extension = e.a;
					return $elm$core$Maybe$Just(extension);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			extensions);
		var continuousYValues = A2(
			$elm$core$List$filterMap,
			function (dp) {
				var _v4 = dp.aW;
				if (!_v4.$) {
					var v = _v4.a;
					return $elm$core$Maybe$Just(v);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2(
				$elm$core$List$concatMap,
				function (e) {
					return _Utils_ap(e.bA.aM, e.bM.aM);
				},
				continuousExtensions));
		var continuousTotalExtent = function () {
			var maybeValuesMin = $elm$core$List$minimum(continuousYValues);
			var max = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(continuousYValues));
			var maybeQuantileMin = A2(
				$elm$core$Maybe$map,
				function (q) {
					return q - (max - q);
				},
				A3($author$project$Chart$ConsumptionProfile$quantile, 0, seriesQuantileOverlap, continuousYValues));
			var min = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$minimum(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[maybeValuesMin, maybeQuantileMin]))));
			return _Utils_Tuple2(min, max);
		}();
		var continuousYScale = A2(
			$gampleman$elm_visualization$Scale$nice,
			4,
			A2(
				$gampleman$elm_visualization$Scale$linear,
				_Utils_Tuple2($author$project$Chart$ConsumptionProfile$h - ($author$project$Chart$ConsumptionProfile$padding.ci + $author$project$Chart$ConsumptionProfile$padding.fa), 0),
				continuousTotalExtent));
		var bandXScale = A3(
			$gampleman$elm_visualization$Scale$band,
			$gampleman$elm_visualization$Scale$defaultBandConfig,
			_Utils_Tuple2(0, $author$project$Chart$ConsumptionProfile$w - ($author$project$Chart$ConsumptionProfile$padding.ca + $author$project$Chart$ConsumptionProfile$padding.gl)),
			$author$project$Chart$ConsumptionProfile$bands);
		var anyContinuousExtensionWithValidDataPresent = !$elm$core$List$isEmpty(continuousYValues);
		var consumptionTotalExtent = function () {
			var consumptionYValues = A2(
				$elm$core$List$filterMap,
				function (v) {
					if (!v.$) {
						var n = v.a;
						return $elm$core$Maybe$Just(n);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.aW;
						},
						current),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.aW;
						},
						previous)));
			var maybeValuesMax = $elm$core$List$maximum(consumptionYValues);
			if (anyContinuousExtensionWithValidDataPresent) {
				var maybeQuantileMax = A2(
					$elm$core$Maybe$map,
					function (q) {
						return q * 2;
					},
					A3($author$project$Chart$ConsumptionProfile$quantile, 10, 100 - seriesQuantileOverlap, consumptionYValues));
				var max = A2(
					$elm$core$Maybe$withDefault,
					100,
					$elm$core$List$maximum(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[maybeValuesMax, maybeQuantileMax]))));
				return _Utils_Tuple2(0, max);
			} else {
				return _Utils_Tuple2(
					0,
					A2($elm$core$Maybe$withDefault, 100, maybeValuesMax));
			}
		}();
		var consumptionYScale = A2(
			$gampleman$elm_visualization$Scale$nice,
			4,
			A2(
				$gampleman$elm_visualization$Scale$linear,
				_Utils_Tuple2($author$project$Chart$ConsumptionProfile$h - ($author$project$Chart$ConsumptionProfile$padding.ci + $author$project$Chart$ConsumptionProfile$padding.fa), 0),
				consumptionTotalExtent));
		var zeroLengthDomain = function (_v2) {
			var dmin = _v2.a;
			var dmax = _v2.b;
			return $elm$core$Basics$isNaN(dmin) && $elm$core$Basics$isNaN(dmax);
		}(
			$gampleman$elm_visualization$Scale$domain(consumptionYScale));
		var continuousAxisTicks = anyContinuousExtensionWithValidDataPresent ? A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$w - $author$project$Chart$ConsumptionProfile$padding.gl, $author$project$Chart$ConsumptionProfile$padding.ci)
						])),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['y-axis']))
				]),
			_List_fromArray(
				[
					A2(
					$gampleman$elm_visualization$Axis$right,
					_List_fromArray(
						[
							$gampleman$elm_visualization$Axis$tickCount(numberOfYTicks),
							$gampleman$elm_visualization$Axis$tickFormat(
							A3(
								$author$project$Chart$ConsumptionProfile$formatFloatToString,
								translations,
								ticksRange(continuousYScale),
								numberOfYTicks))
						]),
					continuousYScale)
				])) : A2($elm_community$typed_svg$TypedSvg$g, _List_Nil, _List_Nil);
		var continuousAxisUnit = function () {
			if (anyContinuousExtensionWithValidDataPresent) {
				var continuousUnit = A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (e) {
								var _v1 = e.dl;
								if (!_v1.$) {
									var ds = _v1.a;
									return $elm$core$Maybe$Just(ds.i$);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							continuousExtensions)));
				return A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$w, $author$project$Chart$ConsumptionProfile$padding.ci / 2.5)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['y-axis-unit']))
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$fontSize(10),
									$elm_community$typed_svg$TypedSvg$Attributes$fontFamily(
									_List_fromArray(
										['sans-serif'])),
									$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(3),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(-9)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(continuousUnit)
								]))
						]));
			} else {
				return A2($elm_community$typed_svg$TypedSvg$g, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$elm_community$typed_svg$TypedSvg$svg,
			_List_fromArray(
				[
					A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, $author$project$Chart$ConsumptionProfile$w, $author$project$Chart$ConsumptionProfile$h),
					$elm_community$typed_svg$TypedSvg$Attributes$class(svgClasses)
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$padding.ca, $author$project$Chart$ConsumptionProfile$padding.ci)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['bands']))
						]),
					A2($author$project$Chart$ConsumptionProfile$alternatingDailyBgs, bandXScale, consumptionYScale)),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Chart$ConsumptionProfile$yGridLine(consumptionYScale),
						A2($gampleman$elm_visualization$Scale$ticks, consumptionYScale, numberOfYTicks))),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$padding.ca, $author$project$Chart$ConsumptionProfile$h - $author$project$Chart$ConsumptionProfile$padding.fa)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['x-axis']))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$bottom,
							_List_fromArray(
								[
									$gampleman$elm_visualization$Axis$tickSizeOuter(0)
								]),
							A2($gampleman$elm_visualization$Scale$toRenderable, formatHour, timeXScale))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$padding.ca, $author$project$Chart$ConsumptionProfile$h - ($author$project$Chart$ConsumptionProfile$padding.fa / 2))
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['x-axis x-axis--only-ticks']))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$bottom,
							_List_fromArray(
								[
									$gampleman$elm_visualization$Axis$tickSizeOuter(0)
								]),
							A2($gampleman$elm_visualization$Scale$toRenderable, formatDay, timeSecondaryXScale))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$padding.ca, $author$project$Chart$ConsumptionProfile$padding.ci)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['y-axis']))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$left,
							_List_fromArray(
								[
									$gampleman$elm_visualization$Axis$tickFormat(
									A3(
										$author$project$Chart$ConsumptionProfile$formatFloatToString,
										translations,
										ticksRange(consumptionYScale),
										numberOfYTicks))
								]),
							consumptionYScale)
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$padding.ca, $author$project$Chart$ConsumptionProfile$padding.ci / 2.5)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['y-axis-unit']))
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$fontSize(10),
									$elm_community$typed_svg$TypedSvg$Attributes$fontFamily(
									_List_fromArray(
										['sans-serif'])),
									$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(3),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(-9)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(unit)
								]))
						])),
					continuousAxisTicks,
					continuousAxisUnit,
					zeroLengthDomain ? $author$project$Enectiva$View$nothing : $author$project$Chart$ConsumptionProfile$consumptionSeries(translations)(timeZone)(timeXScale)(consumptionYScale)(rangeDiffMinutes)(currentColor)(previousColor)(showPrevious)(current)(previous)(unit)(continuousExtensions),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$ConsumptionProfile$padding.ca, $author$project$Chart$ConsumptionProfile$padding.ci)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['continuous-series']))
						]),
					A2(
						$elm$core$List$map,
						$author$project$Chart$ConsumptionProfile$splines(
							A2($author$project$Chart$ConsumptionProfile$tooltipView, translations, timeZone))(timeXScale)(continuousYScale)(timeZone)(currentColor)(previousColor)(showPrevious)(unit)(current)(previous),
						continuousExtensions))
				]));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Divisor$toUnit = function (divisor) {
	switch (divisor.$) {
		case 0:
			var unit = divisor.a.i$;
			return unit;
		case 1:
			var unit = divisor.a.i$;
			return unit;
		case 2:
			var unit = divisor.a.i$;
			return unit;
		default:
			var unit = divisor.a.i$;
			return unit;
	}
};
var $author$project$Chart$ConsumptionProfile$showDailySpecificConsumptionDataPoint = F4(
	function (translations, consumptionUnit, divisor, dataPoint) {
		var _v0 = dataPoint.aW;
		switch (_v0.$) {
			case 0:
				var value = _v0.a;
				var divisorUnit = $author$project$Divisor$toUnit(divisor);
				var msg = A2($author$project$Enectiva$I18n$formatNumber, translations, value) + (' ' + (consumptionUnit + ('/' + divisorUnit)));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xs text-grey-700')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(msg)
						]));
			case 1:
				var msg = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xs text-red-600'),
							$elm$html$Html$Attributes$title(msg)
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'report.consumption_profile.extensions.daily_specific_consumption.missing_data')
						]));
			default:
				var msg = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xs text-yellow-800'),
							$elm$html$Html$Attributes$title(msg)
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'report.consumption_profile.extensions.daily_specific_consumption.impossible_division')
						]));
		}
	});
var $author$project$Chart$ConsumptionProfile$showDailySpecificConsumptionDayBubble = F6(
	function (translations, consumptionUnit, divisor, current, previous, showPrevious) {
		var dataPoints = showPrevious ? _List_fromArray(
			[
				A4($author$project$Chart$ConsumptionProfile$showDailySpecificConsumptionDataPoint, translations, consumptionUnit, divisor, current),
				A4($author$project$Chart$ConsumptionProfile$showDailySpecificConsumptionDataPoint, translations, consumptionUnit, divisor, previous)
			]) : _List_fromArray(
			[
				A4($author$project$Chart$ConsumptionProfile$showDailySpecificConsumptionDataPoint, translations, consumptionUnit, divisor, current)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('p-2')
				]),
			dataPoints);
	});
var $author$project$Chart$ConsumptionProfile$showDailySpecificConsumption = F4(
	function (translations, consumptionUnit, extension, showPrevious) {
		var bubbles = A3(
			$elm$core$List$map2,
			F2(
				function (current, previous) {
					return A6($author$project$Chart$ConsumptionProfile$showDailySpecificConsumptionDayBubble, translations, consumptionUnit, extension.hh, current, previous, showPrevious);
				}),
			extension.g6,
			extension.ie);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute top-2 w-full')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between ml-20 mr-15')
						]),
					bubbles)
				]));
	});
var $author$project$Chart$ConsumptionProfile$ComparisonToggleChecked = $elm$core$Basics$identity;
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$View$toggleInnerHelp = F4(
	function (translations, msg, texts, checked) {
		var attrs = texts ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-yes',
				A2($author$project$Enectiva$I18n$t, translations, 'text.yes')),
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-no',
				A2($author$project$Enectiva$I18n$t, translations, 'text.no'))
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-blue-600')
			]);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(checked),
						$elm$html$Html$Events$onCheck(msg)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('boolean-toggle__handle outline-none hover:bg-grey-800 focus:bg-grey-800'),
					attrs),
				_List_Nil)
			]);
	});
var $author$project$View$toggleHelp = F3(
	function (translations, msg, checked) {
		return A4($author$project$View$toggleInnerHelp, translations, msg, true, checked);
	});
var $author$project$View$toggleWithClass = F5(
	function (translations, cls, txt, msg, checked) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-2'),
					$elm$html$Html$Attributes$class(cls)
				]),
			_List_fromArray(
				[
					txt,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('boolean-toggle')
						]),
					A3($author$project$View$toggleHelp, translations, msg, checked))
				]));
	});
var $author$project$View$toggle = F4(
	function (translations, txt, msg, checked) {
		return A5($author$project$View$toggleWithClass, translations, '', txt, msg, checked);
	});
var $author$project$Chart$ConsumptionProfile$showPreviousToggle = F2(
	function (translations, showPrevious) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute right-0 -top-6 text-sm text-grey-700')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$View$toggle,
					translations,
					A2($author$project$View$tt, translations, 'report.hourly_profile.compare_with_previous'),
					$elm$core$Basics$identity,
					showPrevious)
				]));
	});
var $author$project$Chart$ConsumptionProfile$view = F2(
	function (translations, model) {
		var renderedDailySpecificConsumptionExtension = function (e) {
			if (!e.$) {
				var extension = e.a;
				if (!extension.$) {
					var dailySpecificConsumption = extension.a;
					return $elm$core$Maybe$Just(
						A4($author$project$Chart$ConsumptionProfile$showDailySpecificConsumption, translations, model.i$, dailySpecificConsumption, model.cR));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (extension) {
						if (!extension.$) {
							return true;
						} else {
							return false;
						}
					},
					model.fp)));
		var dailySpecificConsumptionPresent = function () {
			if (!renderedDailySpecificConsumptionExtension.$) {
				return true;
			} else {
				return false;
			}
		}();
		var divClasses = dailySpecificConsumptionPresent ? (model.cR ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('mb-16')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('mb-12')
			])) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			divClasses,
			_List_fromArray(
				[
					A3($author$project$Chart$ConsumptionProfile$chart, translations, model, dailySpecificConsumptionPresent),
					A2($elm$core$Maybe$withDefault, $author$project$Enectiva$View$nothing, renderedDailySpecificConsumptionExtension),
					A2($author$project$Chart$ConsumptionProfile$showPreviousToggle, translations, model.cR)
				]));
	});
var $elm$core$Basics$acos = _Basics_acos;
var $folkertdev$one_true_path_experiment$LowLevel$Command$arcTo = $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$LargestArc = 1;
var $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc = 1;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$SmallestArc = 0;
var $folkertdev$one_true_path_experiment$LowLevel$Command$smallestArc = 0;
var $gampleman$elm_visualization$Shape$Pie$boolToArc = function (b) {
	return b ? $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc : $folkertdev$one_true_path_experiment$LowLevel$Command$smallestArc;
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$Clockwise = 0;
var $folkertdev$one_true_path_experiment$LowLevel$Command$clockwise = 0;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$CounterClockwise = 1;
var $folkertdev$one_true_path_experiment$LowLevel$Command$counterClockwise = 1;
var $gampleman$elm_visualization$Shape$Pie$boolToDirection = function (b) {
	return b ? $folkertdev$one_true_path_experiment$LowLevel$Command$counterClockwise : $folkertdev$one_true_path_experiment$LowLevel$Command$clockwise;
};
var $elm$core$Basics$cos = _Basics_cos;
var $gampleman$elm_visualization$Shape$Pie$epsilon = 1.0e-12;
var $gampleman$elm_visualization$Shape$Pie$mod = F2(
	function (a, b) {
		var frac = a / b;
		return (frac - (frac | 0)) * b;
	});
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sin = _Basics_sin;
var $gampleman$elm_visualization$Shape$Pie$arc_ = F6(
	function (x, y, radius, a0, a1, ccw) {
		var r = $elm$core$Basics$abs(radius);
		if (!r) {
			return $folkertdev$one_true_path_experiment$SubPath$empty;
		} else {
			var tau = 2 * $elm$core$Basics$pi;
			var dy = r * $elm$core$Basics$sin(a0);
			var y0_ = y + dy;
			var dx = r * $elm$core$Basics$cos(a0);
			var x0_ = x + dx;
			var origin = $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
				_Utils_Tuple2(x0_, y0_));
			var da = ccw ? (a0 - a1) : (a1 - a0);
			var cw = $gampleman$elm_visualization$Shape$Pie$boolToDirection(!ccw);
			if (_Utils_cmp(da, tau - $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
				return A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					origin,
					_List_fromArray(
						[
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									e7: $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc,
									dr: cw,
									bN: _Utils_Tuple2(r, r),
									a8: _Utils_Tuple2(x - dx, y - dy),
									bv: 0
								}
								])),
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									e7: $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc,
									dr: cw,
									bN: _Utils_Tuple2(r, r),
									a8: _Utils_Tuple2(x0_, y0_),
									bv: 0
								}
								]))
						]));
			} else {
				var da_ = (da < 0) ? (A2($gampleman$elm_visualization$Shape$Pie$mod, da, tau) + tau) : da;
				return A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					origin,
					_List_fromArray(
						[
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									e7: $gampleman$elm_visualization$Shape$Pie$boolToArc(
										_Utils_cmp(da_, $elm$core$Basics$pi) > -1),
									dr: cw,
									bN: _Utils_Tuple2(r, r),
									a8: _Utils_Tuple2(
										x + (r * $elm$core$Basics$cos(a1)),
										y + (r * $elm$core$Basics$sin(a1))),
									bv: 0
								}
								]))
						]));
			}
		}
	});
var $elm$core$Basics$atan2 = _Basics_atan2;
var $folkertdev$one_true_path_experiment$LowLevel$Command$closePath = $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $folkertdev$elm_deque$Internal$popBack = function (deque) {
	var front = deque.aG;
	var rear = deque.aI;
	var _v0 = _Utils_Tuple2(front, rear);
	if (!_v0.b.b) {
		if (!_v0.a.b) {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
		} else {
			if (!_v0.a.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(x),
					$folkertdev$elm_deque$Internal$empty);
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
			}
		}
	} else {
		var _v2 = _v0.b;
		var r = _v2.a;
		var rs = _v2.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(r),
			$folkertdev$elm_deque$Internal$rebalance(
				{aG: deque.aG, aI: rs, av: deque.av, aw: deque.aw - 1}));
	}
};
var $folkertdev$elm_deque$Deque$popBack = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Tuple$mapSecond($elm$core$Basics$identity),
		$folkertdev$elm_deque$Internal$popBack),
	$folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$elm_deque$Deque$mapAbstract = F2(
	function (f, _v0) {
		var _abstract = _v0;
		return f(_abstract);
	});
var $folkertdev$elm_deque$Deque$pushBack = F2(
	function (elem, _v0) {
		var deque = _v0;
		return A2(
			$folkertdev$elm_deque$Deque$mapAbstract,
			$folkertdev$elm_deque$Internal$rebalance,
			{
				aG: deque.aG,
				aI: A2($elm$core$List$cons, elem, deque.aI),
				av: deque.av,
				aw: deque.aw + 1
			});
	});
var $folkertdev$one_true_path_experiment$SubPath$close = function (subpath) {
	if (subpath.$ === 1) {
		return $folkertdev$one_true_path_experiment$SubPath$Empty;
	} else {
		var moveto = subpath.a.hY;
		var drawtos = subpath.a.hj;
		var _v1 = $folkertdev$elm_deque$Deque$popBack(drawtos);
		if ((!_v1.a.$) && (_v1.a.a.$ === 4)) {
			var _v2 = _v1.a.a;
			var preceding = _v1.b;
			return subpath;
		} else {
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				{
					hj: A2($folkertdev$elm_deque$Deque$pushBack, $folkertdev$one_true_path_experiment$LowLevel$Command$closePath, drawtos),
					hY: moveto
				});
		}
	}
};
var $folkertdev$one_true_path_experiment$SubPath$firstPoint = function (_v0) {
	var moveto = _v0.hY;
	var p = moveto;
	return p;
};
var $folkertdev$one_true_path_experiment$SubPath$map2 = F3(
	function (f, sub1, sub2) {
		var _v0 = _Utils_Tuple2(sub1, sub2);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $folkertdev$one_true_path_experiment$SubPath$Empty;
			} else {
				var _v3 = _v0.a;
				var subpath = _v0.b;
				return subpath;
			}
		} else {
			if (_v0.b.$ === 1) {
				var subpath = _v0.a;
				var _v4 = _v0.b;
				return subpath;
			} else {
				var a = _v0.a.a;
				var b = _v0.b.a;
				return A2(f, a, b);
			}
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$pushBack = F2(
	function (drawto, data) {
		return _Utils_update(
			data,
			{
				hj: A2($folkertdev$elm_deque$Deque$pushBack, drawto, data.hj)
			});
	});
var $folkertdev$elm_deque$Internal$length = function (deque) {
	return deque.av + deque.aw;
};
var $folkertdev$elm_deque$Internal$isEmpty = function (deque) {
	return !$folkertdev$elm_deque$Internal$length(deque);
};
var $folkertdev$elm_deque$Deque$isEmpty = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$isEmpty, $folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$elm_deque$Deque$append = F2(
	function (p, q) {
		var x = p;
		var y = q;
		return $folkertdev$elm_deque$Deque$isEmpty(p) ? q : ($folkertdev$elm_deque$Deque$isEmpty(q) ? p : {
			aG: _Utils_ap(
				x.aG,
				$elm$core$List$reverse(x.aI)),
			aI: $elm$core$List$reverse(
				_Utils_ap(
					y.aG,
					$elm$core$List$reverse(y.aI))),
			av: x.av + x.aw,
			aw: y.av + y.aw
		});
	});
var $folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate = F2(
	function (a, b) {
		return _Utils_update(
			a,
			{
				hj: A2($folkertdev$elm_deque$Deque$append, a.hj, b.hj)
			});
	});
var $folkertdev$one_true_path_experiment$SubPath$connect = function () {
	var helper = F2(
		function (right, left) {
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate,
					A2(
						$folkertdev$one_true_path_experiment$SubPath$pushBack,
						$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(
							_List_fromArray(
								[
									$folkertdev$one_true_path_experiment$SubPath$firstPoint(right)
								])),
						left),
					right));
		});
	return $folkertdev$one_true_path_experiment$SubPath$map2(helper);
}();
var $gampleman$elm_visualization$Shape$Pie$cornerTangents = F7(
	function (x0, y0, x1, y1, r1, rc, cw) {
		var y01 = y0 - y1;
		var x01 = x0 - x1;
		var r = r1 - rc;
		var lo = (cw ? rc : (-rc)) / $elm$core$Basics$sqrt(
			A2($elm$core$Basics$pow, x01, 2) + A2($elm$core$Basics$pow, y01, 2));
		var ox = lo * y01;
		var x10 = x1 + ox;
		var x11 = x0 + ox;
		var x00 = (x11 + x10) / 2;
		var oy = (-lo) * x01;
		var y10 = y1 + oy;
		var y11 = y0 + oy;
		var y00 = (y11 + y10) / 2;
		var dy = y10 - y11;
		var dx = x10 - x11;
		var dd = (x11 * y10) - (x10 * y11);
		var d2 = A2($elm$core$Basics$pow, dx, 2) + A2($elm$core$Basics$pow, dy, 2);
		var d = ((dy < 0) ? (-1) : 1) * $elm$core$Basics$sqrt(
			A2(
				$elm$core$Basics$max,
				0,
				(A2($elm$core$Basics$pow, r, 2) * d2) - A2($elm$core$Basics$pow, dd, 2)));
		var cy1 = (((-dd) * dx) + (dy * d)) / d2;
		var dy1 = cy1 - y00;
		var cy0 = (((-dd) * dx) - (dy * d)) / d2;
		var dy0 = cy0 - y00;
		var cx1 = ((dd * dy) + (dx * d)) / d2;
		var dx1 = cx1 - x00;
		var cx0 = ((dd * dy) - (dx * d)) / d2;
		var dx0 = cx0 - x00;
		var _v0 = (_Utils_cmp(
			A2($elm$core$Basics$pow, dx0, 2) + A2($elm$core$Basics$pow, dy0, 2),
			A2($elm$core$Basics$pow, dx1, 2) + A2($elm$core$Basics$pow, dy1, 2)) > 0) ? _Utils_Tuple2(cx1, cy1) : _Utils_Tuple2(cx0, cy0);
		var fcx = _v0.a;
		var fxy = _v0.b;
		return {aq: fcx, ar: fxy, aY: -ox, bu: fcx * ((r1 / r) - 1), aZ: -oy, bw: fxy * ((r1 / r) - 1)};
	});
var $gampleman$elm_visualization$Shape$Pie$intersect = F8(
	function (x0, y0, x1, y1, x2, y2, x3, y3) {
		var y32 = y3 - y2;
		var y10 = y1 - y0;
		var x32 = x3 - x2;
		var x10 = x1 - x0;
		var t = ((x32 * (y0 - y2)) - (y32 * (x0 - x2))) / ((y32 * x10) - (x32 * y10));
		return _Utils_Tuple2(x0 + (t * x10), y0 + (t * y10));
	});
var $folkertdev$elm_deque$Internal$foldl = F3(
	function (f, initial, deque) {
		return function (initial_) {
			return A3($elm$core$List$foldr, f, initial_, deque.aI);
		}(
			A3($elm$core$List$foldl, f, initial, deque.aG));
	});
var $folkertdev$elm_deque$Deque$foldl = F2(
	function (f, initial) {
		return A2(
			$elm$core$Basics$composeL,
			A2($folkertdev$elm_deque$Internal$foldl, f, initial),
			$folkertdev$elm_deque$Deque$unwrap);
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$updateCursorState = F2(
	function (drawto, state) {
		var noControlPoint = function (currentState) {
			return _Utils_update(
				currentState,
				{_: $elm$core$Maybe$Nothing});
		};
		var maybeUpdateCursor = function (coordinate) {
			return _Utils_update(
				state,
				{
					u: A2($elm$core$Maybe$withDefault, state.u, coordinate)
				});
		};
		var _v0 = state.u;
		var cursorX = _v0.a;
		var cursorY = _v0.b;
		switch (drawto.$) {
			case 0:
				var coordinates = drawto.a;
				return noControlPoint(
					maybeUpdateCursor(
						$elm_community$list_extra$List$Extra$last(coordinates)));
			case 1:
				var coordinates = drawto.a;
				var _v2 = $elm_community$list_extra$List$Extra$last(coordinates);
				if (_v2.$ === 1) {
					return state;
				} else {
					var _v3 = _v2.a;
					var control1 = _v3.a;
					var control2 = _v3.b;
					var target = _v3.c;
					return _Utils_update(
						state,
						{
							u: target,
							_: $elm$core$Maybe$Just(control2)
						});
				}
			case 2:
				var coordinates = drawto.a;
				var _v4 = $elm_community$list_extra$List$Extra$last(coordinates);
				if (_v4.$ === 1) {
					return state;
				} else {
					var _v5 = _v4.a;
					var control = _v5.a;
					var target = _v5.b;
					return _Utils_update(
						state,
						{
							u: target,
							_: $elm$core$Maybe$Just(control)
						});
				}
			case 3:
				var _arguments = drawto.a;
				return noControlPoint(
					maybeUpdateCursor(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.a8;
							},
							$elm_community$list_extra$List$Extra$last(_arguments))));
			default:
				return noControlPoint(state);
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$finalCursorState = function (_v0) {
	var moveto = _v0.hY;
	var drawtos = _v0.hj;
	var _v1 = moveto;
	var start = _v1;
	var initial = {u: start, _: $elm$core$Maybe$Nothing, cU: start};
	return A3($folkertdev$elm_deque$Deque$foldl, $folkertdev$one_true_path_experiment$LowLevel$Command$updateCursorState, initial, drawtos);
};
var $folkertdev$one_true_path_experiment$SubPath$finalPoint = A2(
	$elm$core$Basics$composeR,
	$folkertdev$one_true_path_experiment$SubPath$finalCursorState,
	function ($) {
		return $.u;
	});
var $folkertdev$elm_deque$Internal$map = F2(
	function (f, deque) {
		return {
			aG: A2($elm$core$List$map, f, deque.aG),
			aI: A2($elm$core$List$map, f, deque.aI),
			av: deque.av,
			aw: deque.aw
		};
	});
var $folkertdev$elm_deque$Deque$map = function (f) {
	return $folkertdev$elm_deque$Deque$mapAbstract(
		$folkertdev$elm_deque$Internal$map(f));
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple2 = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple2(
			f(a),
			f(b));
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple3 = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			f(a),
			f(b),
			f(c));
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapCoordinateDrawTo = F2(
	function (f, drawto) {
		switch (drawto.$) {
			case 0:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(
					A2($elm$core$List$map, f, coordinates));
			case 1:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(
					A2(
						$elm$core$List$map,
						$folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple3(f),
						coordinates));
			case 2:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(
					A2(
						$elm$core$List$map,
						$folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple2(f),
						coordinates));
			case 3:
				var _arguments = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(
					A2(
						$elm$core$List$map,
						function (argument) {
							return _Utils_update(
								argument,
								{
									a8: f(argument.a8)
								});
						},
						_arguments));
			default:
				return $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath;
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$mapCoordinateInstructions = F2(
	function (f, _v0) {
		var moveto = _v0.hY;
		var drawtos = _v0.hj;
		var coordinate = moveto;
		return {
			hj: A2(
				$folkertdev$elm_deque$Deque$map,
				$folkertdev$one_true_path_experiment$LowLevel$Command$mapCoordinateDrawTo(f),
				drawtos),
			hY: f(coordinate)
		};
	});
var $ianmackenzie$elm_geometry$Vector2d$plus = F2(
	function (_v0, _v1) {
		var v2 = _v0;
		var v1 = _v1;
		return {M: v1.M + v2.M, N: v1.N + v2.N};
	});
var $folkertdev$one_true_path_experiment$SubPath$continue = function () {
	var helper = F2(
		function (right, left) {
			var distance = A2(
				$ianmackenzie$elm_geometry$Vector2d$minus,
				A2(
					$ianmackenzie$elm_geometry$Vector2d$fromTuple,
					$ianmackenzie$elm_units$Quantity$float,
					$folkertdev$one_true_path_experiment$SubPath$firstPoint(right)),
				A2(
					$ianmackenzie$elm_geometry$Vector2d$fromTuple,
					$ianmackenzie$elm_units$Quantity$float,
					$folkertdev$one_true_path_experiment$SubPath$finalPoint(left)));
			var mapper = A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$ianmackenzie$elm_geometry$Vector2d$toTuple($ianmackenzie$elm_units$Quantity$toFloat),
					$ianmackenzie$elm_geometry$Vector2d$plus(distance)),
				$ianmackenzie$elm_geometry$Vector2d$fromTuple($ianmackenzie$elm_units$Quantity$float));
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate,
					left,
					A2($folkertdev$one_true_path_experiment$SubPath$mapCoordinateInstructions, mapper, right)));
		});
	return $folkertdev$one_true_path_experiment$SubPath$map2(helper);
}();
var $gampleman$elm_visualization$Shape$Pie$makeArc = F6(
	function (x, y, radius, a0, a1, ccw) {
		return $folkertdev$one_true_path_experiment$SubPath$continue(
			A6($gampleman$elm_visualization$Shape$Pie$arc_, x, y, radius, a0, a1, ccw));
	});
var $elm$core$Basics$asin = _Basics_asin;
var $gampleman$elm_visualization$Shape$Pie$myAsin = function (x) {
	return (x >= 1) ? ($elm$core$Basics$pi / 2) : ((_Utils_cmp(x, -1) < 1) ? ((-$elm$core$Basics$pi) / 2) : $elm$core$Basics$asin(x));
};
var $gampleman$elm_visualization$Shape$Pie$arc = function (arcData) {
	var _v0 = (_Utils_cmp(arcData.j3, arcData.kN) > 0) ? _Utils_Tuple2(arcData.kN, arcData.j3) : _Utils_Tuple2(arcData.j3, arcData.kN);
	var r0 = _v0.a;
	var r1 = _v0.b;
	if (_Utils_cmp(r1, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) {
		return _List_fromArray(
			[
				$folkertdev$one_true_path_experiment$SubPath$close(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
						_Utils_Tuple2(0, 0)),
					_List_Nil))
			]);
	} else {
		var a1 = arcData.fn - ($elm$core$Basics$pi / 2);
		var a0 = arcData.dW - ($elm$core$Basics$pi / 2);
		var cw = _Utils_cmp(a1, a0) > 0;
		var da = $elm$core$Basics$abs(a1 - a0);
		if (_Utils_cmp(da, (2 * $elm$core$Basics$pi) - $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
			var p = A7(
				$gampleman$elm_visualization$Shape$Pie$makeArc,
				0,
				0,
				r1,
				a0,
				a1,
				!cw,
				A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
						_Utils_Tuple2(
							r1 * $elm$core$Basics$cos(a0),
							r1 * $elm$core$Basics$sin(a0))),
					_List_Nil));
			return (_Utils_cmp(r0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? _List_fromArray(
				[
					p,
					$folkertdev$one_true_path_experiment$SubPath$close(
					A7(
						$gampleman$elm_visualization$Shape$Pie$makeArc,
						0,
						0,
						r0,
						a1,
						a0,
						cw,
						A2(
							$folkertdev$one_true_path_experiment$SubPath$with,
							$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
								_Utils_Tuple2(
									r0 * $elm$core$Basics$cos(a1),
									r0 * $elm$core$Basics$sin(a1))),
							_List_Nil)))
				]) : _List_fromArray(
				[
					$folkertdev$one_true_path_experiment$SubPath$close(p)
				]);
		} else {
			var rc = A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(r1 - r0) / 2,
				arcData.ff);
			var ap = arcData.f1 / 2;
			var rp = (_Utils_cmp(ap, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? ((arcData.f2 > 0) ? arcData.f2 : $elm$core$Basics$sqrt(
				A2($elm$core$Basics$pow, r0, 2) + A2($elm$core$Basics$pow, r1, 2))) : 0;
			var _v1 = function () {
				if (_Utils_cmp(rp, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
					var p1 = $gampleman$elm_visualization$Shape$Pie$myAsin(
						(rp / r1) * $elm$core$Basics$sin(ap));
					return (_Utils_cmp(da - (p1 * 2), $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? (cw ? _Utils_Tuple3(a0 + p1, a1 - p1, da - (p1 * 2)) : _Utils_Tuple3(a0 - p1, a1 + p1, da - (p1 * 2))) : _Utils_Tuple3((a0 + a1) / 2, (a0 + a1) / 2, 0);
				} else {
					return _Utils_Tuple3(a0, a1, da);
				}
			}();
			var a01 = _v1.a;
			var a11 = _v1.b;
			var da1 = _v1.c;
			var x01 = r1 * $elm$core$Basics$cos(a01);
			var y01 = r1 * $elm$core$Basics$sin(a01);
			var x11 = r1 * $elm$core$Basics$cos(a11);
			var y11 = r1 * $elm$core$Basics$sin(a11);
			var _v2 = function () {
				if (_Utils_cmp(rp, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
					var p0 = $gampleman$elm_visualization$Shape$Pie$myAsin(
						(rp / r0) * $elm$core$Basics$sin(ap));
					return (_Utils_cmp(da - (p0 * 2), $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? (cw ? _Utils_Tuple3(a0 + p0, a1 - p0, da - (p0 * 2)) : _Utils_Tuple3(a0 - p0, a1 + p0, da - (p0 * 2))) : _Utils_Tuple3((a0 + a1) / 2, (a0 + a1) / 2, 0);
				} else {
					return _Utils_Tuple3(a0, a1, da);
				}
			}();
			var a00 = _v2.a;
			var a10 = _v2.b;
			var da0 = _v2.c;
			var x00 = r0 * $elm$core$Basics$cos(a00);
			var y00 = r0 * $elm$core$Basics$sin(a00);
			var x10 = r0 * $elm$core$Basics$cos(a10);
			var y10 = r0 * $elm$core$Basics$sin(a10);
			var _v3 = (_Utils_cmp(da0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? A8($gampleman$elm_visualization$Shape$Pie$intersect, x01, y01, x00, y00, x11, y11, x10, y10) : _Utils_Tuple2(x10, y10);
			var ocx = _v3.a;
			var ocy = _v3.b;
			var _v4 = _Utils_Tuple2(x11 - ocx, y11 - ocy);
			var bx = _v4.a;
			var by = _v4.b;
			var _v5 = _Utils_Tuple2(x01 - ocx, y01 - ocy);
			var ax = _v5.a;
			var ay = _v5.b;
			var _v6 = function () {
				if ((_Utils_cmp(rc, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) && (_Utils_cmp(da, $elm$core$Basics$pi) < 0)) {
					var lc = $elm$core$Basics$sqrt(
						A2($elm$core$Basics$pow, ocx, 2) + A2($elm$core$Basics$pow, ocy, 2));
					var kc = 1 / $elm$core$Basics$sin(
						$elm$core$Basics$acos(
							((ax * bx) + (ay * by)) / ($elm$core$Basics$sqrt(
								A2($elm$core$Basics$pow, ax, 2) + A2($elm$core$Basics$pow, ay, 2)) * $elm$core$Basics$sqrt(
								A2($elm$core$Basics$pow, bx, 2) + A2($elm$core$Basics$pow, by, 2)))) / 2);
					return _Utils_Tuple2(
						A2($elm$core$Basics$min, rc, (r0 - lc) / (kc - 1)),
						A2($elm$core$Basics$min, rc, (r1 - lc) / (kc + 1)));
				} else {
					return _Utils_Tuple2(rc, rc);
				}
			}();
			var rc0 = _v6.a;
			var rc1 = _v6.b;
			var outerRing = function () {
				if (_Utils_cmp(da1, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) {
					return A2(
						$folkertdev$one_true_path_experiment$SubPath$with,
						$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
							_Utils_Tuple2(x01, y01)),
						_List_Nil);
				} else {
					if (_Utils_cmp(rc1, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
						var t1 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x11, y11, x10, y10, r1, rc1, cw);
						var t0 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x00, y00, x01, y01, r1, rc1, cw);
						var p = A2(
							$folkertdev$one_true_path_experiment$SubPath$with,
							$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
								_Utils_Tuple2(t0.aq + t0.aY, t0.ar + t0.aZ)),
							_List_Nil);
						return (_Utils_cmp(rc1, rc) < 0) ? A7(
							$gampleman$elm_visualization$Shape$Pie$makeArc,
							t0.aq,
							t0.ar,
							rc1,
							A2($elm$core$Basics$atan2, t0.aZ, t0.aY),
							A2($elm$core$Basics$atan2, t1.aZ, t1.aY),
							!cw,
							p) : A7(
							$gampleman$elm_visualization$Shape$Pie$makeArc,
							t1.aq,
							t1.ar,
							rc1,
							A2($elm$core$Basics$atan2, t1.bw, t1.bu),
							A2($elm$core$Basics$atan2, t1.aZ, t1.aY),
							!cw,
							A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								0,
								0,
								r1,
								A2($elm$core$Basics$atan2, t0.ar + t0.bw, t0.aq + t0.bu),
								A2($elm$core$Basics$atan2, t1.ar + t1.bw, t1.aq + t1.bu),
								!cw,
								A7(
									$gampleman$elm_visualization$Shape$Pie$makeArc,
									t0.aq,
									t0.ar,
									rc1,
									A2($elm$core$Basics$atan2, t0.aZ, t0.aY),
									A2($elm$core$Basics$atan2, t0.bw, t0.bu),
									!cw,
									p)));
					} else {
						return A7(
							$gampleman$elm_visualization$Shape$Pie$makeArc,
							0,
							0,
							r1,
							a01,
							a11,
							!cw,
							A2(
								$folkertdev$one_true_path_experiment$SubPath$with,
								$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
									_Utils_Tuple2(x01, y01)),
								_List_Nil));
					}
				}
			}();
			if ((_Utils_cmp(r0, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) || (_Utils_cmp(da0, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1)) {
				return _List_fromArray(
					[
						$folkertdev$one_true_path_experiment$SubPath$close(
						A2(
							$folkertdev$one_true_path_experiment$SubPath$connect,
							A2(
								$folkertdev$one_true_path_experiment$SubPath$with,
								$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
									_Utils_Tuple2(x10, y10)),
								_List_Nil),
							outerRing))
					]);
			} else {
				if (_Utils_cmp(rc0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
					var t1 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x01, y01, x00, y00, r0, -rc0, cw);
					var t0 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x10, y10, x11, y11, r0, -rc0, cw);
					var p = A2(
						$folkertdev$one_true_path_experiment$SubPath$connect,
						A2(
							$folkertdev$one_true_path_experiment$SubPath$with,
							$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
								_Utils_Tuple2(t0.aq + t0.aY, t0.ar + t0.aZ)),
							_List_Nil),
						outerRing);
					return (_Utils_cmp(rc0, rc) < 0) ? _List_fromArray(
						[
							$folkertdev$one_true_path_experiment$SubPath$close(
							A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								t0.aq,
								t0.ar,
								rc0,
								A2($elm$core$Basics$atan2, t0.aZ, t0.aY),
								A2($elm$core$Basics$atan2, t1.aZ, t1.aY),
								!cw,
								p))
						]) : _List_fromArray(
						[
							$folkertdev$one_true_path_experiment$SubPath$close(
							A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								t1.aq,
								t1.ar,
								rc0,
								A2($elm$core$Basics$atan2, t1.bw, t1.bu),
								A2($elm$core$Basics$atan2, t1.aZ, t1.aY),
								!cw,
								A7(
									$gampleman$elm_visualization$Shape$Pie$makeArc,
									0,
									0,
									r0,
									A2($elm$core$Basics$atan2, t0.ar + t0.bw, t0.aq + t0.bu),
									A2($elm$core$Basics$atan2, t1.ar + t1.bw, t1.aq + t1.bu),
									cw,
									A7(
										$gampleman$elm_visualization$Shape$Pie$makeArc,
										t0.aq,
										t0.ar,
										rc0,
										A2($elm$core$Basics$atan2, t0.aZ, t0.aY),
										A2($elm$core$Basics$atan2, t0.bw, t0.bu),
										!cw,
										p))))
						]);
				} else {
					return _List_fromArray(
						[
							$folkertdev$one_true_path_experiment$SubPath$close(
							A2(
								$folkertdev$one_true_path_experiment$SubPath$connect,
								A6($gampleman$elm_visualization$Shape$Pie$arc_, 0, 0, r0, a10, a00, cw),
								outerRing))
						]);
				}
			}
		}
	}
};
var $gampleman$elm_visualization$Shape$arc = $gampleman$elm_visualization$Shape$Pie$arc;
var $author$project$Chart$Percentage$classes = $elm$core$Array$fromList(
	_List_fromArray(
		['report-percentage', 'report-percentage--unused']));
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Chart$Percentage$arcClass = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Array$get, index, $author$project$Chart$Percentage$classes));
};
var $author$project$Chart$Percentage$dim = 200;
var $author$project$Chart$Percentage$radius = $author$project$Chart$Percentage$dim / 2;
var $author$project$Chart$Percentage$annular = function (arcs) {
	var makeSlice = F2(
		function (index, datum) {
			return A2(
				$folkertdev$one_true_path_experiment$Path$element,
				$gampleman$elm_visualization$Shape$arc(
					_Utils_update(
						datum,
						{j3: $author$project$Chart$Percentage$radius * 0.55})),
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							[
								$author$project$Chart$Percentage$arcClass(index)
							]))
					]));
		});
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$Percentage$radius, $author$project$Chart$Percentage$radius)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_Nil,
				A2($elm$core$List$indexedMap, makeSlice, arcs))
			]));
};
var $gampleman$elm_visualization$Shape$defaultPieConfig = {ff: 0, fn: 2 * $elm$core$Basics$pi, j3: 0, kN: 100, f1: 0, f2: 0, k7: $elm$core$Basics$compare, dW: 0, i0: $elm$core$Basics$identity};
var $author$project$Chart$Percentage$centerIcon = function (raw) {
	var offset = ($author$project$Chart$Percentage$dim - 50) / 2;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, offset, offset)
					]))
			]),
		_List_fromArray(
			[raw]));
};
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$SvgIcons$energyIcon = F6(
	function (cls, iconWidth, iconHeight, children, maybeClass, maybeWidth) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('energy-icon'),
					$elm$svg$Svg$Attributes$class(cls),
					$elm$svg$Svg$Attributes$class(
					A2($elm$core$Maybe$withDefault, '', maybeClass)),
					$elm$svg$Svg$Attributes$viewBox(
					'0 0 ' + ($elm$core$String$fromFloat(iconWidth) + (' ' + $elm$core$String$fromFloat(iconHeight)))),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconWidth, maybeWidth))),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconHeight, maybeWidth)))
				]),
			children);
	});
var $author$project$SvgIcons$co = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	21.75,
	23.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12.037,23H9.67v-2.445l-1.621,1.541l-1.628-1.712l3.249-3.085v-3.506l-3.002,1.734l-1.056,4.39l-2.296-0.556l0.53-2.207 l-2.137,1.234l-1.185-2.052l2.117-1.22l-2.143-0.635l0.668-2.265l4.296,1.271l3.045-1.758L5.496,9.991l-4.33,1.281L0.498,9.007 l2.178-0.644L0.537,7.127l1.185-2.05l2.117,1.224L3.316,4.126l2.296-0.553l1.047,4.356L9.67,9.667V6.18L6.421,3.095l1.628-1.71 L9.67,2.924V0.5h2.367v2.449l1.646-1.564l1.629,1.71l-3.275,3.11v3.488l3.055-1.764l1.047-4.356l2.295,0.553l-0.521,2.175 l2.098-1.213l1.184,2.051l-2.118,1.224l2.177,0.644l-0.668,2.265l-4.33-1.281l-3.011,1.738l3.045,1.757l4.296-1.269l0.668,2.263 l-2.145,0.636l2.1,1.211l-1.184,2.051l-2.119-1.226l0.529,2.209l-2.295,0.556l-1.057-4.39l-3.045-1.76v3.506l3.275,3.11l-1.629,1.71 l-1.646-1.564V23z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$el = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	14.87,
	24,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m 4.973,1.9999455 c -0.36,0 -0.678,0.225 -0.783,0.555 L 0.537,12.767946 c -0.133,0.416 0.109,0.855 0.543,0.982 0.078,0.023 0.16,0.036 0.241,0.036 h 2.767 l -0.752,9.366 c -0.034,0.436 0.303,0.812 0.755,0.846 0.291,0.02 0.571,-0.107 0.738,-0.339 l 9.397,-12.571 c 0.258,-0.357 0.159,-0.847 -0.211,-1.0930004 -0.143,-0.089 -0.301,-0.139 -0.467,-0.139 H 9.666 l 3.881,-6.7200001 c 0.203,-0.388 0.039,-0.859 -0.367,-1.055 -0.114,-0.053 -0.239,-0.081 -0.368,-0.081 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$ga = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	17.34,
	23,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 7.983,0.50455415 C 7.85,0.53055415 7.746,0.63555416 7.729,0.76955416 6.952,5.2625542 5.221,7.1065542 3.611,8.7925542 2.003,10.476554 0.499,12.045554 0.499,15.651554 c 0,1.74 0.771,3.201 1.924,4.342 1.154,1.138 2.688,1.961 4.263,2.482 0.166,0.054 0.343,-0.038 0.395,-0.205 0.031,-0.098 0.013,-0.205 -0.05,-0.286 -1.541,-1.85 -1.971,-3.185 -1.935,-4.27 0.032,-0.956 0.443,-1.763 0.864,-2.591 0.622,0.5 1.163,0.914 1.453,1.1 0.177,0.111 0.299,0.183 0.383,0.226 0.084,0.042 0.158,0.069 0.158,0.069 0.09,0.025 0.187,0.012 0.264,-0.041 0,0 0.627,-0.432 1.13,-1.382 0.421,-0.798 0.749,-2.007 0.657,-3.624 2.023,2.204 2.773,4.091 2.75,5.683 -0.03,2.084 -1.282,3.749 -2.418,4.792 -0.131,0.11 -0.149,0.31 -0.037,0.441 0.071,0.086 0.182,0.127 0.296,0.106 3.244,-0.455 6.245,-3.308 6.245,-6.902 0,-2.544 -0.439,-4.794 -1.74,-7.1539998 -1.299,-2.361 -3.449,-4.825 -6.854,-7.85500004 -0.071,-0.064 -0.169,-0.092 -0.264,-0.078 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$hca = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$he = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$lf = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	23.93,
	22.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3.527,7.357c0,0,2.992,3.304,2.992,4.888c0,1.582-1.34,2.867-2.992,2.867c-1.653,0-2.993-1.283-2.993-2.867 C0.535,10.662,3.527,7.357,3.527,7.357z M23.429,21.12L22.6,19.012c0.231-0.179,0.33-0.48,0.214-0.76l-3.292-7.833l0.604-0.739 c0.127-0.145,0.18-0.341,0.143-0.536c-0.038-0.196-0.159-0.362-0.325-0.454l-7.321-4.248c-0.252-0.144-0.582-0.11-0.804,0.066 l-1.563-1.184c-0.074-0.058-0.162-0.1-0.267-0.126L2.816,1.52C2.443,1.424,2.031,1.676,1.963,2.027L1.589,3.726 C1.51,4.075,1.743,4.429,2.106,4.514l5.898,1.375C8.1,5.958,8.465,6.237,8.929,6.591c0.149,0.115,0.288,0.22,0.422,0.323 C9.208,7.167,9.237,7.486,9.459,7.699l0.438,0.418L12,19.264c0.194,1.155,1.308,2.061,2.537,2.061h0.03 c0.367,0,0.726-0.073,1.067-0.219l2.699-1.158l0.039,0.109c0.088,0.266,0.351,0.45,0.647,0.458l0.797,2.028 C19.906,22.813,20.181,23,20.481,23c0.102,0,0.198-0.021,0.281-0.06l2.296-0.989C23.388,21.811,23.55,21.446,23.429,21.12z M15.396,18.36c-0.227,0.094-0.486-0.05-0.524-0.28l-1.02-5.179c0,0-0.104-0.496,0.358-0.602c0.463-0.104,1.037-0.233,1.037-0.233 l2.003,5.561L15.396,18.36z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$wa = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	16.3,
	22.52,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M8.476,1.155c-0.15-0.209-0.501-0.209-0.651,0L6.007,3.656C4.715,5.439,0.5,11.511,0.5,14.869 c0,4.221,3.435,7.65,7.649,7.65c4.219,0,7.649-3.433,7.649-7.65c0-3.358-4.22-9.432-5.51-11.213L8.476,1.155z')
				]),
			_List_Nil)
		]));
var $author$project$Types$energyIconWithOpts = F3(
	function (_class, size, energy) {
		switch (energy) {
			case 1:
				return A2($author$project$SvgIcons$el, _class, size);
			case 2:
				return A2($author$project$SvgIcons$ga, _class, size);
			case 3:
				return A2($author$project$SvgIcons$wa, _class, size);
			case 4:
				return A2($author$project$SvgIcons$he, _class, size);
			case 5:
				return A2($author$project$SvgIcons$co, _class, size);
			case 6:
				return A2($author$project$SvgIcons$hca, _class, size);
			case 7:
				return A2($author$project$SvgIcons$lf, _class, size);
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $elm_community$typed_svg$TypedSvg$Attributes$d = $elm_community$typed_svg$TypedSvg$Core$attribute('d');
var $author$project$Chart$Percentage$savingIcon = A2(
	$elm_community$typed_svg$TypedSvg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$x('0px'),
			$elm$svg$Svg$Attributes$y('8px'),
			$elm$svg$Svg$Attributes$width('51px'),
			$elm$svg$Svg$Attributes$height('38.02px'),
			A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, -14.7, -9.01, 51, 38.02)
		]),
	_List_fromArray(
		[
			A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#199C49'),
							$elm_community$typed_svg$TypedSvg$Attributes$d('M29.893-8.501c-1.461,0.074-2.835,0.718-3.834,1.792l-20.98,21.97l-10.09-7.489c-2.417-1.96-5.966-1.592-7.931,0.827 c-1.96,2.417-1.589,5.968,0.828,7.931l0,0l14.099,10.72c2.266,1.843,5.565,1.642,7.595-0.457L34.152,1.098 c2.196-2.197,2.196-5.76,0-7.958C33.026-7.984,31.479-8.58,29.893-8.501z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Chart$Percentage$rawIcon = function (_v0) {
	var energy = _v0.hm;
	var excess = _v0.fo;
	return excess ? A3(
		$author$project$Types$energyIconWithOpts,
		$elm$core$Maybe$Just('energy-icon--with-warning fill-current'),
		$elm$core$Maybe$Just(50),
		energy) : $author$project$Chart$Percentage$savingIcon;
};
var $author$project$Chart$Percentage$icon = A2($elm$core$Basics$composeR, $author$project$Chart$Percentage$rawIcon, $author$project$Chart$Percentage$centerIcon);
var $elm$core$List$sortWith = _List_sortWith;
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $gampleman$elm_visualization$Shape$Pie$pie = F2(
	function (settings, data) {
		var unsafeGet = F2(
			function (index, array) {
				unsafeGet:
				while (true) {
					var _v0 = A2($elm$core$Array$get, index, array);
					if (!_v0.$) {
						var v = _v0.a;
						return v;
					} else {
						var $temp$index = index,
							$temp$array = array;
						index = $temp$index;
						array = $temp$array;
						continue unsafeGet;
					}
				}
			});
		var summer = F2(
			function (a, b) {
				var v = settings.i0(a);
				return (v > 0) ? (v + b) : b;
			});
		var sum = A3($elm$core$List$foldr, summer, 0, data);
		var sortedIndices = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$map($elm$core$Tuple$first),
				$elm$core$List$sortWith(
					F2(
						function (_v2, _v3) {
							var a = _v2.b;
							var b = _v3.b;
							return A2(settings.k7, a, b);
						}))),
			$elm$core$List$indexedMap($elm$core$Tuple$pair));
		var dataArray = $elm$core$Array$fromList(data);
		var da = A2(
			$elm$core$Basics$min,
			2 * $elm$core$Basics$pi,
			A2($elm$core$Basics$max, (-2) * $elm$core$Basics$pi, settings.fn - settings.dW));
		var p = A2(
			$elm$core$Basics$min,
			$elm$core$Basics$abs(da) / $elm$core$List$length(data),
			settings.f1);
		var pa = p * ((da < 0) ? (-1) : 1);
		var k = (!sum) ? 0 : ((da - ($elm$core$List$length(data) * pa)) / sum);
		var computeValue = F2(
			function (el, angle) {
				var value = settings.i0(el);
				return {
					ff: settings.ff,
					fn: (angle + ((value > 0) ? (value * k) : 0)) + pa,
					j3: settings.j3,
					kN: settings.kN,
					f1: p,
					f2: settings.f2,
					dW: angle
				};
			});
		var helper = F2(
			function (index, _v1) {
				var angle = _v1.a;
				var result = _v1.b;
				var r = A2(
					computeValue,
					A2(unsafeGet, index, dataArray),
					angle);
				return _Utils_Tuple2(
					r.fn,
					A3($elm$core$Dict$insert, index, r, result));
			});
		return $elm$core$Dict$values(
			A3(
				$elm$core$List$foldl,
				helper,
				_Utils_Tuple2(settings.dW, $elm$core$Dict$empty),
				sortedIndices(data)).b);
	});
var $gampleman$elm_visualization$Shape$pie = $gampleman$elm_visualization$Shape$Pie$pie;
var $author$project$Chart$Percentage$view = function (model) {
	var data = model.jA;
	var pieData = A2(
		$gampleman$elm_visualization$Shape$pie,
		_Utils_update(
			$gampleman$elm_visualization$Shape$defaultPieConfig,
			{
				kN: $author$project$Chart$Percentage$radius,
				k7: F2(
					function (_v0, _v1) {
						return 1;
					})
			}),
		data);
	return A2(
		$elm_community$typed_svg$TypedSvg$svg,
		_List_fromArray(
			[
				A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, $author$project$Chart$Percentage$dim, $author$project$Chart$Percentage$dim)
			]),
		_List_fromArray(
			[
				$author$project$Chart$Percentage$annular(pieData),
				$author$project$Chart$Percentage$icon(model)
			]));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Chart$Shared$container = function (state) {
	return $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id(state.dh),
				$elm$html$Html$Attributes$class('relative')
			]));
};
var $author$project$Chart$Shared$Clickable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$CursorMovedOverTooltip = function (a) {
	return {$: 1, a: a};
};
var $author$project$Chart$Shared$LegendItemClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Chart$Shared$NotClickable = {$: 0};
var $author$project$Chart$Shared$Left = 0;
var $author$project$Chart$Shared$Right = 1;
var $author$project$Chart$Shared$maybeAddUnit = F2(
	function (maybeUnit, str) {
		if (maybeUnit.$ === 1) {
			return str;
		} else {
			var unit = maybeUnit.a;
			return _Utils_ap(
				str,
				_Utils_ap($author$project$View$nbsp, unit));
		}
	});
var $author$project$Chart$Shared$px = function (num) {
	return $elm$core$String$fromFloat(num) + 'px';
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Chart$Shared$productionText = F3(
	function (translations, p, _v0) {
		var unit = _v0.i$;
		var productionPercent = _v0.ik;
		var absolute = _Utils_ap(
			A2($author$project$Enectiva$I18n$formatNumber, translations, p),
			_Utils_ap($author$project$View$nbsp, unit));
		if (productionPercent.$ === 1) {
			return absolute;
		} else {
			var pp = productionPercent.a;
			return A2($author$project$Enectiva$I18n$formatNumber, translations, pp) + ($author$project$View$nbsp + ('% (' + (A2($author$project$Enectiva$I18n$t, translations, 'stats.label.of_consumption') + ('), ' + absolute))));
		}
	});
var $author$project$Chart$Shared$subordinateConsumptionDetailView = F4(
	function (translations, sizes, alignment, detail) {
		var production = function () {
			var _v3 = detail.ii;
			if (!_v3.$) {
				var p = _v3.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Enectiva$I18n$t, translations, 'stats.label.total_production'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3($author$project$Chart$Shared$productionText, translations, p, detail))
									]))
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var absolute = _Utils_ap(
			A2($author$project$Enectiva$I18n$formatNumber, translations, detail.g2),
			_Utils_ap($author$project$View$nbsp, detail.i$));
		var txt = function () {
			var _v2 = detail.g4;
			if (_v2.$ === 1) {
				return absolute;
			} else {
				var p = _v2.a;
				return A2($author$project$Enectiva$I18n$formatNumber, translations, p) + ($author$project$View$nbsp + ('%, ' + absolute));
			}
		}();
		var _v0 = function () {
			if (!alignment) {
				return _Utils_Tuple3('left', sizes.ca + 10, '');
			} else {
				return _Utils_Tuple3('right', sizes.gl + 10, 'text-right');
			}
		}();
		var side = _v0.a;
		var horizontalOffset = _v0.b;
		var cls = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute bg-white opacity-70 p-2 rounded'),
					$elm$html$Html$Attributes$class('fast-colors-transition hover:opacity-100'),
					$elm$html$Html$Attributes$class(cls),
					A2(
					$elm$html$Html$Attributes$style,
					side,
					$author$project$Chart$Shared$px(horizontalOffset)),
					A2(
					$elm$html$Html$Attributes$style,
					'top',
					$author$project$Chart$Shared$px(35))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Enectiva$I18n$t, translations, 'stats.label.total_consumption'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(txt)
									]))
							]))
					]),
				production));
	});
var $author$project$Svg$Extra$viewMaybe = F2(
	function (maybe, viewFn) {
		if (!maybe.$) {
			var a = maybe.a;
			return viewFn(a);
		} else {
			return $elm$svg$Svg$text('');
		}
	});
var $author$project$Chart$Shared$additionalInfoView = F3(
	function (translations, sizes, additionalInfo) {
		switch (additionalInfo.$) {
			case 0:
				return $author$project$Enectiva$View$nothing;
			case 3:
				return $author$project$Enectiva$View$nothing;
			case 1:
				var unit = additionalInfo.a;
				var fp = additionalInfo.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute z-10 bg-white opacity-70 p-2 rounded'),
							$elm$html$Html$Attributes$class('fast-colors-transition hover:opacity-100'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$author$project$Chart$Shared$px(sizes.ca + 10)),
							A2(
							$elm$html$Html$Attributes$style,
							'bottom',
							$author$project$Chart$Shared$px(sizes.fa + 10))
						]),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var k = _v1.a;
							var v = _v1.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(k)
											])),
										$elm$html$Html$text(': '),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$author$project$Chart$Shared$maybeAddUnit,
													unit,
													A2($author$project$Enectiva$I18n$formatNumber, translations, v)))
											]))
									]));
						},
						$elm$core$Dict$toList(fp)));
			default:
				var currentDetail = additionalInfo.a;
				var maybeComparisonDetail = additionalInfo.b;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4($author$project$Chart$Shared$subordinateConsumptionDetailView, translations, sizes, 0, currentDetail),
							A2(
							$author$project$Svg$Extra$viewMaybe,
							maybeComparisonDetail,
							A3($author$project$Chart$Shared$subordinateConsumptionDetailView, translations, sizes, 1))
						]));
		}
	});
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Chart$Shared$header = F2(
	function (title, subtitle) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['fill-current text-base text-blue-700 text-center z-10 m-auto leading-tight relative']))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['text-xs text-grey-600 fill-current text-center m-auto mt-1 -mb-5 relative']))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', subtitle))
					]))
			]);
	});
var $author$project$Chart$Shared$SliceLegend = 3;
var $author$project$Chart$Shared$BarLegend = 2;
var $author$project$Chart$Shared$categoricalSeriesToLegendItem = function (s) {
	return {f: s.f, r: s.r, kt: s.kt, ea: 2};
};
var $author$project$Chart$Shared$LineLegend = 0;
var $author$project$Chart$Shared$LineWithCircleLegend = 1;
var $author$project$Chart$Shared$timeSeriesToLegendItem = function (s) {
	var variant = s.a1 ? 1 : 0;
	return {f: s.f, r: s.r, kt: s.kt, ea: variant};
};
var $author$project$Chart$Shared$dataToLegendItems = function (data) {
	switch (data.$) {
		case 0:
			var primaryYAxisData = data.b;
			var secondaryYAxisData = data.c;
			return A2(
				$elm$core$List$map,
				$author$project$Visibility$map(
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Chart$Shared$timeSeriesToLegendItem)),
				_Utils_ap(
					primaryYAxisData.jA,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.jA;
							},
							secondaryYAxisData))));
		case 1:
			var primaryYAxisData = data.c;
			var secondaryYAxisData = data.d;
			return A2(
				$elm$core$List$concatMap,
				function (cd) {
					switch (cd.$) {
						case 0:
							var vs = cd.a;
							return $elm$core$List$singleton(
								A2($author$project$Visibility$map, $author$project$Chart$Shared$categoricalSeriesToLegendItem, vs));
						case 1:
							var vss = cd.a;
							return A2(
								$elm$core$List$map,
								$author$project$Visibility$map($author$project$Chart$Shared$categoricalSeriesToLegendItem),
								vss);
						default:
							var vs = cd.a;
							return $elm$core$List$singleton(
								A2($author$project$Visibility$map, $author$project$Chart$Shared$timeSeriesToLegendItem, vs));
					}
				},
				_Utils_ap(
					primaryYAxisData.jA,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.jA;
							},
							secondaryYAxisData))));
		default:
			var primarySlices = data.b;
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (idx, slice) {
						return $author$project$Visibility$Visible(
							{f: slice.f, r: idx, kt: slice.kt, ea: 3});
					}),
				primarySlices);
	}
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Visibility$isHidden = function (optional) {
	if (!optional.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Chart$Shared$legendVariantClass = function (variant) {
	switch (variant) {
		case 0:
			return 'w-4 h-px pt-px box-content';
		case 1:
			return 'w-4 h-px pt-px box-content inline-flex items-center justify-center legend-circle';
		case 2:
			return 'w-4 h-3 rounded-sm';
		default:
			return 'w-3 h-3 rounded-full';
	}
};
var $author$project$Chart$Shared$legendSeriesIndicator = F2(
	function (variant, bgColor) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Chart$Shared$legendVariantClass(variant)),
					A2($elm$html$Html$Attributes$style, 'background-color', bgColor)
				]),
			_List_Nil);
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Chart$Shared$legendItemView = F2(
	function (clickability, vl) {
		var item = $author$project$Visibility$value(vl);
		var bgColor = function () {
			if (!vl.$) {
				var l = vl.a;
				return $avh4$elm_color$Color$toCssString(l.f);
			} else {
				return '#7c7c7c';
			}
		}();
		var attrs = function () {
			if (!clickability.$) {
				return _List_Nil;
			} else {
				var toggleMsg = clickability.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						toggleMsg(item.r)),
						$elm$html$Html$Attributes$class('cursor-pointer')
					]);
			}
		}();
		return _Utils_Tuple2(
			item.kt,
			A2(
				$elm$html$Html$li,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-flex items-center whitespace-nowrap gap-1'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'text-grey-600',
									$author$project$Visibility$isHidden(vl))
								]))
						]),
					attrs),
				_List_fromArray(
					[
						A2($author$project$Chart$Shared$legendSeriesIndicator, item.ea, bgColor),
						$elm$html$Html$text(item.kt)
					])));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $author$project$Chart$Shared$legendView = F3(
	function (data, clickability, sticky) {
		var items = $author$project$Chart$Shared$dataToLegendItems(data);
		var _class = sticky ? 'sticky bottom-5 py-4 px-8 bg-white rounded shadow-md w-fit mx-auto' : 'w-full my-2';
		return A2(
			$elm$html$Html$Keyed$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(_class),
					$elm$html$Html$Attributes$class('flex items-center gap-2 justify-center text-2xs flex-wrap')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Chart$Shared$legendItemView(clickability),
				items));
	});
var $author$project$Chart$Shared$isSampled = function (data) {
	return function (v) {
		return !_Utils_eq(v, $elm$core$Maybe$Nothing);
	}(
		$author$project$Visibility$value(data).a.a6);
};
var $author$project$Chart$Shared$isAnySampled = function (_v0) {
	var data = _v0.jA;
	return A2($elm$core$List$any, $author$project$Chart$Shared$isSampled, data);
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Chart$Shared$indicatorDimensionsClasses = function (sizes) {
	return (sizes.h < 449) ? {dx: 'text-xs', b7: 'w-4 h-4', dC: '-left-4', d4: '-top-0.075'} : (((sizes.h > 450) && (sizes.h < 749)) ? {dx: 'text-sm', b7: 'w-5 h-5', dC: '-left-5', d4: '-top-0.5'} : {dx: 'text-sm', b7: 'w-6 h-6', dC: '-left-6', d4: '-top-1'});
};
var $author$project$Enectiva$I18n$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$applyOption = function (option) {
	if (!option.$) {
		var placeholder = option.a;
		var value = option.b;
		return A2(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('%{' + (placeholder + '}'))),
			$elm$core$Basics$always(value));
	} else {
		return $elm$core$Basics$identity;
	}
};
var $author$project$Enectiva$I18n$one = 'one';
var $author$project$Enectiva$I18n$other = 'other';
var $author$project$Enectiva$I18n$fallbackPluralizationFn = function (cnt) {
	if (cnt === 1) {
		return $author$project$Enectiva$I18n$one;
	} else {
		return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$few = 'few';
var $author$project$Enectiva$I18n$czechPluralizationFn = function (cnt) {
	switch (cnt) {
		case 1:
			return $author$project$Enectiva$I18n$one;
		case 2:
			return $author$project$Enectiva$I18n$few;
		case 3:
			return $author$project$Enectiva$I18n$few;
		case 4:
			return $author$project$Enectiva$I18n$few;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$frenchPluralizationFn = function (cnt) {
	switch (cnt) {
		case 0:
			return $author$project$Enectiva$I18n$one;
		case 1:
			return $author$project$Enectiva$I18n$one;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$slovakPluralizationFn = $author$project$Enectiva$I18n$czechPluralizationFn;
var $author$project$Enectiva$I18n$pluralizationFns = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('cs', $author$project$Enectiva$I18n$czechPluralizationFn),
			_Utils_Tuple2('sk', $author$project$Enectiva$I18n$slovakPluralizationFn),
			_Utils_Tuple2('fr', $author$project$Enectiva$I18n$frenchPluralizationFn),
			_Utils_Tuple2(
			'hu',
			$elm$core$Basics$always($author$project$Enectiva$I18n$other))
		]));
var $author$project$Enectiva$I18n$countToKeyPathSegment = F2(
	function (_v0, cnt) {
		var l = _v0.a;
		return A3(
			$elm$core$Basics$apR,
			A2($elm$core$Dict$get, l, $author$project$Enectiva$I18n$pluralizationFns),
			$elm$core$Maybe$withDefault($author$project$Enectiva$I18n$fallbackPluralizationFn),
			$elm$core$Basics$abs(cnt));
	});
var $author$project$Enectiva$I18n$providedCount = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (o) {
					if (o.$ === 1) {
						var cnt = o.a;
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$Just(cnt));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				options)));
};
var $author$project$Enectiva$I18n$tt = F3(
	function (translations, key, options) {
		var _v0 = $author$project$Enectiva$I18n$providedCount(options);
		if (!_v0.$) {
			var cnt = _v0.a;
			var _v1 = A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				_Utils_ap(
					$author$project$Enectiva$I18n$keyToKeyPath(key),
					_List_fromArray(
						[
							A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, cnt)
						])));
			if (_v1.$ === 1) {
				var _v2 = A2(
					$author$project$Enectiva$I18n$tHelp,
					translations,
					_Utils_ap(
						$author$project$Enectiva$I18n$keyToKeyPath(key),
						_List_fromArray(
							[
								A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, 1)
							])));
				if (_v2.$ === 1) {
					return A2($author$project$Enectiva$I18n$t, translations, key);
				} else {
					var localized = _v2.a;
					return localized;
				}
			} else {
				var localized = _v1.a;
				return A2(
					$author$project$Enectiva$I18n$applyOption,
					A2(
						$author$project$Enectiva$I18n$Placeholder,
						'count',
						$elm$core$String$fromInt(cnt)),
					localized);
			}
		} else {
			return A3(
				$elm$core$List$foldl,
				$author$project$Enectiva$I18n$applyOption,
				A2($author$project$Enectiva$I18n$t, translations, key),
				options);
		}
	});
var $author$project$Chart$Shared$samplingNoteView = F2(
	function (translations, _v0) {
		var name = _v0.kt;
		var samplingRatio = _v0.a6;
		var _v1 = function () {
			if (!samplingRatio.$) {
				var ratio = samplingRatio.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Enectiva$I18n$tt,
						translations,
						'stats.sampling.sampled',
						_List_fromArray(
							[
								A2(
								$author$project$Enectiva$I18n$Placeholder,
								'ratio',
								A2($author$project$Enectiva$I18n$formatNumber, translations, ratio))
							])),
					'text-black');
			} else {
				return _Utils_Tuple2(
					A2($author$project$Enectiva$I18n$t, translations, 'stats.sampling.not_sampled'),
					'text-grey-600');
			}
		}();
		var samplingText = _v1.a;
		var cls = _v1.b;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(cls)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name + (': ' + samplingText))
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Chart$Shared$samplingView = F4(
	function (translations, sizes, primaryAxis, maybeSecondaryAxis) {
		var secondarySeries = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Visibility$value, $elm$core$Tuple$first),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.jA;
					},
					maybeSecondaryAxis)));
		var primarySeries = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Visibility$value, $elm$core$Tuple$first),
			primaryAxis.jA);
		var items = A2(
			$elm$core$List$map,
			$author$project$Chart$Shared$samplingNoteView(translations),
			_Utils_ap(primarySeries, secondarySeries));
		var dimensions = $author$project$Chart$Shared$indicatorDimensionsClasses(sizes);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute top-0 group z-20')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class(dimensions.b7),
							$elm$html$Html$Attributes$class(dimensions.d4),
							$elm$html$Html$Attributes$class('flex relative'),
							A2($elm$html$Html$Attributes$attribute, 'data-dashboard-chart-target', 'chartContentSampling')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(dimensions.b7),
									$elm$html$Html$Attributes$class('shrink-0 animate-ping'),
									$elm$html$Html$Attributes$class('bg-blue-600 opacity-70 rounded-full relative')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(dimensions.dC),
									$elm$html$Html$Attributes$class(dimensions.dx),
									$elm$html$Html$Attributes$class('w-full h-full text-white font-bold'),
									$elm$html$Html$Attributes$class('bg-blue-600 opacity-70 rounded-full relative'),
									$elm$html$Html$Attributes$class('shrink-0 flex items-center justify-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('?')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute top-0 mt-6 ml-2 bg-white overflow-hidden p-2 max-h-184 shadow-md rounded transform scale-0'),
							$elm$html$Html$Attributes$class('group-hover:scale-100')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('overflow-hidden opacity-0 w-96 transition-opacity duration-300 ease-in'),
									$elm$html$Html$Attributes$class('group-hover:opacity-100'),
									$elm$html$Html$Attributes$class('group-focus:opacity-100'),
									$elm$html$Html$Attributes$class('space-y-2')
								]),
							items)
						]))
				]));
	});
var $author$project$Chart$Shared$processingInfoView = F3(
	function (translations, sizes, data) {
		if (!data.$) {
			var primaryAxis = data.b;
			var maybeSecondaryAxis = data.c;
			var anySecondarySampled = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Chart$Shared$isAnySampled, maybeSecondaryAxis));
			var anyPrimarySampled = $author$project$Chart$Shared$isAnySampled(primaryAxis);
			return (anyPrimarySampled || anySecondarySampled) ? A4($author$project$Chart$Shared$samplingView, translations, sizes, primaryAxis, maybeSecondaryAxis) : $author$project$Enectiva$View$nothing;
		} else {
			return $author$project$Enectiva$View$nothing;
		}
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Chart$Shared$serverErrorView = F2(
	function (translations, error) {
		var _v0 = error.aQ;
		if (!_v0.$) {
			var link = _v0.a;
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(error.fi),
						$elm$html$Html$text(' – '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(link),
								$elm$html$Html$Attributes$target('blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Enectiva$I18n$t, translations, 'stats.link.edit'))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(error.fi)
					]));
		}
	});
var $author$project$Chart$Shared$serverErrorGroupView = F2(
	function (translations, group) {
		if (!group.$) {
			var entries = group.a;
			return A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-1')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Chart$Shared$serverErrorView(translations),
					entries));
		} else {
			var series = group.a;
			var entries = group.b;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-semibold text-grey-700')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(series)
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-2'),
								$elm$html$Html$Attributes$class('flex flex-col gap-1')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Chart$Shared$serverErrorView(translations),
							entries))
					]));
		}
	});
var $author$project$Chart$Shared$serverErrorsViewHelp = F3(
	function (translations, sizes, groups) {
		var dimensions = $author$project$Chart$Shared$indicatorDimensionsClasses(sizes);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute top-0 group z-20')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class(dimensions.b7),
							$elm$html$Html$Attributes$class(dimensions.d4),
							$elm$html$Html$Attributes$class('flex relative'),
							A2($elm$html$Html$Attributes$attribute, 'data-dashboard-chart-target', 'chartContentError')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(dimensions.b7),
									$elm$html$Html$Attributes$class('shrink-0 animate-ping'),
									$elm$html$Html$Attributes$class('bg-red-600 opacity-70 rounded-full relative')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(dimensions.dC),
									$elm$html$Html$Attributes$class(dimensions.dx),
									$elm$html$Html$Attributes$class('w-full h-full rounded-full bg-red-800 text-white font-bold'),
									$elm$html$Html$Attributes$class('shrink-0 flex items-center justify-center relative')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('!')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute top-0 mt-6 ml-2 bg-white overflow-hidden p-2 max-h-184 shadow-md rounded transform scale-0'),
							$elm$html$Html$Attributes$class('group-hover:scale-100')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('overflow-hidden opacity-0 min-w-64 max-w-lg transition-opacity duration-300 ease-in'),
									$elm$html$Html$Attributes$class('group-hover:opacity-100'),
									$elm$html$Html$Attributes$class('group-focus:opacity-100'),
									$elm$html$Html$Attributes$class('flex flex-col gap-2')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Chart$Shared$serverErrorGroupView(translations),
								groups))
						]))
				]));
	});
var $author$project$Chart$Shared$serverErrorsView = F3(
	function (translations, sizes, errors) {
		if (!errors.$) {
			return $author$project$Enectiva$View$nothing;
		} else {
			var groups = errors.a;
			return A3($author$project$Chart$Shared$serverErrorsViewHelp, translations, sizes, groups);
		}
	});
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$Chart$Shared$continuousTablesByYAxisView = F4(
	function (translations, tabler, timeZone, _v0) {
		var yAxis = _v0.o;
		var data = _v0.jA;
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Visibility$value,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					A3(tabler, translations, timeZone, yAxis))),
			data);
	});
var $author$project$Chart$Shared$nbsp = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(160));
var $author$project$Chart$Shared$spaceRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString(' '));
var $author$project$Chart$Shared$replaceSpacesByNbsp = function (str) {
	return A3(
		$elm$regex$Regex$replace,
		$author$project$Chart$Shared$spaceRegex,
		function (_v0) {
			return $author$project$Chart$Shared$nbsp;
		},
		str);
};
var $author$project$Chart$Shared$formatNumberWithNbsp = function (translations) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$formatNumber(translations),
		$author$project$Chart$Shared$replaceSpacesByNbsp);
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Chart$Shared$htmlCell = F2(
	function (translations, value) {
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-transparent py-1 px-2 text-right tabular-nums')
				]),
			$elm$core$List$singleton(
				$elm$html$Html$text(
					A2($author$project$Chart$Shared$formatNumberWithNbsp, translations, value))));
	});
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Chart$Shared$unitSuffix = function (unit) {
	return ' [' + (unit + ']');
};
var $author$project$Chart$Shared$horizontalContinuousBodyLine = F3(
	function (translations, yAxis, _v0) {
		var name = _v0.kt;
		var data = _v0.jA;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(
								name,
								$author$project$Chart$Shared$unitSuffix(
									A2($elm$core$Maybe$withDefault, '', yAxis.d))))
						])),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aW;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$author$project$Chart$Shared$htmlCell(translations)),
							$elm$core$Maybe$withDefault(
								A2($elm$html$Html$td, _List_Nil, _List_Nil)))),
					data)));
	});
var $author$project$Chart$Shared$headerCell = function (str) {
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-transparent py-1 px-2')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Chart$Shared$horizontalContinuousHeaderLine = F3(
	function (translations, timeZone, data) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$th, _List_Nil, _List_Nil),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bT;
						},
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Enectiva$I18n$formatTime, translations, timeZone),
							$author$project$Chart$Shared$headerCell)),
					data)));
	});
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Chart$Shared$horizontalContinuousTableView = F4(
	function (translations, timeZone, yAxis, series) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Chart$Shared$horizontalContinuousHeaderLine, translations, timeZone, series.jA)
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Chart$Shared$horizontalContinuousBodyLine, translations, yAxis, series)
						]))
				]));
	});
var $author$project$Chart$Shared$horizontalTableContainer = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('space-y-4 overflow-x-auto')
		]));
var $author$project$Chart$Shared$maybeHtmlCell = F2(
	function (translations, maybeValue) {
		if (maybeValue.$ === 1) {
			return A2($elm$html$Html$td, _List_Nil, _List_Nil);
		} else {
			var value = maybeValue.a;
			return A2($author$project$Chart$Shared$htmlCell, translations, value);
		}
	});
var $author$project$Chart$Shared$verticalContinuousBodyLine = F3(
	function (translations, timeZone, _v0) {
		var time = _v0.bT;
		var value = _v0.aW;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Chart$Shared$headerCell(
					A4($author$project$Enectiva$I18n$formatTimeCustom, 'date_and_time', translations, timeZone, time)),
					A2($author$project$Chart$Shared$maybeHtmlCell, translations, value)
				]));
	});
var $author$project$Chart$Shared$verticalContinuousHeaderLine = F2(
	function (yAxis, _v0) {
		var name = _v0.kt;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$th, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(
								name,
								$author$project$Chart$Shared$unitSuffix(
									A2($elm$core$Maybe$withDefault, '', yAxis.d))))
						]))
				]));
	});
var $author$project$Chart$Shared$verticalContinuousTableView = F4(
	function (translations, timeZone, yAxis, series) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Chart$Shared$verticalContinuousHeaderLine, yAxis, series)
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Chart$Shared$verticalContinuousBodyLine, translations, timeZone),
						series.jA))
				]));
	});
var $author$project$Chart$Shared$verticalTableContainer = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex gap-4 flex-wrap')
		]));
var $author$project$Chart$Shared$continuousTablesView = F5(
	function (translations, tableMode, timeZone, primaryYAxisData, secondaryYAxisData) {
		switch (tableMode) {
			case 0:
				return $author$project$Chart$Shared$horizontalTableContainer(
					$elm$core$List$concat(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									A4($author$project$Chart$Shared$continuousTablesByYAxisView, translations, $author$project$Chart$Shared$horizontalContinuousTableView, timeZone, primaryYAxisData)),
									A2(
									$elm$core$Maybe$map,
									A3($author$project$Chart$Shared$continuousTablesByYAxisView, translations, $author$project$Chart$Shared$horizontalContinuousTableView, timeZone),
									secondaryYAxisData)
								]))));
			case 1:
				return $author$project$Chart$Shared$verticalTableContainer(
					$elm$core$List$concat(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									A4($author$project$Chart$Shared$continuousTablesByYAxisView, translations, $author$project$Chart$Shared$verticalContinuousTableView, timeZone, primaryYAxisData)),
									A2(
									$elm$core$Maybe$map,
									A3($author$project$Chart$Shared$continuousTablesByYAxisView, translations, $author$project$Chart$Shared$verticalContinuousTableView, timeZone),
									secondaryYAxisData)
								]))));
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$Chart$Shared$groupDiscreteDataByXAxis = function (data) {
	return A2(
		$elm$core$List$map,
		function (_v3) {
			var head = _v3.a;
			var tail = _v3.b;
			return _Utils_Tuple2(
				head.a,
				A2(
					$elm$core$List$cons,
					head.b,
					A2($elm$core$List$map, $elm$core$Tuple$second, tail)));
		},
		A2(
			$elm_community$list_extra$List$Extra$groupWhile,
			F2(
				function (_v1, _v2) {
					var xAxisA = _v1.a;
					var xAxisB = _v2.a;
					return _Utils_eq(xAxisA, xAxisB);
				}),
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$map,
					function (d) {
						return _Utils_Tuple2(
							function () {
								switch (d.$) {
									case 0:
										var series = d.a;
										return $author$project$Visibility$value(series).bZ;
									case 1:
										var series = d.a;
										return A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Visibility$value,
													function ($) {
														return $.bZ;
													}),
												$elm$core$List$head(series)));
									default:
										var series = d.a;
										return A2(
											$elm$core$List$map,
											function ($) {
												return $.aN;
											},
											$author$project$Visibility$value(series).jA);
								}
							}(),
							d);
					},
					data))));
};
var $author$project$Chart$Shared$discreteTablesByYAxisView = F3(
	function (translations, tabler, _v0) {
		var yAxis = _v0.o;
		var data = _v0.jA;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var xAxis = _v1.a;
				var d = _v1.b;
				return A4(tabler, translations, xAxis, yAxis, d);
			},
			$author$project$Chart$Shared$groupDiscreteDataByXAxis(data));
	});
var $author$project$Chart$Shared$categoricalSeriesLine = F3(
	function (translations, suffix, _v0) {
		var name = _v0.kt;
		var data = _v0.jA;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(name, suffix))
						])),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aW;
						},
						$author$project$Chart$Shared$maybeHtmlCell(translations)),
					data)));
	});
var $author$project$Chart$Shared$discreteTimeSeriesLine = F3(
	function (translations, suffix, _v0) {
		var name = _v0.kt;
		var data = _v0.jA;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(name, suffix))
						])),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aW;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$author$project$Chart$Shared$htmlCell(translations)),
							$elm$core$Maybe$withDefault(
								A2($elm$html$Html$td, _List_Nil, _List_Nil)))),
					data)));
	});
var $author$project$Chart$Shared$horizontalDiscreteBodyLines = F2(
	function (translations, data) {
		switch (data.$) {
			case 0:
				var series = data.a;
				return $elm$core$List$singleton(
					A3(
						$author$project$Chart$Shared$categoricalSeriesLine,
						translations,
						'',
						$author$project$Visibility$value(series)));
			case 1:
				var series = data.a;
				return A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Visibility$value,
						A2($author$project$Chart$Shared$categoricalSeriesLine, translations, '')),
					series);
			default:
				var series = data.a;
				return $elm$core$List$singleton(
					A3(
						$author$project$Chart$Shared$discreteTimeSeriesLine,
						translations,
						'',
						$author$project$Visibility$value(series)));
		}
	});
var $elm$html$Html$em = _VirtualDom_node('em');
var $author$project$Chart$Shared$itemHeader = function (translations) {
	return A2($author$project$Enectiva$I18n$t, translations, 'stats.table.entry');
};
var $author$project$Chart$Shared$discreteCornerCell = F2(
	function (translations, unit) {
		return A2(
			$elm$html$Html$th,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$em,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Chart$Shared$itemHeader(translations))
						])),
					$elm$html$Html$text(
					$author$project$Chart$Shared$unitSuffix(unit))
				]));
	});
var $author$project$Chart$Shared$horizontalDiscreteHeaderLine = F3(
	function (translations, categories, yAxis) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Chart$Shared$discreteCornerCell,
					translations,
					A2($elm$core$Maybe$withDefault, '', yAxis.d)),
				A2($elm$core$List$map, $author$project$Chart$Shared$headerCell, categories)));
	});
var $author$project$Chart$Shared$horizontalDiscreteTableView = F4(
	function (translations, categories, yAxis, data) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Chart$Shared$horizontalDiscreteHeaderLine, translations, categories, yAxis)
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$concatMap,
						$author$project$Chart$Shared$horizontalDiscreteBodyLines(translations),
						data))
				]));
	});
var $author$project$Chart$Shared$extractDiscreteDataValues = function (data) {
	switch (data.$) {
		case 0:
			var series = data.a;
			return $elm$core$List$singleton(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aW;
					},
					$author$project$Visibility$value(series).jA));
		case 1:
			var series = data.a;
			return A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Visibility$value,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.jA;
						},
						$elm$core$List$map(
							function ($) {
								return $.aW;
							}))),
				series);
		default:
			var series = data.a;
			return $elm$core$List$singleton(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aW;
					},
					$author$project$Visibility$value(series).jA));
	}
};
var $author$project$Chart$Shared$verticalDiscreteBodyLine = F2(
	function (translations, _v0) {
		var category = _v0.a;
		var values = _v0.b;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$author$project$Chart$Shared$headerCell(category),
				A2(
					$elm$core$List$map,
					$author$project$Chart$Shared$maybeHtmlCell(translations),
					values)));
	});
var $author$project$Chart$Shared$verticalDiscreteBodyLines = F3(
	function (translations, categories, data) {
		return A2(
			$elm$core$List$map,
			$author$project$Chart$Shared$verticalDiscreteBodyLine(translations),
			A2(
				$elm_community$list_extra$List$Extra$zip,
				categories,
				$elm_community$list_extra$List$Extra$transpose(
					A2($elm$core$List$concatMap, $author$project$Chart$Shared$extractDiscreteDataValues, data))));
	});
var $author$project$Chart$Shared$seriesNameHeaderCell = function (series) {
	return $author$project$Chart$Shared$headerCell(
		$author$project$Visibility$value(series).kt);
};
var $author$project$Chart$Shared$verticalDiscreteHeaderLine = F3(
	function (translations, data, yAxis) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Chart$Shared$discreteCornerCell,
					translations,
					A2($elm$core$Maybe$withDefault, '', yAxis.d)),
				A2(
					$elm$core$List$concatMap,
					function (d) {
						switch (d.$) {
							case 0:
								var series = d.a;
								return $elm$core$List$singleton(
									$author$project$Chart$Shared$seriesNameHeaderCell(series));
							case 1:
								var series = d.a;
								return A2($elm$core$List$map, $author$project$Chart$Shared$seriesNameHeaderCell, series);
							default:
								var series = d.a;
								return $elm$core$List$singleton(
									$author$project$Chart$Shared$seriesNameHeaderCell(series));
						}
					},
					data)));
	});
var $author$project$Chart$Shared$verticalDiscreteTableView = F4(
	function (translations, categories, yAxis, data) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Chart$Shared$verticalDiscreteHeaderLine, translations, data, yAxis)
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A3($author$project$Chart$Shared$verticalDiscreteBodyLines, translations, categories, data))
				]));
	});
var $author$project$Chart$Shared$discreteTablesView = F4(
	function (translations, tableMode, primaryYAxisData, secondaryYAxisData) {
		switch (tableMode) {
			case 0:
				return $author$project$Chart$Shared$horizontalTableContainer(
					$elm$core$List$concat(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									A3($author$project$Chart$Shared$discreteTablesByYAxisView, translations, $author$project$Chart$Shared$horizontalDiscreteTableView, primaryYAxisData)),
									A2(
									$elm$core$Maybe$map,
									A2($author$project$Chart$Shared$discreteTablesByYAxisView, translations, $author$project$Chart$Shared$horizontalDiscreteTableView),
									secondaryYAxisData)
								]))));
			case 1:
				return $author$project$Chart$Shared$verticalTableContainer(
					$elm$core$List$concat(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									A3($author$project$Chart$Shared$discreteTablesByYAxisView, translations, $author$project$Chart$Shared$verticalDiscreteTableView, primaryYAxisData)),
									A2(
									$elm$core$Maybe$map,
									A2($author$project$Chart$Shared$discreteTablesByYAxisView, translations, $author$project$Chart$Shared$verticalDiscreteTableView),
									secondaryYAxisData)
								]))));
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$Chart$Shared$horizontalPieChartDataLine = F3(
	function (translations, yAxis, pie) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Chart$Shared$unitSuffix, yAxis.d)))
						])),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aW;
						},
						$author$project$Chart$Shared$htmlCell(translations)),
					pie)));
	});
var $author$project$Chart$Shared$horizontalPieChartHeaderLine = F2(
	function (translations, pie) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Chart$Shared$itemHeader(translations))
						])),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.kt;
						},
						$author$project$Chart$Shared$headerCell),
					pie)));
	});
var $author$project$Chart$Shared$horizontalPieTableView = F3(
	function (translations, yAxis, pie) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Chart$Shared$horizontalPieChartHeaderLine, translations, pie)
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Chart$Shared$horizontalPieChartDataLine, translations, yAxis, pie)
						]))
				]));
	});
var $author$project$Chart$Shared$verticalPieChartBodyLine = F2(
	function (translations, _v0) {
		var name = _v0.kt;
		var value = _v0.aW;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Chart$Shared$headerCell(name),
					A2($author$project$Chart$Shared$htmlCell, translations, value)
				]));
	});
var $author$project$Chart$Shared$verticalPieChartHeaderLine = F2(
	function (translations, yAxis) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Chart$Shared$headerCell(
					$author$project$Chart$Shared$itemHeader(translations)),
					$author$project$Chart$Shared$headerCell(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Chart$Shared$unitSuffix, yAxis.d)))
				]));
	});
var $author$project$Chart$Shared$verticalPieTableView = F3(
	function (translations, yAxis, pie) {
		return A2(
			$elm$core$List$map,
			$elm$html$Html$table(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-xs')
					])),
			$elm$core$List$singleton(
				A2(
					$elm$core$List$cons,
					A2($author$project$Chart$Shared$verticalPieChartHeaderLine, translations, yAxis),
					A2(
						$elm$core$List$map,
						$author$project$Chart$Shared$verticalPieChartBodyLine(translations),
						pie))));
	});
var $author$project$Chart$Shared$piesTableView = F5(
	function (translations, tableMode, yAxis, primaryPie, maybeSecondaryPie) {
		switch (tableMode) {
			case 0:
				return $author$project$Chart$Shared$horizontalTableContainer(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A3($author$project$Chart$Shared$horizontalPieTableView, translations, yAxis, primaryPie)),
								A2(
								$elm$core$Maybe$map,
								A2($author$project$Chart$Shared$horizontalPieTableView, translations, yAxis),
								maybeSecondaryPie)
							])));
			case 1:
				return $author$project$Chart$Shared$verticalTableContainer(
					$elm$core$List$concat(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									A3($author$project$Chart$Shared$verticalPieTableView, translations, yAxis, primaryPie)),
									A2(
									$elm$core$Maybe$map,
									A2($author$project$Chart$Shared$verticalPieTableView, translations, yAxis),
									maybeSecondaryPie)
								]))));
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$Chart$Shared$tableViewState = F3(
	function (translations, tableMode, _v0) {
		var data = _v0.jA;
		var timeZone = _v0.iU;
		switch (data.$) {
			case 1:
				var primaryYAxisData = data.c;
				var secondaryYAxisData = data.d;
				return A4($author$project$Chart$Shared$discreteTablesView, translations, tableMode, primaryYAxisData, secondaryYAxisData);
			case 0:
				var primaryYAxisData = data.b;
				var secondaryYAxisData = data.c;
				return A5($author$project$Chart$Shared$continuousTablesView, translations, tableMode, timeZone, primaryYAxisData, secondaryYAxisData);
			default:
				var yAxis = data.a;
				var primaryPie = data.b;
				var maybeSecondaryPie = data.c;
				return A5($author$project$Chart$Shared$piesTableView, translations, tableMode, yAxis, primaryPie, maybeSecondaryPie);
		}
	});
var $author$project$Chart$Shared$Coordinates = F2(
	function (x, y) {
		return {M: x, N: y};
	});
var $author$project$Chart$Shared$mouseEventPageCoordsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pageY',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pageX',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Chart$Shared$Coordinates)));
var $author$project$Chart$Shared$tooltipGutter = 7;
var $author$project$Chart$Shared$tooltipWidth = 250;
var $author$project$Chart$Shared$tooltipView = F3(
	function (translations, transitioningTooltip, cursorPositionTagger) {
		return A2(
			$author$project$Svg$Extra$viewMaybe,
			$gampleman$elm_visualization$Transition$value(transitioningTooltip),
			function (_v0) {
				var tooltip = _v0.K;
				var opacity = _v0.bJ;
				var y = tooltip.O.N - ($author$project$Chart$Shared$tooltipGutter * 2);
				var xBase = tooltip.O.M + tooltip.O.a9;
				var x = (_Utils_cmp(xBase, $author$project$Chart$Shared$tooltipWidth + $author$project$Chart$Shared$tooltipGutter) > 0) ? ((xBase - $author$project$Chart$Shared$tooltipWidth) - $author$project$Chart$Shared$tooltipGutter) : (xBase + $author$project$Chart$Shared$tooltipGutter);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute bg-white p-2 border-box shadow-md rounded z-10'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$author$project$Chart$Shared$px(x)),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$author$project$Chart$Shared$px(y)),
							A2(
							$elm$html$Html$Attributes$style,
							'width',
							$author$project$Chart$Shared$px($author$project$Chart$Shared$tooltipWidth)),
							A2(
							$elm$html$Html$Attributes$style,
							'opacity',
							$elm$core$String$fromFloat(opacity)),
							A2(
							$elm$html$Html$Events$on,
							'mousemove',
							A2($elm$json$Json$Decode$map, cursorPositionTagger, $author$project$Chart$Shared$mouseEventPageCoordsDecoder))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(tooltip.fF)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Svg$Extra$viewMaybe,
									tooltip.d,
									function (title) {
										return A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(title)
												]));
									}),
									A2(
									$author$project$Svg$Extra$viewMaybe,
									tooltip.d,
									$elm$core$Basics$always(
										$elm$html$Html$text(': '))),
									$elm$html$Html$text(
									A2($author$project$Chart$Shared$maybeAddUnit, tooltip.i$, tooltip.aW))
								]))
						]));
			});
	});
var $author$project$Chart$Shared$DataBackgroundClicked = {$: 14};
var $author$project$Visibility$isVisible = function (optional) {
	if (!optional.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Chart$Shared$anySeriesVisible = function (data) {
	return A2(
		$elm$core$List$any,
		function (d) {
			switch (d.$) {
				case 0:
					var sb = d.a;
					return $author$project$Visibility$isVisible(sb);
				case 1:
					var bgs = d.a;
					return A2($elm$core$List$any, $author$project$Visibility$isVisible, bgs);
				default:
					var fl = d.a;
					return $author$project$Visibility$isVisible(fl);
			}
		},
		data);
};
var $avh4$elm_color$Color$white = A4($avh4$elm_color$Color$RgbaSpace, 255 / 255, 255 / 255, 255 / 255, 1.0);
var $author$project$Chart$Shared$backgroundView = F2(
	function (sizes, attrs) {
		return A2(
			$elm_community$typed_svg$TypedSvg$rect,
			_Utils_ap(
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(sizes.h),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(sizes.p),
						$elm_community$typed_svg$TypedSvg$Attributes$fill(
						$elm_community$typed_svg$TypedSvg$Types$Paint($avh4$elm_color$Color$white))
					]),
				attrs),
			_List_Nil);
	});
var $author$project$Chart$Shared$columnInBandGap = 2;
var $author$project$Chart$Shared$CursorMovedOverDataBackground = function (a) {
	return {$: 0, a: a};
};
var $author$project$Chart$Shared$mouseEventOffsetDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'offsetY',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'offsetX',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Chart$Shared$Coordinates)));
var $elm_community$typed_svg$TypedSvg$Events$on = $elm$virtual_dom$VirtualDom$on;
var $author$project$Chart$Shared$cursorOverBackgroundListener = A2(
	$elm_community$typed_svg$TypedSvg$Events$on,
	'mousemove',
	$elm$virtual_dom$VirtualDom$Normal(
		A2($elm$json$Json$Decode$map, $author$project$Chart$Shared$CursorMovedOverDataBackground, $author$project$Chart$Shared$mouseEventOffsetDecoder)));
var $elm_community$typed_svg$TypedSvg$Events$simpleOn = function (name) {
	return function (msg) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Events$on,
			name,
			$elm$virtual_dom$VirtualDom$Normal(
				$elm$json$Json$Decode$succeed(msg)));
	};
};
var $elm_community$typed_svg$TypedSvg$Events$onClick = $elm_community$typed_svg$TypedSvg$Events$simpleOn('click');
var $author$project$Chart$Shared$primaryXAxisUnit = function (unit) {
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, -4, 8)
					])),
				$elm_community$typed_svg$TypedSvg$Attributes$class(
				_List_fromArray(
					['text-bold text-2xs']))
			]),
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$text_,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(unit)
					]))
			]));
};
var $author$project$Chart$Shared$pxPerChar = 6;
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Chart$Shared$barSegmentOpacityHelp = F3(
	function (highlights, seriesName, category) {
		var highlightForSeries = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (h) {
					return _Utils_eq(h.aJ, seriesName);
				},
				highlights));
		if (!highlightForSeries.$) {
			var type_ = highlightForSeries.a.d6;
			switch (type_.$) {
				case 1:
					var highlightCategories = type_.a;
					return A2($elm$core$List$member, category, highlightCategories) ? '' : 'opacity-50';
				case 0:
					var highlightCategories = type_.a;
					return A2($elm$core$List$member, category, highlightCategories) ? '' : 'opacity-50';
				case 3:
					return 'opacity-50';
				default:
					return '';
			}
		} else {
			return 'opacity-20';
		}
	});
var $author$project$Chart$Shared$barSegmentOpacity = F3(
	function (maybeStatHighlight, seriesName, category) {
		if (!maybeStatHighlight.$) {
			var highlights = maybeStatHighlight.a;
			return A3($author$project$Chart$Shared$barSegmentOpacityHelp, highlights, seriesName, category);
		} else {
			return '';
		}
	});
var $author$project$Chart$Shared$colorPreferenceWithFallback = F2(
	function (fallback, preference) {
		if (preference.$ === 1) {
			var c = preference.a;
			return c;
		} else {
			return fallback;
		}
	});
var $author$project$Chart$Shared$singleBarToRenderableBarSegments = F4(
	function (categories, unit, maybeStatHighlight, series) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (dataPointIndex, _v0) {
					var category = _v0.a;
					var dp = _v0.b;
					var _v1 = dp.aW;
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var value = _v1.a;
						var title = function () {
							var _v3 = dp.e_;
							if (!_v3.$) {
								var suffix = _v3.a;
								return $elm$core$Maybe$Just(series.kt + (' ' + suffix));
							} else {
								return $elm$core$Maybe$Just(series.kt);
							}
						}();
						var label = A2($elm$core$Maybe$withDefault, category, dp.bL);
						var _v2 = (value >= 0) ? _Utils_Tuple2(0, value) : _Utils_Tuple2(value, 0);
						var lower = _v2.a;
						var upper = _v2.b;
						return $elm$core$Maybe$Just(
							{
								aN: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm_community$list_extra$List$Extra$getAt, dataPointIndex, categories)),
								f: A2($author$project$Chart$Shared$colorPreferenceWithFallback, series.f, dp.aC),
								fF: label,
								aQ: dp.aQ,
								dE: lower,
								dL: A3($author$project$Chart$Shared$barSegmentOpacity, maybeStatHighlight, series.kt, label),
								gq: series.r,
								d: title,
								i$: unit,
								d9: upper,
								aW: A2($elm$core$Maybe$withDefault, 0, dp.aW)
							});
					}
				}),
			A2($elm_community$list_extra$List$Extra$zip, series.bZ, series.jA));
	});
var $author$project$Chart$Shared$CursorEnteredBar = function (a) {
	return {$: 6, a: a};
};
var $author$project$Chart$Shared$CursorLeftBar = {$: 7};
var $elm$svg$Svg$a = $elm$svg$Svg$trustedNode('a');
var $elm$svg$Svg$Attributes$target = _VirtualDom_attribute('target');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Chart$Shared$maybeLink = F2(
	function (maybeUrl, svg) {
		if (maybeUrl.$ === 1) {
			return svg;
		} else {
			var link = maybeUrl.a;
			return A2(
				$elm$svg$Svg$a,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$xlinkHref(link),
						$elm$svg$Svg$Attributes$target('_blank')
					]),
				_List_fromArray(
					[svg]));
		}
	});
var $author$project$Chart$Shared$stripe = F6(
	function (translations, sizes, stripeWidth, _v0, index, segment) {
		var scaleY = _v0.a;
		var scaleX = _v0.b;
		var xOffset = A2($gampleman$elm_visualization$Scale$convert, scaleX, segment.dE);
		var stripeLength = A2($gampleman$elm_visualization$Scale$convert, scaleX, segment.d9) - xOffset;
		var inBandXOffset = index * (stripeWidth + $author$project$Chart$Shared$columnInBandGap);
		var yOffset = A2($gampleman$elm_visualization$Scale$convert, scaleY, segment.aN) + inBandXOffset;
		var tooltip = {
			O: {a9: stripeLength, M: xOffset + sizes.ca, N: (yOffset + sizes.ci) + stripeWidth},
			fF: segment.fF,
			d: segment.d,
			i$: segment.i$,
			aW: A2($author$project$View$formatNumberWithNbsp, translations, segment.aW),
			bY: false
		};
		return A2(
			$author$project$Chart$Shared$maybeLink,
			segment.aQ,
			A2(
				$elm_community$typed_svg$TypedSvg$rect,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(xOffset),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(yOffset),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(stripeLength),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(stripeWidth),
						$elm_community$typed_svg$TypedSvg$Attributes$fill(
						$elm_community$typed_svg$TypedSvg$Types$Paint(segment.f)),
						A2(
						$elm_community$typed_svg$TypedSvg$Events$on,
						'mouseenter',
						$elm$virtual_dom$VirtualDom$Normal(
							$elm$json$Json$Decode$succeed(
								$author$project$Chart$Shared$CursorEnteredBar(tooltip)))),
						A2(
						$elm_community$typed_svg$TypedSvg$Events$on,
						'mouseleave',
						$elm$virtual_dom$VirtualDom$Normal(
							$elm$json$Json$Decode$succeed($author$project$Chart$Shared$CursorLeftBar))),
						$elm$svg$Svg$Attributes$class('transition-opacity duration-500 ease-in-out'),
						$elm$svg$Svg$Attributes$class(segment.dL)
					]),
				_List_Nil));
	});
var $author$project$Chart$Shared$stripeGroup = F5(
	function (translations, sizes, stripeWidth, scales, indexOffset) {
		return $elm$core$List$filterMap(
			$elm$core$Maybe$map(
				A5($author$project$Chart$Shared$stripe, translations, sizes, stripeWidth, scales, indexOffset)));
	});
var $gampleman$elm_visualization$Axis$TickSizeInner = function (a) {
	return {$: 3, a: a};
};
var $gampleman$elm_visualization$Axis$tickSizeInner = $gampleman$elm_visualization$Axis$TickSizeInner;
var $gampleman$elm_visualization$Axis$Ticks = function (a) {
	return {$: 0, a: a};
};
var $gampleman$elm_visualization$Axis$ticks = $gampleman$elm_visualization$Axis$Ticks;
var $gampleman$elm_visualization$Axis$top = A4($gampleman$elm_visualization$Axis$element, $gampleman$elm_visualization$Axis$verticalAttrs, -1, '0em', 'middle');
var $author$project$Chart$Shared$verticalBarGridLine = F3(
	function (sizes, scaleX, tick) {
		var x = A2($gampleman$elm_visualization$Scale$convert, scaleX, tick);
		return A2(
			$elm_community$typed_svg$TypedSvg$line,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1(x),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2(x),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(0),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2((sizes.p - sizes.ci) - sizes.fa),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['stroke-current text-grey-600 opacity-50']))
				]),
			_List_Nil);
	});
var $author$project$Chart$Shared$verticalBarGridLines = F2(
	function (sizes, scaleX) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(_List_Nil)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Chart$Shared$verticalBarGridLine, sizes, scaleX),
				A2(
					$gampleman$elm_visualization$Scale$ticks,
					scaleX,
					$author$project$Chart$Shared$yAxisTickCount(sizes.h))));
	});
var $author$project$Svg$Extra$viewIf = F2(
	function (condition, viewFn) {
		return condition ? viewFn(0) : $elm$svg$Svg$text('');
	});
var $author$project$Chart$Shared$viewHorizontalBarChart = F4(
	function (translations, dimensionConfig, categories, xAxisData) {
		var topGutter = 45 + 20;
		var seriesCount = $elm$core$List$length(xAxisData.jA);
		var renderableData = A2(
			$elm$core$List$filterMap,
			function (d) {
				if ((!d.$) && (!d.a.$)) {
					var series = d.a.a;
					return $elm$core$Maybe$Just(
						A4($author$project$Chart$Shared$singleBarToRenderableBarSegments, categories, xAxisData.o.d, $elm$core$Maybe$Nothing, series));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			xAxisData.jA);
		var leftGutter = $author$project$Chart$Shared$pxPerChar * (2 + A2(
			$elm$core$Maybe$withDefault,
			12,
			$elm$core$List$maximum(
				A2($elm$core$List$map, $elm$core$String$length, categories))));
		var groupCount = $elm$core$List$length(renderableData);
		var totalGapsWidth = (groupCount - 1) * $author$project$Chart$Shared$columnInBandGap;
		var bandHeight = (seriesCount > 2) ? (seriesCount * 25) : 50;
		var sizes = {
			fa: $author$project$Chart$Shared$bottomPaddingWithSpaceForLegend,
			p: (topGutter + $author$project$Chart$Shared$bottomPaddingWithSpaceForLegend) + ($elm$core$List$length(categories) * bandHeight),
			ca: leftGutter,
			gl: 0,
			ci: topGutter,
			h: dimensionConfig.h
		};
		var maxWidth = (sizes.h - sizes.ca) - sizes.gl;
		var scaleY = A3(
			$gampleman$elm_visualization$Scale$band,
			_Utils_update(
				$gampleman$elm_visualization$Scale$defaultBandConfig,
				{kO: 0.2, kP: 0.2}),
			_Utils_Tuple2(0, (sizes.p - sizes.ci) - sizes.fa),
			categories);
		var bandWidth = $gampleman$elm_visualization$Scale$bandwidth(scaleY);
		var stripeWidth = (bandWidth - totalGapsWidth) / groupCount;
		var atLeastOnePrimarySeriesVisible = $author$project$Chart$Shared$anySeriesVisible(xAxisData.jA);
		var xAxisAttrs = atLeastOnePrimarySeriesVisible ? _List_fromArray(
			[
				$gampleman$elm_visualization$Axis$tickCount(
				$author$project$Chart$Shared$yAxisTickCount(sizes.h)),
				$gampleman$elm_visualization$Axis$tickSizeInner(4),
				$gampleman$elm_visualization$Axis$tickSizeOuter(0),
				$gampleman$elm_visualization$Axis$tickFormat(
				$author$project$Enectiva$I18n$formatNumber(translations))
			]) : _List_fromArray(
			[
				$gampleman$elm_visualization$Axis$ticks(_List_Nil),
				$gampleman$elm_visualization$Axis$tickSizeOuter(0)
			]);
		var _v0 = A2($author$project$Chart$Shared$yDomainExtentDiscrete, xAxisData.o.cO, xAxisData.jA);
		var min = _v0.a;
		var max = _v0.b;
		var scaleX = A2(
			$gampleman$elm_visualization$Scale$nice,
			$author$project$Chart$Shared$yAxisTickCount(sizes.h),
			A2(
				$gampleman$elm_visualization$Scale$linear,
				_Utils_Tuple2(0, maxWidth),
				_Utils_Tuple2(min, max)));
		return _Utils_Tuple2(
			_List_fromArray(
				[
					A2(
					$author$project$Chart$Shared$backgroundView,
					sizes,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Events$onClick($author$project$Chart$Shared$DataBackgroundClicked),
							$author$project$Chart$Shared$cursorOverBackgroundListener
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca - 1, sizes.ci)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$left,
							_List_fromArray(
								[
									$gampleman$elm_visualization$Axis$tickCount(
									$elm$core$List$length(categories)),
									$gampleman$elm_visualization$Axis$tickSizeOuter(0)
								]),
							A2($gampleman$elm_visualization$Scale$toRenderable, $elm$core$Basics$identity, scaleY))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca - 1, sizes.ci)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Svg$Extra$viewIf,
							atLeastOnePrimarySeriesVisible,
							function (_v1) {
								return A2($author$project$Chart$Shared$verticalBarGridLines, sizes, scaleX);
							}),
							A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_Nil,
							_List_fromArray(
								[
									A2($gampleman$elm_visualization$Axis$top, xAxisAttrs, scaleX)
								])),
							A2($author$project$Svg$Extra$viewMaybe, xAxisData.o.d, $author$project$Chart$Shared$primaryXAxisUnit)
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca, sizes.ci)
								]))
						]),
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							A4(
								$author$project$Chart$Shared$stripeGroup,
								translations,
								sizes,
								stripeWidth,
								_Utils_Tuple2(scaleY, scaleX)),
							renderableData)))
				]),
			sizes);
	});
var $author$project$Chart$Shared$adaptiveTimeTickFormatter = F3(
	function (translations, timeZone, date) {
		var time = $elm$time$Time$posixToMillis(date);
		var significant = function (interval) {
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(
					A3($justinmimbs$time_extra$Time$Extra$floor, interval, timeZone, date)),
				time) < 0;
		};
		return significant(13) ? A4($author$project$Enectiva$I18n$formatTimeCustom, 'second', translations, timeZone, date) : (significant(11) ? A4($author$project$Enectiva$I18n$formatTimeCustom, 'hour', translations, timeZone, date) : (significant(2) ? A4($author$project$Enectiva$I18n$formatTimeCustom, 'day', translations, timeZone, date) : (significant(0) ? A4($author$project$Enectiva$I18n$formatTimeCustom, 'month', translations, timeZone, date) : A4($author$project$Enectiva$I18n$formatTimeCustom, 'year', translations, timeZone, date))));
	});
var $folkertdev$one_true_path_experiment$Curve$linear = function (points) {
	if (!points.b) {
		return $folkertdev$one_true_path_experiment$SubPath$empty;
	} else {
		var x = points.a;
		var xs = points.b;
		return A2(
			$folkertdev$one_true_path_experiment$SubPath$with,
			$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(x),
			_List_fromArray(
				[
					$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(xs)
				]));
	}
};
var $folkertdev$one_true_path_experiment$Curve$step = F2(
	function (factor, points) {
		var helper = F2(
			function (_v1, _v2) {
				var x0 = _v1.a;
				var y0 = _v1.b;
				var x = _v2.a;
				var y = _v2.b;
				if (factor <= 0) {
					return _List_fromArray(
						[
							_Utils_Tuple2(x0, y),
							_Utils_Tuple2(x, y)
						]);
				} else {
					var x1 = (x0 * (1 - factor)) + (x * factor);
					return _List_fromArray(
						[
							_Utils_Tuple2(x1, y0),
							_Utils_Tuple2(x1, y)
						]);
				}
			});
		if (!points.b) {
			return $folkertdev$one_true_path_experiment$SubPath$empty;
		} else {
			var p = points.a;
			var ps = points.b;
			return $folkertdev$one_true_path_experiment$Curve$linear(
				A2(
					$elm$core$List$cons,
					p,
					_Utils_ap(
						$elm$core$List$concat(
							A3($elm$core$List$map2, helper, points, ps)),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								p,
								$elm_community$list_extra$List$Extra$last(ps))
							]))));
		}
	});
var $gampleman$elm_visualization$Shape$stepCurve = function (factor) {
	return $folkertdev$one_true_path_experiment$Curve$step(
		A3($elm$core$Basics$clamp, 0, 1, factor));
};
var $author$project$Chart$Shared$curveToShape = function (curve) {
	if (!curve) {
		return $gampleman$elm_visualization$Shape$stepCurve(1);
	} else {
		return $gampleman$elm_visualization$Shape$monotoneInXCurve;
	}
};
var $author$project$Chart$Shared$line = F3(
	function (toCoords, curve, dataPoints) {
		return A2(
			$gampleman$elm_visualization$Shape$line,
			$author$project$Chart$Shared$curveToShape(curve),
			A2($elm$core$List$map, toCoords, dataPoints));
	});
var $author$project$Chart$Shared$pathElement = F2(
	function (toCoords, series) {
		return A2(
			$folkertdev$one_true_path_experiment$Path$element,
			A3($author$project$Chart$Shared$line, toCoords, series.bi, series.jA),
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$stroke(
					$elm_community$typed_svg$TypedSvg$Types$Paint(series.f)),
					$elm_community$typed_svg$TypedSvg$Attributes$fill($elm_community$typed_svg$TypedSvg$Types$PaintNone),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['stroke-1.5']))
				]));
	});
var $author$project$Chart$Shared$lines = F3(
	function (sizes, toCoords, series) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca, sizes.ci)
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Chart$Shared$pathElement(toCoords),
				series));
	});
var $author$project$Chart$Shared$continuousLines = F3(
	function (sizes, toCoords, data) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var scaleY = _v0.a;
					var seriesWithUnits = _v0.b;
					return A3(
						$author$project$Chart$Shared$lines,
						sizes,
						toCoords(scaleY),
						A2($elm$core$List$map, $elm$core$Tuple$second, seriesWithUnits));
				},
				data));
	});
var $author$project$Chart$Shared$CursorEnteredCircle = function (a) {
	return {$: 8, a: a};
};
var $author$project$Chart$Shared$CursorLeftCircle = {$: 9};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$r = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$r(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Chart$Shared$circle = F4(
	function (sizes, clr, tooltipBuilder, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		var tooltip = tooltipBuilder(
			{a9: 0, M: x + sizes.ca, N: y + sizes.ci});
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, x, y)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$circle,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$stroke(
							$elm_community$typed_svg$TypedSvg$Types$Paint(clr)),
							$elm_community$typed_svg$TypedSvg$Attributes$fill(
							$elm_community$typed_svg$TypedSvg$Types$Paint(clr)),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['transition-transform', 'transform', 'duration-75', 'ease-in-out', 'hover:scale-200'])),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$r(3),
							A2(
							$elm_community$typed_svg$TypedSvg$Events$on,
							'mouseenter',
							$elm$virtual_dom$VirtualDom$Normal(
								$elm$json$Json$Decode$succeed(
									$author$project$Chart$Shared$CursorEnteredCircle(tooltip)))),
							A2(
							$elm_community$typed_svg$TypedSvg$Events$on,
							'mouseleave',
							$elm$virtual_dom$VirtualDom$Normal(
								$elm$json$Json$Decode$succeed($author$project$Chart$Shared$CursorLeftCircle)))
						]),
					_List_Nil)
				]));
	});
var $author$project$Chart$Shared$circles = F4(
	function (sizes, toCoords, tooltipBuilder, _v0) {
		var unit = _v0.a;
		var series = _v0.b;
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (idx, dp) {
							return A2(
								$elm$core$Maybe$map,
								A3(
									$author$project$Chart$Shared$circle,
									sizes,
									series.f,
									A4(tooltipBuilder, unit, series.kt, dp, idx)),
								toCoords(dp));
						}),
					series.jA)));
	});
var $author$project$Chart$Shared$points = F4(
	function (sizes, toCoords, tooltipBuilder, seriesWithUnits) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca, sizes.ci)
						]))
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$Chart$Shared$circles, sizes, toCoords, tooltipBuilder),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						function ($) {
							return $.a1;
						}),
					seriesWithUnits)));
	});
var $author$project$Chart$Shared$continuousPoints = F5(
	function (translations, sizes, timeFormatter, toCoords, data) {
		var tooltipBuilder = F5(
			function (unit, seriesName, dp, _v1, coords) {
				return {
					O: coords,
					fF: timeFormatter(dp.bT),
					d: $elm$core$Maybe$Just(seriesName),
					i$: unit,
					aW: function () {
						var _v2 = dp.fF;
						if (!_v2.$) {
							var valueLabel = _v2.a;
							return valueLabel;
						} else {
							return A2(
								$author$project$View$formatNumberWithNbsp,
								translations,
								A2($elm$core$Maybe$withDefault, 0, dp.aW));
						}
					}(),
					bY: false
				};
			});
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var scaleY = _v0.a;
					var seriesWithUnits = _v0.b;
					return A4(
						$author$project$Chart$Shared$points,
						sizes,
						toCoords(scaleY),
						tooltipBuilder,
						seriesWithUnits);
				},
				data));
	});
var $author$project$Chart$Shared$continuousTimeDataToCoords = F3(
	function (scaleX, scaleY, _v0) {
		var time = _v0.bT;
		var value = _v0.aW;
		return A2(
			$elm$core$Maybe$map,
			function (v) {
				return _Utils_Tuple2(
					A2($gampleman$elm_visualization$Scale$convert, scaleX, time),
					A2($gampleman$elm_visualization$Scale$convert, scaleY, v));
			},
			value);
	});
var $author$project$Chart$Shared$horizontalGridLine = F3(
	function (sizes, scaleY, tick) {
		var y = A2($gampleman$elm_visualization$Scale$convert, scaleY, tick);
		return A2(
			$elm_community$typed_svg$TypedSvg$line,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(y),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2(y),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1(0),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2((sizes.h - sizes.ca) - sizes.gl),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['stroke-current text-grey-600 opacity-50']))
				]),
			_List_Nil);
	});
var $author$project$Chart$Shared$horizontalGridLines = F2(
	function (sizes, scaleY) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca - 1, sizes.ci)
						]))
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Chart$Shared$horizontalGridLine, sizes, scaleY),
				A2(
					$gampleman$elm_visualization$Scale$ticks,
					scaleY,
					$author$project$Chart$Shared$yAxisTickCount(sizes.p))));
	});
var $elm_community$typed_svg$TypedSvg$Types$AnchorMiddle = 2;
var $elm_community$typed_svg$TypedSvg$Types$Rotate = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Chart$Shared$primaryYAxisUnit = F2(
	function (height, unit) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A3($elm_community$typed_svg$TypedSvg$Types$Rotate, -90, 0, 0),
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, (-height) * 0.45, 18)
						])),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['text-bold']))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$text_,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(unit)
						]))
				]));
	});
var $author$project$Chart$Shared$secondaryYAxisUnit = F2(
	function (sizes, unit) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A3($elm_community$typed_svg$TypedSvg$Types$Rotate, 90, 0, 0),
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.p * 0.45, -(sizes.h - 18))
						])),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['text-bold']))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$text_,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(unit)
						]))
				]));
	});
var $author$project$Enectiva$I18n$formatInteger = F2(
	function (translations, num) {
		return A3($author$project$Enectiva$I18n$formatNumberWithPrecision, translations, $author$project$Enectiva$I18n$AsInteger, num);
	});
var $author$project$Chart$Shared$scaleFloat = function (number) {
	return (number >= 1000000000000000) ? _Utils_Tuple2(number / 1000000000000000, 'P') : ((number >= 1000000000000) ? _Utils_Tuple2(number / 1000000000000, 'T') : ((number >= 1000000000) ? _Utils_Tuple2(number / 1000000000, 'G') : ((number >= 1000000) ? _Utils_Tuple2(number / 1000000, 'M') : ((number >= 1000) ? _Utils_Tuple2(number / 1000, 'k') : _Utils_Tuple2(number, '')))));
};
var $author$project$Chart$Shared$scaleAndFormatFloat = F2(
	function (translations, number) {
		var _v0 = $author$project$Chart$Shared$scaleFloat(number);
		var scaled = _v0.a;
		var unit = _v0.b;
		return _Utils_eq(
			scaled,
			$elm$core$Basics$round(scaled)) ? _Utils_ap(
			A2(
				$author$project$Enectiva$I18n$formatInteger,
				translations,
				$elm$core$Basics$round(scaled)),
			unit) : _Utils_ap(
			A2($author$project$Enectiva$I18n$formatNumber, translations, scaled),
			unit);
	});
var $author$project$Chart$Shared$formatYAxisTick = F3(
	function (translations, numberGroup, number) {
		if (numberGroup === 1) {
			var _v1 = $author$project$Chart$Shared$scaleFloat(number);
			var scaled = _v1.a;
			var unit = _v1.b;
			return _Utils_ap(
				A2(
					$author$project$Enectiva$I18n$formatInteger,
					translations,
					$elm$core$Basics$round(scaled)),
				unit);
		} else {
			return A2($author$project$Chart$Shared$scaleAndFormatFloat, translations, number);
		}
	});
var $author$project$Chart$Shared$yAxisTickFormatter = F3(
	function (translations, yAxis, number) {
		return A3($author$project$Chart$Shared$formatYAxisTick, translations, yAxis.f_, number);
	});
var $author$project$Chart$Shared$discontinuityWidth = $author$project$Chart$Shared$discontinuityHeight;
var $elm_community$typed_svg$TypedSvg$Core$text = $elm$virtual_dom$VirtualDom$text;
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $elm_community$typed_svg$TypedSvg$path = $elm_community$typed_svg$TypedSvg$Core$node('path');
var $author$project$Chart$Shared$verticalDiscontinuityElement = function (alignment) {
	var slants = function () {
		if (!alignment) {
			return 'M 3 8 L 17 3 M 3 18 L 17 13';
		} else {
			return 'M 3 3 L 17 8 M 3 13 L 17 18';
		}
	}();
	return A2(
		$elm_community$typed_svg$TypedSvg$path,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$stroke(
				$elm_community$typed_svg$TypedSvg$Types$Paint($avh4$elm_color$Color$black)),
				$elm_community$typed_svg$TypedSvg$Attributes$d('M 10.5 0 v 5 ' + (slants + ' M 10.5 15 v 5'))
			]),
		_List_Nil);
};
var $author$project$Chart$Shared$yAxisView = F5(
	function (alignment, sizes, renderTicks, tickFormatter, _v0) {
		var scaleY = _v0.a;
		var discontinuity = _v0.b;
		var height = A2($author$project$Chart$Shared$yAxisHeight, sizes, discontinuity);
		var axisAttrs = renderTicks ? _List_fromArray(
			[
				$gampleman$elm_visualization$Axis$tickCount(
				$author$project$Chart$Shared$yAxisTickCount(height)),
				$gampleman$elm_visualization$Axis$tickSizeInner(4),
				$gampleman$elm_visualization$Axis$tickSizeOuter(0),
				$gampleman$elm_visualization$Axis$tickFormat(tickFormatter)
			]) : _List_fromArray(
			[
				$gampleman$elm_visualization$Axis$ticks(_List_Nil),
				$gampleman$elm_visualization$Axis$tickSizeOuter(0)
			]);
		var _v1 = function () {
			if (!alignment) {
				return _Utils_Tuple2($gampleman$elm_visualization$Axis$left, sizes.ca - 1);
			} else {
				return _Utils_Tuple2($gampleman$elm_visualization$Axis$right, sizes.h - sizes.gl);
			}
		}();
		var axisFn = _v1.a;
		var leftOffset = _v1.b;
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, leftOffset, sizes.ci)
								]))
						]),
					_List_fromArray(
						[
							A2(axisFn, axisAttrs, scaleY)
						])),
					discontinuity ? A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, leftOffset - ($author$project$Chart$Shared$discontinuityWidth / 2), sizes.ci + height)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Chart$Shared$verticalDiscontinuityElement(alignment)
						])) : $elm_community$typed_svg$TypedSvg$Core$text('')
				]));
	});
var $author$project$Chart$Shared$continuousYAxesView = F4(
	function (translations, sizes, primaryAxis, maybeSecondaryAxis) {
		var secondary = function () {
			if (maybeSecondaryAxis.$ === 1) {
				return _List_Nil;
			} else {
				var secondaryAxis = maybeSecondaryAxis.a;
				return _List_fromArray(
					[
						A5(
						$author$project$Chart$Shared$yAxisView,
						1,
						sizes,
						A2($elm$core$List$any, $author$project$Visibility$isVisible, secondaryAxis.jA),
						A2($author$project$Chart$Shared$yAxisTickFormatter, translations, primaryAxis.o),
						A2($author$project$Chart$Shared$yScaleFromContinuous, sizes, secondaryAxis)),
						A2(
						$author$project$Svg$Extra$viewMaybe,
						secondaryAxis.o.d,
						$author$project$Chart$Shared$secondaryYAxisUnit(sizes))
					]);
			}
		}();
		var atLeastOnePrimarySeriesVisible = A2($elm$core$List$any, $author$project$Visibility$isVisible, primaryAxis.jA);
		var _v0 = A2($author$project$Chart$Shared$yScaleFromContinuous, sizes, primaryAxis);
		var primaryScale = _v0.a;
		var primaryDiscontinuity = _v0.b;
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Svg$Extra$viewIf,
						atLeastOnePrimarySeriesVisible,
						function (_v1) {
							return A2($author$project$Chart$Shared$horizontalGridLines, sizes, primaryScale);
						}),
						A5(
						$author$project$Chart$Shared$yAxisView,
						0,
						sizes,
						atLeastOnePrimarySeriesVisible,
						A2($author$project$Chart$Shared$yAxisTickFormatter, translations, primaryAxis.o),
						_Utils_Tuple2(primaryScale, primaryDiscontinuity)),
						A2(
						$author$project$Svg$Extra$viewMaybe,
						primaryAxis.o.d,
						$author$project$Chart$Shared$primaryYAxisUnit(sizes.p))
					]),
				secondary));
	});
var $author$project$Chart$Shared$dataAreaWidthInPx = function (_v0) {
	var width = _v0.h;
	var left = _v0.ca;
	var right = _v0.gl;
	return (width - left) - right;
};
var $author$project$Chart$Shared$renderableContinuousData = F3(
	function (sizes, timeZone, yAxisData) {
		return _Utils_Tuple2(
			A2($author$project$Chart$Shared$yScaleFromContinuous, sizes, yAxisData).a,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var series = _v0.a;
					var shift = _v0.b;
					return _Utils_Tuple2(
						yAxisData.o.d,
						_Utils_update(
							series,
							{
								jA: A2(
									$elm$core$List$map,
									function (dp) {
										return _Utils_update(
											dp,
											{
												bT: A3($author$project$Chart$Shared$applyTemporalShift, shift, timeZone, dp.bT)
											});
									},
									series.jA)
							}));
				},
				A2($elm$core$List$filterMap, $author$project$Visibility$toMaybe, yAxisData.jA)));
	});
var $author$project$Chart$Shared$actualTickCount = F2(
	function (scale, tickCount) {
		return $elm$core$List$length(
			A2($gampleman$elm_visualization$Scale$ticks, scale, tickCount));
	});
var $author$project$Chart$Shared$positive = function (n) {
	return n > 0;
};
var $author$project$Chart$Shared$selectOptimalTickCount = F3(
	function (scale, width, approxTickLabelWidth) {
		var breadth = 3;
		var avg = (width / approxTickLabelWidth) | 0;
		var range = A2(
			$elm$core$List$filter,
			$author$project$Chart$Shared$positive,
			A2($elm$core$List$range, avg - breadth, avg + breadth));
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, _v1) {
					var tickCount = _v0.a;
					var arg = _v0.b;
					var bestSoFar = _v1.a;
					var arg_ = _v1.b;
					return (_Utils_cmp(
						$elm$core$Basics$abs(tickCount - avg),
						$elm$core$Basics$abs(bestSoFar - avg)) < 0) ? _Utils_Tuple2(tickCount, arg) : _Utils_Tuple2(bestSoFar, arg_);
				}),
			_Utils_Tuple2(
				A2($author$project$Chart$Shared$actualTickCount, scale, avg),
				avg),
			A2(
				$elm$core$List$map,
				function (arg) {
					return _Utils_Tuple2(
						A2($author$project$Chart$Shared$actualTickCount, scale, arg),
						arg);
				},
				range)).b;
	});
var $author$project$Chart$Shared$timeXAxisView = F4(
	function (sizes, tickCountEstimate, tickFormatter, scaleX) {
		var axisAttrs = function () {
			if (tickCountEstimate.$ === 1) {
				return _List_fromArray(
					[
						$gampleman$elm_visualization$Axis$ticks(_List_Nil),
						$gampleman$elm_visualization$Axis$tickSizeOuter(0)
					]);
			} else {
				var tce = tickCountEstimate.a;
				return _List_fromArray(
					[
						$gampleman$elm_visualization$Axis$tickCount(tce),
						$gampleman$elm_visualization$Axis$tickSizeOuter(0),
						$gampleman$elm_visualization$Axis$tickFormat(tickFormatter)
					]);
			}
		}();
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca - 1, sizes.p - sizes.fa)
						]))
				]),
			_List_fromArray(
				[
					A2($gampleman$elm_visualization$Axis$bottom, axisAttrs, scaleX)
				]));
	});
var $author$project$Chart$Shared$verticalGridLine = F3(
	function (sizes, scaleX, tick) {
		var x = A2($gampleman$elm_visualization$Scale$convert, scaleX, tick);
		return (!x) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm_community$typed_svg$TypedSvg$line,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(0),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2((sizes.p - sizes.ci) - sizes.fa),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1(x),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2(x),
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['fill-current text-grey-600']))
					]),
				_List_Nil));
	});
var $author$project$Chart$Shared$verticalGridLines = F3(
	function (sizes, tickCountEstimate, scaleX) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca - 1, sizes.ci)
						]))
				]),
			A2(
				$elm$core$List$filterMap,
				A2($author$project$Chart$Shared$verticalGridLine, sizes, scaleX),
				A2($gampleman$elm_visualization$Scale$ticks, scaleX, tickCountEstimate)));
	});
var $author$project$Chart$Shared$xAxisTickLabelWidth = 180;
var $author$project$Chart$Shared$viewLineChart = F6(
	function (translations, dimensionConfig, timeZone, now, primaryYAxisData, secondaryYAxisData) {
		var xTickFormatter = A2($author$project$Chart$Shared$adaptiveTimeTickFormatter, translations, timeZone);
		var visibleSeries = A2($author$project$Chart$Shared$visibleContinuousSeries, primaryYAxisData, secondaryYAxisData);
		var timeFormatter = A3($author$project$Enectiva$I18n$formatTimeCustom, 'date_and_time', translations, timeZone);
		var somethingToShow = !$elm$core$List$isEmpty(visibleSeries);
		var sizes = A4($author$project$Chart$Shared$calculateSizes, $author$project$Chart$Shared$continuousSeriesHasStats, primaryYAxisData, secondaryYAxisData, dimensionConfig);
		var scaleX = A4($author$project$Chart$Shared$timeXScale, sizes, timeZone, now, visibleSeries);
		var tickCountEstimate = somethingToShow ? $elm$core$Maybe$Just(
			A3(
				$author$project$Chart$Shared$selectOptimalTickCount,
				scaleX,
				$elm$core$Basics$round(
					$author$project$Chart$Shared$dataAreaWidthInPx(sizes)),
				$author$project$Chart$Shared$xAxisTickLabelWidth)) : $elm$core$Maybe$Nothing;
		var toCoords = $author$project$Chart$Shared$continuousTimeDataToCoords(scaleX);
		var renderableData = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A3($author$project$Chart$Shared$renderableContinuousData, sizes, timeZone, primaryYAxisData)),
					A2(
					$elm$core$Maybe$map,
					A2($author$project$Chart$Shared$renderableContinuousData, sizes, timeZone),
					secondaryYAxisData)
				]));
		return _Utils_Tuple2(
			_List_fromArray(
				[
					A2(
					$author$project$Chart$Shared$backgroundView,
					sizes,
					_List_fromArray(
						[$author$project$Chart$Shared$cursorOverBackgroundListener])),
					A2(
					$author$project$Svg$Extra$viewMaybe,
					tickCountEstimate,
					function (tce) {
						return A3($author$project$Chart$Shared$verticalGridLines, sizes, tce, scaleX);
					}),
					A4($author$project$Chart$Shared$timeXAxisView, sizes, tickCountEstimate, xTickFormatter, scaleX),
					A4($author$project$Chart$Shared$continuousYAxesView, translations, sizes, primaryYAxisData, secondaryYAxisData),
					A3($author$project$Chart$Shared$continuousLines, sizes, toCoords, renderableData),
					A5($author$project$Chart$Shared$continuousPoints, translations, sizes, timeFormatter, toCoords, renderableData)
				]),
			sizes);
	});
var $author$project$Chart$Shared$Middle = 1;
var $author$project$Chart$Shared$OneQuarter = 0;
var $author$project$Chart$Shared$ThreeQuarters = 2;
var $author$project$Chart$Shared$CursorEnteredSlice = function (a) {
	return {$: 12, a: a};
};
var $author$project$Chart$Shared$CursorLeftSlice = {$: 13};
var $author$project$Chart$Shared$SliceClicked = {$: 11};
var $gampleman$elm_visualization$Shape$Pie$centroid = function (arcData) {
	var r = (arcData.j3 + arcData.kN) / 2;
	var a = ((arcData.dW + arcData.fn) / 2) - ($elm$core$Basics$pi / 2);
	return _Utils_Tuple2(
		$elm$core$Basics$cos(a) * r,
		$elm$core$Basics$sin(a) * r);
};
var $gampleman$elm_visualization$Shape$centroid = $gampleman$elm_visualization$Shape$Pie$centroid;
var $author$project$Chart$Shared$pieLabelDistance = 10;
var $author$project$Chart$Shared$dataPie = F4(
	function (translations, yAxis, sliceData, _v0) {
		var top = _v0.a;
		var left = _v0.b;
		var radius = _v0.c;
		var values = A2(
			$elm$core$List$map,
			function ($) {
				return $.aW;
			},
			sliceData);
		var sum = $elm$core$List$sum(values);
		var sliceBuilder = function (_v2) {
			var slice = _v2.a;
			var data = _v2.b;
			var _v1 = $gampleman$elm_visualization$Shape$centroid(
				_Utils_update(
					slice,
					{j3: radius + $author$project$Chart$Shared$pieLabelDistance, kN: radius + $author$project$Chart$Shared$pieLabelDistance}));
			var x = _v1.a;
			var y = _v1.b;
			var coords = {a9: 0, M: x + left, N: y + top};
			var tooltip = {
				O: coords,
				fF: data.kt,
				d: $elm$core$Maybe$Nothing,
				i$: yAxis.d,
				aW: A2($author$project$View$formatNumberWithNbsp, translations, data.aW),
				bY: false
			};
			return A2(
				$folkertdev$one_true_path_experiment$Path$element,
				$gampleman$elm_visualization$Shape$arc(slice),
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$fill(
						$elm_community$typed_svg$TypedSvg$Types$Paint(data.f)),
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['stroke-current stroke-2 text-white'])),
						$elm_community$typed_svg$TypedSvg$Events$onClick($author$project$Chart$Shared$SliceClicked),
						A2(
						$elm_community$typed_svg$TypedSvg$Events$on,
						'mouseenter',
						$elm$virtual_dom$VirtualDom$Normal(
							$elm$json$Json$Decode$succeed(
								$author$project$Chart$Shared$CursorEnteredSlice(tooltip)))),
						A2(
						$elm_community$typed_svg$TypedSvg$Events$on,
						'mouseleave',
						$elm$virtual_dom$VirtualDom$Normal(
							$elm$json$Json$Decode$succeed($author$project$Chart$Shared$CursorLeftSlice)))
					]));
		};
		var pie = A2(
			$gampleman$elm_visualization$Shape$pie,
			_Utils_update(
				$gampleman$elm_visualization$Shape$defaultPieConfig,
				{kN: radius}),
			A2(
				$elm$core$List$map,
				function (v) {
					return ((v / sum) < 0.0001) ? 0 : v;
				},
				values));
		return _List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_Nil,
				A2(
					$elm$core$List$map,
					sliceBuilder,
					A2($elm_community$list_extra$List$Extra$zip, pie, sliceData)))
			]);
	});
var $author$project$Chart$Shared$emptyPie = F2(
	function (translations, radius) {
		return _List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$circle,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$fill(
						$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$Chart$Shared$fallbackColor)),
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['fill-current text-grey-300'])),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$r(radius)
					]),
				_List_Nil),
				A2(
				$elm_community$typed_svg$TypedSvg$text_,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2),
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['fill-current text-grey-700 font-bold text-lg']))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Enectiva$I18n$t, translations, 'stats.no_data'))
					]))
			]);
	});
var $author$project$Chart$Shared$onePieView = F6(
	function (translations, sizes, position, yAxis, radius, data) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aW;
				},
				data));
		var top = sizes.p / 2;
		var left = function () {
			switch (position) {
				case 0:
					return sizes.h / 4;
				case 1:
					return sizes.h / 2;
				default:
					return (sizes.h * 3) / 4;
			}
		}();
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, left, top)
						]))
				]),
			(total > 0) ? A4(
				$author$project$Chart$Shared$dataPie,
				translations,
				yAxis,
				data,
				_Utils_Tuple3(top, left, radius)) : A2($author$project$Chart$Shared$emptyPie, translations, radius));
	});
var $author$project$Chart$Shared$pieChartSizes = function (dimensionConfig) {
	return {fa: $author$project$Chart$Shared$bottomPaddingWithSpaceForLegend, p: dimensionConfig.p, ca: 0, gl: 0, ci: 45, h: dimensionConfig.h};
};
var $author$project$Chart$Shared$pieRadius = function (sizes) {
	return ((((sizes.p - sizes.ci) - sizes.fa) - ($author$project$Chart$Shared$pieLabelDistance * 2)) - 50) / 2;
};
var $author$project$Chart$Shared$viewPieChart = F5(
	function (translations, dimensionConfig, yAxis, currentData, comparisonData) {
		var sizes = $author$project$Chart$Shared$pieChartSizes(dimensionConfig);
		var radius = $author$project$Chart$Shared$pieRadius(sizes);
		var primaryPiePosition = function () {
			if (comparisonData.$ === 1) {
				return 1;
			} else {
				return 0;
			}
		}();
		return _Utils_Tuple2(
			_List_fromArray(
				[
					A2(
					$author$project$Chart$Shared$backgroundView,
					sizes,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Events$onClick($author$project$Chart$Shared$DataBackgroundClicked)
						])),
					A6($author$project$Chart$Shared$onePieView, translations, sizes, primaryPiePosition, yAxis, radius, currentData),
					A2(
					$author$project$Svg$Extra$viewMaybe,
					comparisonData,
					A5($author$project$Chart$Shared$onePieView, translations, sizes, 2, yAxis, radius))
				]),
			sizes);
	});
var $author$project$Chart$Shared$tickPadding = 2;
var $author$project$Chart$Shared$estimateMaxCategoryWidth = function (categories) {
	return A2(
		$elm$core$Maybe$withDefault,
		1,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$toFloat,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$mul($author$project$Chart$Shared$pxPerChar),
					$elm$core$Basics$add($author$project$Chart$Shared$tickPadding * 2))),
			$elm$core$List$maximum(
				A2($elm$core$List$map, $elm$core$String$length, categories))));
};
var $author$project$Chart$Shared$findFraction = F3(
	function (max, total, divisor) {
		findFraction:
		while (true) {
			if (_Utils_cmp(total / divisor, max) < 0) {
				return divisor;
			} else {
				var $temp$max = max,
					$temp$total = total,
					$temp$divisor = divisor + 1;
				max = $temp$max;
				total = $temp$total;
				divisor = $temp$divisor;
				continue findFraction;
			}
		}
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Chart$Shared$filterCategoriesForLabelling = F2(
	function (categories, sizes) {
		var xAxisTickWidth = $author$project$Chart$Shared$estimateMaxCategoryWidth(categories);
		var maxCategoryCount = sizes.h / xAxisTickWidth;
		var count = $elm$core$List$length(categories);
		var fraction = A3($author$project$Chart$Shared$findFraction, maxCategoryCount, count, 1);
		return $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var idx = _v0.a;
						return !A2($elm$core$Basics$modBy, fraction, idx);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, categories))));
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Chart$Shared$xAxisTickCount = function (sizes) {
	return $elm$core$Basics$floor(
		$author$project$Chart$Shared$dataAreaWidthInPx(sizes) / $author$project$Chart$Shared$xAxisTickLabelWidth);
};
var $author$project$Chart$Shared$categoricalXAxisView = F3(
	function (sizes, categories, scaleX) {
		var labelledCategories = A2($author$project$Chart$Shared$filterCategoriesForLabelling, categories, sizes);
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca - 1, sizes.p - sizes.fa)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$gampleman$elm_visualization$Axis$bottom,
					_List_fromArray(
						[
							$gampleman$elm_visualization$Axis$tickCount(
							$author$project$Chart$Shared$xAxisTickCount(sizes)),
							$gampleman$elm_visualization$Axis$tickSizeOuter(0),
							$gampleman$elm_visualization$Axis$tickFormat(
							function (category) {
								return A2($elm$core$Set$member, category, labelledCategories) ? category : '';
							})
						]),
					A2($gampleman$elm_visualization$Scale$toRenderable, $elm$core$Basics$identity, scaleX))
				]));
	});
var $author$project$Chart$Shared$categoricalYAxesView = F4(
	function (translations, sizes, primaryAxis, maybeSecondaryAxis) {
		var secondary = function () {
			if (maybeSecondaryAxis.$ === 1) {
				return _List_Nil;
			} else {
				var secondaryAxis = maybeSecondaryAxis.a;
				return _List_fromArray(
					[
						A5(
						$author$project$Chart$Shared$yAxisView,
						1,
						sizes,
						$author$project$Chart$Shared$anySeriesVisible(secondaryAxis.jA),
						A2($author$project$Chart$Shared$yAxisTickFormatter, translations, primaryAxis.o),
						A2($author$project$Chart$Shared$yScaleFromAxisData, sizes, secondaryAxis)),
						A2(
						$author$project$Svg$Extra$viewMaybe,
						secondaryAxis.o.d,
						$author$project$Chart$Shared$secondaryYAxisUnit(sizes))
					]);
			}
		}();
		var atLeastOnePrimarySeriesVisible = $author$project$Chart$Shared$anySeriesVisible(primaryAxis.jA);
		var _v0 = A2($author$project$Chart$Shared$yScaleFromAxisData, sizes, primaryAxis);
		var primaryScale = _v0.a;
		var primaryDiscontinuity = _v0.b;
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Svg$Extra$viewIf,
						atLeastOnePrimarySeriesVisible,
						function (_v1) {
							return A2($author$project$Chart$Shared$horizontalGridLines, sizes, primaryScale);
						}),
						A5(
						$author$project$Chart$Shared$yAxisView,
						0,
						sizes,
						atLeastOnePrimarySeriesVisible,
						A2($author$project$Chart$Shared$yAxisTickFormatter, translations, primaryAxis.o),
						_Utils_Tuple2(primaryScale, primaryDiscontinuity)),
						A2(
						$author$project$Svg$Extra$viewMaybe,
						primaryAxis.o.d,
						$author$project$Chart$Shared$primaryYAxisUnit(sizes.p))
					]),
				secondary));
	});
var $author$project$Chart$Shared$BarClicked = function (a) {
	return {$: 10, a: a};
};
var $author$project$Chart$Shared$columnSegment = F7(
	function (translations, sizes, _v0, columnWidth, inBandXOffset, dataPointIndex, maybeBarSegment) {
		var scaleX = _v0.a;
		var scaleY = _v0.b;
		if (maybeBarSegment.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var barSegment = maybeBarSegment.a;
			var yOffset = A2($gampleman$elm_visualization$Scale$convert, scaleY, barSegment.d9);
			var xOffset = A2($gampleman$elm_visualization$Scale$convert, scaleX, barSegment.aN) + inBandXOffset;
			var tooltip = {
				O: {a9: columnWidth, M: xOffset + sizes.ca, N: yOffset + sizes.ci},
				fF: barSegment.fF,
				d: barSegment.d,
				i$: barSegment.i$,
				aW: A2($author$project$View$formatNumberWithNbsp, translations, barSegment.aW),
				bY: false
			};
			var h = A2($gampleman$elm_visualization$Scale$convert, scaleY, barSegment.dE) - yOffset;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Chart$Shared$maybeLink,
					barSegment.aQ,
					A2(
						$elm_community$typed_svg$TypedSvg$rect,
						_List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(xOffset),
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(yOffset),
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(columnWidth),
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(h),
								$elm_community$typed_svg$TypedSvg$Attributes$fill(
								$elm_community$typed_svg$TypedSvg$Types$Paint(barSegment.f)),
								A2(
								$elm_community$typed_svg$TypedSvg$Events$on,
								'mouseenter',
								$elm$virtual_dom$VirtualDom$Normal(
									$elm$json$Json$Decode$succeed(
										$author$project$Chart$Shared$CursorEnteredBar(tooltip)))),
								A2(
								$elm_community$typed_svg$TypedSvg$Events$on,
								'mouseleave',
								$elm$virtual_dom$VirtualDom$Normal(
									$elm$json$Json$Decode$succeed($author$project$Chart$Shared$CursorLeftBar))),
								$elm_community$typed_svg$TypedSvg$Events$onClick(
								$author$project$Chart$Shared$BarClicked(dataPointIndex)),
								$elm$svg$Svg$Attributes$class('transition-opacity duration-500 ease-in-out'),
								$elm$svg$Svg$Attributes$class(barSegment.dL)
							]),
						_List_Nil)));
		}
	});
var $author$project$Chart$Shared$column = F6(
	function (translations, sizes, scales, columnWidth, groupIndex, dataPoints) {
		var inBandXOffset = groupIndex * (columnWidth + $author$project$Chart$Shared$columnInBandGap);
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$indexedMap,
					A5($author$project$Chart$Shared$columnSegment, translations, sizes, scales, columnWidth, inBandXOffset),
					dataPoints)));
	});
var $author$project$Chart$Shared$columnGroup = F7(
	function (translations, sizes, scales, columnWidth, indexOffset, groupIndex, groupData) {
		return A2(
			$elm$core$List$map,
			A5($author$project$Chart$Shared$column, translations, sizes, scales, columnWidth, indexOffset + groupIndex),
			groupData);
	});
var $author$project$Chart$Shared$columnsForYAxis = F6(
	function (translations, sizes, scaleX, columnWidth, _v0, _v1) {
		var scaleY = _v0.a;
		var groups = _v0.b;
		var indexOffset = _v1.a;
		var agg = _v1.b;
		return _Utils_Tuple2(
			indexOffset + $elm$core$List$length(groups),
			_Utils_ap(
				agg,
				$elm$core$List$concat(
					A2(
						$elm$core$List$indexedMap,
						A5(
							$author$project$Chart$Shared$columnGroup,
							translations,
							sizes,
							_Utils_Tuple2(scaleX, scaleY),
							columnWidth,
							indexOffset),
						groups))));
	});
var $TSFoster$elm_tuple_extra$Tuple3$second = function (_v0) {
	var b = _v0.b;
	return b;
};
var $author$project$Chart$Shared$columns = F4(
	function (translations, sizes, scaleX, renderableData) {
		var groupCount = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $TSFoster$elm_tuple_extra$Tuple3$second, $elm$core$List$length),
				renderableData));
		var totalGapsWidth = (groupCount - 1) * $author$project$Chart$Shared$columnInBandGap;
		var bandWidth = $gampleman$elm_visualization$Scale$bandwidth(scaleX);
		var columnWidth = (bandWidth - totalGapsWidth) / groupCount;
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca, sizes.ci)
						]))
				]),
			A3(
				$elm$core$List$foldl,
				A4($author$project$Chart$Shared$columnsForYAxis, translations, sizes, scaleX, columnWidth),
				_Utils_Tuple2(0, _List_Nil),
				renderableData).b);
	});
var $author$project$Chart$Shared$discreteLines = F3(
	function (sizes, toCoords, data) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var scaleY = _v0.a;
					var seriesWithUnits = _v0.c;
					return A3(
						$author$project$Chart$Shared$lines,
						sizes,
						toCoords(scaleY),
						A2($elm$core$List$map, $elm$core$Tuple$second, seriesWithUnits));
				},
				data));
	});
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Chart$Shared$discretePoints = F5(
	function (translations, sizes, xAxis, toCoords, data) {
		var tooltipBuilder = F5(
			function (unit, seriesName, dp, idx, coords) {
				return {
					O: coords,
					fF: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm_community$maybe_extra$Maybe$Extra$orElse,
							A2($elm_community$list_extra$List$Extra$getAt, idx, xAxis),
							dp.bL)),
					d: $elm$core$Maybe$Just(seriesName),
					i$: unit,
					aW: A2(
						$author$project$View$formatNumberWithNbsp,
						translations,
						A2($elm$core$Maybe$withDefault, 0, dp.aW)),
					bY: false
				};
			});
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var scaleY = _v0.a;
					var seriesWithUnits = _v0.c;
					return A4(
						$author$project$Chart$Shared$points,
						sizes,
						toCoords(scaleY),
						tooltipBuilder,
						seriesWithUnits);
				},
				data));
	});
var $author$project$Chart$Shared$barStatsWithSeriesName = function (data) {
	var series = $author$project$Visibility$value(data);
	return $elm$core$List$isEmpty(series.V) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$core$List$map,
			function (stat) {
				return {f: series.f, r: series.r, eA: 2, aJ: series.kt, aK: stat};
			},
			series.V));
};
var $author$project$Chart$Shared$lineStatsWithSeriesName = function (data) {
	var series = $author$project$Visibility$value(data);
	return $elm$core$List$isEmpty(series.V) ? _List_Nil : A2(
		$elm$core$List$map,
		function (stat) {
			return {f: series.f, r: series.r, eA: 1, aJ: series.kt, aK: stat};
		},
		series.V);
};
var $author$project$Chart$Shared$discreteAxisSeriesStatsWithSeriesName = function (data) {
	switch (data.$) {
		case 0:
			var sb = data.a;
			return $elm$core$List$concat(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$author$project$Chart$Shared$barStatsWithSeriesName(sb)
						])));
		case 1:
			var bgs = data.a;
			return $elm$core$List$concat(
				A2($elm$core$List$filterMap, $author$project$Chart$Shared$barStatsWithSeriesName, bgs));
		default:
			var fl = data.a;
			return $author$project$Chart$Shared$lineStatsWithSeriesName(fl);
	}
};
var $author$project$Chart$Shared$PrimaryAxis = 0;
var $author$project$Chart$Shared$SecondaryAxis = 1;
var $author$project$Chart$Shared$compareStatTypes = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					return 1;
				} else {
					return 0;
				}
			case 1:
				switch (_v0.b.$) {
					case 1:
						return 1;
					case 0:
						return 2;
					default:
						return 0;
				}
			case 2:
				switch (_v0.b.$) {
					case 2:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return 1;
					case 0:
						var _v15 = _v0.a;
						return 2;
					case 1:
						var _v16 = _v0.a;
						return 2;
					default:
						var _v17 = _v0.a;
						return 0;
				}
			case 5:
				switch (_v0.b.$) {
					case 5:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return 1;
					case 0:
						var _v18 = _v0.a;
						return 2;
					case 1:
						var _v19 = _v0.a;
						return 2;
					case 2:
						var _v20 = _v0.a;
						var _v21 = _v0.b;
						return 2;
					default:
						var _v22 = _v0.a;
						return 0;
				}
			case 7:
				switch (_v0.b.$) {
					case 7:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return 1;
					case 0:
						var _v23 = _v0.a;
						return 2;
					case 1:
						var _v24 = _v0.a;
						return 2;
					case 2:
						var _v25 = _v0.a;
						var _v26 = _v0.b;
						return 2;
					case 5:
						var _v27 = _v0.a;
						var _v28 = _v0.b;
						return 2;
					default:
						var _v29 = _v0.a;
						return 0;
				}
			case 3:
				switch (_v0.b.$) {
					case 3:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return 1;
					case 0:
						var _v30 = _v0.a;
						return 2;
					case 1:
						var _v31 = _v0.a;
						return 2;
					case 2:
						var _v32 = _v0.a;
						var _v33 = _v0.b;
						return 2;
					case 5:
						var _v34 = _v0.a;
						var _v35 = _v0.b;
						return 2;
					case 7:
						var _v36 = _v0.a;
						var _v37 = _v0.b;
						return 2;
					default:
						var _v38 = _v0.a;
						return 0;
				}
			case 4:
				switch (_v0.b.$) {
					case 4:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return 1;
					case 0:
						var _v39 = _v0.a;
						return 2;
					case 1:
						var _v40 = _v0.a;
						return 2;
					case 2:
						var _v41 = _v0.a;
						var _v42 = _v0.b;
						return 2;
					case 5:
						var _v43 = _v0.a;
						var _v44 = _v0.b;
						return 2;
					case 7:
						var _v45 = _v0.a;
						var _v46 = _v0.b;
						return 2;
					case 3:
						var _v47 = _v0.a;
						var _v48 = _v0.b;
						return 2;
					default:
						var _v49 = _v0.a;
						return 0;
				}
			case 6:
				switch (_v0.b.$) {
					case 6:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return 1;
					case 8:
						var _v50 = _v0.a;
						var _v51 = _v0.b;
						return 0;
					default:
						var _v52 = _v0.a;
						return 2;
				}
			default:
				if (_v0.b.$ === 8) {
					var _v13 = _v0.a;
					var _v14 = _v0.b;
					return 1;
				} else {
					var _v53 = _v0.a;
					return 2;
				}
		}
	});
var $author$project$Chart$Shared$compareStats = F2(
	function (a, b) {
		return A2($author$project$Chart$Shared$compareStatTypes, a.c4, b.c4);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$fromCons = $elm$core$Tuple$pair;
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				helper:
				while (true) {
					if (!scattered.b) {
						return $elm$core$List$reverse(gathered);
					} else {
						var toGather = scattered.a;
						var population = scattered.b;
						var _v1 = A2(
							$elm$core$List$partition,
							testFn(toGather),
							population);
						var gathering = _v1.a;
						var remaining = _v1.b;
						var $temp$scattered = remaining,
							$temp$gathered = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered);
						scattered = $temp$scattered;
						gathered = $temp$gathered;
						continue helper;
					}
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$head = function (_v0) {
	var h = _v0.a;
	return h;
};
var $author$project$Chart$Shared$groupStatsByTypeAndSort = function (annotatedStats) {
	return A2(
		$elm$core$List$sortWith,
		F2(
			function (a, b) {
				return A2(
					$author$project$Chart$Shared$compareStats,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$head(a).aK,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$head(b).aK);
			}),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var head = _v1.a;
				var tail = _v1.b;
				return A2($turboMaCk$non_empty_list_alias$List$NonEmpty$fromCons, head, tail);
			},
			A2(
				$elm_community$list_extra$List$Extra$gatherEqualsBy,
				function (_v0) {
					var stat = _v0.aK;
					return stat.kt;
				},
				annotatedStats)));
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$length = function (_v0) {
	var t = _v0.b;
	return $elm$core$List$length(t) + 1;
};
var $author$project$Chart$Shared$moreSeriesThanStatsCanFit = function (stats) {
	return A2(
		$elm$core$List$any,
		function (g) {
			return $turboMaCk$non_empty_list_alias$List$NonEmpty$length(g) > 3;
		},
		stats);
};
var $author$project$Chart$Shared$StatsDialogCloseButtonClicked = {$: 21};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$scope = $elm$html$Html$Attributes$stringProperty('scope');
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Chart$Shared$statValueCell = F3(
	function (translations, statsForSeries, statToRender) {
		var currentStat = A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v1) {
				var stat = _v1.aK;
				return _Utils_eq(stat.kt, statToRender.kt);
			},
			statsForSeries);
		var content = function () {
			if (currentStat.$ === 1) {
				return _List_Nil;
			} else {
				var s = currentStat.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Chart$Shared$scaleAndFormatFloat, translations, s.aK.aW))
					]);
			}
		}();
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('px-2 py-1 text-right tabular-nums')
				]),
			content);
	});
var $author$project$Chart$Shared$completeStatsTableRow = F4(
	function (translations, statsToRender, tableIndex, _v0) {
		var seriesIndex = _v0.a;
		var stats = _v0.b;
		var variant = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.eA;
				},
				$elm$core$List$head(stats)));
		var valueCells = A2(
			$elm$core$List$map,
			A2($author$project$Chart$Shared$statValueCell, translations, stats),
			statsToRender);
		var seriesName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.aJ;
				},
				$elm$core$List$head(stats)));
		var cls = (!A2($elm$core$Basics$modBy, 2, tableIndex)) ? 'bg-grey-200' : '';
		var bgColor = A2(
			$elm$core$Maybe$withDefault,
			'#000000',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.f;
					},
					$avh4$elm_color$Color$toCssString),
				$elm$core$List$head(stats)));
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(cls)
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$scope('row'),
								$elm$html$Html$Attributes$class('text-left text-grey-600 font-normal px-2 py-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(seriesName)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Chart$Shared$legendSeriesIndicator, variant, bgColor)
							]))
					]),
				valueCells));
	});
var $author$project$Chart$Shared$statHeaderClass = 'text-grey-600 text-right px-2 py-px font-normal';
var $author$project$Chart$Shared$completeStatsTableHelp = F2(
	function (translations, annotatedStats) {
		var statsBySeriesIndex = A2(
			$elm$core$List$map,
			function (_v0) {
				var head = _v0.a;
				var tail = _v0.b;
				return _Utils_Tuple2(
					head.r,
					A2($elm$core$List$cons, head, tail));
			},
			A2(
				$elm_community$list_extra$List$Extra$gatherEqualsBy,
				function ($) {
					return $.r;
				},
				annotatedStats));
		var statSupersetToRender = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$head,
				function ($) {
					return $.aK;
				}),
			$author$project$Chart$Shared$groupStatsByTypeAndSort(annotatedStats));
		return A2(
			$elm$html$Html$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$colspan(2),
											$elm$html$Html$Attributes$class($author$project$Chart$Shared$statHeaderClass)
										]),
									_List_Nil),
								A2(
									$elm$core$List$map,
									function (s) {
										return A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class($author$project$Chart$Shared$statHeaderClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(s.kt)
												]));
									},
									statSupersetToRender)))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Chart$Shared$completeStatsTableRow, translations, statSupersetToRender),
						statsBySeriesIndex))
				]));
	});
var $author$project$Chart$Shared$completeStatsTable = F3(
	function (translations, unit, statsBySeriesName) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-lg text-grey-600 text-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(unit)
						])),
					A2($author$project$Chart$Shared$completeStatsTableHelp, translations, statsBySeriesName)
				]));
	});
var $author$project$Dialog$options = {cr: $elm$core$Maybe$Nothing, cJ: $elm$core$Maybe$Nothing, cK: $elm$core$Maybe$Nothing, d: $elm$core$Maybe$Nothing};
var $author$project$SvgIcons$close = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$x('0px'),
			$elm$svg$Svg$Attributes$y('0px'),
			$elm$svg$Svg$Attributes$width('12.729px'),
			$elm$svg$Svg$Attributes$height('12.729px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 12.729 12.729'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 12.729,2.122 10.606,0 6.364,4.243 2.122,0 0,2.122 4.243,6.364 0,10.607 2.121,12.729 6.364,8.485 10.606,12.729 12.729,10.606 8.486,6.364 Z')
				]),
			_List_Nil)
		]));
var $author$project$Dialog$cancelButton = F2(
	function (translations, onCancel) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$title(
					A2($author$project$Enectiva$I18n$t, translations, 'cancel')),
					$elm$html$Html$Events$onClick(onCancel),
					$elm$html$Html$Attributes$class('w-6 h-6'),
					$elm$html$Html$Attributes$class('text-white flex items-center justify-center'),
					$elm$html$Html$Attributes$class('bg-grey-500 rounded transition-colors duration-75'),
					$elm$html$Html$Attributes$class('hover:bg-grey-800 focus:bg-grey-800')
				]),
			_List_fromArray(
				[$author$project$SvgIcons$close]));
	});
var $author$project$Dialog$placeholder = A2($elm$html$Html$div, _List_Nil, _List_Nil);
var $author$project$Enectiva$View$viewJust = F2(
	function (view, maybe) {
		if (!maybe.$) {
			var whatever = maybe.a;
			return view(whatever);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Enectiva$View$viewMaybe = F3(
	function (viewValue, viewError, maybe) {
		if (!maybe.$) {
			var whatever = maybe.a;
			return viewValue(whatever);
		} else {
			return viewError(0);
		}
	});
var $author$project$Dialog$dialogHeading = F2(
	function (translations, _v0) {
		var onCancel = _v0.cJ;
		var title = _v0.d;
		return _Utils_eq(
			_Utils_Tuple2(onCancel, title),
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)) ? _List_Nil : $elm$core$List$singleton(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between items-center gap-8')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Enectiva$View$viewMaybe,
						$elm$core$Basics$identity,
						$elm$core$Basics$always($author$project$Dialog$placeholder),
						title),
						A2(
						$author$project$Enectiva$View$viewJust,
						$author$project$Dialog$cancelButton(translations),
						onCancel)
					])));
	});
var $author$project$Dialog$doneButton = function (_v0) {
	var tagger = _v0.a;
	var txt = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-4 flex flex-right justify-end')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('submit-button'),
						$elm$html$Html$Events$onClick(tagger),
						$elm$html$Html$Attributes$type_('button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Dialog$view = F5(
	function (translations, elementId, opts, attr, content) {
		return A3(
			$elm$html$Html$node,
			'dialog',
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(elementId),
						$elm$html$Html$Attributes$class('space-y-4 min-w-64 shadow-md rounded'),
						$elm$html$Html$Attributes$class(
						A2($elm$core$Maybe$withDefault, '', opts.cr))
					]),
				attr),
			_Utils_ap(
				A2($author$project$Dialog$dialogHeading, translations, opts),
				_Utils_ap(
					content,
					_List_fromArray(
						[
							A2($author$project$Enectiva$View$viewJust, $author$project$Dialog$doneButton, opts.cK)
						]))));
	});
var $author$project$Dialog$withCancelButton = F2(
	function (onCancel, opts) {
		return _Utils_update(
			opts,
			{
				cJ: $elm$core$Maybe$Just(onCancel)
			});
	});
var $author$project$Chart$Shared$statsDialog = F2(
	function (translations, setsOfStats) {
		return A5(
			$author$project$Dialog$view,
			translations,
			$author$project$Chart$Shared$moreStatsDialogId,
			A2($author$project$Dialog$withCancelButton, $author$project$Chart$Shared$StatsDialogCloseButtonClicked, $author$project$Dialog$options),
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-center gap-8 pb-16 px-8')
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var unit = _v0.a;
							var stats = _v0.b;
							return A3($author$project$Chart$Shared$completeStatsTable, translations, unit, stats);
						},
						setsOfStats))));
	});
var $author$project$Chart$Shared$StatsDialogButtonClicked = {$: 20};
var $author$project$Chart$Shared$statsDialogButton = function (translations) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$title(
				A2($author$project$Enectiva$I18n$t, translations, 'stats.advanced.more')),
				$elm$html$Html$Attributes$class('bg-blue-600 rounded-full text-white font-bold px-3 tracking-wider'),
				$elm$html$Html$Attributes$class('w-16 h-6 mt-1'),
				$elm$html$Html$Attributes$class('hover:bg-blue-800 focus:bg-blue-800'),
				$elm_community$typed_svg$TypedSvg$Events$onClick($author$project$Chart$Shared$StatsDialogButtonClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('•••')
			]));
};
var $author$project$Chart$Shared$CursorEnteredStatGroup = function (a) {
	return {$: 18, a: a};
};
var $author$project$Chart$Shared$CursorLeftStatGroup = function (a) {
	return {$: 19, a: a};
};
var $elm_community$typed_svg$TypedSvg$Events$onMouseOut = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mouseout');
var $elm_community$typed_svg$TypedSvg$Events$onMouseOver = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mouseover');
var $author$project$Chart$Shared$CursorEnteredStatValue = function (a) {
	return {$: 16, a: a};
};
var $author$project$Chart$Shared$CursorLeftStatValue = function (a) {
	return {$: 17, a: a};
};
var $author$project$Chart$Shared$cssColorString = F2(
	function (kind, values) {
		return kind + ('(' + (A2($elm$core$String$join, ', ', values) + ')'));
	});
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {je: a, jk: b, jV: g, kU: r};
};
var $author$project$Chart$Shared$colorToCssRgba = function (c) {
	var _v0 = $avh4$elm_color$Color$toRgba(c);
	var red = _v0.kU;
	var green = _v0.jV;
	var blue = _v0.jk;
	var alpha = _v0.je;
	return A2(
		$author$project$Chart$Shared$cssColorString,
		'rgba',
		_List_fromArray(
			[
				$elm$core$String$fromFloat(red * 255),
				$elm$core$String$fromFloat(green * 255),
				$elm$core$String$fromFloat(blue * 255),
				$elm$core$String$fromFloat(alpha)
			]));
};
var $elm_community$typed_svg$TypedSvg$Events$onMouseEnter = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mouseenter');
var $elm_community$typed_svg$TypedSvg$Events$onMouseLeave = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mouseleave');
var $author$project$Chart$Shared$statCategories = function (stat) {
	var _v0 = stat.c4;
	switch (_v0.$) {
		case 1:
			var categories = _v0.a;
			return categories;
		case 0:
			var categories = _v0.a;
			return categories;
		default:
			return _List_Nil;
	}
};
var $author$project$Chart$Shared$statValueView = F5(
	function (translations, axis, unit, valueTextClass, annotated) {
		var seriesName = annotated.aJ;
		var stat = annotated.aK;
		var highlight = {ef: axis, aJ: seriesName, d6: stat.c4, aW: stat.aW};
		var formattedValue = A2($author$project$Enectiva$I18n$formatNumber, translations, stat.aW) + (' ' + unit);
		var title = function (categories) {
			if (!categories.b) {
				return formattedValue;
			} else {
				var cs = categories;
				return function (cats) {
					return formattedValue + (' - ' + cats);
				}(
					A2($elm$core$String$join, ', ', cs));
			}
		}(
			$author$project$Chart$Shared$statCategories(stat));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 items-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tabular-nums text-right'),
							$elm$html$Html$Attributes$class(valueTextClass),
							$elm_community$typed_svg$TypedSvg$Events$onMouseEnter(
							$author$project$Chart$Shared$CursorEnteredStatValue(highlight)),
							$elm_community$typed_svg$TypedSvg$Events$onMouseLeave(
							$author$project$Chart$Shared$CursorLeftStatValue(highlight)),
							$elm$html$Html$Attributes$title(seriesName + (': ' + title))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Chart$Shared$scaleAndFormatFloat, translations, stat.aW))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-1 h-5'),
							A2(
							$elm$html$Html$Attributes$style,
							'background-color',
							$author$project$Chart$Shared$colorToCssRgba(annotated.f))
						]),
					_List_Nil)
				]));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$tail = function (_v0) {
	var t = _v0.b;
	return t;
};
var $author$project$Chart$Shared$statView = F4(
	function (translations, axis, unit, labelledStats) {
		var tail = A2(
			$elm$core$List$take,
			2,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$tail(labelledStats));
		var seriesCount = 1 + $elm$core$List$length(tail);
		var valueTextClass = function () {
			switch (seriesCount) {
				case 1:
					return 'text-3xl text-grey-600 font-semibold';
				case 2:
					return 'text-2xl text-grey-600 font-semibold';
				default:
					return 'text-lg text-grey-700 font-semibold';
			}
		}();
		var head = $turboMaCk$non_empty_list_alias$List$NonEmpty$head(labelledStats);
		var highlights = A2(
			$elm$core$List$map,
			function (_v0) {
				var seriesName = _v0.aJ;
				var stat = _v0.aK;
				return {ef: axis, aJ: seriesName, d6: stat.c4, aW: stat.aW};
			},
			A2($elm$core$List$cons, head, tail));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-normal text-grey-600 pr-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(head.aK.kt)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-1 items-end'),
						$elm_community$typed_svg$TypedSvg$Events$onMouseOver(
						$author$project$Chart$Shared$CursorEnteredStatGroup(highlights)),
						$elm_community$typed_svg$TypedSvg$Events$onMouseOut(
						$author$project$Chart$Shared$CursorLeftStatGroup(highlights))
					]),
				A2(
					$elm$core$List$cons,
					A5($author$project$Chart$Shared$statValueView, translations, axis, unit, valueTextClass, head),
					A2(
						$elm$core$List$map,
						A4($author$project$Chart$Shared$statValueView, translations, axis, unit, valueTextClass),
						tail))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-grey-600 ml-2'),
						$elm$html$Html$Attributes$class('truncate'),
						$elm$html$Html$Attributes$title(unit)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(unit)
					]))
			]);
	});
var $author$project$Chart$Shared$statsView = F4(
	function (translations, axis, unit, sortedStatsGroupedByType) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full grid advanced-stats-grid items-center gap-y-4 py-2')
				]),
			A2(
				$elm$core$List$concatMap,
				A3($author$project$Chart$Shared$statView, translations, axis, unit),
				sortedStatsGroupedByType));
	});
var $author$project$Chart$Shared$oneStatsTable = F2(
	function (translations, _v0) {
		var axis = _v0.a;
		var unit = _v0.b;
		var stats = _v0.c;
		var sortedStatsGroupedByType = $author$project$Chart$Shared$groupStatsByTypeAndSort(stats);
		var dialogNeeded = $author$project$Chart$Shared$moreSeriesThanStatsCanFit(sortedStatsGroupedByType);
		return dialogNeeded ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-4 justify-between h-full')
				]),
			_List_fromArray(
				[
					A4($author$project$Chart$Shared$statsView, translations, axis, unit, sortedStatsGroupedByType),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-end')
						]),
					_List_fromArray(
						[
							$author$project$Chart$Shared$statsDialogButton(translations),
							A2(
							$author$project$Chart$Shared$statsDialog,
							translations,
							_List_fromArray(
								[
									_Utils_Tuple2(unit, stats)
								]))
						]))
				])) : A4($author$project$Chart$Shared$statsView, translations, axis, unit, sortedStatsGroupedByType);
	});
var $author$project$Chart$Shared$StatsToggleClicked = function (a) {
	return {$: 22, a: a};
};
var $author$project$View$toggleWithoutText = F3(
	function (translations, msg, checked) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('boolean-toggle')
				]),
			A4($author$project$View$toggleInnerHelp, translations, msg, false, checked));
	});
var $author$project$Chart$Shared$twoStatsTables = F4(
	function (translations, displaySecondaryStats, _v0, _v1) {
		var primaryUnit = _v0.a;
		var primaryStats = _v0.b;
		var secondaryUnit = _v1.a;
		var secondaryStats = _v1.b;
		var secondaryStatsGroupedByType = $author$project$Chart$Shared$groupStatsByTypeAndSort(secondaryStats);
		var primaryStatsGroupedByType = $author$project$Chart$Shared$groupStatsByTypeAndSort(primaryStats);
		var dialogNeeded = $author$project$Chart$Shared$moreSeriesThanStatsCanFit(primaryStatsGroupedByType) || $author$project$Chart$Shared$moreSeriesThanStatsCanFit(secondaryStatsGroupedByType);
		var dialogElements = dialogNeeded ? _List_fromArray(
			[
				$author$project$Chart$Shared$statsDialogButton(translations),
				A2(
				$author$project$Chart$Shared$statsDialog,
				translations,
				_List_fromArray(
					[
						_Utils_Tuple2(primaryUnit, primaryStats),
						_Utils_Tuple2(secondaryUnit, secondaryStats)
					]))
			]) : _List_Nil;
		var currentStatsView = displaySecondaryStats ? A4($author$project$Chart$Shared$statsView, translations, 1, secondaryUnit, secondaryStatsGroupedByType) : A4($author$project$Chart$Shared$statsView, translations, 0, primaryUnit, primaryStatsGroupedByType);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-4 justify-between h-full')
				]),
			_List_fromArray(
				[
					currentStatsView,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-2 justify-end')
						]),
					A2(
						$elm$core$List$cons,
						A3($author$project$View$toggleWithoutText, translations, $author$project$Chart$Shared$StatsToggleClicked, displaySecondaryStats),
						dialogElements))
				]));
	});
var $author$project$Chart$Shared$statsSidebarView = F5(
	function (translations, displaySecondaryStats, primaryAxis, maybeSecondaryAxis, extractor) {
		var secondaryStats = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jA;
					},
					$elm$core$List$concatMap(extractor)),
				maybeSecondaryAxis));
		var secondaryCount = $elm$core$List$length(secondaryStats);
		var primaryStats = A2($elm$core$List$concatMap, extractor, primaryAxis.jA);
		var primaryCount = $elm$core$List$length(primaryStats);
		if ((!primaryCount) && (!secondaryCount)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var secondaryUnit = A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.o;
							},
							function ($) {
								return $.d;
							}),
						maybeSecondaryAxis)));
			var primaryUnit = A2($elm$core$Maybe$withDefault, '', primaryAxis.o.d);
			return ((primaryCount >= 1) && (secondaryCount >= 1)) ? $elm$core$Maybe$Just(
				A4(
					$author$project$Chart$Shared$twoStatsTables,
					translations,
					displaySecondaryStats,
					_Utils_Tuple2(primaryUnit, primaryStats),
					_Utils_Tuple2(secondaryUnit, secondaryStats))) : (((primaryCount >= 1) && (!secondaryCount)) ? $elm$core$Maybe$Just(
				A2(
					$author$project$Chart$Shared$oneStatsTable,
					translations,
					_Utils_Tuple3(0, primaryUnit, primaryStats))) : $elm$core$Maybe$Just(
				A2(
					$author$project$Chart$Shared$oneStatsTable,
					translations,
					_Utils_Tuple3(1, secondaryUnit, secondaryStats))));
		}
	});
var $author$project$Chart$Shared$discreteStatsSidebarView = F4(
	function (translations, displaySecondaryStats, primaryAxis, maybeSecondaryAxis) {
		return A5($author$project$Chart$Shared$statsSidebarView, translations, displaySecondaryStats, primaryAxis, maybeSecondaryAxis, $author$project$Chart$Shared$discreteAxisSeriesStatsWithSeriesName);
	});
var $author$project$Chart$Shared$discreteTimeDataToCoords = F3(
	function (scaleX, scaleY, _v0) {
		var category = _v0.aN;
		var value = _v0.aW;
		return A2(
			$elm$core$Maybe$map,
			function (v) {
				return _Utils_Tuple2(
					A2($gampleman$elm_visualization$Scale$convert, scaleX, category),
					A2($gampleman$elm_visualization$Scale$convert, scaleY, v));
			},
			value);
	});
var $author$project$Chart$Shared$highlightedAverageLine = F6(
	function (sizes, lineSizes, scaleX, primaryYAxisData, secondaryYAxisData, highlights) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				function (h) {
					var _v0 = h.d6;
					if (_v0.$ === 3) {
						var _v1 = $gampleman$elm_visualization$Scale$range(scaleX);
						var x1 = _v1.a;
						var x2 = _v1.b;
						var _v2 = function () {
							var _v3 = h.ef;
							if (!_v3) {
								return A2($author$project$Chart$Shared$yScaleFromAxisData, lineSizes, primaryYAxisData);
							} else {
								return A2(
									$author$project$Chart$Shared$yScaleFromAxisData,
									lineSizes,
									A2($elm$core$Maybe$withDefault, primaryYAxisData, secondaryYAxisData));
							}
						}();
						var scaleY = _v2.a;
						var y = $elm$core$String$fromFloat(
							A2($gampleman$elm_visualization$Scale$convert, scaleY, h.aW));
						return $elm$core$Maybe$Just(
							A2(
								$elm_community$typed_svg$TypedSvg$g,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$transform(
										_List_fromArray(
											[
												A2($elm_community$typed_svg$TypedSvg$Types$Translate, sizes.ca, sizes.ci)
											]))
									]),
								$elm$core$List$singleton(
									A2(
										$elm$svg$Svg$line,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$x1(
												$elm$core$String$fromFloat(x1)),
												$elm$svg$Svg$Attributes$y1(y),
												$elm$svg$Svg$Attributes$x2(
												$elm$core$String$fromFloat(x2)),
												$elm$svg$Svg$Attributes$y2(y),
												$elm$svg$Svg$Attributes$class('stroke-1.5 stroke-current text-orange-600')
											]),
										_List_Nil))));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				highlights));
	});
var $elm$core$List$map3 = _List_map3;
var $elm_community$list_extra$List$Extra$triple = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $elm_community$list_extra$List$Extra$zip3 = $elm$core$List$map3($elm_community$list_extra$List$Extra$triple);
var $author$project$Chart$Shared$barGroupToRenderableBarSegments = F4(
	function (categories, unit, maybeStatHighlight, series) {
		var visibleSeries = A2($elm$core$List$filterMap, $author$project$Visibility$toMaybe, series);
		var _v0 = $author$project$Chart$Shared$calculateStack(visibleSeries);
		var values = _v0.lB;
		var labels = _v0.kb;
		var renderableDataBySeriesName = $elm$core$Dict$fromList(
			A2($elm_community$list_extra$List$Extra$zip, labels, values));
		var renderableSeries = A2(
			$elm$core$List$filterMap,
			function (s) {
				return A2(
					$elm$core$Maybe$map,
					function (barEnds) {
						return A2(
							$elm$core$List$indexedMap,
							F2(
								function (dataPointIndex, _v2) {
									var _v3 = _v2.a;
									var lower = _v3.a;
									var upper = _v3.b;
									var category = _v2.b;
									var dp = _v2.c;
									var title = function () {
										var _v4 = dp.e_;
										if (!_v4.$) {
											var suffix = _v4.a;
											return $elm$core$Maybe$Just(s.kt + (' ' + suffix));
										} else {
											return $elm$core$Maybe$Just(s.kt);
										}
									}();
									var label = A2($elm$core$Maybe$withDefault, category, dp.bL);
									return $elm$core$Maybe$Just(
										{
											aN: A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm_community$list_extra$List$Extra$getAt, dataPointIndex, categories)),
											f: A2($author$project$Chart$Shared$colorPreferenceWithFallback, s.f, dp.aC),
											fF: label,
											aQ: dp.aQ,
											dE: lower,
											dL: A3($author$project$Chart$Shared$barSegmentOpacity, maybeStatHighlight, s.kt, label),
											gq: s.r,
											d: title,
											i$: unit,
											d9: upper,
											aW: A2($elm$core$Maybe$withDefault, 0, dp.aW)
										});
								}),
							A3($elm_community$list_extra$List$Extra$zip3, barEnds, s.bZ, s.jA));
					},
					A2($elm$core$Dict$get, s.kt, renderableDataBySeriesName));
			},
			visibleSeries);
		if (!renderableSeries.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var list = renderableSeries;
			return $elm$core$Maybe$Just(list);
		}
	});
var $author$project$Chart$Shared$seriesSetToRenderableBarSegments = F4(
	function (categories, unit, maybeStatHighlight, categoricalData) {
		_v0$2:
		while (true) {
			switch (categoricalData.$) {
				case 0:
					if (!categoricalData.a.$) {
						var series = categoricalData.a.a;
						return $elm$core$Maybe$Just(
							$elm$core$List$singleton(
								A4($author$project$Chart$Shared$singleBarToRenderableBarSegments, categories, unit, maybeStatHighlight, series)));
					} else {
						break _v0$2;
					}
				case 1:
					var series = categoricalData.a;
					return A4($author$project$Chart$Shared$barGroupToRenderableBarSegments, categories, unit, maybeStatHighlight, series);
				default:
					break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Chart$Shared$toBarSegmentsByAxis = F4(
	function (sizes, categories, maybeStatHighlight, yAxisData) {
		var scale = A2($author$project$Chart$Shared$yScaleFromAxisData, sizes, yAxisData).a;
		var lineData = A2(
			$elm$core$List$map,
			$elm$core$Tuple$pair(yAxisData.o.d),
			$author$project$Chart$Shared$onlyFakeLineSeries(yAxisData.jA));
		var barSegments = A2(
			$elm$core$List$filterMap,
			A3($author$project$Chart$Shared$seriesSetToRenderableBarSegments, categories, yAxisData.o.d, maybeStatHighlight),
			yAxisData.jA);
		return _Utils_Tuple3(scale, barSegments, lineData);
	});
var $author$project$Chart$Shared$toBarSegments = F5(
	function (sizes, categories, maybeStatHighlight, primaryXAxisData, secondaryYAxisData) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A4($author$project$Chart$Shared$toBarSegmentsByAxis, sizes, categories, maybeStatHighlight, primaryXAxisData)),
					A2(
					$elm$core$Maybe$map,
					A3($author$project$Chart$Shared$toBarSegmentsByAxis, sizes, categories, maybeStatHighlight),
					secondaryYAxisData)
				]));
	});
var $author$project$Chart$Shared$viewVerticalBarChart = F7(
	function (translations, dimensionConfig, displaySecondaryStats, categories, maybeStatHighlight, primaryYAxisData, secondaryYAxisData) {
		var sizes = A4($author$project$Chart$Shared$calculateSizes, $author$project$Chart$Shared$discreteSeriesHasStats, primaryYAxisData, secondaryYAxisData, dimensionConfig);
		var scaleX = A2($author$project$Chart$Shared$categoricalXScale, sizes, categories);
		var toCoords = $author$project$Chart$Shared$discreteTimeDataToCoords(scaleX);
		var renderableData = A5($author$project$Chart$Shared$toBarSegments, sizes, categories, maybeStatHighlight, primaryYAxisData, secondaryYAxisData);
		var lineSizes = A2($author$project$Chart$Shared$lineSizesInCategoricalChart, scaleX, sizes);
		return _Utils_Tuple3(
			_List_fromArray(
				[
					A2(
					$author$project$Chart$Shared$backgroundView,
					sizes,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Events$onClick($author$project$Chart$Shared$DataBackgroundClicked),
							$author$project$Chart$Shared$cursorOverBackgroundListener
						])),
					A3($author$project$Chart$Shared$categoricalXAxisView, sizes, categories, scaleX),
					A4($author$project$Chart$Shared$categoricalYAxesView, translations, sizes, primaryYAxisData, secondaryYAxisData),
					A4($author$project$Chart$Shared$columns, translations, sizes, scaleX, renderableData),
					A3($author$project$Chart$Shared$discreteLines, lineSizes, toCoords, renderableData),
					A5($author$project$Chart$Shared$discretePoints, translations, lineSizes, categories, toCoords, renderableData),
					function () {
					if (!maybeStatHighlight.$) {
						var highlights = maybeStatHighlight.a;
						return A6($author$project$Chart$Shared$highlightedAverageLine, sizes, lineSizes, scaleX, primaryYAxisData, secondaryYAxisData, highlights);
					} else {
						return A2($elm_community$typed_svg$TypedSvg$g, _List_Nil, _List_Nil);
					}
				}()
				]),
			A4($author$project$Chart$Shared$discreteStatsSidebarView, translations, displaySecondaryStats, primaryYAxisData, secondaryYAxisData),
			sizes);
	});
var $author$project$Chart$Shared$viewKnownDimensions = F3(
	function (translations, dimensionConfig, state) {
		var viewOpts = function () {
			var _v1 = state.jA;
			switch (_v1.$) {
				case 0:
					var now = _v1.a;
					var primaryYAxisData = _v1.b;
					var secondaryYAxisData = _v1.c;
					var _v2 = A6($author$project$Chart$Shared$viewLineChart, translations, dimensionConfig, state.iU, now, primaryYAxisData, secondaryYAxisData);
					var chartElements = _v2.a;
					var sz = _v2.b;
					return {
						cF: $author$project$Chart$Shared$Clickable($author$project$Chart$Shared$LegendItemClicked),
						aV: sz,
						cW: $elm$core$Maybe$Nothing,
						dX: false,
						cY: chartElements,
						c3: $author$project$Chart$Shared$CursorMovedOverTooltip
					};
				case 1:
					if (!_v1.a) {
						var _v3 = _v1.a;
						var categories = _v1.b;
						var primaryYAxisData = _v1.c;
						var secondaryYAxisData = _v1.d;
						var _v4 = A7($author$project$Chart$Shared$viewVerticalBarChart, translations, dimensionConfig, state.fj, categories, state.bR, primaryYAxisData, secondaryYAxisData);
						var chartElements = _v4.a;
						var statsSidebar = _v4.b;
						var sz = _v4.c;
						return {
							cF: $author$project$Chart$Shared$Clickable($author$project$Chart$Shared$LegendItemClicked),
							aV: sz,
							cW: statsSidebar,
							dX: false,
							cY: chartElements,
							c3: $elm$core$Basics$always($author$project$Chart$Shared$IrrelevantMsg)
						};
					} else {
						var _v5 = _v1.a;
						var categories = _v1.b;
						var primaryYAxisData = _v1.c;
						var _v6 = A4($author$project$Chart$Shared$viewHorizontalBarChart, translations, dimensionConfig, categories, primaryYAxisData);
						var chartElements = _v6.a;
						var sz = _v6.b;
						return {
							cF: $author$project$Chart$Shared$Clickable($author$project$Chart$Shared$LegendItemClicked),
							aV: sz,
							cW: $elm$core$Maybe$Nothing,
							dX: true,
							cY: chartElements,
							c3: $elm$core$Basics$always($author$project$Chart$Shared$IrrelevantMsg)
						};
					}
				default:
					var yAxis = _v1.a;
					var currentData = _v1.b;
					var comparisonData = _v1.c;
					var _v7 = A5($author$project$Chart$Shared$viewPieChart, translations, dimensionConfig, yAxis, currentData, comparisonData);
					var chartElements = _v7.a;
					var sz = _v7.b;
					return {
						cF: $author$project$Chart$Shared$NotClickable,
						aV: sz,
						cW: $elm$core$Maybe$Nothing,
						dX: false,
						cY: chartElements,
						c3: $elm$core$Basics$always($author$project$Chart$Shared$IrrelevantMsg)
					};
			}
		}();
		var chartWithLegendErrorsAndOtherElements = _Utils_ap(
			A2($author$project$Chart$Shared$header, state.d, state.iO),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full flex justify-between items-start')
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$svg,
							_List_fromArray(
								[
									A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, viewOpts.aV.h, viewOpts.aV.p),
									$elm_community$typed_svg$TypedSvg$Attributes$class(
									_List_fromArray(
										['flex-1 overflow-visible'])),
									$elm$svg$Svg$Attributes$style(
									'max-width: ' + $author$project$Chart$Shared$px(viewOpts.aV.h))
								]),
							viewOpts.cY),
							function () {
							var _v0 = viewOpts.cW;
							if (_v0.$ === 1) {
								return $author$project$Enectiva$View$nothing;
							} else {
								var statsSidebar = _v0.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pl-2 md:pl-4 lg:pl-8 box-content w-1/4 mt-5')
										]),
									_List_fromArray(
										[statsSidebar]));
							}
						}()
						])),
					A3($author$project$Chart$Shared$serverErrorsView, translations, viewOpts.aV, state.iE),
					A3($author$project$Chart$Shared$processingInfoView, translations, viewOpts.aV, state.jA),
					A3($author$project$Chart$Shared$additionalInfoView, translations, viewOpts.aV, state.gR),
					A3($author$project$Chart$Shared$legendView, state.jA, viewOpts.cF, viewOpts.dX),
					A3($author$project$Chart$Shared$tooltipView, translations, state.K, viewOpts.c3)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white min-w-48 loaded-chart')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Chart$Shared$container, state, chartWithLegendErrorsAndOtherElements)
					]),
				_List_fromArray(
					[
						A3($author$project$Chart$Shared$tableViewState, translations, state.iP, state)
					])));
	});
var $author$project$Chart$Shared$view = F2(
	function (translations, model) {
		if (!model.$) {
			var state = model.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Chart$Shared$container, state, _List_Nil)
					]));
		} else {
			var dimensionConfig = model.a;
			var state = model.b;
			return A3($author$project$Chart$Shared$viewKnownDimensions, translations, dimensionConfig, state);
		}
	});
var $author$project$Chart$SingleEntity$classes = _List_fromArray(
	['below-theoretical', 'excess']);
var $author$project$Chart$SingleEntity$column = F2(
	function (xScale, _v0) {
		var month = _v0.a;
		var values = _v0.b;
		var block = F2(
			function (barClass, _v1) {
				var upperY = _v1.a;
				var lowerY = _v1.b;
				return A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
							A2($gampleman$elm_visualization$Scale$convert, xScale, month)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$List$minimum(
									_List_fromArray(
										[lowerY, upperY])))),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
							$gampleman$elm_visualization$Scale$bandwidth(xScale)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(
							$elm$core$Basics$abs(upperY - lowerY)),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								[barClass]))
						]),
					_List_Nil);
			});
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['column']))
				]),
			A3($elm$core$List$map2, block, $author$project$Chart$SingleEntity$classes, values));
	});
var $author$project$Chart$SingleEntity$series = _List_fromArray(
	[
		{
		e2: function (cd) {
			var _v0 = cd.dZ;
			if (!_v0.$) {
				var tc = _v0.a;
				return A2($elm$core$Basics$min, cd.e3, tc);
			} else {
				return cd.e3;
			}
		},
		fF: 'basic'
	},
		{
		e2: function (cd) {
			var _v1 = cd.dZ;
			if (!_v1.$) {
				var tc = _v1.a;
				return A2($elm$core$Basics$max, cd.e3 - tc, 0);
			} else {
				return 0;
			}
		},
		fF: 'excess'
	}
	]);
var $author$project$Chart$SingleEntity$samples = function (points) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var label = _v0.fF;
			var accessor = _v0.e2;
			return _Utils_Tuple2(
				label,
				A2($elm$core$List$map, accessor, points));
		},
		$author$project$Chart$SingleEntity$series);
};
var $author$project$Chart$SingleEntity$config = function (points) {
	return {
		jA: $author$project$Chart$SingleEntity$samples(points),
		kG: $gampleman$elm_visualization$Shape$stackOffsetNone,
		kL: $elm$core$Basics$identity
	};
};
var $author$project$Chart$SingleEntity$theoreticalCurve = F2(
	function (shape, points) {
		return function (path) {
			return A2(
				$folkertdev$one_true_path_experiment$Path$element,
				path,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['line'])),
						$elm_community$typed_svg$TypedSvg$Attributes$noFill,
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(2)
					]));
		}(
			A2($gampleman$elm_visualization$Shape$line, shape, points));
	});
var $author$project$Chart$SingleEntity$drawTheoreticalCurve = $author$project$Chart$SingleEntity$theoreticalCurve($gampleman$elm_visualization$Shape$monotoneInXCurve);
var $elm$svg$Svg$Attributes$dx = _VirtualDom_attribute('dx');
var $author$project$Chart$SingleEntity$h = 400;
var $author$project$Chart$SingleEntity$padding = {fa: 60, ca: 60, gl: 30, ci: 30};
var $gampleman$elm_visualization$Shape$linearCurve = $folkertdev$one_true_path_experiment$Curve$linear;
var $author$project$Chart$SingleEntity$theoreticalLegendCurve = A2(
	$author$project$Chart$SingleEntity$theoreticalCurve,
	$gampleman$elm_visualization$Shape$linearCurve,
	_List_fromArray(
		[
			$elm$core$Maybe$Just(
			_Utils_Tuple2(0, 0)),
			$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 0))
		]));
var $author$project$Chart$SingleEntity$w = 1000;
var $author$project$Chart$SingleEntity$yGridLine = F3(
	function (yScale, index, tick) {
		return A2(
			$elm_community$typed_svg$TypedSvg$line,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1($author$project$Chart$SingleEntity$padding.ca),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2($author$project$Chart$SingleEntity$w - $author$project$Chart$SingleEntity$padding.gl),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(
					$author$project$Chart$SingleEntity$padding.ci + A2($gampleman$elm_visualization$Scale$convert, yScale, tick)),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2(
					$author$project$Chart$SingleEntity$padding.ci + A2($gampleman$elm_visualization$Scale$convert, yScale, tick)),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['horizontal-grid-line'])),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(0.5)
				]),
			_List_Nil);
	});
var $author$project$Chart$SingleEntity$view = F2(
	function (translations, model) {
		var points = model.ib;
		var timeZone = model.iU;
		var theoretical = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dZ;
				},
				points));
		var months = A2(
			$elm$core$List$map,
			function ($) {
				return $.hW;
			},
			points);
		var xScale = A3(
			$gampleman$elm_visualization$Scale$band,
			_Utils_update(
				$gampleman$elm_visualization$Scale$defaultBandConfig,
				{kO: 0.35, kP: 0.35}),
			_Utils_Tuple2(0, $author$project$Chart$SingleEntity$w - ($author$project$Chart$SingleEntity$padding.ci + $author$project$Chart$SingleEntity$padding.fa)),
			months);
		var minTheoretical = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$minimum(theoretical));
		var maxTheoretical = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(theoretical));
		var formatDate = A2(
			$elm$core$Basics$composeR,
			$author$project$Enectiva$I18n$dateToMidnight,
			A3($author$project$Enectiva$I18n$formatTimeCustom, 'month', translations, timeZone));
		var _v0 = $gampleman$elm_visualization$Shape$stack(
			$author$project$Chart$SingleEntity$config(points));
		var values = _v0.lB;
		var labels = _v0.kb;
		var extent = _v0.jQ;
		var _v1 = extent;
		var minBar = _v1.a;
		var maxBar = _v1.b;
		var totalExtent = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$minimum(
					_List_fromArray(
						[minBar, minTheoretical]))),
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					_List_fromArray(
						[maxBar, maxTheoretical]))));
		var yScale = A2(
			$gampleman$elm_visualization$Scale$nice,
			4,
			A2(
				$gampleman$elm_visualization$Scale$linear,
				_Utils_Tuple2($author$project$Chart$SingleEntity$h - ($author$project$Chart$SingleEntity$padding.ca + $author$project$Chart$SingleEntity$padding.gl), 0),
				totalExtent));
		var monthValues = $elm_community$list_extra$List$Extra$transpose(values);
		var scaledValues = A2(
			$elm$core$List$map,
			$elm$core$List$map(
				function (_v5) {
					var y1 = _v5.a;
					var y2 = _v5.b;
					return _Utils_Tuple2(
						A2($gampleman$elm_visualization$Scale$convert, yScale, y1),
						A2($gampleman$elm_visualization$Scale$convert, yScale, y2));
				}),
			monthValues);
		return A2(
			$elm_community$typed_svg$TypedSvg$svg,
			_List_fromArray(
				[
					A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, $author$project$Chart$SingleEntity$w, $author$project$Chart$SingleEntity$h),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['bar-chart']))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Chart$SingleEntity$yGridLine(yScale),
						A2($gampleman$elm_visualization$Scale$ticks, yScale, 10))),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$SingleEntity$padding.ca - 1, $author$project$Chart$SingleEntity$h - $author$project$Chart$SingleEntity$padding.fa)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['x-axis']))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$bottom,
							_List_fromArray(
								[
									$gampleman$elm_visualization$Axis$tickCount(10)
								]),
							A2($gampleman$elm_visualization$Scale$toRenderable, formatDate, xScale))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$SingleEntity$padding.ca, $author$project$Chart$SingleEntity$padding.ci)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['y-axis']))
						]),
					_List_fromArray(
						[
							A2($gampleman$elm_visualization$Axis$left, _List_Nil, yScale)
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$SingleEntity$padding.ca, $author$project$Chart$SingleEntity$padding.ci / 2.5)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['y-axis-unit']))
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fontSize('10'),
									$elm$svg$Svg$Attributes$fontFamily('sans-serif'),
									$elm$svg$Svg$Attributes$textAnchor('end'),
									$elm$svg$Svg$Attributes$x('-9')
								]),
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Core$text(model.i$)
								]))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$SingleEntity$padding.ca, $author$project$Chart$SingleEntity$padding.ci)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['series']))
						]),
					A2(
						$elm$core$List$map,
						$author$project$Chart$SingleEntity$column(xScale),
						A3(
							$elm$core$List$map2,
							F2(
								function (a, b) {
									return _Utils_Tuple2(a, b);
								}),
							months,
							scaledValues))),
					A2(
					$author$project$Enectiva$View$viewIf,
					function (_v2) {
						var theoreticalPoints = A2(
							$elm$core$List$map,
							function (cd) {
								var _v3 = cd.dZ;
								if (!_v3.$) {
									var tc = _v3.a;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											A2($gampleman$elm_visualization$Scale$convert, xScale, cd.hW),
											A2($gampleman$elm_visualization$Scale$convert, yScale, tc)));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							points);
						return A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$transform(
									_List_fromArray(
										[
											A2(
											$elm_community$typed_svg$TypedSvg$Types$Translate,
											$author$project$Chart$SingleEntity$padding.ca + ($gampleman$elm_visualization$Scale$bandwidth(xScale) / 2),
											$author$project$Chart$SingleEntity$padding.ci)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Chart$SingleEntity$drawTheoreticalCurve(theoreticalPoints)
								]));
					},
					model.fD),
					A2(
					$author$project$Enectiva$View$viewIf,
					function (_v4) {
						return A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$transform(
									_List_fromArray(
										[
											A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Chart$SingleEntity$padding.ca, $author$project$Chart$SingleEntity$h - ($author$project$Chart$SingleEntity$padding.fa / 3))
										])),
									$elm_community$typed_svg$TypedSvg$Attributes$class(
									_List_fromArray(
										['legend']))
								]),
							_List_fromArray(
								[
									A2(
									$elm_community$typed_svg$TypedSvg$text_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$fontSize('10'),
											$elm$svg$Svg$Attributes$fontFamily('sans-serif'),
											$elm$svg$Svg$Attributes$textAnchor('start'),
											$elm$svg$Svg$Attributes$dx('20')
										]),
									_List_fromArray(
										[
											$elm_community$typed_svg$TypedSvg$Core$text(
											A2($author$project$Enectiva$I18n$t, translations, 'report.individual_energies.v1.theoretical_consumption'))
										])),
									A2(
									$elm_community$typed_svg$TypedSvg$g,
									_List_fromArray(
										[
											$elm_community$typed_svg$TypedSvg$Attributes$transform(
											_List_fromArray(
												[
													A2($elm_community$typed_svg$TypedSvg$Types$Translate, 0, -3)
												]))
										]),
									_List_fromArray(
										[$author$project$Chart$SingleEntity$theoreticalLegendCurve]))
								]));
					},
					model.fD)
				]));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ParentMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Desc = 1;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Duration = 2;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Sort = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Time = 1;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationInMinutesIsBetween = F2(
	function (_v0, range) {
		var min = _v0.Z;
		var max = _v0.S;
		return (_Utils_cmp(min, range.B) < 1) && (_Utils_cmp(range.B, max) < 0);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventTableColumnName = F2(
	function (translations, key) {
		return A2($author$project$Enectiva$I18n$t, translations, 'stats.binary_analysis.' + key);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$EventRowEntered = function (a) {
	return {$: 5, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$EventRowLeft = {$: 6};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minutesString = F2(
	function (translations, n) {
		var hours = (n / 60) | 0;
		if (hours > 0) {
			var minutes = n - (hours * 60);
			return $elm$core$String$fromInt(hours) + (' ' + (A2($author$project$Enectiva$I18n$t, translations, 'time.units.hours') + (' ' + ($elm$core$String$fromInt(minutes) + (' ' + A2($author$project$Enectiva$I18n$t, translations, 'time.units.minutes'))))));
		} else {
			return $elm$core$String$fromInt(n) + ' min';
		}
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationString = F2(
	function (translations, interval) {
		return A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minutesString, translations, interval.B);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventIsHighlighted = F2(
	function (highlight, event) {
		switch (highlight.$) {
			case 0:
				return false;
			case 1:
				var eh = highlight.a;
				return _Utils_eq(eh, event);
			default:
				var rh = highlight.a;
				return A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationInMinutesIsBetween, rh, event.cO);
		}
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$intervalRangeString = F3(
	function (translations, timeZone, _v0) {
		var from = _v0.jT;
		var to = _v0.lj;
		return A3($author$project$Enectiva$I18n$formatTime, translations, timeZone, from) + (' - ' + A3($author$project$Enectiva$I18n$formatTime, translations, timeZone, to));
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventTableRow = F5(
	function (translations, timeZone, highlight, i, event) {
		var seriesName = event.aJ;
		var range = event.cO;
		var bgColor = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventIsHighlighted, highlight, event) ? 'bg-orange-500' : ((!A2($elm$core$Basics$modBy, 2, i)) ? '' : 'bg-grey-200');
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Events$onMouseEnter(
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$EventRowEntered(event)),
					$elm$html$Html$Events$onMouseLeave($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$EventRowLeft),
					$elm$html$Html$Attributes$class('fast-colors-transition'),
					$elm$html$Html$Attributes$class(bgColor)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(seriesName)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$intervalRangeString, translations, timeZone, range))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationString, translations, range))
						]))
				]));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$isSortActive = F3(
	function (sortBy, dir, sorting) {
		return _Utils_eq(sortBy, sorting.dV) && _Utils_eq(dir, sorting.dr);
	});
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$compareByTime = F2(
	function (a, b) {
		return A2(
			$elm$core$Basics$compare,
			$elm$time$Time$posixToMillis(a.cO.jT),
			$elm$time$Time$posixToMillis(b.cO.jT));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$flippedComparison = F3(
	function (base, a, b) {
		var _v0 = A2(base, a, b);
		switch (_v0) {
			case 0:
				return 2;
			case 1:
				return 1;
			default:
				return 0;
		}
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$sorter = function (_v0) {
	var sortBy = _v0.dV;
	var direction = _v0.dr;
	var baseSorter = function () {
		switch (sortBy) {
			case 2:
				return F2(
					function (a, b) {
						return A2($elm$core$Basics$compare, a.cO.B, b.cO.B);
					});
			case 1:
				return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$compareByTime;
			default:
				return F2(
					function (a, b) {
						var _v3 = A2($elm$core$Basics$compare, a.aJ, b.aJ);
						if (_v3 === 1) {
							return A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$compareByTime, a, b);
						} else {
							var order = _v3;
							return order;
						}
					});
		}
	}();
	if (!direction) {
		return baseSorter;
	} else {
		return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$flippedComparison(baseSorter);
	}
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$sortEvents = function (sorting) {
	return $elm$core$List$sortWith(
		$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$sorter(sorting));
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$toEvents = $elm$core$List$concatMap(
	function (_v0) {
		var name = _v0.kt;
		var data = _v0.jA;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var range = _v1.cO;
				var reliability = _v1.cg;
				return {cO: range, cg: reliability, aJ: name};
			},
			data);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventsTable = F3(
	function (translations, interactivity, _v0) {
		var series = _v0.iD;
		var sorting = _v0.eV;
		var durationFilter = _v0.bB;
		var highlight = _v0.aO;
		var timeZone = _v0.iU;
		var dataRows = A2(
			$elm$core$List$indexedMap,
			$elm$html$Html$Lazy$lazy2(
				A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventTableRow, translations, timeZone, highlight)),
			A2(
				$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$sortEvents,
				sorting,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.cO;
						},
						$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationInMinutesIsBetween(durationFilter)),
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$toEvents(series))));
		var cell = F2(
			function (sortBy, key) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sticky top-0 p-2 bg-grey-300')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center gap-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventTableColumnName, translations, key)),
									A2(
									$author$project$Enectiva$View$viewIf,
									$elm$core$Basics$always(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col text-grey-500')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('button'),
															$elm$html$Html$Attributes$class('inline-block leading-none hover:text-black focus:text-black'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'text-grey-700',
																	A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$isSortActive, sortBy, 0, sorting))
																])),
															$elm$html$Html$Events$onClick(
															A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Sort, sortBy, 0))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('▲')
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('button'),
															$elm$html$Html$Attributes$class('inline-block leading-none hover:text-black focus:text-black'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'text-grey-700',
																	A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$isSortActive, sortBy, 1, sorting))
																])),
															$elm$html$Html$Events$onClick(
															A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Sort, sortBy, 1))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('▼\n')
														]))
												]))),
									!_Utils_eq(interactivity, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NotInteractive))
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list max-h-184 overflow-auto relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(cell, 0, 'series'),
											A2(cell, 1, 'event.time'),
											A2(cell, 2, 'event.duration')
										]))
								])),
							A2($elm$html$Html$tbody, _List_Nil, dataRows)
						]))
				]));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$HistogramThumbDragged = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Lower = 0;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$RangeBarEntered = function (a) {
	return {$: 7, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$RangeBarLeft = {$: 8};
var $author$project$ChartAndControlSet$DoubleRange$Step = $elm$core$Basics$identity;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$Upper = 1;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$asPercent = function (n) {
	return $elm$core$String$fromFloat(n * 100) + '%';
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketIsInRange = F2(
	function (idx, _v0) {
		var min = _v0.Z;
		var max = _v0.S;
		var lowerBound = idx * $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration;
		var upperBound = lowerBound + $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration;
		return (_Utils_cmp(min, lowerBound) < 1) && (_Utils_cmp(upperBound, max) < 1);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationFilterRangeView = F2(
	function (translations, _v0) {
		var min = _v0.Z;
		var max = _v0.S;
		var upperBound = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minutesString, translations, max);
		var lowerBound = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minutesString, translations, min);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(lowerBound + (' – ' + upperBound))
				]));
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$incrementBucket = F3(
	function (lastBucketIndex, duration, bs) {
		var idx = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$minimum(
				_List_fromArray(
					[(duration / $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration) | 0, lastBucketIndex])));
		var currentValue = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, idx, bs));
		return A3($elm$core$Array$set, idx, currentValue + 1, bs);
	});
var $author$project$View$newline = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(10));
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$rangeIsHighlighted = F2(
	function (highlight, range) {
		switch (highlight.$) {
			case 0:
				return false;
			case 2:
				var rh = highlight.a;
				return _Utils_eq(rh, range);
			default:
				var event = highlight.a;
				return A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationInMinutesIsBetween, range, event.cO);
		}
	});
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $author$project$ChartAndControlSet$DoubleRange$activeColor = '#1c3d5a';
var $author$project$ChartAndControlSet$DoubleRange$inactiveColor = '#bababa';
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$View$intTargetValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $elm$core$String$toInt(s);
		if (!_v0.$) {
			var i = _v0.a;
			return $elm$json$Json$Decode$succeed(i);
		} else {
			return $elm$json$Json$Decode$fail('Invalid int string `' + (s + '`'));
		}
	},
	$elm$html$Html$Events$targetValue);
var $author$project$ChartAndControlSet$DoubleRange$stepDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$View$intTargetValueDecoder);
var $author$project$ChartAndControlSet$DoubleRange$stepToString = function (_v0) {
	var s = _v0;
	return $elm$core$String$fromInt(s);
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$ChartAndControlSet$DoubleRange$slider = function (config) {
	var upperId = config.ex + 'upper';
	var lowerId = config.ex + 'lower';
	var _v0 = config.lx;
	var upperStep = _v0;
	var _v1 = config.kq;
	var minStep = _v1;
	var _v2 = config.kl;
	var maxStep = _v2;
	var stepPercentage = function (n) {
		return n / 100;
	}(
		$elm$core$Basics$round(((config.k9 / (maxStep - minStep)) * 100) * 100));
	var _v3 = config.kf;
	var lowerStep = _v3;
	var split = A2(
		$elm$core$Maybe$withDefault,
		config.k9,
		$elm$core$List$minimum(
			_List_fromArray(
				[
					($elm$core$Basics$round(((upperStep - lowerStep) / 2) / config.k9) * config.k9) + lowerStep,
					maxStep - config.k9
				])));
	var lowerThumbRelativePosition = (lowerStep / split) * 100;
	var upperThumbRelativePosition = ((upperStep - split) / (maxStep - split)) * 100;
	var _v4 = config.j6 ? _Utils_Tuple2($author$project$ChartAndControlSet$DoubleRange$activeColor, $author$project$ChartAndControlSet$DoubleRange$inactiveColor) : _Utils_Tuple2($author$project$ChartAndControlSet$DoubleRange$inactiveColor, $author$project$ChartAndControlSet$DoubleRange$activeColor);
	var outColor = _v4.a;
	var inColor = _v4.b;
	var lowerGradient = 'linear-gradient(90deg,  ' + (outColor + (' 0%, ' + (outColor + (' ' + ($elm$core$String$fromFloat(lowerThumbRelativePosition) + ('%, ' + (inColor + (' ' + ($elm$core$String$fromFloat(lowerThumbRelativePosition) + '%)')))))))));
	var upperGradient = 'linear-gradient(90deg, ' + (inColor + (' 0%, ' + (inColor + (' ' + ($elm$core$String$fromFloat(upperThumbRelativePosition) + ('%,  ' + (outColor + (' ' + ($elm$core$String$fromFloat(upperThumbRelativePosition) + '%)')))))))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('range-slider'),
				$elm$html$Html$Attributes$class(config.j_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(lowerId),
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$min(
						$author$project$ChartAndControlSet$DoubleRange$stepToString(config.kq)),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromInt(split)),
						$elm$html$Html$Attributes$step(
						$elm$core$String$fromInt(config.k9)),
						$elm$html$Html$Attributes$value(config.kh),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromFloat(stepPercentage * ((split / config.k9) | 0)) + '%'),
						A2(
						$elm$html$Html$Events$on,
						'input',
						A2($elm$json$Json$Decode$map, config.kg, $author$project$ChartAndControlSet$DoubleRange$stepDecoder)),
						A2(
						$elm$html$Html$Events$on,
						'change',
						A2($elm$json$Json$Decode$map, config.kg, $author$project$ChartAndControlSet$DoubleRange$stepDecoder))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(upperId),
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$min(
						$elm$core$String$fromInt(split)),
						$elm$html$Html$Attributes$max(
						$author$project$ChartAndControlSet$DoubleRange$stepToString(config.kl)),
						$elm$html$Html$Attributes$step(
						$elm$core$String$fromInt(config.k9)),
						$elm$html$Html$Attributes$value(config.lz),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromFloat(100 - (stepPercentage * ((split / config.k9) | 0))) + '%'),
						A2(
						$elm$html$Html$Events$on,
						'input',
						A2($elm$json$Json$Decode$map, config.ly, $author$project$ChartAndControlSet$DoubleRange$stepDecoder)),
						A2(
						$elm$html$Html$Events$on,
						'change',
						A2($elm$json$Json$Decode$map, config.ly, $author$project$ChartAndControlSet$DoubleRange$stepDecoder))
					]),
				_List_Nil),
				A3(
				$elm$html$Html$node,
				'style',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text/css')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('#' + (lowerId + ('::-webkit-slider-runnable-track{background:' + (lowerGradient + '}')))),
						$elm$html$Html$text('#' + (upperId + ('::-webkit-slider-runnable-track{background:' + (upperGradient + '}')))),
						$elm$html$Html$text('#' + (lowerId + ('::-moz-range-track{background:' + (lowerGradient + '}')))),
						$elm$html$Html$text('#' + (upperId + ('::-moz-range-track{background:' + (upperGradient + '}'))))
					]))
			]));
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$histogram = F2(
	function (translations, _v0) {
		var series = _v0.iD;
		var histogramPolicy = _v0.ew;
		var domain = _v0.ep;
		var durationFilter = _v0.bB;
		var idPrefix = _v0.ex;
		var highlight = _v0.aO;
		var tooltipText = F2(
			function (_v4, count) {
				var min = _v4.Z;
				var max = _v4.S;
				return $elm$core$String$fromInt(count) + ('× ' + ($author$project$View$newline + (A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minutesString, translations, min) + (' – ' + A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$minutesString, translations, max)))));
			});
		var durations = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.cO;
				},
				function ($) {
					return $.B;
				}),
			$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$toEvents(series));
		var bufferSoThatColumnIsVisibleBehindSlider = 0.02;
		var barRange = F2(
			function (idx, _v3) {
				var lowerBound = idx * $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration;
				var upperBound = _Utils_eq(idx + 1, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$maxBuckets) ? domain.S : (lowerBound + $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration);
				return {S: upperBound, Z: lowerBound};
			});
		var _v1 = function () {
			if (histogramPolicy.$ === 1) {
				return _Utils_Tuple3(
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$maxBuckets,
					{S: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$shortenedScaleMax, Z: domain.Z},
					{
						S: A2(
							$elm$core$Maybe$withDefault,
							$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$shortenedScaleMax,
							$elm$core$List$minimum(
								_List_fromArray(
									[durationFilter.S, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$shortenedScaleMax]))),
						Z: durationFilter.Z
					});
			} else {
				var bs = histogramPolicy.a;
				return _Utils_Tuple3(bs, domain, durationFilter);
			}
		}();
		var numberOfBuckets = _v1.a;
		var scaledDomain = _v1.b;
		var scaledDurationFilter = _v1.c;
		var barWidth = $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$asPercent(1.0 / numberOfBuckets);
		var buckets = $elm$core$Array$toList(
			A3(
				$elm$core$List$foldl,
				$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$incrementBucket(numberOfBuckets - 1),
				A2($elm$core$Array$repeat, numberOfBuckets, 0),
				durations));
		var maxCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(buckets));
		var bars = A2(
			$elm$core$List$indexedMap,
			F2(
				function (idx, count) {
					var range = A2(barRange, idx, count);
					var height = (!count) ? 0 : ((count / maxCount) + bufferSoThatColumnIsVisibleBehindSlider);
					var bgColor = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$rangeIsHighlighted, highlight, range) ? 'bg-orange-500' : (A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketIsInRange, idx, durationFilter) ? 'bg-blue-700' : 'bg-grey-500 filtered-out-texture');
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute bottom-0 border-box fast-colors-transition rounded-t'),
								$elm$html$Html$Attributes$class('group'),
								$elm$html$Html$Attributes$class(bgColor),
								A2(
								$elm$html$Html$Attributes$style,
								'height',
								$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$asPercent(height)),
								A2(
								$elm$html$Html$Attributes$style,
								'left',
								$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$asPercent(idx / numberOfBuckets)),
								A2($elm$html$Html$Attributes$style, 'width', barWidth),
								$elm$html$Html$Attributes$title(
								A2(tooltipText, range, count)),
								$elm$html$Html$Events$onMouseEnter(
								$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$RangeBarEntered(range)),
								$elm$html$Html$Events$onMouseLeave($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$RangeBarLeft)
							]),
						(count > 0) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute font-bold text-center w-full text-transparent -mt-6'),
										$elm$html$Html$Attributes$class(
										A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketIsInRange, idx, durationFilter) ? 'group-hover:text-blue-700' : 'group-hover:text-grey-500')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(count) + '×')
									]))
							]) : _List_Nil);
				}),
			buckets);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center flex-auto max-w-md px-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-blue-700 text-base')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Enectiva$I18n$t, translations, 'stats.binary_analysis.event_duration_histogram'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2 w-full h-64 flex flex-col')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grow relative flex gap-px')
								]),
							bars),
							$author$project$ChartAndControlSet$DoubleRange$slider(
							{
								j_: 'h-4 grow-0 shrink-0',
								ex: idPrefix,
								j6: false,
								kf: scaledDurationFilter.Z,
								kg: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$HistogramThumbDragged(0),
								kh: $elm$core$String$fromInt(durationFilter.Z),
								kl: scaledDomain.S,
								kq: scaledDomain.Z,
								k9: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$bucketDuration,
								lx: scaledDurationFilter.S,
								ly: $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$HistogramThumbDragged(1),
								lz: $elm$core$String$fromInt(durationFilter.S)
							})
						])),
					A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationFilterRangeView, translations, durationFilter)
				]));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$detailsHelp = F3(
	function (translations, interactivity, chart) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between gap-8')
				]),
			_List_fromArray(
				[
					A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventsTable, translations, interactivity, chart),
					A2(
					$author$project$Enectiva$View$viewIf,
					$elm$core$Basics$always(
						A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$histogram, translations, chart)),
					!_Utils_eq(interactivity, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NotInteractive))
				]));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ToggleDetails = {$: 2};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$toggleDetailsButton = function (translations) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'click',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ToggleDetails, true))),
				$elm$html$Html$Attributes$class('link')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($author$project$Enectiva$I18n$t, translations, 'stats.binary_analysis.toggle_details'))
			]));
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$details = F3(
	function (translations, interactivity, chart) {
		var someData = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq(0),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jA;
					},
					$elm$core$List$length),
				chart.iD));
		var downloadButton = function () {
			if (interactivity.$ === 1) {
				var button = interactivity.a;
				return A2($elm$html$Html$map, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ParentMsg, button);
			} else {
				return $author$project$Enectiva$View$nothing;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row-reverse justify-between w-full')
						]),
					_List_fromArray(
						[
							downloadButton,
							function () {
							var _v0 = _Utils_Tuple2(interactivity, someData);
							if ((_v0.a.$ === 1) && _v0.b) {
								return $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$toggleDetailsButton(translations);
							} else {
								return $author$project$Enectiva$View$nothing;
							}
						}()
						])),
					A2(
					$author$project$Enectiva$View$viewIf,
					$elm$core$Basics$always(
						A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$detailsHelp, translations, interactivity, chart)),
					chart.dq)
				]));
	});
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeNoData = F3(
	function (translations, offset, width) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-grey-500 filtered-out-texture w-full h-full absolute'),
					$elm$html$Html$Attributes$title(
					A2($author$project$Enectiva$I18n$t, translations, 'stats.binary_analysis.no_data')),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$asPercent(width)),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$asPercent(offset))
				]),
			_List_Nil);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeBaseline = F3(
	function (translations, chart, maybeRange) {
		var noDataRanges = function () {
			if (maybeRange.$ === 1) {
				return _List_fromArray(
					[
						A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeNoData, translations, 0, 1)
					]);
			} else {
				var range = maybeRange.a;
				if (_Utils_eq(range, chart.cO)) {
					return _List_Nil;
				} else {
					var rightMissingDataRange = A2(
						$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$newTimeRange,
						$elm$time$Time$posixToMillis(range.lj),
						$elm$time$Time$posixToMillis(chart.cO.lj));
					var leftMissingDataRange = A2(
						$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$newTimeRange,
						$elm$time$Time$posixToMillis(chart.cO.jT),
						$elm$time$Time$posixToMillis(range.jT));
					var leftStrip = (!leftMissingDataRange.B) ? _List_Nil : _List_fromArray(
						[
							A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeNoData, translations, 0, leftMissingDataRange.B / chart.cO.B)
						]);
					var rightStrip = (!rightMissingDataRange.B) ? _List_Nil : _List_fromArray(
						[
							A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeNoData, translations, (leftMissingDataRange.B + range.B) / chart.cO.B, rightMissingDataRange.B / chart.cO.B)
						]);
					return _Utils_ap(leftStrip, rightStrip);
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-blue-200 h-2 absolute w-full rounded mt-3')
				]),
			noDataRanges);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$StripeEntered = function (a) {
	return {$: 3, a: a};
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$StripeLeft = {$: 4};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$timeRangeRatio = F2(
	function (dividend, divisor) {
		return (dividend.B / divisor.B) * 100;
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeInterval = F5(
	function (translations, monitoredValueLabel, _v0, seriesName, interval) {
		var range = _v0.cO;
		var durationFilter = _v0.bB;
		var highlight = _v0.aO;
		var timeZone = _v0.iU;
		var title = function (tit) {
			return A2(
				$elm$core$Maybe$withDefault,
				tit,
				A2(
					$elm$core$Maybe$map,
					function (c) {
						return _Utils_ap(
							tit,
							_Utils_ap(
								$author$project$View$newline,
								A3(
									$author$project$Enectiva$I18n$tt,
									translations,
									'stats.binary_analysis.reliability',
									_List_fromArray(
										[
											A2(
											$author$project$Enectiva$I18n$Placeholder,
											'reliability',
											A2($author$project$Enectiva$I18n$formatNumber, translations, c * 100))
										]))));
					},
					interval.cg));
		}(
			monitoredValueLabel + (' ' + (A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationString, translations, interval.cO) + ($author$project$View$newline + A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$intervalRangeString, translations, timeZone, interval.cO)))));
		var intervalWidth = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$timeRangeRatio, interval.cO, range);
		var event = {cO: interval.cO, cg: interval.cg, aJ: seriesName};
		var bgColor = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$eventIsHighlighted, highlight, event) ? 'bg-orange-500' : ((!A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$durationInMinutesIsBetween, durationFilter, interval.cO)) ? 'filtered-out-texture bg-grey-500' : 'bg-blue-700');
		var beginningOffsetRange = A2(
			$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$newTimeRange,
			$elm$time$Time$posixToMillis(range.jT),
			$elm$time$Time$posixToMillis(interval.cO.jT));
		var beginningOffset = A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$timeRangeRatio, beginningOffsetRange, range);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute h-full min-w-px fast-colors-transition z-10 rounded'),
					$elm$html$Html$Attributes$class(bgColor),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromFloat(intervalWidth) + '%'),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$elm$core$String$fromFloat(beginningOffset) + '%'),
					$elm$html$Html$Attributes$title(title),
					$elm$html$Html$Events$onMouseEnter(
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$StripeEntered(event)),
					$elm$html$Html$Events$onMouseLeave($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$StripeLeft)
				]),
			_List_Nil);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripe = F3(
	function (translations, chart, _v0) {
		var name = _v0.kt;
		var monitoredValueLabel = _v0.hV;
		var data = _v0.jA;
		var dataRange = _v0.g9;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative h-8')
				]),
			A2(
				$elm$core$List$cons,
				A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeBaseline, translations, chart, dataRange),
				A2(
					$elm$core$List$map,
					A4($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripeInterval, translations, monitoredValueLabel, chart, name),
					data)));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$tickView = F5(
	function (translations, timeZone, offset, time, isAtLastGuide) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-24 text-center -ml-12 absolute bg-white hover:z-10'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('-ml-24 text-right', isAtLastGuide)
						])),
					A2($elm$html$Html$Attributes$style, 'left', offset)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Enectiva$I18n$formatTime, translations, timeZone, time))
				]));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$sixHours = 360;
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticksWithDistanceHelp = F4(
	function (distance, low, high, list) {
		ticksWithDistanceHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$time$Time$posixToMillis(low),
				$elm$time$Time$posixToMillis(high)) > 0) {
				return list;
			} else {
				var newLow = $elm$time$Time$millisToPosix(
					((distance * 1000) * 60) + $elm$time$Time$posixToMillis(low));
				var $temp$distance = distance,
					$temp$low = newLow,
					$temp$high = high,
					$temp$list = _Utils_ap(
					list,
					_List_fromArray(
						[low]));
				distance = $temp$distance;
				low = $temp$low;
				high = $temp$high;
				list = $temp$list;
				continue ticksWithDistanceHelp;
			}
		}
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticksWithDistance = F2(
	function (distance, _v0) {
		var from = _v0.jT;
		var to = _v0.lj;
		return A4($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticksWithDistanceHelp, distance, from, to, _List_Nil);
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticksHelp = F2(
	function (candidate, range) {
		ticksHelp:
		while (true) {
			var stepCount = (range.B / candidate) | 0;
			if (stepCount <= 16) {
				return A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticksWithDistance, candidate, range);
			} else {
				var $temp$candidate = candidate * 2,
					$temp$range = range;
				candidate = $temp$candidate;
				range = $temp$range;
				continue ticksHelp;
			}
		}
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticks = function (_v0) {
	var range = _v0.cO;
	return A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticksHelp, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$sixHours, range);
};
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripes = F2(
	function (translations, chart) {
		var strps = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-3')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripe, translations, chart),
				chart.iD));
		var numberOfGuideLines = $elm$core$List$length(
			$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticks(chart));
		var spacing = 100.0 / (numberOfGuideLines - 1);
		var leftOffset = function (idx) {
			return $elm$core$String$fromFloat(idx * spacing) + '%';
		};
		var tickLabels = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full relative text-grey-500 h-12')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (idx, time) {
							return (!A2($elm$core$Basics$modBy, 2, idx)) ? $elm$core$Maybe$Just(
								A5(
									$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$tickView,
									translations,
									chart.iU,
									leftOffset(idx),
									time,
									_Utils_eq(idx, numberOfGuideLines - 1))) : $elm$core$Maybe$Nothing;
						}),
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticks(chart))));
		var guides = A2(
			$elm$core$List$indexedMap,
			F2(
				function (idx, _v1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('h-full absolute border-l border-solid border-grey-500'),
								A2(
								$elm$html$Html$Attributes$style,
								'left',
								leftOffset(idx))
							]),
						_List_Nil);
				}),
			$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$ticks(chart));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-32 my-3')
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var name = _v0.kt;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center h-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full text-right whitespace-nowrap truncate overflow-hidden relative py-2'),
												$elm$html$Html$Attributes$class('hover:z-10 hover:overflow-visible hover:whitespace-normal hover:bg-white')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(name)
											]))
									]));
						},
						chart.iD)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grow shrink-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_Utils_ap(
								guides,
								_List_fromArray(
									[strps]))),
							tickLabels
						]))
				]));
	});
var $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$view = F3(
	function (translations, interactivity, chart) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-4 rounded-md p-4 w-full border-box bg-white'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'border border-grey-400 border-solid',
							!_Utils_eq(interactivity, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NotInteractive))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-blue-700 text-center text-lg')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(chart.d)
						])),
					A2(
					$elm$html$Html$Lazy$lazy,
					$author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$stripes(translations),
					chart),
					A2(
					$elm$html$Html$Lazy$lazy,
					A2($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$details, translations, interactivity),
					chart)
				]));
	});
var $author$project$ChartAndControlSet$HeatMap$ParentMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$ChartAndControlSet$HeatMap$AnyCellClicked = {$: 1};
var $author$project$ChartAndControlSet$HeatMap$anyCellClickHandler = F2(
	function (highlight, attrs) {
		if (highlight.$ === 2) {
			return A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onClick($author$project$ChartAndControlSet$HeatMap$AnyCellClicked),
				attrs);
		} else {
			return attrs;
		}
	});
var $author$project$ChartAndControlSet$HeatMap$axisCategoryTooltip = function (category) {
	if (!category.$) {
		var s = category.a;
		return s;
	} else {
		var tooltip = category.b;
		return tooltip;
	}
};
var $author$project$Palette$fallback = 'lightgrey';
var $author$project$ChartAndControlSet$HeatMap$aboveHighlightedCell = F4(
	function (start, end, row, column) {
		return _Utils_eq(start.a, row + 1) && ((_Utils_cmp(start.b, column) < 1) && (_Utils_cmp(column, end.b) < 1));
	});
var $author$project$ChartAndControlSet$HeatMap$blue600 = '#2779bd';
var $author$project$ChartAndControlSet$HeatMap$highlightedCell = F4(
	function (start, end, row, column) {
		return _Utils_eq(start.a, row) && ((_Utils_cmp(start.b, column) < 1) && (_Utils_cmp(column, end.b) < 1));
	});
var $author$project$ChartAndControlSet$HeatMap$onWithinDaySegments = F3(
	function (fn, highlight, acc) {
		switch (highlight.$) {
			case 0:
				return acc;
			case 1:
				var coordinateRanges = highlight.a;
				return A3($elm$core$List$foldl, fn, acc, coordinateRanges);
			default:
				var coordinateRanges = highlight.a;
				return A3($elm$core$List$foldl, fn, acc, coordinateRanges);
		}
	});
var $author$project$ChartAndControlSet$HeatMap$highlightBottom = F3(
	function (highlight, row, column) {
		return A2(
			$author$project$ChartAndControlSet$HeatMap$onWithinDaySegments,
			F2(
				function (_v0, attrs) {
					var start = _v0.cU;
					var end = _v0.cw;
					return (A4($author$project$ChartAndControlSet$HeatMap$highlightedCell, start, end, row, column) || A4($author$project$ChartAndControlSet$HeatMap$aboveHighlightedCell, start, end, row, column)) ? A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$style, 'border-bottom-color', $author$project$ChartAndControlSet$HeatMap$blue600),
						attrs) : attrs;
				}),
			highlight);
	});
var $author$project$ChartAndControlSet$HeatMap$HighlightCellClicked = {$: 0};
var $author$project$ChartAndControlSet$HeatMap$highlightClickHandler = F3(
	function (highlight, row, column) {
		return A2(
			$author$project$ChartAndControlSet$HeatMap$onWithinDaySegments,
			F2(
				function (_v0, attrs) {
					var start = _v0.cU;
					var end = _v0.cw;
					if (highlight.$ === 1) {
						return A4($author$project$ChartAndControlSet$HeatMap$highlightedCell, start, end, row, column) ? A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onClick($author$project$ChartAndControlSet$HeatMap$HighlightCellClicked),
							attrs) : attrs;
					} else {
						return attrs;
					}
				}),
			highlight);
	});
var $author$project$ChartAndControlSet$HeatMap$lastHighlightedCell = F3(
	function (end, row, column) {
		return _Utils_eq(end.a, row) && _Utils_eq(column, end.b);
	});
var $author$project$ChartAndControlSet$HeatMap$leftOfHighlight = F3(
	function (start, row, column) {
		return _Utils_eq(start.a, row) && _Utils_eq(column + 1, start.b);
	});
var $author$project$ChartAndControlSet$HeatMap$highlightRight = F3(
	function (highlight, row, column) {
		return A2(
			$author$project$ChartAndControlSet$HeatMap$onWithinDaySegments,
			F2(
				function (_v0, attrs) {
					var start = _v0.cU;
					var end = _v0.cw;
					return (A3($author$project$ChartAndControlSet$HeatMap$lastHighlightedCell, end, row, column) || A3($author$project$ChartAndControlSet$HeatMap$leftOfHighlight, start, row, column)) ? A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$style, 'border-right-color', $author$project$ChartAndControlSet$HeatMap$blue600),
						attrs) : attrs;
				}),
			highlight);
	});
var $author$project$ChartAndControlSet$HeatMap$scaleColour = F2(
	function (_v0, value) {
		var min = _v0.Z;
		var step = _v0.cX;
		if (!step) {
			return $author$project$Palette$fallback;
		} else {
			var len = $author$project$Palette$length;
			var maxRangeValue = min + (step * len);
			return (_Utils_cmp(value, maxRangeValue) > -1) ? A2(
				$elm$core$Maybe$withDefault,
				$author$project$Palette$fallback,
				A2($elm$core$Array$get, len - 1, $author$project$Palette$gradual)) : A2(
				$elm$core$Maybe$withDefault,
				$author$project$Palette$fallback,
				A2(
					$elm$core$Array$get,
					$elm$core$Basics$floor((value - min) / step),
					$author$project$Palette$gradual));
		}
	});
var $author$project$ChartAndControlSet$HeatMap$dataCell = function (translations) {
	return function (range) {
		return function (highlight) {
			return function (unit) {
				return function (yLabel) {
					return function (row) {
						return function (column) {
							return function (from) {
								return function (to) {
									return function (value) {
										var formattedValue = function () {
											if (!value.$) {
												var number = value.a;
												return A2($author$project$Enectiva$I18n$formatNumber, translations, number);
											} else {
												return ' – ';
											}
										}();
										var tooltip = A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('absolute bg-white p-2 hidden min-w-32 top-full left-2/5 z-10 shadow rounded group-hover:block')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$ChartAndControlSet$HeatMap$axisCategoryTooltip(yLabel))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$ChartAndControlSet$HeatMap$axisCategoryTooltip(from) + (' - ' + $author$project$ChartAndControlSet$HeatMap$axisCategoryTooltip(to)))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(formattedValue + (' ' + unit))
														]))
												]));
										var colour = function () {
											if (highlight.$ === 2) {
												return A3(
													$author$project$ChartAndControlSet$HeatMap$onWithinDaySegments,
													F2(
														function (_v1, clr) {
															var start = _v1.cU;
															var end = _v1.cw;
															if (A4($author$project$ChartAndControlSet$HeatMap$highlightedCell, start, end, row, column)) {
																if (!value.$) {
																	var number = value.a;
																	return A2($author$project$ChartAndControlSet$HeatMap$scaleColour, range, number);
																} else {
																	return clr;
																}
															} else {
																return clr;
															}
														}),
													highlight,
													$author$project$Palette$fallback);
											} else {
												if (!value.$) {
													var number = value.a;
													return A2($author$project$ChartAndControlSet$HeatMap$scaleColour, range, number);
												} else {
													return $author$project$Palette$fallback;
												}
											}
										}();
										return A2(
											$elm$html$Html$td,
											A2(
												$author$project$ChartAndControlSet$HeatMap$anyCellClickHandler,
												highlight,
												A4(
													$author$project$ChartAndControlSet$HeatMap$highlightClickHandler,
													highlight,
													row,
													column,
													A4(
														$author$project$ChartAndControlSet$HeatMap$highlightRight,
														highlight,
														row,
														column,
														A4(
															$author$project$ChartAndControlSet$HeatMap$highlightBottom,
															highlight,
															row,
															column,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('relative group hover:screen-orange-600'),
																	$elm$html$Html$Attributes$class('border border-solid border-transparent'),
																	A2($elm$html$Html$Attributes$style, 'background-color', colour)
																]))))),
											_List_fromArray(
												[tooltip]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ChartAndControlSet$HeatMap$dataCells = F8(
	function (translations, range, highlight, unit, yLabel, xAxis, row, values) {
		return A5(
			$elm$core$List$map4,
			A6($author$project$ChartAndControlSet$HeatMap$dataCell, translations, range, highlight, unit, yLabel, row),
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xAxis.de) - 1),
			xAxis.de,
			A2(
				$elm$core$List$drop,
				1,
				_Utils_ap(
					xAxis.de,
					_List_fromArray(
						[xAxis.e8]))),
			values);
	});
var $author$project$ChartAndControlSet$HeatMap$axisCategoryLabel = function (category) {
	if (!category.$) {
		var s = category.a;
		return s;
	} else {
		var label = category.a;
		return label;
	}
};
var $author$project$ChartAndControlSet$HeatMap$rowHeader = F3(
	function (highlight, yLabel, row) {
		return A2(
			$elm$html$Html$th,
			A4(
				$author$project$ChartAndControlSet$HeatMap$highlightRight,
				highlight,
				row,
				-1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-right py-2 pr-3 bg-transparent font-medium text-grey-800')
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$ChartAndControlSet$HeatMap$axisCategoryLabel(yLabel))
				]));
	});
var $author$project$ChartAndControlSet$HeatMap$heatMapSeriesRow = F8(
	function (translations, range, highlight, unit, xAxis, row, yLabel, values) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A3($author$project$ChartAndControlSet$HeatMap$rowHeader, highlight, yLabel, row),
				A8($author$project$ChartAndControlSet$HeatMap$dataCells, translations, range, highlight, unit, yLabel, xAxis, row, values)));
	});
var $author$project$ChartAndControlSet$HeatMap$heatMapSeriesRows = F3(
	function (translations, range, heatMap) {
		return A4(
			$elm$core$List$map3,
			A5($author$project$ChartAndControlSet$HeatMap$heatMapSeriesRow, translations, range, heatMap.aO, heatMap.iD.i$, heatMap.bZ),
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(heatMap.o) - 1),
			heatMap.o,
			heatMap.iD.jA);
	});
var $author$project$ChartAndControlSet$HeatMap$legendDivisor = 3;
var $author$project$ChartAndControlSet$HeatMap$legendField = F7(
	function (translations, unit, appearance, _v0, valueFrom, valueTo, color) {
		var showStart = _v0.a;
		var showEnd = _v0.b;
		var to = A2($author$project$Enectiva$I18n$formatNumber, translations, valueTo);
		var rightLabel = showEnd ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ml-1/2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(to)
				])) : $author$project$Enectiva$View$nothing;
		var from = A2($author$project$Enectiva$I18n$formatNumber, translations, valueFrom);
		var leftLabel = showStart ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('-ml-1/2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(from)
				])) : $author$project$Enectiva$View$nothing;
		var range = from + (' - ' + (to + (' ' + unit)));
		var appearanceClass = function () {
			if (!appearance) {
				return 'min-w-10';
			} else {
				return 'w-6';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b-16 border-solid'),
					$elm$html$Html$Attributes$class(appearanceClass),
					A2($elm$html$Html$Attributes$style, 'border-bottom-color', color),
					$elm$html$Html$Attributes$title(range)
				]),
			_List_fromArray(
				[leftLabel, rightLabel]));
	});
var $author$project$ChartAndControlSet$HeatMap$legendFieldsHelp = F6(
	function (translations, unit, idx, _v0, appearance, colorPalette) {
		var min = _v0.Z;
		var step = _v0.cX;
		if (!colorPalette.b) {
			return _List_Nil;
		} else {
			if (!colorPalette.b.b) {
				var color = colorPalette.a;
				return $elm$core$List$singleton(
					A7(
						$author$project$ChartAndControlSet$HeatMap$legendField,
						translations,
						unit,
						appearance,
						_Utils_Tuple2(
							!A2($elm$core$Basics$modBy, $author$project$ChartAndControlSet$HeatMap$legendDivisor, idx),
							true),
						min,
						min + step,
						color));
			} else {
				var color = colorPalette.a;
				var others = colorPalette.b;
				return A2(
					$elm$core$List$cons,
					A7(
						$author$project$ChartAndControlSet$HeatMap$legendField,
						translations,
						unit,
						appearance,
						_Utils_Tuple2(
							!A2($elm$core$Basics$modBy, $author$project$ChartAndControlSet$HeatMap$legendDivisor, idx),
							false),
						min,
						min + step,
						color),
					A6(
						$author$project$ChartAndControlSet$HeatMap$legendFieldsHelp,
						translations,
						unit,
						idx + 1,
						{Z: min + step, cX: step},
						appearance,
						others));
			}
		}
	});
var $author$project$ChartAndControlSet$HeatMap$legendFields = F5(
	function (translations, range, appearance, unit, colorPalette) {
		return (!range.cX) ? _List_Nil : A6($author$project$ChartAndControlSet$HeatMap$legendFieldsHelp, translations, unit, 0, range, appearance, colorPalette);
	});
var $elm_community$list_extra$List$Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i - 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(
				$elm$core$List$length(list) - 1,
				acc),
			list).b;
	});
var $author$project$ChartAndControlSet$HeatMap$columnClass = $elm$html$Html$Attributes$class('text-left relative py-2 px-1 border border-solid border-transparent bg-transparent font-medium text-grey-800');
var $author$project$ChartAndControlSet$HeatMap$columnHeader = F3(
	function (from, highlight, column) {
		return A2(
			$elm$html$Html$th,
			A4(
				$author$project$ChartAndControlSet$HeatMap$highlightBottom,
				highlight,
				-1,
				column,
				_List_fromArray(
					[$author$project$ChartAndControlSet$HeatMap$columnClass])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('-left-1/2 relative text-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$ChartAndControlSet$HeatMap$axisCategoryLabel(from))
						]))
				]));
	});
var $author$project$ChartAndControlSet$HeatMap$lastColumnHeader = F4(
	function (from, backstop, highlight, column) {
		return A2(
			$elm$html$Html$th,
			A4(
				$author$project$ChartAndControlSet$HeatMap$highlightBottom,
				highlight,
				-1,
				column,
				_List_fromArray(
					[$author$project$ChartAndControlSet$HeatMap$columnClass])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('-left-1/2 relative text-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$ChartAndControlSet$HeatMap$axisCategoryLabel(from))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('left-1/2 text-center absolute top-0 py-2 px-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$ChartAndControlSet$HeatMap$axisCategoryLabel(backstop))
						]))
				]));
	});
var $author$project$ChartAndControlSet$HeatMap$xAxisLabel = F5(
	function (backstop, highlight, column, from, list) {
		if (!list.b) {
			return _List_fromArray(
				[
					A4($author$project$ChartAndControlSet$HeatMap$lastColumnHeader, from, backstop, highlight, column)
				]);
		} else {
			var cells = list;
			return A2(
				$elm$core$List$cons,
				A3($author$project$ChartAndControlSet$HeatMap$columnHeader, from, highlight, column),
				cells);
		}
	});
var $author$project$ChartAndControlSet$HeatMap$timeHeadlineRow = function (heatMap) {
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-transparent w-28 min-w-28')
					]),
				_List_Nil),
			A3(
				$elm_community$list_extra$List$Extra$indexedFoldr,
				A2($author$project$ChartAndControlSet$HeatMap$xAxisLabel, heatMap.bZ.e8, heatMap.aO),
				_List_Nil,
				heatMap.bZ.de)));
};
var $author$project$ChartAndControlSet$HeatMap$view = F3(
	function (translations, downloadButton, heatMap) {
		var range = function () {
			var _v1 = heatMap.aO;
			if (_v1.$ === 2) {
				var valueRange = _v1.b;
				return valueRange;
			} else {
				return heatMap.iD.cO;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-none m-0 p-0 relative space-y-2')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Enectiva$View$viewJust,
					function (title) {
						return A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-4 w-full text-center text-blue-800 text-lg')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]));
					},
					heatMap.d),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-0 w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$ChartAndControlSet$HeatMap$timeHeadlineRow(heatMap)
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A3($author$project$ChartAndControlSet$HeatMap$heatMapSeriesRows, translations, range, heatMap))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sticky bottom-0 flex justify-center gap-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white flex text-grey-800 rounded shadow-md'),
									function () {
									var _v0 = heatMap.ee;
									if (!_v0) {
										return $elm$html$Html$Attributes$class('py-4 pr-8 pl-10');
									} else {
										return $elm$html$Html$Attributes$class('py-2 pr-4 pl-6');
									}
								}()
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex justify-center gap-px')
										]),
									A5(
										$author$project$ChartAndControlSet$HeatMap$legendFields,
										translations,
										range,
										heatMap.ee,
										heatMap.iD.i$,
										$elm$core$Array$toList($author$project$Palette$gradual))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-8'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('hidden', heatMap.ee === 1)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(heatMap.iD.i$)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-end w-full')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$map, $author$project$ChartAndControlSet$HeatMap$ParentMsg, downloadButton)
						]))
				]));
	});
var $author$project$Chart$view = function (_v0) {
	var chart = _v0.aA;
	var translations = _v0.cl;
	switch (chart.$) {
		case 0:
			var percentage = chart.a;
			return $author$project$Chart$Percentage$view(percentage);
		case 1:
			var se = chart.a;
			return A2($author$project$Chart$SingleEntity$view, translations, se);
		case 2:
			var ae = chart.a;
			return A2($author$project$Chart$AggregateEntities$view, translations, ae);
		case 3:
			var c = chart.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Chart$GeneralMsg,
				A2($author$project$Chart$Shared$view, translations, c));
		case 4:
			var c = chart.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Chart$ConsumptionProfileMsg,
				A2($author$project$Chart$ConsumptionProfile$view, translations, c));
		case 5:
			var c = chart.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Chart$HeatMapMsg,
				A3($author$project$ChartAndControlSet$HeatMap$view, translations, $author$project$Enectiva$View$nothing, c));
		case 6:
			var c = chart.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Chart$BinaryAnalysisMsg,
				A3($author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$view, translations, $author$project$ChartAndControlSet$BinaryDataSeriesAnalysis$NotInteractive, c));
		default:
			return A2($author$project$ChartAndControlSet$ChartControls$error, translations, 'failed_to_load_chart_controls');
	}
};
var $author$project$Chart$main = $elm$browser$Browser$element(
	{j1: $author$project$Chart$init, ld: $author$project$Chart$subscriptions, lw: $author$project$Chart$update, lD: $author$project$Chart$view});
/*
_Platform_export({'Chart':{'init':$author$project$Chart$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (translations) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (locale) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (chart) {
							return $elm$json$Json$Decode$succeed(
								{aA: chart, fR: locale, cl: translations});
						},
						A2($elm$json$Json$Decode$field, 'chart', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'locale', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'translations', $elm$json$Json$Decode$value)))(0)}});}(this));
*/
export const Elm = {'Chart':{'init':$author$project$Chart$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (translations) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (locale) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (chart) {
							return $elm$json$Json$Decode$succeed(
								{aA: chart, fR: locale, cl: translations});
						},
						A2($elm$json$Json$Decode$field, 'chart', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'locale', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'translations', $elm$json$Json$Decode$value)))(0)}};
  